// Auto-generated from halfLife.json - patterns as RLE
const patterns = {
  'b2-6_s0-1': {
    'Glider c/3 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\n2bB$BA$b2B!',
      description: 'Glider, speed c/3 (period 6, displacement 2)',
    },
    'Glider c/3 2': {
      rle: 'x = 4, y = 5, rule = FuzzyLife/3\n2bB$BAbA$BA$BAbA$2bB!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Glider c/3 3': {
      rle: 'x = 5, y = 4, rule = FuzzyLife/3\n2bA$5A$A3bA$b3A!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Glider c/3 4': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\n2bA$A$b2A!',
      description: 'Glider, speed c/3 (period 6, displacement 2)',
    },
    'Glider c/6 5': {
      rle: 'x = 5, y = 4, rule = FuzzyLife/3\n2bA$bBb2A$2Ab2A$bBA!',
      description: 'Glider, speed c/6 (period 6, displacement 1)',
    },
    'Oscillator P1': {
      rle: 'x = 1, y = 1, rule = FuzzyLife/3\nB!',
      description: 'Period 1 oscillator (smallest)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 2, rule = FuzzyLife/3\n2bB$BA!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P3 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nAB$BA!',
      description: 'Period 3 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 6, y = 6, rule = FuzzyLife/3\n2b2A$bB2bB$Ab2AbA$Ab2AbA$bB2bB$2b2A!',
      description: 'Period 4 oscillator (smallest)',
    },
    'Oscillator P8 1': {
      rle: 'x = 7, y = 7, rule = FuzzyLife/3\n3bB$3bA$2bBAB$B5AB$2b2B2bA$2b3A$3b2B!',
      description: 'Period 8 oscillator (smallest)',
    },
    'Oscillator P12 1': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\n3bB$bB$bAB$B!',
      description: 'Period 12 oscillator (smallest)',
    },
  },
  'b2-4_s1': {
    'Glider c/3 1': {
      rle: 'x = 4, y = 5, rule = FuzzyLife/3\n2bB$BAbA$BA$BAbA$2bB!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 1, rule = FuzzyLife/3\nAB!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 4, y = 6, rule = FuzzyLife/3\n3bB$bBA$b2A$B2bB$4A$2bB!',
      description: 'Period 4 oscillator (smallest)',
    },
    'Oscillator P6 1': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\n3bB$2b2A$B$bA!',
      description: 'Period 6 oscillator (smallest)',
    },
    'Oscillator P8 1': {
      rle: 'x = 8, y = 7, rule = FuzzyLife/3\n6bB$A3bB2AB$B3bB2AB$5bB$$$2bAB!',
      description: 'Period 8 oscillator (smallest)',
    },
  },
  'b1_s0': {
    'Glider c 1': {
      rle: 'x = 2, y = 4, rule = FuzzyLife/3\nbA$A$A$bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 5, y = 3, rule = FuzzyLife/3\n4bA$b3A$A!',
      description: 'Period 4 oscillator (smallest)',
    },
  },
  'b2-4_s0-1,5': {
    'Glider c/3 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\n2bB$BA$b2B!',
      description: 'Glider, speed c/3 (period 6, displacement 2)',
    },
    'Glider c/6 2': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\nb2A$A$3A!',
      description: 'Glider, speed c/6 (period 6, displacement 1)',
    },
    'Glider c/3 3': {
      rle: 'x = 5, y = 4, rule = FuzzyLife/3\n2bA$5A$A3bA$b3A!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Glider c/6 4': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\n2bB$BA$BAB!',
      description: 'Glider, speed c/6 (period 6, displacement 1)',
    },
    'Glider c/3 5': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\n2bA$A$b2A!',
      description: 'Glider, speed c/3 (period 6, displacement 2)',
    },
    'Glider c/6 6': {
      rle: 'x = 5, y = 4, rule = FuzzyLife/3\n2bA$bBb2A$2Ab2A$bBA!',
      description: 'Glider, speed c/6 (period 6, displacement 1)',
    },
    'Oscillator P1': {
      rle: 'x = 1, y = 1, rule = FuzzyLife/3\nB!',
      description: 'Period 1 oscillator (smallest)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 2, rule = FuzzyLife/3\n2bB$BA!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P3 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nAB$BA!',
      description: 'Period 3 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\nbAbB$Bb2A$2A$BbAB!',
      description: 'Period 4 oscillator (smallest)',
    },
    'Oscillator P8 1': {
      rle: 'x = 5, y = 6, rule = FuzzyLife/3\n4bB$3bAB$3bA$B2AB$bA$bB!',
      description: 'Period 8 oscillator (smallest)',
    },
    'Oscillator P12 1': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\n3bB$bB$bAB$B!',
      description: 'Period 12 oscillator (smallest)',
    },
  },
  'b2_s0,2-3': {
    'Glider c/3 1': {
      rle: 'x = 2, y = 4, rule = FuzzyLife/3\nbA$2B$2B$bA!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Glider c/3 2': {
      rle: 'x = 4, y = 2, rule = FuzzyLife/3\nb2A$A2BA!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Glider c/3 3': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\n2bB$3A$3A$2bB!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Oscillator P1': {
      rle: 'x = 1, y = 1, rule = FuzzyLife/3\nB!',
      description: 'Period 1 oscillator (smallest)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 2, rule = FuzzyLife/3\nb2A$AB!',
      description: 'Period 2 oscillator (smallest)',
    },
  },
  'b2-5_s1,5': {
    'Glider c/3 1': {
      rle: 'x = 5, y = 4, rule = FuzzyLife/3\n2bA$5A$A3bA$b3A!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 1, y = 2, rule = FuzzyLife/3\nA$B!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P6 1': {
      rle: 'x = 7, y = 2, rule = FuzzyLife/3\nA3bABA$B3bABA!',
      description: 'Period 6 oscillator (smallest)',
    },
  },
  'b2-5_s1,5-6': {
    'Glider c/3 1': {
      rle: 'x = 5, y = 5, rule = FuzzyLife/3\n2bAB$2AbAB$2AbA$2AbAB$2bAB!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 1, rule = FuzzyLife/3\nAB!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P6 1': {
      rle: 'x = 8, y = 2, rule = FuzzyLife/3\nA4bABA$B4bABA!',
      description: 'Period 6 oscillator (smallest)',
    },
  },
  'b2-7_s2,4-5': {
    'Glider c/2 1': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\nb2A$4A$A2BA$A2bA!',
      description: 'Glider, speed c/2 (period 2, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 2, rule = FuzzyLife/3\nb2A$AB!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n2bB$B2bB$bB!',
      description: 'Period 4 oscillator (smallest)',
    },
    'Oscillator P10 1': {
      rle: 'x = 6, y = 6, rule = FuzzyLife/3\n2b2B$$Bb2BbB$Bb2BbB$$2b2B!',
      description: 'Period 10 oscillator (smallest)',
    },
  },
  'b2-5_s1,6-7': {
    'Glider c/3 1': {
      rle: 'x = 5, y = 4, rule = FuzzyLife/3\n2bA$5A$A3bA$b3A!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 1, y = 2, rule = FuzzyLife/3\nA$B!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P3 1': {
      rle: 'x = 8, y = 6, rule = FuzzyLife/3\n6b2A$6b2B$6b2A$$ABA$ABA!',
      description: 'Period 3 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 4, y = 7, rule = FuzzyLife/3\n2bA$2AbB$3bA$3A$bBbB$4A$bB!',
      description: 'Period 4 oscillator (smallest)',
    },
    'Oscillator P6 1': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\n3bB$2b2A$B$bA!',
      description: 'Period 6 oscillator (smallest)',
    },
  },
  'b2-4_s0-1': {
    'Glider c/6 1': {
      rle: 'x = 5, y = 4, rule = FuzzyLife/3\n2bA$bBb2A$2Ab2A$bBA!',
      description: 'Glider, speed c/6 (period 6, displacement 1)',
    },
    'Glider c/3 2': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\n2bB$BA$b2B!',
      description: 'Glider, speed c/3 (period 6, displacement 2)',
    },
    'Glider c/6 3': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\nb2A$A$3A!',
      description: 'Glider, speed c/6 (period 6, displacement 1)',
    },
    'Glider c/3 4': {
      rle: 'x = 5, y = 4, rule = FuzzyLife/3\n2bA$5A$A3bA$b3A!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Glider c/3 5': {
      rle: 'x = 4, y = 5, rule = FuzzyLife/3\n2bB$BAbA$BA$BAbA$2bB!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Glider c/6 6': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\n2bB$BA$BAB!',
      description: 'Glider, speed c/6 (period 6, displacement 1)',
    },
    'Glider c/3 7': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\n2bA$A$b2A!',
      description: 'Glider, speed c/3 (period 6, displacement 2)',
    },
    'Oscillator P1': {
      rle: 'x = 1, y = 1, rule = FuzzyLife/3\nB!',
      description: 'Period 1 oscillator (smallest)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 2, rule = FuzzyLife/3\n2bB$BA!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P3 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nAB$BA!',
      description: 'Period 3 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 5, y = 3, rule = FuzzyLife/3\n2bAB$2bAbA$BAbB!',
      description: 'Period 4 oscillator (smallest)',
    },
    'Oscillator P12 1': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\n3bB$bB$bAB$B!',
      description: 'Period 12 oscillator (smallest)',
    },
  },
  'b2-4_s1,6-7': {
    'Glider c/3 1': {
      rle: 'x = 4, y = 5, rule = FuzzyLife/3\n2bB$BAbA$BA$BAbA$2bB!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 1, y = 2, rule = FuzzyLife/3\nA$B!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P6 1': {
      rle: 'x = 3, y = 6, rule = FuzzyLife/3\n2bB$B$$$ABA$ABA!',
      description: 'Period 6 oscillator (smallest)',
    },
    'Oscillator P8 1': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\n2bB$B2AB$B2AB$bB!',
      description: 'Period 8 oscillator (smallest)',
    },
  },
  'b2-6_s0-1,4': {
    'Glider c/3 1': {
      rle: 'x = 5, y = 6, rule = FuzzyLife/3\n2bA$5A$2bB$5A$$5A!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Glider c/3 2': {
      rle: 'x = 5, y = 3, rule = FuzzyLife/3\nbAbA$B3bB$b3A!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Oscillator P1': {
      rle: 'x = 1, y = 1, rule = FuzzyLife/3\nB!',
      description: 'Period 1 oscillator (smallest)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 2, rule = FuzzyLife/3\n2bB$BA!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P3 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nAB$BA!',
      description: 'Period 3 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 9, y = 5, rule = FuzzyLife/3\n5bAB$2bBAbAbA$BAbAbA2bB$2bBAbAbA$5bAB!',
      description: 'Period 4 oscillator (smallest)',
    },
    'Glider c/6 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\n2bB$BA$BAB!',
      description: 'Glider, speed c/6 (period 6, displacement 1)',
    },
    'Oscillator P12 1': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\n3bB$bB$bAB$B!',
      description: 'Period 12 oscillator (smallest)',
    },
  },
  'b2-5_s3-4': {
    'Glider c/3 1': {
      rle: 'x = 5, y = 5, rule = FuzzyLife/3\n2bA$2b2A$ABb2A$ABABA$bAB!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\n2bA$2B$3A!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n2bBA$A2B$b2BA!',
      description: 'Period 4 oscillator (smallest)',
    },
    'Oscillator P6 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\nbBA$2B$ABA!',
      description: 'Period 6 oscillator (smallest)',
    },
  },
  'b2-4_s1,7-8': {
    'Glider c/3 1': {
      rle: 'x = 5, y = 5, rule = FuzzyLife/3\n2bAB$2AbAB$2AbA$2AbAB$2bAB!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 1, y = 2, rule = FuzzyLife/3\nA$B!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 5, y = 3, rule = FuzzyLife/3\n2bA$Bb2AB$b2A!',
      description: 'Period 4 oscillator (smallest)',
    },
    'Oscillator P6 1': {
      rle: 'x = 2, y = 7, rule = FuzzyLife/3\nbA$B$$$2A$2B$2A!',
      description: 'Period 6 oscillator (smallest)',
    },
    'Oscillator P8 1': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\n2bB$B2AB$B2AB$bB!',
      description: 'Period 8 oscillator (smallest)',
    },
  },
  'b2-7_s2,7-8': {
    'Glider c/9 1': {
      rle: 'x = 4, y = 5, rule = FuzzyLife/3\n2bA$b2A$B2bA$2AB$b2A!',
      description: 'Glider, speed c/9 (period 9, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 2, rule = FuzzyLife/3\nb2A$AB!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\nbAB$3B$BA!',
      description: 'Period 4 oscillator (smallest)',
    },
    'Oscillator P6 1': {
      rle: 'x = 6, y = 6, rule = FuzzyLife/3\n2b2A$bA2BA$AB2ABA$AB2ABA$bA2BA$2b2A!',
      description: 'Period 6 oscillator (smallest)',
    },
  },
  'b2-5_s3-4,6': {
    'Glider c/3 1': {
      rle: 'x = 5, y = 5, rule = FuzzyLife/3\n2bA$2AbBA$ABbAB$2b3B$2b2A!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Glider c/3 2': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\n2bA$BAB$Bb2B$A2BA!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Glider c/3 3': {
      rle: 'x = 5, y = 5, rule = FuzzyLife/3\n2bA$2b2A$ABb2A$ABABA$bAB!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\nbA$A2B$2A!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n2bBA$A2B$b2BA!',
      description: 'Period 4 oscillator (smallest)',
    },
    'Oscillator P6 1': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\n2bA$A2B$b2BA$AbA!',
      description: 'Period 6 oscillator (smallest)',
    },
  },
  'b2-4_s0-1,5-6': {
    'Glider c/3 1': {
      rle: 'x = 5, y = 4, rule = FuzzyLife/3\n2bA$5A$A3bA$b3A!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Glider c/6 2': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\n2bB$BA$BAB!',
      description: 'Glider, speed c/6 (period 6, displacement 1)',
    },
    'Glider c/6 3': {
      rle: 'x = 5, y = 4, rule = FuzzyLife/3\n2bA$bBb2A$2Ab2A$bBA!',
      description: 'Glider, speed c/6 (period 6, displacement 1)',
    },
    'Glider c/3 4': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\n2bA$A$b2A!',
      description: 'Glider, speed c/3 (period 6, displacement 2)',
    },
    'Oscillator P1': {
      rle: 'x = 1, y = 1, rule = FuzzyLife/3\nB!',
      description: 'Period 1 oscillator (smallest)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 2, rule = FuzzyLife/3\n2bB$BA!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P3 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nAB$BA!',
      description: 'Period 3 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 7, y = 6, rule = FuzzyLife/3\n4bBA$bBAbAbB$AbABAbA$Bb2AbA$bAbAbB$3bBA!',
      description: 'Period 4 oscillator (smallest)',
    },
    'Oscillator P6 1': {
      rle: 'x = 2, y = 4, rule = FuzzyLife/3\nbB$B$B$bB!',
      description: 'Period 6 oscillator (smallest)',
    },
    'Oscillator P12 1': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\n3bB$bB$bAB$B!',
      description: 'Period 12 oscillator (smallest)',
    },
    'Oscillator P22 1': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\n2bA$2BbB$4A$2bB!',
      description: 'Period 22 oscillator (smallest)',
    },
  },
  'b2-6_s0-1,4-5': {
    'Glider c/3 1': {
      rle: 'x = 5, y = 4, rule = FuzzyLife/3\n2bA$5A$AbBbA$b3A!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Oscillator P1': {
      rle: 'x = 1, y = 1, rule = FuzzyLife/3\nB!',
      description: 'Period 1 oscillator (smallest)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 2, rule = FuzzyLife/3\n2bB$BA!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P3 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nAB$BA!',
      description: 'Period 3 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 5, y = 3, rule = FuzzyLife/3\n2bAB$2bAbA$BAbB!',
      description: 'Period 4 oscillator (smallest)',
    },
    'Oscillator P10 1': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\n2bA$2AbB$A2BA$bAB!',
      description: 'Period 10 oscillator (smallest)',
    },
    'Oscillator P12 1': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\n3bB$bB$bAB$B!',
      description: 'Period 12 oscillator (smallest)',
    },
  },
  'b1_s0,2': {
    'Glider c 1': {
      rle: 'x = 2, y = 4, rule = FuzzyLife/3\nbA$A$A$bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P3 1': {
      rle: 'x = 5, y = 5, rule = FuzzyLife/3\n2bA$bBAB$2Ab2A$bBAB$2bA!',
      description: 'Period 3 oscillator (smallest)',
    },
  },
  'b2-6_s0-1,4-6': {
    'Glider c/3 1': {
      rle: 'x = 5, y = 3, rule = FuzzyLife/3\nbAbA$B3bB$b3A!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Oscillator P1': {
      rle: 'x = 1, y = 1, rule = FuzzyLife/3\nB!',
      description: 'Period 1 oscillator (smallest)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 2, rule = FuzzyLife/3\n2bB$BA!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P3 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nAB$BA!',
      description: 'Period 3 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 5, y = 3, rule = FuzzyLife/3\n2bAB$2bAbA$BAbB!',
      description: 'Period 4 oscillator (smallest)',
    },
    'Oscillator P6 1': {
      rle: 'x = 7, y = 8, rule = FuzzyLife/3\n5bA$3b2AB$3b2ABA$B4bAB$$$bBA$bAB!',
      description: 'Period 6 oscillator (smallest)',
    },
    'Oscillator P8 1': {
      rle: 'x = 7, y = 8, rule = FuzzyLife/3\n4bA$2bAbB2A$2A4B$A5BA$b2BA2B$A3BbBA$bA4B$BAb2AbA!',
      description: 'Period 8 oscillator (smallest)',
    },
    'Oscillator P10 1': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\n2bA$2AbB$A2BA$bAB!',
      description: 'Period 10 oscillator (smallest)',
    },
    'Oscillator P11 1': {
      rle: 'x = 5, y = 5, rule = FuzzyLife/3\n3bAB$A3BA$bBAB$A3B$BAbA!',
      description: 'Period 11 oscillator (smallest)',
    },
    'Oscillator P12 1': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\n3bB$bB$bAB$B!',
      description: 'Period 12 oscillator (smallest)',
    },
    'Oscillator P16 1': {
      rle: 'x = 16, y = 23, rule = FuzzyLife/3\n6bAbAbAbA$6b2ABABAB$b2AbAb2BbBbBbBA$Bb4Bb7BA$A3Bb3BbBbBb2BA$ABb3Bb6B2AB$A3Bb4BbBb2BA$bBbBb4BbBAb2BA$A5B2A7B$bB2bBb2BbBbB2bBA$b14B$ABAbBbBbBbBbBbBA$b6Bb7B$ABbBb5Bb4B$bA4BbBbBbBA2B$ABbBb6BA3BA$2A4BbBbBbBA2B$bBbBb7BA2BA$A5B2bB2b4B$2b2Bb7BA2BA$2bA3BbBbBbBAB2A$4b6BABAB$4b3A2bAbAbA!',
      description: 'Period 16 oscillator (smallest)',
    },
    'Oscillator P20 1': {
      rle: 'x = 9, y = 10, rule = FuzzyLife/3\n4bBbAbB$b2A2BAB2A$Bb2BbBbA$A7BA$bB2bBA2B$A4BA2BA$bBAb4B$AB2ABb2BA$2A5B$2bAbAbA!',
      description: 'Period 20 oscillator (smallest)',
    },
    'Oscillator P24 1': {
      rle: 'x = 11, y = 11, rule = FuzzyLife/3\n4bA2bAbAB$2bA6B2A$2b2B2A2BbB$ABAbA2b3B$b7BbB$bBA2Bb4BA$A2BA3Bb2A$b4Bb4BA$A2Bb3BbB$2bBA3B2A$2bAbAbA!',
      description: 'Period 24 oscillator (smallest)',
    },
    'Oscillator P26 1': {
      rle: 'x = 11, y = 12, rule = FuzzyLife/3\n5bAbA$3b2A3B$3bBb4BA$bA4BA2BA$b2BbBb4BA$A6Bb2BA$bB2bBb4B$A6B2bB$bAbBb5BA$A3BbBbBbB$BA4BA2B2A$BAbAbAbAbAB!',
      description: 'Period 26 oscillator (smallest)',
    },
    'Oscillator P28 1': {
      rle: 'x = 15, y = 14, rule = FuzzyLife/3\n5b2AbAbAbAbA$2bA11B$2b3Bb3BbBA2BA$ABAbBbBbBbBA2B$b13BA$2BbBbBbB2bBAbBA$bBbBbBb4BbAB$b8BbB2AB$AB2bBbBbBbB2ABA$bA4BABA3BAB$ABbBA2BAB2ABbBA$Bb2BA8BA$b2A2BA7BA$4bAb2AbAbA!',
      description: 'Period 28 oscillator (smallest)',
    },
    'Oscillator P36 1': {
      rle: 'x = 17, y = 15, rule = FuzzyLife/3\n8bA2bA$3b2AbAbA2BA$bA7Bb2BbA$bA2BABA4BbBA$ABbBbBbB2b4BbA$2A9Bb3BA$bBb2AbBbBb3Bb2B$A8BbBb4B$2ABbBbBb5B2bBA$bA3Bb3BbBb4BA$2bAb3Bb4B2A2B$2bA2Bb3Bb2B2A2BA$4b3Bb8B$4bA10BA$6bAbA2bAbA!',
      description: 'Period 36 oscillator (smallest)',
    },
    'Oscillator P42 1': {
      rle: 'x = 11, y = 13, rule = FuzzyLife/3\n6b3A$4bA5BA$4b6B$2bA2BbB2bBA$2b8B$A2BbBbBb2BA$A2Bb6B$b4BbB2bB$AB2b6BA$b4BbB2AB$A2BbBA4BA$2bA6BA$2bAb2AbAbA!',
      description: 'Period 42 oscillator (smallest)',
    },
    'Oscillator P52 1': {
      rle: 'x = 13, y = 14, rule = FuzzyLife/3\n11b2A$3bAbAbAbAb2A$3bBA7B$bA2BbBbBb2BA$2b6Bb2B$bBbBbBb5BA$A8B2bB$b2BbBbBb4BA$bA7B2bBA$3bBbBb5BA$3bA2BbBbBbB$5b3Bb2B2A$5bA5B$7b2AbA!',
      description: 'Period 52 oscillator (smallest)',
    },
  },
  'b2-4_s0-1,5-7': {
    'Glider c/3 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\n2bA$A$b2A!',
      description: 'Glider, speed c/3 (period 6, displacement 2)',
    },
    'Glider c/3 2': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\n2bB$BA$b2B!',
      description: 'Glider, speed c/3 (period 6, displacement 2)',
    },
    'Glider c/3 3': {
      rle: 'x = 5, y = 4, rule = FuzzyLife/3\n2bA$5A$A3bA$b3A!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Glider c/6 4': {
      rle: 'x = 5, y = 4, rule = FuzzyLife/3\n2bA$bBb2A$2Ab2A$bBA!',
      description: 'Glider, speed c/6 (period 6, displacement 1)',
    },
    'Oscillator P1': {
      rle: 'x = 1, y = 1, rule = FuzzyLife/3\nB!',
      description: 'Period 1 oscillator (smallest)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 2, rule = FuzzyLife/3\n2bB$BA!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P3 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nAB$BA!',
      description: 'Period 3 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 6, y = 5, rule = FuzzyLife/3\n3bB$bBAbA$b2A2bB$B2b2A$bAB!',
      description: 'Period 4 oscillator (smallest)',
    },
    'Oscillator P22 1': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\n2bA$2BbB$4A$2bB!',
      description: 'Period 22 oscillator (smallest)',
    },
  },
  'b2-5_s2,4': {
    'Glider c/4 1': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\nb2A$4A$4A!',
      description: 'Glider, speed c/4 (period 4, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 2, rule = FuzzyLife/3\nb2A$AB!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n2bB$B2bB$bB!',
      description: 'Period 4 oscillator (smallest)',
    },
    'Oscillator P6 1': {
      rle: 'x = 5, y = 5, rule = FuzzyLife/3\n2bA$2bAB$2AB2A$bBAbB$2bAB!',
      description: 'Period 6 oscillator (smallest)',
    },
    'Oscillator P12 1': {
      rle: 'x = 7, y = 3, rule = FuzzyLife/3\n2bA3bA$3AbAbB$2bAbA2B!',
      description: 'Period 12 oscillator (smallest)',
    },
  },
  'b2-6_s0-1,5': {
    'Glider c/3 1': {
      rle: 'x = 5, y = 4, rule = FuzzyLife/3\n2bA$5A$A3bA$b3A!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Glider c/3 2': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\n2bA$A$b2A!',
      description: 'Glider, speed c/3 (period 6, displacement 2)',
    },
    'Glider c/6 3': {
      rle: 'x = 5, y = 4, rule = FuzzyLife/3\n2bA$bBb2A$2Ab2A$bBA!',
      description: 'Glider, speed c/6 (period 6, displacement 1)',
    },
    'Oscillator P1': {
      rle: 'x = 1, y = 1, rule = FuzzyLife/3\nB!',
      description: 'Period 1 oscillator (smallest)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 2, rule = FuzzyLife/3\n2bB$BA!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P3 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nAB$BA!',
      description: 'Period 3 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 6, y = 4, rule = FuzzyLife/3\n3bB$3b2AB$B2A$2bBA!',
      description: 'Period 4 oscillator (smallest)',
    },
    'Oscillator P6 1': {
      rle: 'x = 4, y = 2, rule = FuzzyLife/3\nb2B$B2bB!',
      description: 'Period 6 oscillator (smallest)',
    },
    'Oscillator P8 1': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\n2bB$B2AB$B2AB$bB!',
      description: 'Period 8 oscillator (smallest)',
    },
    'Oscillator P12 1': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\n3bB$bB$bAB$B!',
      description: 'Period 12 oscillator (smallest)',
    },
  },
  'b2-4_s0-1,4': {
    'Glider c/6 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\n2bB$BA$BAB!',
      description: 'Glider, speed c/6 (period 6, displacement 1)',
    },
    'Glider c/3 2': {
      rle: 'x = 5, y = 4, rule = FuzzyLife/3\n2bA$5A$AbBbA$b3A!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Glider c/3 3': {
      rle: 'x = 6, y = 5, rule = FuzzyLife/3\n3b2A$2bAbA$AbAB2A$AbAbA$AbAbA!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Glider c/6 4': {
      rle: 'x = 5, y = 4, rule = FuzzyLife/3\n2bA$bBb2A$2Ab2A$bBA!',
      description: 'Glider, speed c/6 (period 6, displacement 1)',
    },
    'Oscillator P1': {
      rle: 'x = 1, y = 1, rule = FuzzyLife/3\nB!',
      description: 'Period 1 oscillator (smallest)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 2, rule = FuzzyLife/3\n2bB$BA!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P3 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nAB$BA!',
      description: 'Period 3 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 6, y = 5, rule = FuzzyLife/3\n3bB$bBAbA$AbAbA$bAbAbB$BAB!',
      description: 'Period 4 oscillator (smallest)',
    },
  },
  'b2-5_s2,4-5': {
    'Glider c/2 1': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\nb2A$4A$A2BA$A2bA!',
      description: 'Glider, speed c/2 (period 2, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 2, rule = FuzzyLife/3\nb2A$AB!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\nb2A$ABAB$BABA$b2A!',
      description: 'Period 4 oscillator (smallest)',
    },
    'Oscillator P10 1': {
      rle: 'x = 6, y = 6, rule = FuzzyLife/3\n2b2B$$Bb2BbB$Bb2BbB$$2b2B!',
      description: 'Period 10 oscillator (smallest)',
    },
    'Glider c/20 1': {
      rle: 'x = 5, y = 5, rule = FuzzyLife/3\n3bA$3bA$ABAbA$ABbB$bABA!',
      description: 'Glider, speed c/20 (period 20, displacement 1)',
    },
  },
  'b1_s0,2-3': {
    'Glider c 1': {
      rle: 'x = 2, y = 4, rule = FuzzyLife/3\nbA$A$A$bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
  },
  'b2-6_s0,3-4': {
    'Glider c/3 1': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\n2bBA$A3B$2AbB$b3A!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Oscillator P1': {
      rle: 'x = 1, y = 1, rule = FuzzyLife/3\nB!',
      description: 'Period 1 oscillator (smallest)',
    },
    'Oscillator P2 1': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n2bA$A2B$A2BA!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P3 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\n2bB$bA$B!',
      description: 'Period 3 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n2bBA$A2B$b2BA!',
      description: 'Period 4 oscillator (smallest)',
    },
    'Oscillator P6 1': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\n2bA$A2BA$b2B$AbA!',
      description: 'Period 6 oscillator (smallest)',
    },
    'Oscillator P7 1': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\n2bA$bBAB$3AB$b2BA!',
      description: 'Period 7 oscillator (smallest)',
    },
    'Oscillator P24 1': {
      rle: 'x = 5, y = 5, rule = FuzzyLife/3\n3bA$bA2B$bBbAB$A3B$2b2A!',
      description: 'Period 24 oscillator (smallest)',
    },
  },
  'b2-5_s2,4-8': {
    'Glider c/20 1': {
      rle: 'x = 5, y = 5, rule = FuzzyLife/3\n3bA$2AB$A2b2A$b2AB$2bA!',
      description: 'Glider, speed c/20 (period 20, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 2, rule = FuzzyLife/3\nb2A$AB!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\nbAbB$A2B$2ABA$bBA!',
      description: 'Period 4 oscillator (smallest)',
    },
    'Oscillator P6 1': {
      rle: 'x = 5, y = 4, rule = FuzzyLife/3\n3bA$A3BA$BA2B$b2AbA!',
      description: 'Period 6 oscillator (smallest)',
    },
  },
  'b2-4_s2,4': {
    'Glider c/4 1': {
      rle: 'x = 4, y = 5, rule = FuzzyLife/3\n2bA$4A$bA$4A$2bA!',
      description: 'Glider, speed c/4 (period 4, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 2, rule = FuzzyLife/3\nb2A$AB!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n2bB$B2bB$bB!',
      description: 'Period 4 oscillator (smallest)',
    },
    'Oscillator P6 1': {
      rle: 'x = 6, y = 6, rule = FuzzyLife/3\n2b2A$bA2BA$AB2ABA$AB2ABA$bA2BA$2b2A!',
      description: 'Period 6 oscillator (smallest)',
    },
  },
  'b2-7_s3,5-7': {
    'Glider c/2 1': {
      rle: 'x = 5, y = 12, rule = FuzzyLife/3\nbAbA$2AB2A$ABABA$ABABA$ABABA$ABABA$ABABA$ABABA$ABABA$ABABA$2AB2A$bABA!',
      description: 'Glider, speed c/2 (period 2, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\n3bA$2b2B$bBbB$A2BA!',
      description: 'Period 2 oscillator (smallest)',
    },
  },
  'b1_s0,2-5': {
    'Glider c 1': {
      rle: 'x = 4, y = 2, rule = FuzzyLife/3\nb2A$A2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
  },
  'b2-4_s2,4-5': {
    'Glider c/2 1': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\nb2A$4A$A2BA$A2bA!',
      description: 'Glider, speed c/2 (period 2, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 2, rule = FuzzyLife/3\nb2A$AB!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n2bB$B2bB$bB!',
      description: 'Period 4 oscillator (smallest)',
    },
    'Oscillator P10 1': {
      rle: 'x = 6, y = 6, rule = FuzzyLife/3\n2b2B$$Bb2BbB$Bb2BbB$$2b2B!',
      description: 'Period 10 oscillator (smallest)',
    },
  },
  'b1_s0,2-6': {
    'Glider c 1': {
      rle: 'x = 2, y = 4, rule = FuzzyLife/3\nbA$A$A$bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
  },
  'b2-7_s3-4': {
    'Glider c/6 1': {
      rle: 'x = 5, y = 5, rule = FuzzyLife/3\n2bA$b3A$ABABA$b3B$bAbA!',
      description: 'Glider, speed c/6 (period 12, displacement 2)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\nbA$A2B$2A!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n2bBA$A2B$b2BA!',
      description: 'Period 4 oscillator (smallest)',
    },
    'Oscillator P6 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\nbBA$2B$ABA!',
      description: 'Period 6 oscillator (smallest)',
    },
    'Oscillator P8 1': {
      rle: 'x = 4, y = 5, rule = FuzzyLife/3\n2bA$A2BA$3bB$A2B$2bBA!',
      description: 'Period 8 oscillator (smallest)',
    },
    'Oscillator P12 1': {
      rle: 'x = 13, y = 13, rule = FuzzyLife/3\n6bA$4bA3BA$4bA3BA$3bB5AB$b5Ab5A$b2B2A3B2A2B$A2BAb3BbA2BA$b2B2A3B2A2B$b5Ab5A$3bB5AB$4bA3BA$4bA3BA$6bA!',
      description: 'Period 12 oscillator (smallest)',
    },
    'Oscillator P16 1': {
      rle: 'x = 5, y = 5, rule = FuzzyLife/3\n3bA$bA2B$bB2AB$A3B$2b2A!',
      description: 'Period 16 oscillator (smallest)',
    },
  },
  'b2-4_s2,4-6': {
    'Glider c/4 1': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\nb2A$A2BA$4A!',
      description: 'Glider, speed c/4 (period 4, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 2, rule = FuzzyLife/3\nb2A$AB!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n2bB$B2bB$bB!',
      description: 'Period 4 oscillator (smallest)',
    },
    'Oscillator P6 1': {
      rle: 'x = 5, y = 4, rule = FuzzyLife/3\n2bBbA$A3B$A4B$b3A!',
      description: 'Period 6 oscillator (smallest)',
    },
  },
  'b1_s0,2-7': {
    'Glider c 1': {
      rle: 'x = 4, y = 2, rule = FuzzyLife/3\nb2A$A2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
  },
  'b2-7_s3-4,6': {
    'Glider c/3 1': {
      rle: 'x = 5, y = 5, rule = FuzzyLife/3\n2b2A$2bBA$AB2bA$ABABA$bAB!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Glider c/3 2': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\n2bA$A3B$b2AB$b2BA!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Glider c/3 3': {
      rle: 'x = 5, y = 5, rule = FuzzyLife/3\n2bA$2AbBA$ABbAB$2b2BA$2b2A!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\nbA$A2B$2A!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n2bBA$A2B$b2BA!',
      description: 'Period 4 oscillator (smallest)',
    },
    'Oscillator P5 1': {
      rle: 'x = 6, y = 6, rule = FuzzyLife/3\n2b2A$2b2B$A4BA$A4BA$2b2B$2b2A!',
      description: 'Period 5 oscillator (smallest)',
    },
    'Oscillator P6 1': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\n2bA$A2B$b2BA$AbA!',
      description: 'Period 6 oscillator (smallest)',
    },
    'Oscillator P8 1': {
      rle: 'x = 4, y = 5, rule = FuzzyLife/3\n2bA$A2B$bBAB$A2B$2bA!',
      description: 'Period 8 oscillator (smallest)',
    },
  },
  'b2-4_s2,4-7': {
    'Glider c/4 1': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\nb2A$A2BA$4A!',
      description: 'Glider, speed c/4 (period 4, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 2, rule = FuzzyLife/3\nb2A$AB!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n2bB$B2bB$bB!',
      description: 'Period 4 oscillator (smallest)',
    },
    'Oscillator P6 1': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\n3bB$A2B$3B$bAbA!',
      description: 'Period 6 oscillator (smallest)',
    },
    'Oscillator P12 1': {
      rle: 'x = 8, y = 9, rule = FuzzyLife/3\n5bAB$3bBbB2A$4b3BA$AbAb2BbA$b6BA$A3Bb2BA$bBb4B$A6B$A2bA!',
      description: 'Period 12 oscillator (smallest)',
    },
  },
  'b1_s0,2-8': {
    'Glider c 1': {
      rle: 'x = 2, y = 4, rule = FuzzyLife/3\nbA$A$A$bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
  },
  'b1_s0,3': {
    'Glider c 1': {
      rle: 'x = 2, y = 4, rule = FuzzyLife/3\nbA$A$A$bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
  },
  'b2-6_s0-1,5-6': {
    'Glider c/6 1': {
      rle: 'x = 5, y = 4, rule = FuzzyLife/3\n2bA$bBb2A$2Ab2A$bBA!',
      description: 'Glider, speed c/6 (period 6, displacement 1)',
    },
    'Glider c/3 2': {
      rle: 'x = 5, y = 4, rule = FuzzyLife/3\n2bA$5A$A3bA$b3A!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Glider c/6 3': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\n2bB$BA$BAB!',
      description: 'Glider, speed c/6 (period 6, displacement 1)',
    },
    'Glider c/3 4': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\n2bA$A$b2A!',
      description: 'Glider, speed c/3 (period 6, displacement 2)',
    },
    'Oscillator P1': {
      rle: 'x = 1, y = 1, rule = FuzzyLife/3\nB!',
      description: 'Period 1 oscillator (smallest)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 2, rule = FuzzyLife/3\n2bB$BA!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P3 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nAB$BA!',
      description: 'Period 3 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 6, y = 6, rule = FuzzyLife/3\n3bB$bAbA$Bb2AbA$bA2bAB$bAbA$2bBA!',
      description: 'Period 4 oscillator (smallest)',
    },
    'Glider c/3 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\n2bB$BA$b2B!',
      description: 'Glider, speed c/3 (period 6, displacement 2)',
    },
    'Oscillator P12 1': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\n3bB$bB$bAB$B!',
      description: 'Period 12 oscillator (smallest)',
    },
    'Oscillator P22 1': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\n2bA$2BbB$4A$2bB!',
      description: 'Period 22 oscillator (smallest)',
    },
  },
  'b2-5_s2,8': {
    'Glider c/9 1': {
      rle: 'x = 4, y = 5, rule = FuzzyLife/3\n2bA$b2A$B2bA$2AB$b2A!',
      description: 'Glider, speed c/9 (period 9, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 2, rule = FuzzyLife/3\nb2A$AB!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P6 1': {
      rle: 'x = 6, y = 6, rule = FuzzyLife/3\n2b2A$bA2BA$AB2ABA$AB2ABA$bA2BA$2b2A!',
      description: 'Period 6 oscillator (smallest)',
    },
  },
  'b2-4_s0-1,5-8': {
    'Glider c/3 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\n2bA$A$b2A!',
      description: 'Glider, speed c/3 (period 6, displacement 2)',
    },
    'Glider c/6 2': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\nb2A$A$3A!',
      description: 'Glider, speed c/6 (period 6, displacement 1)',
    },
    'Glider c/6 3': {
      rle: 'x = 5, y = 4, rule = FuzzyLife/3\n2bA$bBb2A$2Ab2A$bBA!',
      description: 'Glider, speed c/6 (period 6, displacement 1)',
    },
    'Glider c/3 4': {
      rle: 'x = 5, y = 4, rule = FuzzyLife/3\n2bA$5A$A3bA$b3A!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Oscillator P1': {
      rle: 'x = 1, y = 1, rule = FuzzyLife/3\nB!',
      description: 'Period 1 oscillator (smallest)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 2, rule = FuzzyLife/3\n2bB$BA!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P3 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nAB$BA!',
      description: 'Period 3 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 6, y = 4, rule = FuzzyLife/3\n2bAB$3b2AB$B2A$2bBA!',
      description: 'Period 4 oscillator (smallest)',
    },
    'Oscillator P6 1': {
      rle: 'x = 4, y = 2, rule = FuzzyLife/3\nb2B$B2bB!',
      description: 'Period 6 oscillator (smallest)',
    },
    'Oscillator P12 1': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\n3bB$bB$bAB$B!',
      description: 'Period 12 oscillator (smallest)',
    },
    'Oscillator P22 1': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\n2bA$2BbB$4A$2bB!',
      description: 'Period 22 oscillator (smallest)',
    },
  },
  'b2-5_s0-1': {
    'Glider c/6 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\nb2A$A$3A!',
      description: 'Glider, speed c/6 (period 6, displacement 1)',
    },
    'Glider c/3 2': {
      rle: 'x = 4, y = 5, rule = FuzzyLife/3\n2bB$BAbA$BA$BAbA$2bB!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Glider c/6 3': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\n2bB$BA$BAB!',
      description: 'Glider, speed c/6 (period 6, displacement 1)',
    },
    'Glider c/3 4': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\n2bA$A$b2A!',
      description: 'Glider, speed c/3 (period 6, displacement 2)',
    },
    'Glider c/6 5': {
      rle: 'x = 5, y = 4, rule = FuzzyLife/3\n2bA$bBb2A$2Ab2A$bBA!',
      description: 'Glider, speed c/6 (period 6, displacement 1)',
    },
    'Oscillator P1': {
      rle: 'x = 1, y = 1, rule = FuzzyLife/3\nB!',
      description: 'Period 1 oscillator (smallest)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 2, rule = FuzzyLife/3\n2bB$BA!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P3 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nAB$BA!',
      description: 'Period 3 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\nbAbB$Bb2A$2A$BbAB!',
      description: 'Period 4 oscillator (smallest)',
    },
    'Oscillator P8 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\nbAB$BAB$BA!',
      description: 'Period 8 oscillator (smallest)',
    },
    'Oscillator P12 1': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\n3bB$bB$bAB$B!',
      description: 'Period 12 oscillator (smallest)',
    },
  },
  'b2-3_s2,4-7': {
    'Glider c/2 1': {
      rle: 'x = 14, y = 6, rule = FuzzyLife/3\n8bBbA$b2A2bAb3B$6A2Bb5B$6A2Bb5B$b2A2bAb3B$8bBbA!',
      description: 'Glider, speed c/2 (period 20, displacement 10)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 2, rule = FuzzyLife/3\nb2A$AB!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P3 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\nABA$3B$ABA!',
      description: 'Period 3 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\n3bA$b2B$b2BA$B2bA!',
      description: 'Period 4 oscillator (smallest)',
    },
    'Oscillator P6 1': {
      rle: 'x = 6, y = 6, rule = FuzzyLife/3\n2b2A$bA2BA$AB2bBA$AB2bBA$bA2BA$2b2A!',
      description: 'Period 6 oscillator (smallest)',
    },
    'Oscillator P8 1': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\nbABA$A2B$3B$A2bB!',
      description: 'Period 8 oscillator (smallest)',
    },
    'Oscillator P12 1': {
      rle: 'x = 6, y = 5, rule = FuzzyLife/3\n4bBA$b4B$6B$Ab2BbA$b4A!',
      description: 'Period 12 oscillator (smallest)',
    },
    'Oscillator P13 1': {
      rle: 'x = 6, y = 6, rule = FuzzyLife/3\n3bA$bAbAB$2b2BbA$2A4B$bBb2B$2bABbA!',
      description: 'Period 13 oscillator (smallest)',
    },
    'Oscillator P14 1': {
      rle: 'x = 5, y = 4, rule = FuzzyLife/3\n2bB$A3BA$5B$bAbA!',
      description: 'Period 14 oscillator (smallest)',
    },
    'Oscillator P50 1': {
      rle: 'x = 7, y = 9, rule = FuzzyLife/3\nb2A3bB$2Bb3B$b6B$3Bb2B$b4B$2bBb2B$A5B$Ab4BA$bABb3A!',
      description: 'Period 50 oscillator (smallest)',
    },
  },
  'b2-4_s2,8': {
    'Glider c/4 1': {
      rle: 'x = 4, y = 5, rule = FuzzyLife/3\n2bA$4A$bA$4A$2bA!',
      description: 'Glider, speed c/4 (period 4, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 2, rule = FuzzyLife/3\nb2A$AB!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\nbAB$3B$BA!',
      description: 'Period 4 oscillator (smallest)',
    },
    'Oscillator P6 1': {
      rle: 'x = 6, y = 6, rule = FuzzyLife/3\n2b2A$bA2BA$AB2ABA$AB2ABA$bA2BA$2b2A!',
      description: 'Period 6 oscillator (smallest)',
    },
  },
  'b2-6_s0-1,5-7': {
    'Glider c/3 1': {
      rle: 'x = 4, y = 5, rule = FuzzyLife/3\n2bB$BAbA$BA$BAbA$2bB!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Glider c/6 2': {
      rle: 'x = 5, y = 4, rule = FuzzyLife/3\n2bA$bBb2A$2Ab2A$bBA!',
      description: 'Glider, speed c/6 (period 6, displacement 1)',
    },
    'Glider c/6 3': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\nb2A$A$3A!',
      description: 'Glider, speed c/6 (period 6, displacement 1)',
    },
    'Oscillator P1': {
      rle: 'x = 1, y = 1, rule = FuzzyLife/3\nB!',
      description: 'Period 1 oscillator (smallest)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 2, rule = FuzzyLife/3\n2bB$BA!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P3 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nAB$BA!',
      description: 'Period 3 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 5, y = 5, rule = FuzzyLife/3\n2bAB$2bAbA$BAbA$2b2AB$2bB!',
      description: 'Period 4 oscillator (smallest)',
    },
    'Glider c/6 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\n2bB$BA$BAB!',
      description: 'Glider, speed c/6 (period 6, displacement 1)',
    },
    'Oscillator P12 1': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\n3bB$bB$bAB$B!',
      description: 'Period 12 oscillator (smallest)',
    },
  },
  'b2_s2-3': {
    'Glider c/3 1': {
      rle: 'x = 2, y = 4, rule = FuzzyLife/3\nbA$2B$2B$bA!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Glider c/3 2': {
      rle: 'x = 4, y = 2, rule = FuzzyLife/3\nb2A$A2BA!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Glider c/3 3': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\n2bB$3A$3A$2bB!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 2, rule = FuzzyLife/3\nb2A$AB!',
      description: 'Period 2 oscillator (smallest)',
    },
  },
  'b2-4_s0-1,6': {
    'Glider c/3 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\n2bB$BA$b2B!',
      description: 'Glider, speed c/3 (period 6, displacement 2)',
    },
    'Glider c/3 2': {
      rle: 'x = 4, y = 5, rule = FuzzyLife/3\n2bB$BAbA$BA$BAbA$2bB!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Glider c/6 3': {
      rle: 'x = 5, y = 4, rule = FuzzyLife/3\n2bA$bBb2A$2Ab2A$bBA!',
      description: 'Glider, speed c/6 (period 6, displacement 1)',
    },
    'Glider c/6 4': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\nb2A$A$3A!',
      description: 'Glider, speed c/6 (period 6, displacement 1)',
    },
    'Oscillator P1': {
      rle: 'x = 1, y = 1, rule = FuzzyLife/3\nB!',
      description: 'Period 1 oscillator (smallest)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 2, rule = FuzzyLife/3\n2bB$BA!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P3 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nAB$BA!',
      description: 'Period 3 oscillator (smallest)',
    },
    'Glider c/6 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\n2bB$BA$BAB!',
      description: 'Glider, speed c/6 (period 6, displacement 1)',
    },
    'Oscillator P8 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\nbAB$BAB$BA!',
      description: 'Period 8 oscillator (smallest)',
    },
    'Oscillator P12 1': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\n3bB$bB$bAB$B!',
      description: 'Period 12 oscillator (smallest)',
    },
  },
  'b2-6_s0-1,5-8': {
    'Glider c/3 1': {
      rle: 'x = 5, y = 4, rule = FuzzyLife/3\n2bA$5A$A3bA$b3A!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Glider c/6 2': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\n2bB$BA$BAB!',
      description: 'Glider, speed c/6 (period 6, displacement 1)',
    },
    'Oscillator P1': {
      rle: 'x = 1, y = 1, rule = FuzzyLife/3\nB!',
      description: 'Period 1 oscillator (smallest)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 2, rule = FuzzyLife/3\n2bB$BA!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P3 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nAB$BA!',
      description: 'Period 3 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 6, y = 4, rule = FuzzyLife/3\n3bBA$b2A2bB$B2b2A$bAB!',
      description: 'Period 4 oscillator (smallest)',
    },
    'Oscillator P22 1': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\n2bA$2BbB$4A$2bB!',
      description: 'Period 22 oscillator (smallest)',
    },
  },
  'b2-5_s0-1,4': {
    'Glider c/6 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\n2bB$BA$BAB!',
      description: 'Glider, speed c/6 (period 6, displacement 1)',
    },
    'Glider c/3 2': {
      rle: 'x = 5, y = 3, rule = FuzzyLife/3\nbAbA$B3bB$b3A!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Glider c/6 3': {
      rle: 'x = 5, y = 4, rule = FuzzyLife/3\n2bA$bBb2A$2Ab2A$bBA!',
      description: 'Glider, speed c/6 (period 6, displacement 1)',
    },
    'Glider c/6 4': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\nb2A$A$3A!',
      description: 'Glider, speed c/6 (period 6, displacement 1)',
    },
    'Oscillator P1': {
      rle: 'x = 1, y = 1, rule = FuzzyLife/3\nB!',
      description: 'Period 1 oscillator (smallest)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 2, rule = FuzzyLife/3\n2bB$BA!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P3 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nAB$BA!',
      description: 'Period 3 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 3, y = 6, rule = FuzzyLife/3\n2bB$B2A$A$A$B2A$2bB!',
      description: 'Period 4 oscillator (smallest)',
    },
    'Oscillator P8 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\nbAB$BAB$BA!',
      description: 'Period 8 oscillator (smallest)',
    },
    'Oscillator P12 1': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\n3bB$bB$bAB$B!',
      description: 'Period 12 oscillator (smallest)',
    },
  },
  'b2_s2-3,5': {
    'Glider c/3 1': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\nb2A$A2BA$A2BA!',
      description: 'Glider, speed c/3 (period 6, displacement 2)',
    },
    'Glider c/3 2': {
      rle: 'x = 2, y = 4, rule = FuzzyLife/3\nbA$2B$2B$bA!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Glider c/3 3': {
      rle: 'x = 4, y = 2, rule = FuzzyLife/3\nb2A$A2BA!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Glider c/3 4': {
      rle: 'x = 4, y = 2, rule = FuzzyLife/3\nb2A$B2AB!',
      description: 'Glider, speed c/3 (period 6, displacement 2)',
    },
    'Glider c/3 5': {
      rle: 'x = 4, y = 6, rule = FuzzyLife/3\n2bA$BAB$2AbA$2AbA$BAB$2bA!',
      description: 'Glider, speed c/3 (period 6, displacement 2)',
    },
    'Glider c/3 6': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\nA2BA$4B$B2AB!',
      description: 'Glider, speed c/3 (period 6, displacement 2)',
    },
    'Glider c/3 7': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\nA2bA$$b2B$A2BA!',
      description: 'Glider, speed c/3 (period 6, displacement 2)',
    },
    'Glider c/3 8': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\n2bB$3A$3A$2bB!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 2, rule = FuzzyLife/3\nb2A$AB!',
      description: 'Period 2 oscillator (smallest)',
    },
  },
  'b2-5_s1': {
    'Glider c/3 1': {
      rle: 'x = 4, y = 5, rule = FuzzyLife/3\n2bB$BAbA$BA$BAbA$2bB!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Glider c/3 2': {
      rle: 'x = 5, y = 4, rule = FuzzyLife/3\n2bA$5A$A3bA$b3A!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 1, y = 2, rule = FuzzyLife/3\nA$B!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P6 1': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\n3bB$3bA$BA$bA!',
      description: 'Period 6 oscillator (smallest)',
    },
    'Oscillator P8 1': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\n2bB$B2AB$B2AB$bB!',
      description: 'Period 8 oscillator (smallest)',
    },
  },
  'b2_s0-1': {
    'Glider c/3 1': {
      rle: 'x = 7, y = 3, rule = FuzzyLife/3\n5b2B$2AbBbA$4bB!',
      description: 'Glider, speed c/3 (period 6, displacement 2)',
    },
    'Glider c/3 2': {
      rle: 'x = 6, y = 2, rule = FuzzyLife/3\n3bAbA$3B2A!',
      description: 'Glider, speed c/3 (period 6, displacement 2)',
    },
    'Glider c/3 3': {
      rle: 'x = 5, y = 3, rule = FuzzyLife/3\nb2AbA$BbBAB$AbAbA!',
      description: 'Glider, speed c/3 (period 6, displacement 2)',
    },
    'Glider c/3 4': {
      rle: 'x = 6, y = 3, rule = FuzzyLife/3\nbAb3A$AbBA2B$A2b3A!',
      description: 'Glider, speed c/3 (period 6, displacement 2)',
    },
    'Oscillator P1': {
      rle: 'x = 1, y = 1, rule = FuzzyLife/3\nB!',
      description: 'Period 1 oscillator (smallest)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\n2bB$bA$B!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P3 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nAB$BA!',
      description: 'Period 3 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\n3bB$bBA$BA$2bB!',
      description: 'Period 4 oscillator (smallest)',
    },
  },
  'b2-6_s0-1,6': {
    'Glider c/3 1': {
      rle: 'x = 5, y = 5, rule = FuzzyLife/3\n2bAB$2AbAB$2AbA$2AbAB$2bAB!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Glider c/3 2': {
      rle: 'x = 4, y = 5, rule = FuzzyLife/3\n2bB$BAbA$BA$BAbA$2bB!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Oscillator P1': {
      rle: 'x = 1, y = 1, rule = FuzzyLife/3\nB!',
      description: 'Period 1 oscillator (smallest)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 2, rule = FuzzyLife/3\n2bB$BA!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P3 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nAB$BA!',
      description: 'Period 3 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 5, y = 4, rule = FuzzyLife/3\n4bB$b2A$BbB$bA!',
      description: 'Period 4 oscillator (smallest)',
    },
    'Glider c/6 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\n2bB$BA$BAB!',
      description: 'Glider, speed c/6 (period 6, displacement 1)',
    },
    'Oscillator P8 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\nbAB$BAB$BA!',
      description: 'Period 8 oscillator (smallest)',
    },
    'Oscillator P12 1': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\n3bB$bB$bAB$B!',
      description: 'Period 12 oscillator (smallest)',
    },
  },
  'b2-8_s0-1': {
    'Glider c/6 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\nb2A$A$3A!',
      description: 'Glider, speed c/6 (period 6, displacement 1)',
    },
    'Glider c/6 2': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\n2bB$BA$BAB!',
      description: 'Glider, speed c/6 (period 6, displacement 1)',
    },
    'Glider c/3 3': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\n2bB$BA$b2B!',
      description: 'Glider, speed c/3 (period 6, displacement 2)',
    },
    'Glider c/6 4': {
      rle: 'x = 5, y = 4, rule = FuzzyLife/3\n2bA$bBb2A$2Ab2A$bBA!',
      description: 'Glider, speed c/6 (period 6, displacement 1)',
    },
    'Glider c/3 5': {
      rle: 'x = 4, y = 5, rule = FuzzyLife/3\n2bB$BAbA$BA$BAbA$2bB!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Glider c/3 6': {
      rle: 'x = 5, y = 4, rule = FuzzyLife/3\n2bA$5A$A3bA$b3A!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Oscillator P1': {
      rle: 'x = 1, y = 1, rule = FuzzyLife/3\nB!',
      description: 'Period 1 oscillator (smallest)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 2, rule = FuzzyLife/3\n2bB$BA!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P3 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nAB$BA!',
      description: 'Period 3 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 4, y = 5, rule = FuzzyLife/3\n2bAB$BA$2b2A$2AbB$BbA!',
      description: 'Period 4 oscillator (smallest)',
    },
    'Oscillator P8 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\nbAB$BAB$BA!',
      description: 'Period 8 oscillator (smallest)',
    },
    'Oscillator P12 1': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\n3bB$bB$bAB$B!',
      description: 'Period 12 oscillator (smallest)',
    },
  },
  'b2-3_s3-4,6': {
    'Glider c/5 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\nbB$3B$BbB!',
      description: 'Glider, speed c/5 (period 5, displacement 1)',
    },
    'Glider c/5 2': {
      rle: 'x = 5, y = 4, rule = FuzzyLife/3\n2bA$A3BA$bBbB$bBbB!',
      description: 'Glider, speed c/5 (period 5, displacement 1)',
    },
    'Glider c/5 3': {
      rle: 'x = 5, y = 4, rule = FuzzyLife/3\n2bA$2bB$A3BA$2Ab2A!',
      description: 'Glider, speed c/5 (period 5, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\nbA$A2B$2A!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\n2bA$b2BA$A2B$bAbA!',
      description: 'Period 4 oscillator (smallest)',
    },
    'Oscillator P5 1': {
      rle: 'x = 6, y = 6, rule = FuzzyLife/3\n2b2A$2b2B$A4BA$A4BA$2b2B$2b2A!',
      description: 'Period 5 oscillator (smallest)',
    },
    'Oscillator P6 1': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\n2bA$A2BA$b2B$AbA!',
      description: 'Period 6 oscillator (smallest)',
    },
  },
  'b2-4_s0-1,6-7': {
    'Glider c/6 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\nb2A$A$3A!',
      description: 'Glider, speed c/6 (period 6, displacement 1)',
    },
    'Glider c/3 2': {
      rle: 'x = 5, y = 4, rule = FuzzyLife/3\n2bA$5A$A3bA$b3A!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Glider c/6 3': {
      rle: 'x = 5, y = 4, rule = FuzzyLife/3\n2bA$bBb2A$2Ab2A$bBA!',
      description: 'Glider, speed c/6 (period 6, displacement 1)',
    },
    'Glider c/6 4': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\n2bB$BA$BAB!',
      description: 'Glider, speed c/6 (period 6, displacement 1)',
    },
    'Oscillator P1': {
      rle: 'x = 1, y = 1, rule = FuzzyLife/3\nB!',
      description: 'Period 1 oscillator (smallest)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 2, rule = FuzzyLife/3\n2bB$BA!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P3 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nAB$BA!',
      description: 'Period 3 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\nbAbB$Bb2A$2A$BbAB!',
      description: 'Period 4 oscillator (smallest)',
    },
    'Glider c/3 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\n2bB$BA$b2B!',
      description: 'Glider, speed c/3 (period 6, displacement 2)',
    },
    'Oscillator P8 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\nbAB$BAB$BA!',
      description: 'Period 8 oscillator (smallest)',
    },
    'Oscillator P12 1': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\n3bB$bB$bAB$B!',
      description: 'Period 12 oscillator (smallest)',
    },
  },
  'b2_s2-3,5-6': {
    'Glider c/3 1': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\nb2A$A2BA$A2BA!',
      description: 'Glider, speed c/3 (period 6, displacement 2)',
    },
    'Glider c/3 2': {
      rle: 'x = 2, y = 4, rule = FuzzyLife/3\nbA$2B$2B$bA!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Glider c/3 3': {
      rle: 'x = 4, y = 2, rule = FuzzyLife/3\nb2A$A2BA!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Glider c/3 4': {
      rle: 'x = 4, y = 2, rule = FuzzyLife/3\nb2A$B2AB!',
      description: 'Glider, speed c/3 (period 6, displacement 2)',
    },
    'Glider c/3 5': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\nA2BA$4B$B2AB!',
      description: 'Glider, speed c/3 (period 6, displacement 2)',
    },
    'Glider c/3 6': {
      rle: 'x = 4, y = 6, rule = FuzzyLife/3\n2bA$BAB$2AbA$2AbA$BAB$2bA!',
      description: 'Glider, speed c/3 (period 6, displacement 2)',
    },
    'Glider c/3 7': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\n2bB$3A$3A$2bB!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Glider c/3 8': {
      rle: 'x = 5, y = 4, rule = FuzzyLife/3\nbAbBA$AB$AB$bAbBA!',
      description: 'Glider, speed c/3 (period 6, displacement 2)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 2, rule = FuzzyLife/3\nb2A$AB!',
      description: 'Period 2 oscillator (smallest)',
    },
  },
  'b2-6_s0-1,6-7': {
    'Glider c/3 1': {
      rle: 'x = 5, y = 4, rule = FuzzyLife/3\n2bA$5A$A3bA$b3A!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Glider c/6 2': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\nb2A$A$3A!',
      description: 'Glider, speed c/6 (period 6, displacement 1)',
    },
    'Glider c/3 3': {
      rle: 'x = 4, y = 5, rule = FuzzyLife/3\n2bB$BAbA$BA$BAbA$2bB!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Oscillator P1': {
      rle: 'x = 1, y = 1, rule = FuzzyLife/3\nB!',
      description: 'Period 1 oscillator (smallest)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 2, rule = FuzzyLife/3\n2bB$BA!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P3 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nAB$BA!',
      description: 'Period 3 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 4, y = 5, rule = FuzzyLife/3\nBbAB$2AbA$B$2AbA$BbAB!',
      description: 'Period 4 oscillator (smallest)',
    },
    'Glider c/6 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\n2bB$BA$BAB!',
      description: 'Glider, speed c/6 (period 6, displacement 1)',
    },
    'Oscillator P12 1': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\n3bB$bB$bAB$B!',
      description: 'Period 12 oscillator (smallest)',
    },
  },
  'b2-5_s0-1,5': {
    'Glider c/3 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\n2bA$A$b2A!',
      description: 'Glider, speed c/3 (period 6, displacement 2)',
    },
    'Glider c/6 2': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\nb2A$A$3A!',
      description: 'Glider, speed c/6 (period 6, displacement 1)',
    },
    'Oscillator P1': {
      rle: 'x = 1, y = 1, rule = FuzzyLife/3\nB!',
      description: 'Period 1 oscillator (smallest)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 2, rule = FuzzyLife/3\n2bB$BA!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P3 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nAB$BA!',
      description: 'Period 3 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 4, y = 7, rule = FuzzyLife/3\n2bB$bAbA$Bb2A$2A$Bb2A$2AbB$BbA!',
      description: 'Period 4 oscillator (smallest)',
    },
    'Glider c/6 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\n2bB$BA$BAB!',
      description: 'Glider, speed c/6 (period 6, displacement 1)',
    },
    'Oscillator P12 1': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\n3bB$bB$bAB$B!',
      description: 'Period 12 oscillator (smallest)',
    },
  },
  'b2-8_s0-1,4': {
    'Glider c/6 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\n2bB$BA$BAB!',
      description: 'Glider, speed c/6 (period 6, displacement 1)',
    },
    'Oscillator P1': {
      rle: 'x = 1, y = 1, rule = FuzzyLife/3\nB!',
      description: 'Period 1 oscillator (smallest)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 2, rule = FuzzyLife/3\n2bB$BA!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P3 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nAB$BA!',
      description: 'Period 3 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 5, y = 4, rule = FuzzyLife/3\n4bB$b2A$BbB$bA!',
      description: 'Period 4 oscillator (smallest)',
    },
    'Oscillator P8 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\nbAB$BAB$BA!',
      description: 'Period 8 oscillator (smallest)',
    },
    'Oscillator P12 1': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\n3bB$bB$bAB$B!',
      description: 'Period 12 oscillator (smallest)',
    },
  },
  'b2_s2-3,5-7': {
    'Glider c/3 1': {
      rle: 'x = 2, y = 4, rule = FuzzyLife/3\nbA$2B$2B$bA!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Glider c/3 2': {
      rle: 'x = 4, y = 2, rule = FuzzyLife/3\nb2A$A2BA!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Glider c/3 3': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\n2bB$3A$3A$2bB!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 2, rule = FuzzyLife/3\nb2A$AB!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P30 1': {
      rle: 'x = 5, y = 6, rule = FuzzyLife/3\n3b2A$bBbB$AbBbB$Ab3B$b2BAB$3bBA!',
      description: 'Period 30 oscillator (smallest)',
    },
  },
  'b2-4_s0-1,6-8': {
    'Glider c/6 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\n2bB$BA$BAB!',
      description: 'Glider, speed c/6 (period 6, displacement 1)',
    },
    'Glider c/3 2': {
      rle: 'x = 5, y = 4, rule = FuzzyLife/3\n2bA$5A$A3bA$b3A!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Glider c/3 3': {
      rle: 'x = 4, y = 5, rule = FuzzyLife/3\n2bB$BAbA$BA$BAbA$2bB!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Glider c/3 4': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\n2bA$A$b2A!',
      description: 'Glider, speed c/3 (period 6, displacement 2)',
    },
    'Oscillator P1': {
      rle: 'x = 1, y = 1, rule = FuzzyLife/3\nB!',
      description: 'Period 1 oscillator (smallest)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 2, rule = FuzzyLife/3\n2bB$BA!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P3 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nAB$BA!',
      description: 'Period 3 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\nbAbB$Bb2A$2A$BbAB!',
      description: 'Period 4 oscillator (smallest)',
    },
    'Oscillator P8 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\nbAB$BAB$BA!',
      description: 'Period 8 oscillator (smallest)',
    },
    'Oscillator P12 1': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\n3bB$bB$bAB$B!',
      description: 'Period 12 oscillator (smallest)',
    },
  },
  'b2-6_s0-1,6-8': {
    'Glider c/3 1': {
      rle: 'x = 4, y = 5, rule = FuzzyLife/3\n2bB$BAbA$BA$BAbA$2bB!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Glider c/3 2': {
      rle: 'x = 5, y = 6, rule = FuzzyLife/3\n2bA$5A$$5A$$5A!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Glider c/6 3': {
      rle: 'x = 5, y = 4, rule = FuzzyLife/3\n2bA$bBb2A$2Ab2A$bBA!',
      description: 'Glider, speed c/6 (period 6, displacement 1)',
    },
    'Oscillator P1': {
      rle: 'x = 1, y = 1, rule = FuzzyLife/3\nB!',
      description: 'Period 1 oscillator (smallest)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 2, rule = FuzzyLife/3\n2bB$BA!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P3 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nAB$BA!',
      description: 'Period 3 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 7, y = 5, rule = FuzzyLife/3\n5bB$2bBAbA$BAbABAB$2bBAbA$5bB!',
      description: 'Period 4 oscillator (smallest)',
    },
    'Oscillator P6 1': {
      rle: 'x = 4, y = 2, rule = FuzzyLife/3\nb2B$B2bB!',
      description: 'Period 6 oscillator (smallest)',
    },
    'Oscillator P8 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\nbAB$BAB$BA!',
      description: 'Period 8 oscillator (smallest)',
    },
    'Oscillator P12 1': {
      rle: 'x = 7, y = 5, rule = FuzzyLife/3\n6bB$B$2bB$bBA$3bB!',
      description: 'Period 12 oscillator (smallest)',
    },
  },
  'b2-5_s0-1,5-6': {
    'Glider c/6 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\nb2A$A$3A!',
      description: 'Glider, speed c/6 (period 6, displacement 1)',
    },
    'Glider c/3 2': {
      rle: 'x = 5, y = 4, rule = FuzzyLife/3\n2bA$5A$A3bA$b3A!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Oscillator P1': {
      rle: 'x = 1, y = 1, rule = FuzzyLife/3\nB!',
      description: 'Period 1 oscillator (smallest)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 2, rule = FuzzyLife/3\n2bB$BA!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P3 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nAB$BA!',
      description: 'Period 3 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 5, y = 4, rule = FuzzyLife/3\n3bAB$BABbA$2b2A$3bB!',
      description: 'Period 4 oscillator (smallest)',
    },
    'Oscillator P6 1': {
      rle: 'x = 2, y = 4, rule = FuzzyLife/3\nbB$B$B$bB!',
      description: 'Period 6 oscillator (smallest)',
    },
  },
  'b1_s0,3-4': {
    'Glider c 1': {
      rle: 'x = 4, y = 2, rule = FuzzyLife/3\nb2A$A2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
  },
  'b2-5_s0-1,5-7': {
    'Glider c/6 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\n2bB$BA$BAB!',
      description: 'Glider, speed c/6 (period 6, displacement 1)',
    },
    'Glider c/6 2': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\nb2A$A$3A!',
      description: 'Glider, speed c/6 (period 6, displacement 1)',
    },
    'Glider c/6 3': {
      rle: 'x = 5, y = 4, rule = FuzzyLife/3\n2bA$bBb2A$2Ab2A$bBA!',
      description: 'Glider, speed c/6 (period 6, displacement 1)',
    },
    'Oscillator P1': {
      rle: 'x = 1, y = 1, rule = FuzzyLife/3\nB!',
      description: 'Period 1 oscillator (smallest)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 2, rule = FuzzyLife/3\n2bB$BA!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P3 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nAB$BA!',
      description: 'Period 3 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 5, y = 4, rule = FuzzyLife/3\n4bB$b2A$BbB$bA!',
      description: 'Period 4 oscillator (smallest)',
    },
    'Oscillator P12 1': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\n3bB$bB$bAB$B!',
      description: 'Period 12 oscillator (smallest)',
    },
    'Oscillator P22 1': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\n2bA$2BbB$4A$2bB!',
      description: 'Period 22 oscillator (smallest)',
    },
  },
  'b2_s2-3,5-8': {
    'Glider c/3 1': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\n2bB$3A$3A$2bB!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Glider c/3 2': {
      rle: 'x = 2, y = 4, rule = FuzzyLife/3\nbA$2B$2B$bA!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Glider c/3 3': {
      rle: 'x = 4, y = 2, rule = FuzzyLife/3\nb2A$A2BA!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 2, rule = FuzzyLife/3\nb2A$AB!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P9 1': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\nA2BA$4B$4B$A2BA!',
      description: 'Period 9 oscillator (smallest)',
    },
    'Oscillator P30 1': {
      rle: 'x = 5, y = 6, rule = FuzzyLife/3\n3b2A$bBbB$AbBbB$Ab3B$b2BAB$3bBA!',
      description: 'Period 30 oscillator (smallest)',
    },
  },
  'b2-6_s0-1,7': {
    'Glider c/6 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\n2bB$BA$BAB!',
      description: 'Glider, speed c/6 (period 6, displacement 1)',
    },
    'Glider c/6 2': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\nb2A$A$3A!',
      description: 'Glider, speed c/6 (period 6, displacement 1)',
    },
    'Glider c/3 3': {
      rle: 'x = 4, y = 5, rule = FuzzyLife/3\n2bB$BAbA$BA$BAbA$2bB!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Glider c/3 4': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\n2bA$A$b2A!',
      description: 'Glider, speed c/3 (period 6, displacement 2)',
    },
    'Oscillator P1': {
      rle: 'x = 1, y = 1, rule = FuzzyLife/3\nB!',
      description: 'Period 1 oscillator (smallest)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 2, rule = FuzzyLife/3\n2bB$BA!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P3 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nAB$BA!',
      description: 'Period 3 oscillator (smallest)',
    },
  },
  'b2-8_s0-1,5': {
    'Glider c/3 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\n2bA$A$b2A!',
      description: 'Glider, speed c/3 (period 6, displacement 2)',
    },
    'Glider c/3 2': {
      rle: 'x = 7, y = 6, rule = FuzzyLife/3\n5bB$2A4bB$2ABAbA$2AbAbAB$2AbAbA$2b3A!',
      description: 'Glider, speed c/3 (period 6, displacement 2)',
    },
    'Glider c/6 3': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\n2bB$BA$BAB!',
      description: 'Glider, speed c/6 (period 6, displacement 1)',
    },
    'Glider c/6 4': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\nb2A$A$3A!',
      description: 'Glider, speed c/6 (period 6, displacement 1)',
    },
    'Glider c/3 5': {
      rle: 'x = 6, y = 5, rule = FuzzyLife/3\n4bA$BA2b2A$BAbA$BABAbA$BABAB!',
      description: 'Glider, speed c/3 (period 6, displacement 2)',
    },
    'Glider c/3 6': {
      rle: 'x = 5, y = 5, rule = FuzzyLife/3\n2bAB$2AbAB$2AbA$2AbAB$2bAB!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Glider c/6 7': {
      rle: 'x = 5, y = 4, rule = FuzzyLife/3\n2bA$bBb2A$2Ab2A$bBA!',
      description: 'Glider, speed c/6 (period 6, displacement 1)',
    },
    'Oscillator P1': {
      rle: 'x = 1, y = 1, rule = FuzzyLife/3\nB!',
      description: 'Period 1 oscillator (smallest)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 2, rule = FuzzyLife/3\n2bB$BA!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P3 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nAB$BA!',
      description: 'Period 3 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\nBbAB$2bA$2AbA$BbAB!',
      description: 'Period 4 oscillator (smallest)',
    },
    'Oscillator P22 1': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\n2bA$2BbB$4A$2bB!',
      description: 'Period 22 oscillator (smallest)',
    },
  },
  'b2-4_s0-1,7': {
    'Glider c/6 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\n2bB$BA$BAB!',
      description: 'Glider, speed c/6 (period 6, displacement 1)',
    },
    'Glider c/6 2': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\nb2A$A$3A!',
      description: 'Glider, speed c/6 (period 6, displacement 1)',
    },
    'Glider c/6 3': {
      rle: 'x = 5, y = 4, rule = FuzzyLife/3\n2bA$bBb2A$2Ab2A$bBA!',
      description: 'Glider, speed c/6 (period 6, displacement 1)',
    },
    'Glider c/3 4': {
      rle: 'x = 4, y = 5, rule = FuzzyLife/3\n2bB$BAbA$BA$BAbA$2bB!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Glider c/3 5': {
      rle: 'x = 5, y = 5, rule = FuzzyLife/3\n2bAB$2AbAB$2AbA$2AbAB$2bAB!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Oscillator P1': {
      rle: 'x = 1, y = 1, rule = FuzzyLife/3\nB!',
      description: 'Period 1 oscillator (smallest)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 2, rule = FuzzyLife/3\n2bB$BA!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P3 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nAB$BA!',
      description: 'Period 3 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 5, y = 5, rule = FuzzyLife/3\n2bAB$2bAbA$BAbAB$2bA$2bB!',
      description: 'Period 4 oscillator (smallest)',
    },
    'Glider c/3 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\n2bB$BA$b2B!',
      description: 'Glider, speed c/3 (period 6, displacement 2)',
    },
    'Oscillator P8 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\nbAB$BAB$BA!',
      description: 'Period 8 oscillator (smallest)',
    },
    'Oscillator P12 1': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\n3bB$bB$bAB$B!',
      description: 'Period 12 oscillator (smallest)',
    },
  },
  'b2-5_s0-1,5-8': {
    'Glider c/6 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\nb2A$A$3A!',
      description: 'Glider, speed c/6 (period 6, displacement 1)',
    },
    'Glider c/3 2': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\n2bA$A$b2A!',
      description: 'Glider, speed c/3 (period 6, displacement 2)',
    },
    'Glider c/6 3': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\n2bB$BA$BAB!',
      description: 'Glider, speed c/6 (period 6, displacement 1)',
    },
    'Oscillator P1': {
      rle: 'x = 1, y = 1, rule = FuzzyLife/3\nB!',
      description: 'Period 1 oscillator (smallest)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 2, rule = FuzzyLife/3\n2bB$BA!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P3 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nAB$BA!',
      description: 'Period 3 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 6, y = 4, rule = FuzzyLife/3\n2bAB$3b2AB$B2A$2bBA!',
      description: 'Period 4 oscillator (smallest)',
    },
    'Oscillator P8 1': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\n2bB$B2AB$B2AB$bB!',
      description: 'Period 8 oscillator (smallest)',
    },
  },
  'b2-6_s0-1,7-8': {
    'Glider c/6 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\n2bB$BA$BAB!',
      description: 'Glider, speed c/6 (period 6, displacement 1)',
    },
    'Glider c/3 2': {
      rle: 'x = 4, y = 5, rule = FuzzyLife/3\n2bB$BAbA$BA$BAbA$2bB!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Glider c/3 3': {
      rle: 'x = 5, y = 4, rule = FuzzyLife/3\n2bA$5A$A3bA$b3A!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Oscillator P1': {
      rle: 'x = 1, y = 1, rule = FuzzyLife/3\nB!',
      description: 'Period 1 oscillator (smallest)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 2, rule = FuzzyLife/3\n2bB$BA!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P3 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nAB$BA!',
      description: 'Period 3 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 5, y = 4, rule = FuzzyLife/3\n3bAB$bBA$A2b2A$bBAbB!',
      description: 'Period 4 oscillator (smallest)',
    },
    'Oscillator P8 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\nbAB$BAB$BA!',
      description: 'Period 8 oscillator (smallest)',
    },
    'Oscillator P12 1': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\n3bB$bB$bAB$B!',
      description: 'Period 12 oscillator (smallest)',
    },
    'Oscillator P18 1': {
      rle: 'x = 6, y = 6, rule = FuzzyLife/3\n4bB$3BAB$bA2bB$bB2bA$bBA3B$bB!',
      description: 'Period 18 oscillator (smallest)',
    },
  },
  'b2-8_s0-1,5-6': {
    'Glider c/3 1': {
      rle: 'x = 5, y = 4, rule = FuzzyLife/3\n2bA$5A$A3bA$b3A!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Glider c/6 2': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\nb2A$A$3A!',
      description: 'Glider, speed c/6 (period 6, displacement 1)',
    },
    'Glider c/6 3': {
      rle: 'x = 5, y = 4, rule = FuzzyLife/3\n2bA$bBb2A$2Ab2A$bBA!',
      description: 'Glider, speed c/6 (period 6, displacement 1)',
    },
    'Glider c/6 4': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\n2bB$BA$BAB!',
      description: 'Glider, speed c/6 (period 6, displacement 1)',
    },
    'Oscillator P1': {
      rle: 'x = 1, y = 1, rule = FuzzyLife/3\nB!',
      description: 'Period 1 oscillator (smallest)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 2, rule = FuzzyLife/3\n2bB$BA!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P3 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nAB$BA!',
      description: 'Period 3 oscillator (smallest)',
    },
    'Oscillator P12 1': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\n3bB$bB$bAB$B!',
      description: 'Period 12 oscillator (smallest)',
    },
    'Oscillator P22 1': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\n2bA$2BbB$4A$2bB!',
      description: 'Period 22 oscillator (smallest)',
    },
  },
  'b2_s2-3,6': {
    'Glider c/3 1': {
      rle: 'x = 4, y = 2, rule = FuzzyLife/3\nb2A$A2BA!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Glider c/3 2': {
      rle: 'x = 2, y = 4, rule = FuzzyLife/3\nbA$2B$2B$bA!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Glider c/3 3': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\n2bB$3A$3A$2bB!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 2, rule = FuzzyLife/3\nb2A$AB!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P3 1': {
      rle: 'x = 6, y = 3, rule = FuzzyLife/3\nbB2bB$2B2A2B$bB2bB!',
      description: 'Period 3 oscillator (smallest)',
    },
  },
  'b2-5_s0-1,6': {
    'Glider c/3 1': {
      rle: 'x = 4, y = 5, rule = FuzzyLife/3\n2bB$BAbA$BA$BAbA$2bB!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Glider c/6 2': {
      rle: 'x = 5, y = 4, rule = FuzzyLife/3\n2bA$bBb2A$2Ab2A$bBA!',
      description: 'Glider, speed c/6 (period 6, displacement 1)',
    },
    'Glider c/6 3': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\nb2A$A$3A!',
      description: 'Glider, speed c/6 (period 6, displacement 1)',
    },
    'Glider c/3 4': {
      rle: 'x = 7, y = 6, rule = FuzzyLife/3\n2bAbA$3AB3A$3bA$3Ab3A$$7A!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Oscillator P1': {
      rle: 'x = 1, y = 1, rule = FuzzyLife/3\nB!',
      description: 'Period 1 oscillator (smallest)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 2, rule = FuzzyLife/3\n2bB$BA!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P3 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nAB$BA!',
      description: 'Period 3 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 4, y = 5, rule = FuzzyLife/3\nBbAB$2AbA$B$2AbA$BbAB!',
      description: 'Period 4 oscillator (smallest)',
    },
    'Glider c/6 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\n2bB$BA$BAB!',
      description: 'Glider, speed c/6 (period 6, displacement 1)',
    },
    'Oscillator P12 1': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\n3bB$bB$bAB$B!',
      description: 'Period 12 oscillator (smallest)',
    },
  },
  'b2-4_s0-1,7-8': {
    'Glider c/6 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\nb2A$A$3A!',
      description: 'Glider, speed c/6 (period 6, displacement 1)',
    },
    'Glider c/6 2': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\n2bB$BA$BAB!',
      description: 'Glider, speed c/6 (period 6, displacement 1)',
    },
    'Glider c/8 1': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\n3bB$3bB$$2BbB!',
      description: 'Glider, speed c/8 (period 8, displacement 1)',
    },
    'Oscillator P1': {
      rle: 'x = 1, y = 1, rule = FuzzyLife/3\nB!',
      description: 'Period 1 oscillator (smallest)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 2, rule = FuzzyLife/3\n2bB$BA!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P3 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nAB$BA!',
      description: 'Period 3 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 8, y = 6, rule = FuzzyLife/3\n5bB$5bA$bBABAb2A$AbABA2bB$BbAbAbA$b2AbAB!',
      description: 'Period 4 oscillator (smallest)',
    },
    'Oscillator P12 1': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\n3bB$bB$bAB$B!',
      description: 'Period 12 oscillator (smallest)',
    },
  },
  'b2-8_s0-1,5-7': {
    'Glider c/3 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\n2bB$BA$b2B!',
      description: 'Glider, speed c/3 (period 6, displacement 2)',
    },
    'Glider c/6 2': {
      rle: 'x = 5, y = 4, rule = FuzzyLife/3\n2bA$bBb2A$2Ab2A$bBA!',
      description: 'Glider, speed c/6 (period 6, displacement 1)',
    },
    'Glider c/3 3': {
      rle: 'x = 5, y = 4, rule = FuzzyLife/3\n2bA$5A$A3bA$b3A!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Glider c/6 4': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\nb2A$A$3A!',
      description: 'Glider, speed c/6 (period 6, displacement 1)',
    },
    'Oscillator P1': {
      rle: 'x = 1, y = 1, rule = FuzzyLife/3\nB!',
      description: 'Period 1 oscillator (smallest)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 2, rule = FuzzyLife/3\n2bB$BA!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P3 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nAB$BA!',
      description: 'Period 3 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 7, y = 6, rule = FuzzyLife/3\n6bB$B3bB2A$4bA$4bA$4bB2A$B5bB!',
      description: 'Period 4 oscillator (smallest)',
    },
    'Oscillator P12 1': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\n3bB$bB$bAB$B!',
      description: 'Period 12 oscillator (smallest)',
    },
    'Oscillator P22 1': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\n2bA$2BbB$4A$2bB!',
      description: 'Period 22 oscillator (smallest)',
    },
  },
  'b2-6_s0-1,8': {
    'Glider c/3 1': {
      rle: 'x = 4, y = 5, rule = FuzzyLife/3\n2bB$BAbA$BA$BAbA$2bB!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Glider c/6 2': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\nb2A$A$3A!',
      description: 'Glider, speed c/6 (period 6, displacement 1)',
    },
    'Glider c/3 3': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\n2bA$A$b2A!',
      description: 'Glider, speed c/3 (period 6, displacement 2)',
    },
    'Oscillator P1': {
      rle: 'x = 1, y = 1, rule = FuzzyLife/3\nB!',
      description: 'Period 1 oscillator (smallest)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 2, rule = FuzzyLife/3\n2bB$BA!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P3 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nAB$BA!',
      description: 'Period 3 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 5, y = 4, rule = FuzzyLife/3\n4bB$b2A$BbB$bA!',
      description: 'Period 4 oscillator (smallest)',
    },
    'Glider c/6 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\n2bB$BA$BAB!',
      description: 'Glider, speed c/6 (period 6, displacement 1)',
    },
    'Glider c/8 1': {
      rle: 'x = 6, y = 6, rule = FuzzyLife/3\n4bB$3bAB$2bBbB$bAbA$3Bb2B$4bB!',
      description: 'Glider, speed c/8 (period 8, displacement 1)',
    },
    'Oscillator P12 1': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\n3bB$bB$bAB$B!',
      description: 'Period 12 oscillator (smallest)',
    },
  },
  'b2-5_s0-1,6-7': {
    'Glider c/3 1': {
      rle: 'x = 4, y = 5, rule = FuzzyLife/3\n2bB$BAbA$BA$BAbA$2bB!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Glider c/3 2': {
      rle: 'x = 6, y = 5, rule = FuzzyLife/3\n3b2A$2bAbA$AbAb2A$AbAbA$AbAbA!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Glider c/3 3': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\n2bA$A$b2A!',
      description: 'Glider, speed c/3 (period 6, displacement 2)',
    },
    'Glider c/6 4': {
      rle: 'x = 5, y = 4, rule = FuzzyLife/3\n2bA$bBb2A$2Ab2A$bBA!',
      description: 'Glider, speed c/6 (period 6, displacement 1)',
    },
    'Oscillator P1': {
      rle: 'x = 1, y = 1, rule = FuzzyLife/3\nB!',
      description: 'Period 1 oscillator (smallest)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 2, rule = FuzzyLife/3\n2bB$BA!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P3 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nAB$BA!',
      description: 'Period 3 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 5, y = 4, rule = FuzzyLife/3\n3bAB$bBA$bAbA$BAB!',
      description: 'Period 4 oscillator (smallest)',
    },
    'Glider c/6 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\n2bB$BA$BAB!',
      description: 'Glider, speed c/6 (period 6, displacement 1)',
    },
    'Oscillator P8 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\nbAB$BAB$BA!',
      description: 'Period 8 oscillator (smallest)',
    },
    'Oscillator P10 1': {
      rle: 'x = 5, y = 4, rule = FuzzyLife/3\n3bAB$2bB$2b3A$BA3B!',
      description: 'Period 10 oscillator (smallest)',
    },
    'Oscillator P12 1': {
      rle: 'x = 7, y = 4, rule = FuzzyLife/3\n6bB$B3bB$4bAB$3bB!',
      description: 'Period 12 oscillator (smallest)',
    },
  },
  'b2-8_s0-1,5-8': {
    'Glider c/6 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\nb2A$A$3A!',
      description: 'Glider, speed c/6 (period 6, displacement 1)',
    },
    'Glider c/6 2': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\n2bB$BA$BAB!',
      description: 'Glider, speed c/6 (period 6, displacement 1)',
    },
    'Glider c/3 3': {
      rle: 'x = 4, y = 5, rule = FuzzyLife/3\n2bB$BAbA$BA$BAbA$2bB!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Oscillator P1': {
      rle: 'x = 1, y = 1, rule = FuzzyLife/3\nB!',
      description: 'Period 1 oscillator (smallest)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 2, rule = FuzzyLife/3\n2bB$BA!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P3 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nAB$BA!',
      description: 'Period 3 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 4, y = 5, rule = FuzzyLife/3\n2bAB$BA$2b2A$2AbB$BbA!',
      description: 'Period 4 oscillator (smallest)',
    },
    'Oscillator P12 1': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\n3bB$bB$bAB$B!',
      description: 'Period 12 oscillator (smallest)',
    },
    'Oscillator P22 1': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\n2bA$2BbB$4A$2bB!',
      description: 'Period 22 oscillator (smallest)',
    },
  },
  'b2_s2-3,6-7': {
    'Glider c/3 1': {
      rle: 'x = 2, y = 4, rule = FuzzyLife/3\nbA$2B$2B$bA!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Glider c/3 2': {
      rle: 'x = 4, y = 2, rule = FuzzyLife/3\nb2A$A2BA!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Glider c/3 3': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\n2bB$3A$3A$2bB!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 2, rule = FuzzyLife/3\nb2A$AB!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P20 1': {
      rle: 'x = 5, y = 5, rule = FuzzyLife/3\n3bA$bBAB$bAB$ABb2B$3bBA!',
      description: 'Period 20 oscillator (smallest)',
    },
  },
  'b2-4_s0-1,8': {
    'Glider c/3 1': {
      rle: 'x = 4, y = 5, rule = FuzzyLife/3\n2bB$BAbA$BA$BAbA$2bB!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Glider c/6 2': {
      rle: 'x = 5, y = 4, rule = FuzzyLife/3\n2bA$bBb2A$2Ab2A$bBA!',
      description: 'Glider, speed c/6 (period 6, displacement 1)',
    },
    'Glider c/3 3': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\n2bA$A$b2A!',
      description: 'Glider, speed c/3 (period 6, displacement 2)',
    },
    'Glider c/6 4': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\nb2A$A$3A!',
      description: 'Glider, speed c/6 (period 6, displacement 1)',
    },
    'Oscillator P1': {
      rle: 'x = 1, y = 1, rule = FuzzyLife/3\nB!',
      description: 'Period 1 oscillator (smallest)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 2, rule = FuzzyLife/3\n2bB$BA!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P3 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nAB$BA!',
      description: 'Period 3 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\nbAbB$Bb2A$2A$BbAB!',
      description: 'Period 4 oscillator (smallest)',
    },
    'Oscillator P6 1': {
      rle: 'x = 4, y = 2, rule = FuzzyLife/3\nb2B$B2bB!',
      description: 'Period 6 oscillator (smallest)',
    },
    'Oscillator P8 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\nbAB$BAB$BA!',
      description: 'Period 8 oscillator (smallest)',
    },
    'Oscillator P12 1': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\n3bB$bB$bAB$B!',
      description: 'Period 12 oscillator (smallest)',
    },
  },
  'b2-8_s0-1,6': {
    'Glider c/3 1': {
      rle: 'x = 5, y = 5, rule = FuzzyLife/3\n2bAB$2AbAB$2AbA$2AbAB$2bAB!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Glider c/6 2': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\n2bB$BA$BAB!',
      description: 'Glider, speed c/6 (period 6, displacement 1)',
    },
    'Glider c/3 3': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\n2bA$A$b2A!',
      description: 'Glider, speed c/3 (period 6, displacement 2)',
    },
    'Glider c/6 4': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\nb2A$A$3A!',
      description: 'Glider, speed c/6 (period 6, displacement 1)',
    },
    'Oscillator P1': {
      rle: 'x = 1, y = 1, rule = FuzzyLife/3\nB!',
      description: 'Period 1 oscillator (smallest)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 2, rule = FuzzyLife/3\n2bB$BA!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P3 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nAB$BA!',
      description: 'Period 3 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\nbAbB$Bb2A$2A$BbAB!',
      description: 'Period 4 oscillator (smallest)',
    },
    'Oscillator P8 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\nbAB$BAB$BA!',
      description: 'Period 8 oscillator (smallest)',
    },
    'Oscillator P12 1': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\n3bB$bB$bAB$B!',
      description: 'Period 12 oscillator (smallest)',
    },
  },
  'b2-5_s0-1,6-8': {
    'Glider c/6 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\nb2A$A$3A!',
      description: 'Glider, speed c/6 (period 6, displacement 1)',
    },
    'Glider c/3 2': {
      rle: 'x = 4, y = 5, rule = FuzzyLife/3\n2bB$BAbA$BA$BAbA$2bB!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Glider c/6 3': {
      rle: 'x = 5, y = 4, rule = FuzzyLife/3\n2bA$bBb2A$2Ab2A$bBA!',
      description: 'Glider, speed c/6 (period 6, displacement 1)',
    },
    'Glider c/3 4': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\n2bA$A$b2A!',
      description: 'Glider, speed c/3 (period 6, displacement 2)',
    },
    'Oscillator P1': {
      rle: 'x = 1, y = 1, rule = FuzzyLife/3\nB!',
      description: 'Period 1 oscillator (smallest)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 2, rule = FuzzyLife/3\n2bB$BA!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P3 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nAB$BA!',
      description: 'Period 3 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 4, y = 5, rule = FuzzyLife/3\n2bAB$BA$2b2A$2AbB$BbA!',
      description: 'Period 4 oscillator (smallest)',
    },
    'Glider c/3 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\n2bB$BA$b2B!',
      description: 'Glider, speed c/3 (period 6, displacement 2)',
    },
    'Oscillator P8 1': {
      rle: 'x = 8, y = 7, rule = FuzzyLife/3\n7bB$$BA2B$b2A$AbB$B2A$2bB!',
      description: 'Period 8 oscillator (smallest)',
    },
    'Oscillator P12 1': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\n3bB$bB$bAB$B!',
      description: 'Period 12 oscillator (smallest)',
    },
  },
  'b1_s3-4,7': {
    'Glider c 1': {
      rle: 'x = 4, y = 2, rule = FuzzyLife/3\nb2A$A2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 2': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bA$A$b2A!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 3': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\n2bA$A$A$2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
  },
  'b1_s0,3-5': {
    'Glider c 1': {
      rle: 'x = 2, y = 4, rule = FuzzyLife/3\nbA$A$A$bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
  },
  'b2-8_s0-1,6-7': {
    'Glider c/3 1': {
      rle: 'x = 4, y = 5, rule = FuzzyLife/3\n2bB$BAbA$BA$BAbA$2bB!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Glider c/6 2': {
      rle: 'x = 5, y = 4, rule = FuzzyLife/3\n2bA$bBb2A$2Ab2A$bBA!',
      description: 'Glider, speed c/6 (period 6, displacement 1)',
    },
    'Glider c/3 3': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\n2bA$A$b2A!',
      description: 'Glider, speed c/3 (period 6, displacement 2)',
    },
    'Oscillator P1': {
      rle: 'x = 1, y = 1, rule = FuzzyLife/3\nB!',
      description: 'Period 1 oscillator (smallest)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 2, rule = FuzzyLife/3\n2bB$BA!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P3 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nAB$BA!',
      description: 'Period 3 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 5, y = 3, rule = FuzzyLife/3\n3bB$2b2A$BABAB!',
      description: 'Period 4 oscillator (smallest)',
    },
    'Glider c/6 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\n2bB$BA$BAB!',
      description: 'Glider, speed c/6 (period 6, displacement 1)',
    },
    'Oscillator P8 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\nbAB$BAB$BA!',
      description: 'Period 8 oscillator (smallest)',
    },
    'Oscillator P12 1': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\n3bB$bB$bAB$B!',
      description: 'Period 12 oscillator (smallest)',
    },
  },
  'b2-5_s0-1,7': {
    'Glider c/6 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\n2bB$BA$BAB!',
      description: 'Glider, speed c/6 (period 6, displacement 1)',
    },
    'Oscillator P1': {
      rle: 'x = 1, y = 1, rule = FuzzyLife/3\nB!',
      description: 'Period 1 oscillator (smallest)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 2, rule = FuzzyLife/3\n2bB$BA!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P3 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nAB$BA!',
      description: 'Period 3 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 4, y = 5, rule = FuzzyLife/3\n2bAB$BA$2b2A$2AbB$BbA!',
      description: 'Period 4 oscillator (smallest)',
    },
    'Oscillator P8 1': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\n2bB$B2AB$B2AB$bB!',
      description: 'Period 8 oscillator (smallest)',
    },
  },
  'b2_s2-3,6-8': {
    'Glider c/3 1': {
      rle: 'x = 2, y = 4, rule = FuzzyLife/3\nbA$2B$2B$bA!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Glider c/3 2': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\n2bB$3A$3A$2bB!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Glider c/3 3': {
      rle: 'x = 4, y = 2, rule = FuzzyLife/3\nb2A$A2BA!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Oscillator P1': {
      rle: 'x = 5, y = 4, rule = FuzzyLife/3\n3bB$bBb2B$2BbB$bB!',
      description: 'Period 1 oscillator (smallest)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 2, rule = FuzzyLife/3\nb2A$AB!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P20 1': {
      rle: 'x = 5, y = 5, rule = FuzzyLife/3\n3bA$bBAB$bAB$ABb2B$3bBA!',
      description: 'Period 20 oscillator (smallest)',
    },
  },
  'b2-3_s0-1': {
    'Glider c/3 1': {
      rle: 'x = 5, y = 3, rule = FuzzyLife/3\n2A2bB$BABAB$2A2bB!',
      description: 'Glider, speed c/3 (period 9, displacement 3)',
    },
    'Glider c/3 2': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bA$2AbA$2bA!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Glider c/3 3': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bB$2BAB$3bB!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Glider c/3 4': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\nAb2A$AbAB$Ab2A!',
      description: 'Glider, speed c/3 (period 9, displacement 3)',
    },
    'Glider c/7 1': {
      rle: 'x = 5, y = 5, rule = FuzzyLife/3\n3bA$BAbA$b2AbA$b2AB$bB!',
      description: 'Glider, speed c/7 (period 14, displacement 2)',
    },
    'Glider c/3 5': {
      rle: 'x = 5, y = 3, rule = FuzzyLife/3\nb2AbA$2AbAB$2Ab2A!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Glider c/4 1': {
      rle: 'x = 7, y = 6, rule = FuzzyLife/3\n3bA$bAbAbA$2AbAb2A$2AbAb2A$bAbAbA$2b3A!',
      description: 'Glider, speed c/4 (period 4, displacement 1)',
    },
    'Oscillator P1': {
      rle: 'x = 1, y = 1, rule = FuzzyLife/3\nB!',
      description: 'Period 1 oscillator (smallest)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 2, rule = FuzzyLife/3\n2bB$BA!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P3 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nAB$BA!',
      description: 'Period 3 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\n2bB$b2A$BAB!',
      description: 'Period 4 oscillator (smallest)',
    },
    'Oscillator P6 1': {
      rle: 'x = 7, y = 4, rule = FuzzyLife/3\n5bBA$B4bAB$bA$2bB!',
      description: 'Period 6 oscillator (smallest)',
    },
    'Oscillator P8 1': {
      rle: 'x = 6, y = 5, rule = FuzzyLife/3\n5bB$b2B$3A$2B$5bB!',
      description: 'Period 8 oscillator (smallest)',
    },
  },
  'b2-6_s1,4': {
    'Glider c/3 1': {
      rle: 'x = 5, y = 4, rule = FuzzyLife/3\n2bA$5A$AbBbA$b3A!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 1, rule = FuzzyLife/3\nAB!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P3 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\n2bB$bB$B!',
      description: 'Period 3 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 5, y = 3, rule = FuzzyLife/3\n2bA$Bb2AB$b2A!',
      description: 'Period 4 oscillator (smallest)',
    },
    'Oscillator P6 1': {
      rle: 'x = 3, y = 7, rule = FuzzyLife/3\n2bB$B$$$$ABA$ABA!',
      description: 'Period 6 oscillator (smallest)',
    },
  },
  'b2-8_s0-1,6-8': {
    'Glider c/3 1': {
      rle: 'x = 4, y = 5, rule = FuzzyLife/3\n2bB$BAbA$BA$BAbA$2bB!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Glider c/6 2': {
      rle: 'x = 5, y = 4, rule = FuzzyLife/3\n2bA$bBb2A$2Ab2A$bBA!',
      description: 'Glider, speed c/6 (period 6, displacement 1)',
    },
    'Glider c/6 3': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\nb2A$A$3A!',
      description: 'Glider, speed c/6 (period 6, displacement 1)',
    },
    'Glider c/3 4': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\n2bA$A$b2A!',
      description: 'Glider, speed c/3 (period 6, displacement 2)',
    },
    'Glider c/6 5': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\n2bB$BA$BAB!',
      description: 'Glider, speed c/6 (period 6, displacement 1)',
    },
    'Oscillator P1': {
      rle: 'x = 1, y = 1, rule = FuzzyLife/3\nB!',
      description: 'Period 1 oscillator (smallest)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 2, rule = FuzzyLife/3\n2bB$BA!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P3 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nAB$BA!',
      description: 'Period 3 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 6, y = 4, rule = FuzzyLife/3\n2bAB$3b2AB$B2A$2bBA!',
      description: 'Period 4 oscillator (smallest)',
    },
    'Oscillator P8 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\nbAB$BAB$BA!',
      description: 'Period 8 oscillator (smallest)',
    },
  },
  'b2-5_s0-1,7-8': {
    'Glider c/3 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\n2bA$A$b2A!',
      description: 'Glider, speed c/3 (period 6, displacement 2)',
    },
    'Glider c/6 2': {
      rle: 'x = 5, y = 4, rule = FuzzyLife/3\n2bA$bBb2A$2Ab2A$bBA!',
      description: 'Glider, speed c/6 (period 6, displacement 1)',
    },
    'Glider c/6 3': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\nb2A$A$3A!',
      description: 'Glider, speed c/6 (period 6, displacement 1)',
    },
    'Oscillator P1': {
      rle: 'x = 1, y = 1, rule = FuzzyLife/3\nB!',
      description: 'Period 1 oscillator (smallest)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 2, rule = FuzzyLife/3\n2bB$BA!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P3 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nAB$BA!',
      description: 'Period 3 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 6, y = 4, rule = FuzzyLife/3\n3bBA$b2A2bB$B2b2A$bAB!',
      description: 'Period 4 oscillator (smallest)',
    },
    'Glider c/6 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\n2bB$BA$BAB!',
      description: 'Glider, speed c/6 (period 6, displacement 1)',
    },
    'Oscillator P8 1': {
      rle: 'x = 5, y = 4, rule = FuzzyLife/3\n4bB$BABAB$bAb2A$bBAbB!',
      description: 'Period 8 oscillator (smallest)',
    },
    'Oscillator P12 1': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\n3bB$bB$bAB$B!',
      description: 'Period 12 oscillator (smallest)',
    },
    'Oscillator P18 1': {
      rle: 'x = 6, y = 6, rule = FuzzyLife/3\n4bB$3BAB$bA2bB$bB2bA$bBA3B$bB!',
      description: 'Period 18 oscillator (smallest)',
    },
  },
  'b2-6_s1,8': {
    'Glider c/3 1': {
      rle: 'x = 5, y = 4, rule = FuzzyLife/3\n2bA$5A$A3bA$b3A!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 1, rule = FuzzyLife/3\nAB!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 7, y = 7, rule = FuzzyLife/3\n4bB$2b5A$A2b2BbB$Ab4A$AbABbB$bBAbA$3bB!',
      description: 'Period 4 oscillator (smallest)',
    },
    'Oscillator P6 1': {
      rle: 'x = 6, y = 4, rule = FuzzyLife/3\n5bB$2A$2B2bB$2A!',
      description: 'Period 6 oscillator (smallest)',
    },
  },
  'b2-5_s0-1,8': {
    'Glider c/6 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\n2bB$BA$BAB!',
      description: 'Glider, speed c/6 (period 6, displacement 1)',
    },
    'Glider c/6 2': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\nb2A$A$3A!',
      description: 'Glider, speed c/6 (period 6, displacement 1)',
    },
    'Glider c/3 3': {
      rle: 'x = 4, y = 5, rule = FuzzyLife/3\n2bB$BAbA$BA$BAbA$2bB!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Oscillator P1': {
      rle: 'x = 1, y = 1, rule = FuzzyLife/3\nB!',
      description: 'Period 1 oscillator (smallest)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 2, rule = FuzzyLife/3\n2bB$BA!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P3 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nAB$BA!',
      description: 'Period 3 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 6, y = 4, rule = FuzzyLife/3\n2bAB$3b2AB$B2A$2bBA!',
      description: 'Period 4 oscillator (smallest)',
    },
    'Oscillator P8 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\nbAB$BAB$BA!',
      description: 'Period 8 oscillator (smallest)',
    },
    'Oscillator P12 1': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\n3bB$bB$bAB$B!',
      description: 'Period 12 oscillator (smallest)',
    },
  },
  'b2_s2-3,7': {
    'Glider c/3 1': {
      rle: 'x = 4, y = 2, rule = FuzzyLife/3\nb2A$A2BA!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Glider c/3 2': {
      rle: 'x = 2, y = 4, rule = FuzzyLife/3\nbA$2B$2B$bA!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Glider c/3 3': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\n2bB$3A$3A$2bB!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 2, rule = FuzzyLife/3\nb2A$AB!',
      description: 'Period 2 oscillator (smallest)',
    },
  },
  'b2-8_s0-1,7': {
    'Glider c/3 1': {
      rle: 'x = 4, y = 5, rule = FuzzyLife/3\n2bB$BAbA$BA$BAbA$2bB!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Glider c/3 2': {
      rle: 'x = 5, y = 4, rule = FuzzyLife/3\n2bA$5A$A3bA$b3A!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Glider c/6 3': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\nb2A$A$3A!',
      description: 'Glider, speed c/6 (period 6, displacement 1)',
    },
    'Glider c/6 4': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\n2bB$BA$BAB!',
      description: 'Glider, speed c/6 (period 6, displacement 1)',
    },
    'Oscillator P1': {
      rle: 'x = 1, y = 1, rule = FuzzyLife/3\nB!',
      description: 'Period 1 oscillator (smallest)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 2, rule = FuzzyLife/3\n2bB$BA!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P3 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nAB$BA!',
      description: 'Period 3 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 5, y = 5, rule = FuzzyLife/3\n4bB$3bA$BABbA$2b2AB$2bB!',
      description: 'Period 4 oscillator (smallest)',
    },
    'Oscillator P12 1': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\n3bB$bB$bAB$B!',
      description: 'Period 12 oscillator (smallest)',
    },
  },
  'b2-8_s0-1,7-8': {
    'Glider c/6 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\nb2A$A$3A!',
      description: 'Glider, speed c/6 (period 6, displacement 1)',
    },
    'Glider c/3 2': {
      rle: 'x = 4, y = 5, rule = FuzzyLife/3\n2bB$BAbA$BA$BAbA$2bB!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Glider c/3 3': {
      rle: 'x = 5, y = 4, rule = FuzzyLife/3\n2bA$5A$A3bA$b3A!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Oscillator P1': {
      rle: 'x = 1, y = 1, rule = FuzzyLife/3\nB!',
      description: 'Period 1 oscillator (smallest)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 2, rule = FuzzyLife/3\n2bB$BA!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P3 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nAB$BA!',
      description: 'Period 3 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 7, y = 6, rule = FuzzyLife/3\n5bAB$4bBbA$B3bA$bAbBAB$AbAbA$bBAbA!',
      description: 'Period 4 oscillator (smallest)',
    },
    'Oscillator P6 1': {
      rle: 'x = 2, y = 4, rule = FuzzyLife/3\nbB$B$B$bB!',
      description: 'Period 6 oscillator (smallest)',
    },
    'Oscillator P12 1': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\n3bB$bB$bAB$B!',
      description: 'Period 12 oscillator (smallest)',
    },
  },
  'b2-6_s2': {
    'Glider c/9 1': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\n2bA$2BA$BbA$bA!',
      description: 'Glider, speed c/9 (period 9, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 2, rule = FuzzyLife/3\nb2A$AB!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\nbAB$3B$BA!',
      description: 'Period 4 oscillator (smallest)',
    },
    'Oscillator P6 1': {
      rle: 'x = 6, y = 6, rule = FuzzyLife/3\n2b2A$bA2BA$AB2ABA$AB2ABA$bA2BA$2b2A!',
      description: 'Period 6 oscillator (smallest)',
    },
  },
  'b2-6_s2,4': {
    'Glider c/4 1': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\nb2A$A2BA$4A!',
      description: 'Glider, speed c/4 (period 4, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 2, rule = FuzzyLife/3\nb2A$AB!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n2bB$B2bB$bB!',
      description: 'Period 4 oscillator (smallest)',
    },
  },
  'b2_s2-3,7-8': {
    'Glider c/3 1': {
      rle: 'x = 4, y = 2, rule = FuzzyLife/3\nb2A$A2BA!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Glider c/3 2': {
      rle: 'x = 2, y = 4, rule = FuzzyLife/3\nbA$2B$2B$bA!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Glider c/3 3': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\n2bB$3A$3A$2bB!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Oscillator P1': {
      rle: 'x = 5, y = 4, rule = FuzzyLife/3\n3bB$bBb2B$2BbB$bB!',
      description: 'Period 1 oscillator (smallest)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 2, rule = FuzzyLife/3\nb2A$AB!',
      description: 'Period 2 oscillator (smallest)',
    },
  },
  'b2-6_s2,4-5': {
    'Glider c/2 1': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\nb2A$4A$A2BA$A2bA!',
      description: 'Glider, speed c/2 (period 2, displacement 1)',
    },
    'Glider c/4 1': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\nb2A$A2BA$4A!',
      description: 'Glider, speed c/4 (period 4, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 2, rule = FuzzyLife/3\nb2A$AB!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n2bB$B2bB$bB!',
      description: 'Period 4 oscillator (smallest)',
    },
    'Oscillator P10 1': {
      rle: 'x = 6, y = 6, rule = FuzzyLife/3\n2b2B$$Bb2BbB$Bb2BbB$$2b2B!',
      description: 'Period 10 oscillator (smallest)',
    },
  },
  'b2-6_s2,4-7': {
    'Glider c/4 1': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\nA2bA$b2B$B2bB!',
      description: 'Glider, speed c/4 (period 4, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 2, rule = FuzzyLife/3\nb2A$AB!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P6 1': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\nbAbA$3B$A2B$bAbB!',
      description: 'Period 6 oscillator (smallest)',
    },
    'Oscillator P8 1': {
      rle: 'x = 9, y = 8, rule = FuzzyLife/3\n2bA2bAbA$3b4BAB$2A2BbBbBA$b7B$2BbBbBbBA$b7B$A7BA$bAb3AbA!',
      description: 'Period 8 oscillator (smallest)',
    },
    'Oscillator P10 1': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\nbAbA$A2B$3BA$bAbA!',
      description: 'Period 10 oscillator (smallest)',
    },
    'Oscillator P12 1': {
      rle: 'x = 5, y = 4, rule = FuzzyLife/3\n3bA$A3BA$5B$b3A!',
      description: 'Period 12 oscillator (smallest)',
    },
  },
  'b2-6_s2,6': {
    'Glider c/9 1': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\n2bA$2BA$BbA$bA!',
      description: 'Glider, speed c/9 (period 9, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 2, rule = FuzzyLife/3\nb2A$AB!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\nABA$3B$ABA!',
      description: 'Period 4 oscillator (smallest)',
    },
    'Oscillator P6 1': {
      rle: 'x = 6, y = 6, rule = FuzzyLife/3\n2b2A$bA2BA$AB2ABA$AB2ABA$bA2BA$2b2A!',
      description: 'Period 6 oscillator (smallest)',
    },
  },
  'b2-6_s2,6-8': {
    'Glider c/9 1': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\nb2A$ABAB$3AB!',
      description: 'Glider, speed c/9 (period 9, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 2, rule = FuzzyLife/3\nb2A$AB!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\nABA$3B$ABA!',
      description: 'Period 4 oscillator (smallest)',
    },
    'Oscillator P6 1': {
      rle: 'x = 6, y = 6, rule = FuzzyLife/3\n2b2A$bA2BA$AB2ABA$AB2ABA$bA2BA$2b2A!',
      description: 'Period 6 oscillator (smallest)',
    },
  },
  'b2-8_s0-1,8': {
    'Glider c/3 1': {
      rle: 'x = 4, y = 5, rule = FuzzyLife/3\n2bB$BAbA$BA$BAbA$2bB!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Glider c/3 2': {
      rle: 'x = 5, y = 4, rule = FuzzyLife/3\n2bA$5A$A3bA$b3A!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Glider c/6 3': {
      rle: 'x = 5, y = 4, rule = FuzzyLife/3\n2bA$bBb2A$2Ab2A$bBA!',
      description: 'Glider, speed c/6 (period 6, displacement 1)',
    },
    'Glider c/6 4': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\n2bB$BA$BAB!',
      description: 'Glider, speed c/6 (period 6, displacement 1)',
    },
    'Glider c/3 5': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\n2bA$A$b2A!',
      description: 'Glider, speed c/3 (period 6, displacement 2)',
    },
    'Oscillator P1': {
      rle: 'x = 1, y = 1, rule = FuzzyLife/3\nB!',
      description: 'Period 1 oscillator (smallest)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 2, rule = FuzzyLife/3\n2bB$BA!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P3 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nAB$BA!',
      description: 'Period 3 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 5, y = 4, rule = FuzzyLife/3\n4bB$b2A$BbB$bA!',
      description: 'Period 4 oscillator (smallest)',
    },
    'Oscillator P12 1': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\n3bB$bB$bAB$B!',
      description: 'Period 12 oscillator (smallest)',
    },
  },
  'b2_s2-3,8': {
    'Glider c/3 1': {
      rle: 'x = 4, y = 2, rule = FuzzyLife/3\nb2A$A2BA!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Glider c/3 2': {
      rle: 'x = 2, y = 4, rule = FuzzyLife/3\nbA$2B$2B$bA!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Glider c/3 3': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\n2bB$3A$3A$2bB!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 2, rule = FuzzyLife/3\nb2A$AB!',
      description: 'Period 2 oscillator (smallest)',
    },
  },
  'b1_s0,3-6': {
    'Glider c 1': {
      rle: 'x = 4, y = 2, rule = FuzzyLife/3\nb2A$A2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
  },
  'b2-6_s3-4': {
    'Glider c/3 1': {
      rle: 'x = 5, y = 5, rule = FuzzyLife/3\n2bA$2b2A$ABb2A$b3BA$bAB!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\n2bA$2B$BbA!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n2bBA$A2B$b2BA!',
      description: 'Period 4 oscillator (smallest)',
    },
    'Oscillator P6 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\nbBA$2B$ABA!',
      description: 'Period 6 oscillator (smallest)',
    },
    'Oscillator P8 1': {
      rle: 'x = 5, y = 5, rule = FuzzyLife/3\n2bA$2bBbA$ABbB$b3BA$bAbA!',
      description: 'Period 8 oscillator (smallest)',
    },
    'Oscillator P12 1': {
      rle: 'x = 13, y = 13, rule = FuzzyLife/3\n6bA$4bA3BA$4bA3BA$3bB5AB$b5Ab5A$b2B2A3B2A2B$A2BAb3BbA2BA$b2B2A3B2A2B$b5Ab5A$3bB5AB$4bA3BA$4bA3BA$6bA!',
      description: 'Period 12 oscillator (smallest)',
    },
  },
  'b2-6_s3-4,6': {
    'Glider c/3 1': {
      rle: 'x = 5, y = 5, rule = FuzzyLife/3\n2bA$2b2A$ABb2A$ABABA$bAB!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Glider c/3 2': {
      rle: 'x = 5, y = 5, rule = FuzzyLife/3\n2bA$2AbBA$ABbAB$2b3B$2b2A!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\n2bA$2B$3A!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n2bBA$A2B$b2BA!',
      description: 'Period 4 oscillator (smallest)',
    },
    'Oscillator P6 1': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\n2bA$A2B$b2BA$AbA!',
      description: 'Period 6 oscillator (smallest)',
    },
    'Oscillator P8 1': {
      rle: 'x = 4, y = 5, rule = FuzzyLife/3\n2bA$A2B$bBAB$A2B$2bA!',
      description: 'Period 8 oscillator (smallest)',
    },
  },
  'b1_s3-4,7-8': {
    'Glider c 1': {
      rle: 'x = 2, y = 4, rule = FuzzyLife/3\nbA$A$A$bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 2': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bA$A$b2A!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 3': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\n2bA$A$A$2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
  },
  'b2-8_s1,5-8': {
    'Glider c/3 1': {
      rle: 'x = 5, y = 4, rule = FuzzyLife/3\n2bA$5A$A3bA$b3A!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 1, y = 2, rule = FuzzyLife/3\nA$B!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P6 1': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\n3bB$2b2A$B$bA!',
      description: 'Period 6 oscillator (smallest)',
    },
  },
  'b2-8_s1,8': {
    'Glider c/3 1': {
      rle: 'x = 5, y = 4, rule = FuzzyLife/3\n2bA$5A$A3bA$b3A!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 1, y = 2, rule = FuzzyLife/3\nA$B!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P6 1': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\n3bB$2b2A$B$bA!',
      description: 'Period 6 oscillator (smallest)',
    },
  },
  'b2-7_s0-1,5': {
    'Glider c/3 1': {
      rle: 'x = 4, y = 5, rule = FuzzyLife/3\n2bB$BAbA$BA$BAbA$2bB!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Glider c/6 2': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\nb2A$A$3A!',
      description: 'Glider, speed c/6 (period 6, displacement 1)',
    },
    'Glider c/3 3': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\n2bA$A$b2A!',
      description: 'Glider, speed c/3 (period 6, displacement 2)',
    },
    'Oscillator P1': {
      rle: 'x = 1, y = 1, rule = FuzzyLife/3\nB!',
      description: 'Period 1 oscillator (smallest)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 2, rule = FuzzyLife/3\n2bB$BA!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P3 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nAB$BA!',
      description: 'Period 3 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 5, y = 5, rule = FuzzyLife/3\n3bB$bAbA$Bb2AB$bA2bA$2bAB!',
      description: 'Period 4 oscillator (smallest)',
    },
    'Glider c/6 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\n2bB$BA$BAB!',
      description: 'Glider, speed c/6 (period 6, displacement 1)',
    },
  },
  'b2-7_s0-1': {
    'Glider c/3 1': {
      rle: 'x = 4, y = 5, rule = FuzzyLife/3\n2bB$BAbA$BA$BAbA$2bB!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Glider c/6 2': {
      rle: 'x = 5, y = 4, rule = FuzzyLife/3\n2bA$bBb2A$2Ab2A$bBA!',
      description: 'Glider, speed c/6 (period 6, displacement 1)',
    },
    'Glider c/6 3': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\nb2A$A$3A!',
      description: 'Glider, speed c/6 (period 6, displacement 1)',
    },
    'Glider c/3 4': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\n2bA$A$b2A!',
      description: 'Glider, speed c/3 (period 6, displacement 2)',
    },
    'Oscillator P1': {
      rle: 'x = 1, y = 1, rule = FuzzyLife/3\nB!',
      description: 'Period 1 oscillator (smallest)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 2, rule = FuzzyLife/3\n2bB$BA!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P3 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nAB$BA!',
      description: 'Period 3 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\nbAbB$Bb2A$2A$BbAB!',
      description: 'Period 4 oscillator (smallest)',
    },
    'Glider c/6 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\n2bB$BA$BAB!',
      description: 'Glider, speed c/6 (period 6, displacement 1)',
    },
    'Oscillator P8 1': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\n2bB$B2AB$B2AB$bB!',
      description: 'Period 8 oscillator (smallest)',
    },
    'Oscillator P10 1': {
      rle: 'x = 5, y = 4, rule = FuzzyLife/3\n3bAB$2bB$2b3A$BA3B!',
      description: 'Period 10 oscillator (smallest)',
    },
    'Oscillator P12 1': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\n3bB$bB$bAB$B!',
      description: 'Period 12 oscillator (smallest)',
    },
    'Oscillator P14 1': {
      rle: 'x = 6, y = 5, rule = FuzzyLife/3\n4b2B$4b2A$bBA2B$A2b2A$bBAbB!',
      description: 'Period 14 oscillator (smallest)',
    },
  },
  'b2-7_s0-1,5-6': {
    'Glider c/3 1': {
      rle: 'x = 5, y = 4, rule = FuzzyLife/3\n2bA$5A$A3bA$b3A!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Glider c/3 2': {
      rle: 'x = 4, y = 5, rule = FuzzyLife/3\n2bB$BAbA$BA$BAbA$2bB!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Oscillator P1': {
      rle: 'x = 1, y = 1, rule = FuzzyLife/3\nB!',
      description: 'Period 1 oscillator (smallest)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 2, rule = FuzzyLife/3\n2bB$BA!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P3 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nAB$BA!',
      description: 'Period 3 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 6, y = 6, rule = FuzzyLife/3\n3bB$3bA$b2Ab2A$B2bAbB$b2AbA$3bB!',
      description: 'Period 4 oscillator (smallest)',
    },
    'Oscillator P6 1': {
      rle: 'x = 7, y = 7, rule = FuzzyLife/3\n5bB$4bA$B2bB$$$2bB2bAB$5bBA!',
      description: 'Period 6 oscillator (smallest)',
    },
  },
  'b1_s0,3-7': {
    'Glider c 1': {
      rle: 'x = 4, y = 2, rule = FuzzyLife/3\nb2A$A2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
  },
  'b2-8_s2,4': {
    'Glider c/4 1': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\nb2A$A2BA$4A!',
      description: 'Glider, speed c/4 (period 4, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 2, rule = FuzzyLife/3\nb2A$AB!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n2bB$B2bB$bB!',
      description: 'Period 4 oscillator (smallest)',
    },
    'Oscillator P6 1': {
      rle: 'x = 6, y = 6, rule = FuzzyLife/3\n2b2A$bA2BA$AB2ABA$AB2ABA$bA2BA$2b2A!',
      description: 'Period 6 oscillator (smallest)',
    },
  },
  'b2-7_s0-1,5-7': {
    'Glider c/6 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\n2bB$BA$BAB!',
      description: 'Glider, speed c/6 (period 6, displacement 1)',
    },
    'Glider c/3 2': {
      rle: 'x = 5, y = 4, rule = FuzzyLife/3\n2bA$5A$A3bA$b3A!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Oscillator P1': {
      rle: 'x = 1, y = 1, rule = FuzzyLife/3\nB!',
      description: 'Period 1 oscillator (smallest)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 2, rule = FuzzyLife/3\n2bB$BA!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P3 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nAB$BA!',
      description: 'Period 3 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 6, y = 4, rule = FuzzyLife/3\n3bAbB$2bBb2A$2b2A$BAbB!',
      description: 'Period 4 oscillator (smallest)',
    },
    'Oscillator P12 1': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\n3bB$bB$bAB$B!',
      description: 'Period 12 oscillator (smallest)',
    },
    'Oscillator P22 1': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\n2bA$2BbB$4A$2bB!',
      description: 'Period 22 oscillator (smallest)',
    },
  },
  'b2-8_s2,4-5': {
    'Glider c/2 1': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\nb2A$4A$A2BA$A2bA!',
      description: 'Glider, speed c/2 (period 2, displacement 1)',
    },
    'Glider c/2 2': {
      rle: 'x = 2, y = 4, rule = FuzzyLife/3\n2A$2A$2B$2B!',
      description: 'Glider, speed c/2 (period 2, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 2, rule = FuzzyLife/3\nb2A$AB!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\n2bA$A2BA$3B$bBA!',
      description: 'Period 4 oscillator (smallest)',
    },
    'Oscillator P10 1': {
      rle: 'x = 6, y = 6, rule = FuzzyLife/3\n2b2B$$Bb2BbB$Bb2BbB$$2b2B!',
      description: 'Period 10 oscillator (smallest)',
    },
  },
  'b2-7_s0-1,4': {
    'Glider c/3 1': {
      rle: 'x = 5, y = 3, rule = FuzzyLife/3\nbAbA$B3bB$b3A!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Glider c/3 2': {
      rle: 'x = 5, y = 4, rule = FuzzyLife/3\n2bA$5A$AbBbA$b3A!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Glider c/6 3': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\nb2A$A$3A!',
      description: 'Glider, speed c/6 (period 6, displacement 1)',
    },
    'Oscillator P1': {
      rle: 'x = 1, y = 1, rule = FuzzyLife/3\nB!',
      description: 'Period 1 oscillator (smallest)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 2, rule = FuzzyLife/3\n2bB$BA!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P3 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nAB$BA!',
      description: 'Period 3 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 5, y = 4, rule = FuzzyLife/3\n4bB$b2A$BbB$bA!',
      description: 'Period 4 oscillator (smallest)',
    },
    'Glider c/6 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\n2bB$BA$BAB!',
      description: 'Glider, speed c/6 (period 6, displacement 1)',
    },
    'Oscillator P12 1': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\n3bB$bB$bAB$B!',
      description: 'Period 12 oscillator (smallest)',
    },
    'Oscillator P14 1': {
      rle: 'x = 6, y = 6, rule = FuzzyLife/3\n3bB$Bb2A$2Ab2AB$BbA2bA$bBAbA$3bBAB!',
      description: 'Period 14 oscillator (smallest)',
    },
  },
  'b2-8_s2,6': {
    'Glider c/9 1': {
      rle: 'x = 4, y = 5, rule = FuzzyLife/3\n2bA$b2A$B2bA$2AB$b2A!',
      description: 'Glider, speed c/9 (period 9, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 2, rule = FuzzyLife/3\nb2A$AB!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\nABA$3B$ABA!',
      description: 'Period 4 oscillator (smallest)',
    },
    'Oscillator P6 1': {
      rle: 'x = 6, y = 6, rule = FuzzyLife/3\n2b2A$bA2BA$AB2ABA$AB2ABA$bA2BA$2b2A!',
      description: 'Period 6 oscillator (smallest)',
    },
  },
  'b2-8_s2,7-8': {
    'Glider c/9 1': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\n2bA$bA2B$BA$bAB!',
      description: 'Glider, speed c/9 (period 9, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 2, rule = FuzzyLife/3\nb2A$AB!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 3, y = 5, rule = FuzzyLife/3\nbA$3B$3A$$BbB!',
      description: 'Period 4 oscillator (smallest)',
    },
    'Oscillator P6 1': {
      rle: 'x = 6, y = 6, rule = FuzzyLife/3\n2b2A$bA2BA$AB2ABA$AB2ABA$bA2BA$2b2A!',
      description: 'Period 6 oscillator (smallest)',
    },
  },
  'b2-7_s0-1,5-8': {
    'Glider c/6 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\nb2A$A$3A!',
      description: 'Glider, speed c/6 (period 6, displacement 1)',
    },
    'Glider c/6 2': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\n2bB$BA$BAB!',
      description: 'Glider, speed c/6 (period 6, displacement 1)',
    },
    'Glider c/6 3': {
      rle: 'x = 5, y = 4, rule = FuzzyLife/3\n2bA$bBb2A$2Ab2A$bBA!',
      description: 'Glider, speed c/6 (period 6, displacement 1)',
    },
    'Oscillator P1': {
      rle: 'x = 1, y = 1, rule = FuzzyLife/3\nB!',
      description: 'Period 1 oscillator (smallest)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 2, rule = FuzzyLife/3\n2bB$BA!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P3 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nAB$BA!',
      description: 'Period 3 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 6, y = 5, rule = FuzzyLife/3\n3bB$bBAbA$b2A2bB$B2b2A$bAB!',
      description: 'Period 4 oscillator (smallest)',
    },
    'Oscillator P12 1': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\n3bB$bB$bAB$B!',
      description: 'Period 12 oscillator (smallest)',
    },
    'Oscillator P22 1': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\n2bA$2BbB$4A$2bB!',
      description: 'Period 22 oscillator (smallest)',
    },
  },
  'b2-7_s1': {
    'Glider c/3 1': {
      rle: 'x = 5, y = 4, rule = FuzzyLife/3\n2bA$5A$A3bA$b3A!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 1, rule = FuzzyLife/3\nAB!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 5, y = 5, rule = FuzzyLife/3\n3bB$b2AbA$bAbAB$BAbA$2bBA!',
      description: 'Period 4 oscillator (smallest)',
    },
    'Oscillator P6 1': {
      rle: 'x = 7, y = 2, rule = FuzzyLife/3\n4bABA$BA2bABA!',
      description: 'Period 6 oscillator (smallest)',
    },
  },
  'b2-7_s0-1,6': {
    'Glider c/3 1': {
      rle: 'x = 4, y = 5, rule = FuzzyLife/3\n2bB$BAbA$BA$BAbA$2bB!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Glider c/6 2': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\nb2A$A$3A!',
      description: 'Glider, speed c/6 (period 6, displacement 1)',
    },
    'Glider c/3 3': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\n2bA$A$b2A!',
      description: 'Glider, speed c/3 (period 6, displacement 2)',
    },
    'Glider c/3 4': {
      rle: 'x = 5, y = 4, rule = FuzzyLife/3\n2bA$5A$A3bA$b3A!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Glider c/6 5': {
      rle: 'x = 5, y = 4, rule = FuzzyLife/3\n2bA$bBb2A$2Ab2A$bBA!',
      description: 'Glider, speed c/6 (period 6, displacement 1)',
    },
    'Oscillator P1': {
      rle: 'x = 1, y = 1, rule = FuzzyLife/3\nB!',
      description: 'Period 1 oscillator (smallest)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 2, rule = FuzzyLife/3\n2bB$BA!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P3 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nAB$BA!',
      description: 'Period 3 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 6, y = 4, rule = FuzzyLife/3\n2bAB$3b2AB$B2A$2bBA!',
      description: 'Period 4 oscillator (smallest)',
    },
    'Glider c/6 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\n2bB$BA$BAB!',
      description: 'Glider, speed c/6 (period 6, displacement 1)',
    },
    'Oscillator P8 1': {
      rle: 'x = 6, y = 5, rule = FuzzyLife/3\n3bB$BbAb2B$A2b3A$bAbA$2bBbAB!',
      description: 'Period 8 oscillator (smallest)',
    },
    'Oscillator P10 1': {
      rle: 'x = 5, y = 6, rule = FuzzyLife/3\n4bB$$BA$2bB$3A$3BAB!',
      description: 'Period 10 oscillator (smallest)',
    },
    'Oscillator P12 1': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\n3bB$bB$bAB$B!',
      description: 'Period 12 oscillator (smallest)',
    },
  },
  'b2-7_s0-1,6-7': {
    'Glider c/3 1': {
      rle: 'x = 5, y = 4, rule = FuzzyLife/3\n2bA$5A$A3bA$b3A!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Glider c/6 2': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\nb2A$A$3A!',
      description: 'Glider, speed c/6 (period 6, displacement 1)',
    },
    'Glider c/3 3': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\n2bA$A$b2A!',
      description: 'Glider, speed c/3 (period 6, displacement 2)',
    },
    'Glider c/6 4': {
      rle: 'x = 5, y = 4, rule = FuzzyLife/3\n2bA$bBb2A$2Ab2A$bBA!',
      description: 'Glider, speed c/6 (period 6, displacement 1)',
    },
    'Oscillator P1': {
      rle: 'x = 1, y = 1, rule = FuzzyLife/3\nB!',
      description: 'Period 1 oscillator (smallest)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 2, rule = FuzzyLife/3\n2bB$BA!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P3 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nAB$BA!',
      description: 'Period 3 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 5, y = 3, rule = FuzzyLife/3\n2bAB$2bAbA$BAbB!',
      description: 'Period 4 oscillator (smallest)',
    },
    'Glider c/6 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\n2bB$BA$BAB!',
      description: 'Glider, speed c/6 (period 6, displacement 1)',
    },
    'Oscillator P8 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\nbAB$BAB$BA!',
      description: 'Period 8 oscillator (smallest)',
    },
    'Oscillator P12 1': {
      rle: 'x = 8, y = 6, rule = FuzzyLife/3\n4b3A$3bBbAbB$3bAbAbA$4bBAB$BA3bA$AB3bB!',
      description: 'Period 12 oscillator (smallest)',
    },
  },
  'b2-7_s0-1,6-8': {
    'Glider c/6 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\nb2A$A$3A!',
      description: 'Glider, speed c/6 (period 6, displacement 1)',
    },
    'Glider c/6 2': {
      rle: 'x = 5, y = 4, rule = FuzzyLife/3\n2bA$bBb2A$2Ab2A$bBA!',
      description: 'Glider, speed c/6 (period 6, displacement 1)',
    },
    'Glider c/6 3': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\n2bB$BA$BAB!',
      description: 'Glider, speed c/6 (period 6, displacement 1)',
    },
    'Glider c/3 4': {
      rle: 'x = 4, y = 5, rule = FuzzyLife/3\n2bB$BAbA$BA$BAbA$2bB!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Oscillator P1': {
      rle: 'x = 1, y = 1, rule = FuzzyLife/3\nB!',
      description: 'Period 1 oscillator (smallest)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 2, rule = FuzzyLife/3\n2bB$BA!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P3 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nAB$BA!',
      description: 'Period 3 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\nbAbB$Bb2A$2A$BbAB!',
      description: 'Period 4 oscillator (smallest)',
    },
    'Oscillator P8 1': {
      rle: 'x = 5, y = 4, rule = FuzzyLife/3\n4bB$BABAB$bAb2A$bBAbB!',
      description: 'Period 8 oscillator (smallest)',
    },
    'Oscillator P12 1': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\n3bB$bB$bAB$B!',
      description: 'Period 12 oscillator (smallest)',
    },
  },
  'b1_s0,3-8': {
    'Glider c 1': {
      rle: 'x = 4, y = 2, rule = FuzzyLife/3\nb2A$A2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
  },
  'b3_s0,3-6': {
    'Glider c/4 1': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\nb2A$Bb2B$4B$b2B!',
      description: 'Glider, speed c/4 (period 8, displacement 2)',
    },
    'Oscillator P1': {
      rle: 'x = 1, y = 1, rule = FuzzyLife/3\nB!',
      description: 'Period 1 oscillator (smallest)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 2, rule = FuzzyLife/3\nbB$3B!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P12 1': {
      rle: 'x = 9, y = 8, rule = FuzzyLife/3\n6bB$$$$3B$BA2B4bB$B2AB$A3B!',
      description: 'Period 12 oscillator (smallest)',
    },
    'Glider c/3 1': {
      rle: 'x = 5, y = 7, rule = FuzzyLife/3\n3b2B$b2BAB$5B$2B$5B$b2BAB$3b2B!',
      description: 'Glider, speed c/3 (period 15, displacement 5)',
    },
    'Oscillator P18 1': {
      rle: 'x = 21, y = 16, rule = FuzzyLife/3\n12bA$7b3Bb2BA$7bBb3BbBA$7bBbBb2BA$b3BbBb2Bb2BbA$bBA4BbBbBbB3b3B$3BbBbBbBb5BbBbB$A2B2bBbBbBbBbBb4B$2b4BbBbBbBbBbB2b2BA$2bBbBb5BbBbBbBb3B$2b3B3bBbBbBb4BAB$7bAb2Bb2BbBb3B$7bA2BbBbB$6bABb3BbB$7bA2Bb3B$8bA!',
      description: 'Period 18 oscillator (smallest)',
    },
    'Oscillator P34 1': {
      rle: 'x = 11, y = 11, rule = FuzzyLife/3\n7bB$5b6B$5b2BbBbB$6bBb3B$2B2bBbBbB$7Bb2B$bB5b3B$7BbB$BAB2bBb3B$3B2bBb3B$5b3B!',
      description: 'Period 34 oscillator (smallest)',
    },
  },
  'b2-7_s0-1,7': {
    'Glider c/3 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\n2bA$A$b2A!',
      description: 'Glider, speed c/3 (period 6, displacement 2)',
    },
    'Glider c/3 2': {
      rle: 'x = 4, y = 5, rule = FuzzyLife/3\n2bB$BAbA$BA$BAbA$2bB!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Glider c/6 3': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\nb2A$A$3A!',
      description: 'Glider, speed c/6 (period 6, displacement 1)',
    },
    'Glider c/6 4': {
      rle: 'x = 5, y = 4, rule = FuzzyLife/3\n2bA$bBb2A$2Ab2A$bBA!',
      description: 'Glider, speed c/6 (period 6, displacement 1)',
    },
    'Oscillator P1': {
      rle: 'x = 1, y = 1, rule = FuzzyLife/3\nB!',
      description: 'Period 1 oscillator (smallest)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 2, rule = FuzzyLife/3\n2bB$BA!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P3 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nAB$BA!',
      description: 'Period 3 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 5, y = 4, rule = FuzzyLife/3\n4bB$b2A$BbB$bA!',
      description: 'Period 4 oscillator (smallest)',
    },
    'Glider c/6 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\n2bB$BA$BAB!',
      description: 'Glider, speed c/6 (period 6, displacement 1)',
    },
  },
  'b1_s3-4,8': {
    'Glider c 1': {
      rle: 'x = 2, y = 4, rule = FuzzyLife/3\nbA$A$A$bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 2': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bA$A$b2A!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 3': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\n2bA$A$A$2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 4': {
      rle: 'x = 19, y = 2, rule = FuzzyLife/3\nb2A13b2A$A2bA11bA2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
  },
  'b1_s2': {
    'Glider c 1': {
      rle: 'x = 4, y = 2, rule = FuzzyLife/3\nb2A$A2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 2': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\n2bA$A$A$2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 3': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bA$A$b2A!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 4': {
      rle: 'x = 2, y = 4, rule = FuzzyLife/3\nbA$A$A$bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
  },
  'b3_s0-1,3-6': {
    'Glider c/4 1': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\nb2A$Bb2B$4B$b2B!',
      description: 'Glider, speed c/4 (period 8, displacement 2)',
    },
    'Oscillator P1': {
      rle: 'x = 1, y = 1, rule = FuzzyLife/3\nB!',
      description: 'Period 1 oscillator (smallest)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 3, rule = FuzzyLife/3\nbB$2B$2B!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P3 1': {
      rle: 'x = 1, y = 3, rule = FuzzyLife/3\nB$B$B!',
      description: 'Period 3 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 7, y = 6, rule = FuzzyLife/3\n5bAB$2b2BAbB$2bA2B$$6bB$BbB3bB!',
      description: 'Period 4 oscillator (smallest)',
    },
    'Oscillator P17 1': {
      rle: 'x = 6, y = 5, rule = FuzzyLife/3\n2b2B$2b4B$3B$BA4B$3Bb2B!',
      description: 'Period 17 oscillator (smallest)',
    },
    'Oscillator P18 1': {
      rle: 'x = 12, y = 17, rule = FuzzyLife/3\n8bAB$8b4B$5b5BAB$5bB4b2B$5b6B$3bBbBbB2b2B$11B$BbBbBbBbBb2B$3Bb3BbBb2B$2b3Bb5B$b2Bb3B2b2B$b3B3b3B$3b4B2b2B$2bAB2b4B$3bA3B2bB$4bAb2BA$7bB!',
      description: 'Period 18 oscillator (smallest)',
    },
    'Oscillator P34 1': {
      rle: 'x = 8, y = 6, rule = FuzzyLife/3\n7bB$3Bb2B$BA5B$3B3bB$2b5B$2b2B!',
      description: 'Period 34 oscillator (smallest)',
    },
  },
  'b2-7_s0-1,7-8': {
    'Glider c/6 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\nb2A$A$3A!',
      description: 'Glider, speed c/6 (period 6, displacement 1)',
    },
    'Glider c/3 2': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\n2bA$A$b2A!',
      description: 'Glider, speed c/3 (period 6, displacement 2)',
    },
    'Glider c/6 3': {
      rle: 'x = 5, y = 4, rule = FuzzyLife/3\n2bA$bBb2A$2Ab2A$bBA!',
      description: 'Glider, speed c/6 (period 6, displacement 1)',
    },
    'Oscillator P1': {
      rle: 'x = 1, y = 1, rule = FuzzyLife/3\nB!',
      description: 'Period 1 oscillator (smallest)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 2, rule = FuzzyLife/3\n2bB$BA!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P3 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nAB$BA!',
      description: 'Period 3 oscillator (smallest)',
    },
    'Glider c/3 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\n2bB$BA$b2B!',
      description: 'Glider, speed c/3 (period 6, displacement 2)',
    },
    'Oscillator P8 1': {
      rle: 'x = 5, y = 4, rule = FuzzyLife/3\n4bB$BABAB$bAb2A$bBAbB!',
      description: 'Period 8 oscillator (smallest)',
    },
    'Oscillator P12 1': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\n3bB$bB$bAB$B!',
      description: 'Period 12 oscillator (smallest)',
    },
  },
  'b2-7_s0-1,8': {
    'Glider c/3 1': {
      rle: 'x = 4, y = 5, rule = FuzzyLife/3\n2bB$BAbA$BA$BAbA$2bB!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Glider c/6 2': {
      rle: 'x = 5, y = 4, rule = FuzzyLife/3\n2bA$bBb2A$2Ab2A$bBA!',
      description: 'Glider, speed c/6 (period 6, displacement 1)',
    },
    'Oscillator P1': {
      rle: 'x = 1, y = 1, rule = FuzzyLife/3\nB!',
      description: 'Period 1 oscillator (smallest)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 2, rule = FuzzyLife/3\n2bB$BA!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P3 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nAB$BA!',
      description: 'Period 3 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 7, y = 5, rule = FuzzyLife/3\n5bB$2bBAbA$BAbABAB$2bBAbA$5bB!',
      description: 'Period 4 oscillator (smallest)',
    },
    'Glider c/6 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\n2bB$BA$BAB!',
      description: 'Glider, speed c/6 (period 6, displacement 1)',
    },
    'Oscillator P12 1': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\n3bB$bB$bAB$B!',
      description: 'Period 12 oscillator (smallest)',
    },
  },
  'b1_s0,4': {
    'Glider c 1': {
      rle: 'x = 4, y = 2, rule = FuzzyLife/3\nb2A$A2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
  },
  'b1_s0,4-5': {
    'Glider c 1': {
      rle: 'x = 4, y = 2, rule = FuzzyLife/3\nb2A$A2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
  },
  'b2-3_s0-1,5': {
    'Glider c/3 1': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bB$2BAB$3bB!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Glider c/3 2': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bA$2AbA$3bA!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Glider c/3 3': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bA$2AbA$2bA!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Glider c/3 4': {
      rle: 'x = 5, y = 3, rule = FuzzyLife/3\n4bA$2BAbA$4bA!',
      description: 'Glider, speed c/3 (period 9, displacement 3)',
    },
    'Oscillator P1': {
      rle: 'x = 1, y = 1, rule = FuzzyLife/3\nB!',
      description: 'Period 1 oscillator (smallest)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 2, rule = FuzzyLife/3\n2bB$BA!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P3 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nAB$BA!',
      description: 'Period 3 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\n2bB$b2A$BAB!',
      description: 'Period 4 oscillator (smallest)',
    },
  },
  'b1_s2,4': {
    'Glider c 1': {
      rle: 'x = 4, y = 2, rule = FuzzyLife/3\nb2A$A2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 2': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bA$A$b2A!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 3': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\n2bA$A$A$2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
  },
  'b3-4_s1,3-5': {
    'Glider c/4 1': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\nbA$3B$BAB$bB!',
      description: 'Glider, speed c/4 (period 4, displacement 1)',
    },
    'Glider c/4 2': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\nAbA$3B$ABA!',
      description: 'Glider, speed c/4 (period 4, displacement 1)',
    },
    'Oscillator P1': {
      rle: 'x = 2, y = 1, rule = FuzzyLife/3\n2B!',
      description: 'Period 1 oscillator (smallest)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 1, rule = FuzzyLife/3\nAB!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P3 1': {
      rle: 'x = 1, y = 3, rule = FuzzyLife/3\nB$B$B!',
      description: 'Period 3 oscillator (smallest)',
    },
    'Oscillator P6 1': {
      rle: 'x = 6, y = 3, rule = FuzzyLife/3\n4bBA$$3B!',
      description: 'Period 6 oscillator (smallest)',
    },
    'Oscillator P10 1': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\nb2B$B2bB$4B$b2B!',
      description: 'Period 10 oscillator (smallest)',
    },
  },
  'b1_s3-5': {
    'Glider c 1': {
      rle: 'x = 4, y = 2, rule = FuzzyLife/3\nb2A$A2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 2': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bA$A$b2A!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 3': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\n2bA$A$A$2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 4': {
      rle: 'x = 10, y = 10, rule = FuzzyLife/3\n9bA$7bA$7bA$8bA$$$bA$A$A$2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 5': {
      rle: 'x = 7, y = 7, rule = FuzzyLife/3\n6bA$2bA$$b2A$A4bA$bA2bA$2b2A!',
      description: 'Glider, speed c (period 4, displacement 4)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
  },
  'b3-4_s1-3,5-6': {
    'Glider c/9 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\nABA$3B$BbB!',
      description: 'Glider, speed c/9 (period 9, displacement 1)',
    },
    'Glider c/9 2': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\nbB$BAB$BAB!',
      description: 'Glider, speed c/9 (period 9, displacement 1)',
    },
    'Glider c/9 3': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\nbB$3B$BbB!',
      description: 'Glider, speed c/9 (period 9, displacement 1)',
    },
    'Oscillator P1': {
      rle: 'x = 1, y = 2, rule = FuzzyLife/3\nB$B!',
      description: 'Period 1 oscillator (smallest)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 1, rule = FuzzyLife/3\nAB!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P3 1': {
      rle: 'x = 5, y = 2, rule = FuzzyLife/3\n2BA2B$2BA2B!',
      description: 'Period 3 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 2, y = 3, rule = FuzzyLife/3\nbB$BA$2B!',
      description: 'Period 4 oscillator (smallest)',
    },
    'Oscillator P6 1': {
      rle: 'x = 5, y = 3, rule = FuzzyLife/3\n3b2B$bABbA$2BA2B!',
      description: 'Period 6 oscillator (smallest)',
    },
    'Oscillator P8 1': {
      rle: 'x = 5, y = 5, rule = FuzzyLife/3\n2bB$b3B$5B$b3B$2bB!',
      description: 'Period 8 oscillator (smallest)',
    },
  },
  'b1_s0,4-6': {
    'Glider c 1': {
      rle: 'x = 4, y = 2, rule = FuzzyLife/3\nb2A$A2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
  },
  'b2-3_s0-1,6-8': {
    'Glider c/3 1': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bB$2BAB$3bB!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Glider c/3 2': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bA$2AbA$3bA!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Glider c/3 3': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bA$2AbA$2bA!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Glider c/3 4': {
      rle: 'x = 5, y = 3, rule = FuzzyLife/3\n4bA$2BAbA$4bA!',
      description: 'Glider, speed c/3 (period 9, displacement 3)',
    },
    'Oscillator P1': {
      rle: 'x = 1, y = 1, rule = FuzzyLife/3\nB!',
      description: 'Period 1 oscillator (smallest)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 2, rule = FuzzyLife/3\n2bB$BA!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P3 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nAB$BA!',
      description: 'Period 3 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\n2bB$b2A$BAB!',
      description: 'Period 4 oscillator (smallest)',
    },
    'Oscillator P6 1': {
      rle: 'x = 7, y = 5, rule = FuzzyLife/3\n3bB$2bBbB$B5AB$2bBbB$3bB!',
      description: 'Period 6 oscillator (smallest)',
    },
    'Oscillator P24 1': {
      rle: 'x = 5, y = 3, rule = FuzzyLife/3\nBABAB$BABAB$BABAB!',
      description: 'Period 24 oscillator (smallest)',
    },
  },
  'b2-3_s0-1,5-6': {
    'Glider c/3 1': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bA$2AbA$3bA!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Glider c/3 2': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bB$2BAB$3bB!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Glider c/3 3': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bA$2AbA$2bA!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Glider c/3 4': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\nAb2A$AbAB$Ab2A!',
      description: 'Glider, speed c/3 (period 9, displacement 3)',
    },
    'Glider c/3 5': {
      rle: 'x = 5, y = 3, rule = FuzzyLife/3\n4bA$2BAbA$4bA!',
      description: 'Glider, speed c/3 (period 9, displacement 3)',
    },
    'Oscillator P1': {
      rle: 'x = 1, y = 1, rule = FuzzyLife/3\nB!',
      description: 'Period 1 oscillator (smallest)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 2, rule = FuzzyLife/3\n2bB$BA!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P3 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nAB$BA!',
      description: 'Period 3 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\n2bB$b2A$BAB!',
      description: 'Period 4 oscillator (smallest)',
    },
    'Oscillator P6 1': {
      rle: 'x = 7, y = 6, rule = FuzzyLife/3\n5bB$$$B$bA3bBA$2bB2bAB!',
      description: 'Period 6 oscillator (smallest)',
    },
    'Oscillator P24 1': {
      rle: 'x = 6, y = 5, rule = FuzzyLife/3\n3b3B$3b3A$B2b3B$3b3A$3b3B!',
      description: 'Period 24 oscillator (smallest)',
    },
  },
  'b1_s0,4-7': {
    'Glider c 1': {
      rle: 'x = 2, y = 4, rule = FuzzyLife/3\nbA$A$A$bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
  },
  'b1_s2,4-5': {
    'Glider c 1': {
      rle: 'x = 4, y = 2, rule = FuzzyLife/3\nb2A$A2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 2': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bA$A$b2A!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 3': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\n2bA$A$A$2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
  },
  'b1_s3-5,7': {
    'Glider c 1': {
      rle: 'x = 4, y = 2, rule = FuzzyLife/3\nb2A$A2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 2': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bA$A$b2A!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 3': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\n2bA$A$A$2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
  },
  'b3-4_s3-5': {
    'Glider c/4 1': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\nbA$3B$BAB$bB!',
      description: 'Glider, speed c/4 (period 4, displacement 1)',
    },
    'Glider c/4 2': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\nAbA$3B$ABA!',
      description: 'Glider, speed c/4 (period 4, displacement 1)',
    },
    'Oscillator P1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\n2B$2B!',
      description: 'Period 1 oscillator (smallest)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 2, rule = FuzzyLife/3\nbB$3B!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P10 1': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\nb2B$B2bB$4B$b2B!',
      description: 'Period 10 oscillator (smallest)',
    },
  },
  'b3-4_s3-5,7': {
    'Glider c/4 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\nAbA$3B$ABA!',
      description: 'Glider, speed c/4 (period 4, displacement 1)',
    },
    'Glider c/4 2': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\nbA$3B$BAB$bB!',
      description: 'Glider, speed c/4 (period 4, displacement 1)',
    },
    'Oscillator P1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\n2B$2B!',
      description: 'Period 1 oscillator (smallest)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 2, rule = FuzzyLife/3\nbB$3B!',
      description: 'Period 2 oscillator (smallest)',
    },
  },
  'b3-4_s3-5,7-8': {
    'Glider c/4 1': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\nbA$3B$BAB$bB!',
      description: 'Glider, speed c/4 (period 4, displacement 1)',
    },
    'Glider c/4 2': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\nAbA$3B$ABA!',
      description: 'Glider, speed c/4 (period 4, displacement 1)',
    },
    'Oscillator P1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\n2B$2B!',
      description: 'Period 1 oscillator (smallest)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 2, rule = FuzzyLife/3\nbB$3B!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P10 1': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\nb2B$B2bB$4B$b2B!',
      description: 'Period 10 oscillator (smallest)',
    },
  },
  'b3-4_s3-5,8': {
    'Glider c/4 1': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\nbA$3B$BAB$bB!',
      description: 'Glider, speed c/4 (period 4, displacement 1)',
    },
    'Oscillator P1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\n2B$2B!',
      description: 'Period 1 oscillator (smallest)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 2, rule = FuzzyLife/3\nbB$3B!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P10 1': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\nb2B$B2bB$4B$b2B!',
      description: 'Period 10 oscillator (smallest)',
    },
  },
  'b3-7_s2-3,5-6': {
    'Glider c/7 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\nbB$BAB$BbB!',
      description: 'Glider, speed c/7 (period 14, displacement 2)',
    },
    'Glider c/7 2': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\n3A$3B$BAB!',
      description: 'Glider, speed c/7 (period 14, displacement 2)',
    },
    'Glider c/7 3': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\nbB$BAB$3B$bB!',
      description: 'Glider, speed c/7 (period 14, displacement 2)',
    },
    'Glider c/7 4': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\nbA$BAB$bB$3A!',
      description: 'Glider, speed c/7 (period 14, displacement 2)',
    },
    'Oscillator P1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\n2B$2B!',
      description: 'Period 1 oscillator (smallest)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\nbB$BAB$bB!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P3 1': {
      rle: 'x = 5, y = 2, rule = FuzzyLife/3\n2BA2B$2BA2B!',
      description: 'Period 3 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 4, y = 2, rule = FuzzyLife/3\nBA2B$2BAB!',
      description: 'Period 4 oscillator (smallest)',
    },
    'Oscillator P6 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\nb2B$2BA$BAB!',
      description: 'Period 6 oscillator (smallest)',
    },
    'Oscillator P12 1': {
      rle: 'x = 5, y = 5, rule = FuzzyLife/3\n2b3A$b4B$A3BA$A3B$ABA!',
      description: 'Period 12 oscillator (smallest)',
    },
  },
  'b3-7_s2-3,5-7': {
    'Glider c/7 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\nbB$BAB$BbB!',
      description: 'Glider, speed c/7 (period 14, displacement 2)',
    },
    'Glider c/7 2': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\nbB$BAB$3B$bB!',
      description: 'Glider, speed c/7 (period 14, displacement 2)',
    },
    'Glider c/7 3': {
      rle: 'x = 5, y = 3, rule = FuzzyLife/3\n2bAB$ABABA$2bAB!',
      description: 'Glider, speed c/7 (period 14, displacement 2)',
    },
    'Glider c/7 4': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\n3A$3B$BAB!',
      description: 'Glider, speed c/7 (period 14, displacement 2)',
    },
    'Glider c/7 5': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\nABA$BAB$BbB!',
      description: 'Glider, speed c/7 (period 14, displacement 2)',
    },
    'Glider c/7 6': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\nbA$BAB$bB$3A!',
      description: 'Glider, speed c/7 (period 14, displacement 2)',
    },
    'Glider c/7 7': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n2bB$2BAB$2bB!',
      description: 'Glider, speed c/7 (period 14, displacement 2)',
    },
    'Oscillator P1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\n2B$2B!',
      description: 'Period 1 oscillator (smallest)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\nbB$BAB$bB!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P3 1': {
      rle: 'x = 8, y = 5, rule = FuzzyLife/3\n6b2B$6b2B$$2BA2B$2BA2B!',
      description: 'Period 3 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 4, y = 2, rule = FuzzyLife/3\nBA2B$2BAB!',
      description: 'Period 4 oscillator (smallest)',
    },
    'Oscillator P6 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\nb2B$2BA$BAB!',
      description: 'Period 6 oscillator (smallest)',
    },
    'Oscillator P8 1': {
      rle: 'x = 6, y = 7, rule = FuzzyLife/3\n2AbAbB$5B$A4BA$BAb2B$A4BA$BA2BAB$2B2A2B!',
      description: 'Period 8 oscillator (smallest)',
    },
    'Oscillator P10 1': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\nbA2B$3B$3B$bA2B!',
      description: 'Period 10 oscillator (smallest)',
    },
    'Oscillator P12 1': {
      rle: 'x = 7, y = 6, rule = FuzzyLife/3\n2ABAB2A$A6B$6BA$A2Bb2BA$BABA2BA$2BABA2B!',
      description: 'Period 12 oscillator (smallest)',
    },
    'Oscillator P15 1': {
      rle: 'x = 3, y = 8, rule = FuzzyLife/3\nbA$3B$ABA$3B$3B$ABA$3B$bA!',
      description: 'Period 15 oscillator (smallest)',
    },
    'Oscillator P26 1': {
      rle: 'x = 8, y = 4, rule = FuzzyLife/3\n2bABbAbB$b6BA$Bb5B$bBABbAbB!',
      description: 'Period 26 oscillator (smallest)',
    },
    'Oscillator P28 1': {
      rle: 'x = 6, y = 6, rule = FuzzyLife/3\n3bBA$3b3B$2b3BA$6B$A3BAB$bBA2B!',
      description: 'Period 28 oscillator (smallest)',
    },
    'Oscillator P42 1': {
      rle: 'x = 4, y = 6, rule = FuzzyLife/3\nbA2B$3BA$A3B$b2BA$A3B$B2AB!',
      description: 'Period 42 oscillator (smallest)',
    },
  },
  'b3-8_s2-3,5-6': {
    'Glider c/7 1': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\nbB$BAB$3B$bB!',
      description: 'Glider, speed c/7 (period 14, displacement 2)',
    },
    'Glider c/7 2': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\nbA$BAB$bB$3A!',
      description: 'Glider, speed c/7 (period 14, displacement 2)',
    },
    'Glider c/7 3': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n2bB$2BAB$2bB!',
      description: 'Glider, speed c/7 (period 14, displacement 2)',
    },
    'Oscillator P1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\n2B$2B!',
      description: 'Period 1 oscillator (smallest)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\nbB$BAB$bB!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P3 1': {
      rle: 'x = 5, y = 2, rule = FuzzyLife/3\n2BA2B$2BA2B!',
      description: 'Period 3 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 4, y = 2, rule = FuzzyLife/3\nBbAB$2BbB!',
      description: 'Period 4 oscillator (smallest)',
    },
    'Oscillator P6 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\nb2B$2BA$BAB!',
      description: 'Period 6 oscillator (smallest)',
    },
    'Oscillator P32 1': {
      rle: 'x = 7, y = 7, rule = FuzzyLife/3\n2b3B$b5B$7B$7B$7B$b5B$2b3B!',
      description: 'Period 32 oscillator (smallest)',
    },
  },
  'b3-8_s2-3,5-7': {
    'Glider c/7 1': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\nb3A$4B$b3A!',
      description: 'Glider, speed c/7 (period 14, displacement 2)',
    },
    'Glider c/7 2': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\nbA$BAB$bB$3A!',
      description: 'Glider, speed c/7 (period 14, displacement 2)',
    },
    'Glider c/7 3': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n2bB$2BAB$2bB!',
      description: 'Glider, speed c/7 (period 14, displacement 2)',
    },
    'Glider c/7 4': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\nbB$BAB$3B$bB!',
      description: 'Glider, speed c/7 (period 14, displacement 2)',
    },
    'Glider c/7 5': {
      rle: 'x = 5, y = 3, rule = FuzzyLife/3\n2bAB$ABABA$2bAB!',
      description: 'Glider, speed c/7 (period 14, displacement 2)',
    },
    'Glider c/7 6': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\nbA$3A$BbB$bB!',
      description: 'Glider, speed c/7 (period 14, displacement 2)',
    },
    'Glider c/7 7': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\nbB$BAB$BbB!',
      description: 'Glider, speed c/7 (period 14, displacement 2)',
    },
    'Glider c/7 8': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\n3A$3B$BAB!',
      description: 'Glider, speed c/7 (period 14, displacement 2)',
    },
    'Glider c/7 9': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\nbB$3B$3A!',
      description: 'Glider, speed c/7 (period 14, displacement 2)',
    },
    'Oscillator P1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\n2B$2B!',
      description: 'Period 1 oscillator (smallest)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\nbB$BAB$bB!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P3 1': {
      rle: 'x = 5, y = 2, rule = FuzzyLife/3\n2BA2B$2BA2B!',
      description: 'Period 3 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 4, y = 2, rule = FuzzyLife/3\nBbAB$2BbB!',
      description: 'Period 4 oscillator (smallest)',
    },
    'Oscillator P6 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\nb2B$2BA$BAB!',
      description: 'Period 6 oscillator (smallest)',
    },
    'Oscillator P8 1': {
      rle: 'x = 6, y = 6, rule = FuzzyLife/3\nbB2AB$Bb4B$AB2ABA$AB2ABA$BA2BAB$2B2A2B!',
      description: 'Period 8 oscillator (smallest)',
    },
    'Oscillator P9 1': {
      rle: 'x = 5, y = 5, rule = FuzzyLife/3\n2bBbB$b3B$5B$b3B$BbB!',
      description: 'Period 9 oscillator (smallest)',
    },
    'Oscillator P10 1': {
      rle: 'x = 6, y = 6, rule = FuzzyLife/3\n3bB$2bA3B$2b3B$6B$A4BA$bBbB2A!',
      description: 'Period 10 oscillator (smallest)',
    },
    'Oscillator P15 1': {
      rle: 'x = 3, y = 8, rule = FuzzyLife/3\nbA$3B$ABA$3B$3B$ABA$3B$bA!',
      description: 'Period 15 oscillator (smallest)',
    },
    'Oscillator P26 1': {
      rle: 'x = 8, y = 5, rule = FuzzyLife/3\n5bA$2A2b3A$8B$A5BAB$2ABA3B!',
      description: 'Period 26 oscillator (smallest)',
    },
    'Oscillator P28 1': {
      rle: 'x = 5, y = 6, rule = FuzzyLife/3\n2bA$b3B$BABAB$2BA2B$bABA$2bB!',
      description: 'Period 28 oscillator (smallest)',
    },
  },
  'b3-7_s2-3,5-8': {
    'Glider c/7 1': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\nbB$BAB$3B$bB!',
      description: 'Glider, speed c/7 (period 14, displacement 2)',
    },
    'Glider c/7 2': {
      rle: 'x = 5, y = 3, rule = FuzzyLife/3\n2bAB$ABABA$2bAB!',
      description: 'Glider, speed c/7 (period 14, displacement 2)',
    },
    'Glider c/7 3': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\nbB$3B$3A!',
      description: 'Glider, speed c/7 (period 14, displacement 2)',
    },
    'Glider c/7 4': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\nbA$BAB$bB$3A!',
      description: 'Glider, speed c/7 (period 14, displacement 2)',
    },
    'Glider c/7 5': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\nbAB$BAbB$bAB!',
      description: 'Glider, speed c/7 (period 14, displacement 2)',
    },
    'Glider c/7 6': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n2bB$2BAB$2bB!',
      description: 'Glider, speed c/7 (period 14, displacement 2)',
    },
    'Glider c/7 7': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\nbA$BbB$BAB$bB!',
      description: 'Glider, speed c/7 (period 14, displacement 2)',
    },
    'Glider c/7 8': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\nbA$3A$BbB$bB!',
      description: 'Glider, speed c/7 (period 14, displacement 2)',
    },
    'Glider c/7 9': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\n3A$3B$BAB!',
      description: 'Glider, speed c/7 (period 14, displacement 2)',
    },
    'Oscillator P1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\n2B$2B!',
      description: 'Period 1 oscillator (smallest)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\nbB$BAB$bB!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P3 1': {
      rle: 'x = 5, y = 2, rule = FuzzyLife/3\n2BA2B$2BA2B!',
      description: 'Period 3 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 4, y = 2, rule = FuzzyLife/3\nBbAB$2BbB!',
      description: 'Period 4 oscillator (smallest)',
    },
    'Oscillator P6 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\nb2B$2BA$BAB!',
      description: 'Period 6 oscillator (smallest)',
    },
    'Oscillator P8 1': {
      rle: 'x = 5, y = 6, rule = FuzzyLife/3\n3bA$2bBAB$bBABA$B2bAB$2BbB$b2B!',
      description: 'Period 8 oscillator (smallest)',
    },
    'Oscillator P10 1': {
      rle: 'x = 6, y = 6, rule = FuzzyLife/3\n3bBA$2bA3B$bA4B$5BA$A4B$2ABA2B!',
      description: 'Period 10 oscillator (smallest)',
    },
    'Oscillator P12 1': {
      rle: 'x = 4, y = 6, rule = FuzzyLife/3\n2bAB$3B$3BA$A2BA$b3B$2B2A!',
      description: 'Period 12 oscillator (smallest)',
    },
    'Oscillator P16 1': {
      rle: 'x = 4, y = 10, rule = FuzzyLife/3\n2bAB$3B$3BA$A2BA$4B$A2BA$3B$A2B$b2BA$2B2A!',
      description: 'Period 16 oscillator (smallest)',
    },
    'Oscillator P22 1': {
      rle: 'x = 5, y = 4, rule = FuzzyLife/3\n2bA2B$b3BA$BA3B$b2B2A!',
      description: 'Period 22 oscillator (smallest)',
    },
    'Oscillator P24 1': {
      rle: 'x = 7, y = 7, rule = FuzzyLife/3\n2AB2A2B$A5B$6BA$A6B$6BA$A5B$ABAbAbB!',
      description: 'Period 24 oscillator (smallest)',
    },
    'Oscillator P42 1': {
      rle: 'x = 6, y = 6, rule = FuzzyLife/3\n3bBbB$2bA3B$bA3BA$6B$A4BA$2ABABA!',
      description: 'Period 42 oscillator (smallest)',
    },
    'Oscillator P56 1': {
      rle: 'x = 5, y = 6, rule = FuzzyLife/3\nbBbAB$4B$A3BA$5B$A3BA$2ABAB!',
      description: 'Period 56 oscillator (smallest)',
    },
  },
  'b3-7_s2-3,6': {
    'Glider c/24 1': {
      rle: 'x = 5, y = 5, rule = FuzzyLife/3\n2bA$5B$BbAbB$bBAB$2bB!',
      description: 'Glider, speed c/24 (period 24, displacement 1)',
    },
    'Glider c/24 2': {
      rle: 'x = 5, y = 5, rule = FuzzyLife/3\n2bA$b3B$BbAbB$bBAB$2bB!',
      description: 'Glider, speed c/24 (period 24, displacement 1)',
    },
    'Oscillator P1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\n2B$2B!',
      description: 'Period 1 oscillator (smallest)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\nbB$BAB$bB!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P3 1': {
      rle: 'x = 5, y = 2, rule = FuzzyLife/3\n2BA2B$2BA2B!',
      description: 'Period 3 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\nbB$BAB$b2B!',
      description: 'Period 4 oscillator (smallest)',
    },
    'Oscillator P6 1': {
      rle: 'x = 7, y = 5, rule = FuzzyLife/3\n3b2A$2b4B$bBb2AbB$BAb3B$b2B2A!',
      description: 'Period 6 oscillator (smallest)',
    },
    'Oscillator P10 1': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\n2b2B$bA2B$2BA$2B!',
      description: 'Period 10 oscillator (smallest)',
    },
  },
  'b3-8_s2-3,5-8': {
    'Glider c/7 1': {
      rle: 'x = 5, y = 3, rule = FuzzyLife/3\n2bAB$ABABA$2bAB!',
      description: 'Glider, speed c/7 (period 14, displacement 2)',
    },
    'Glider c/7 2': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\nbB$BAB$BbB!',
      description: 'Glider, speed c/7 (period 14, displacement 2)',
    },
    'Glider c/7 3': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\nb3A$4B$b3A!',
      description: 'Glider, speed c/7 (period 14, displacement 2)',
    },
    'Glider c/7 4': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\n3A$3B$BAB!',
      description: 'Glider, speed c/7 (period 14, displacement 2)',
    },
    'Glider c/7 5': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\nbB$3B$3A!',
      description: 'Glider, speed c/7 (period 14, displacement 2)',
    },
    'Glider c/7 6': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\nbA$BAB$bB$3A!',
      description: 'Glider, speed c/7 (period 14, displacement 2)',
    },
    'Glider c/7 7': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\nbB$BAB$3B$bB!',
      description: 'Glider, speed c/7 (period 14, displacement 2)',
    },
    'Oscillator P1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\n2B$2B!',
      description: 'Period 1 oscillator (smallest)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\nbB$BAB$bB!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P3 1': {
      rle: 'x = 5, y = 2, rule = FuzzyLife/3\n2BA2B$2BA2B!',
      description: 'Period 3 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\n2bB$bBAB$BAB$bB!',
      description: 'Period 4 oscillator (smallest)',
    },
    'Oscillator P6 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\nb2B$2BA$BAB!',
      description: 'Period 6 oscillator (smallest)',
    },
    'Oscillator P8 1': {
      rle: 'x = 7, y = 4, rule = FuzzyLife/3\n2ABAbAB$A5BA$6B$2AB2A2B!',
      description: 'Period 8 oscillator (smallest)',
    },
    'Oscillator P10 1': {
      rle: 'x = 6, y = 4, rule = FuzzyLife/3\n2bBABA$2bA3B$4BAB$BbBbB!',
      description: 'Period 10 oscillator (smallest)',
    },
    'Oscillator P12 1': {
      rle: 'x = 4, y = 6, rule = FuzzyLife/3\nbA2B$3BA$A2B$3B$A2BA$BAbB!',
      description: 'Period 12 oscillator (smallest)',
    },
    'Oscillator P16 1': {
      rle: 'x = 5, y = 7, rule = FuzzyLife/3\nbBbAB$4BA$A4B$4BA$A3BA$b3BA$BbA2B!',
      description: 'Period 16 oscillator (smallest)',
    },
    'Oscillator P20 1': {
      rle: 'x = 6, y = 4, rule = FuzzyLife/3\n2ABA2B$A4B$5BA$B2ABAB!',
      description: 'Period 20 oscillator (smallest)',
    },
    'Oscillator P22 1': {
      rle: 'x = 5, y = 4, rule = FuzzyLife/3\n2bA2B$b3BA$BA3B$b2B2A!',
      description: 'Period 22 oscillator (smallest)',
    },
    'Oscillator P24 1': {
      rle: 'x = 7, y = 6, rule = FuzzyLife/3\nbABAB2A$6BA$A5B$6B$A5BA$BAB2ABA!',
      description: 'Period 24 oscillator (smallest)',
    },
    'Oscillator P28 1': {
      rle: 'x = 10, y = 9, rule = FuzzyLife/3\n5bA$4b3B$3bA3BA$2bA5BA$bA8B$9BA$A8BA$BA8B$2B2A3b2AB!',
      description: 'Period 28 oscillator (smallest)',
    },
    'Oscillator P56 1': {
      rle: 'x = 5, y = 6, rule = FuzzyLife/3\nbAbB$5B$A3BA$5B$A3BA$BAB2A!',
      description: 'Period 56 oscillator (smallest)',
    },
  },
  'b3-5_s0,3-5': {
    'Glider c/4 1': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\nbA$3B$BAB$bB!',
      description: 'Glider, speed c/4 (period 4, displacement 1)',
    },
    'Oscillator P1': {
      rle: 'x = 1, y = 1, rule = FuzzyLife/3\nB!',
      description: 'Period 1 oscillator (smallest)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 2, rule = FuzzyLife/3\nbB$3B!',
      description: 'Period 2 oscillator (smallest)',
    },
  },
  'b3-5_s0,3-6': {
    'Glider c/4 1': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\nb2B$B2bB$4B$b2B!',
      description: 'Glider, speed c/4 (period 4, displacement 1)',
    },
    'Oscillator P1': {
      rle: 'x = 1, y = 1, rule = FuzzyLife/3\nB!',
      description: 'Period 1 oscillator (smallest)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 2, rule = FuzzyLife/3\nbB$3B!',
      description: 'Period 2 oscillator (smallest)',
    },
  },
  'b2-3_s0-1,7': {
    'Glider c/3 1': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bA$2AbA$2bA!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Glider c/3 2': {
      rle: 'x = 5, y = 3, rule = FuzzyLife/3\n4bA$2BAbA$4bA!',
      description: 'Glider, speed c/3 (period 9, displacement 3)',
    },
    'Glider c/3 3': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bA$2AbA$3bA!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Glider c/3 4': {
      rle: 'x = 5, y = 3, rule = FuzzyLife/3\n3bA$2AbAB$3bA!',
      description: 'Glider, speed c/3 (period 9, displacement 3)',
    },
    'Glider c/3 5': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bB$2BAB$3bB!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Glider c/7 1': {
      rle: 'x = 6, y = 5, rule = FuzzyLife/3\n3bAB$bA3bA$BA2b2A$bA2b2A$2bBA!',
      description: 'Glider, speed c/7 (period 14, displacement 2)',
    },
    'Oscillator P1': {
      rle: 'x = 1, y = 1, rule = FuzzyLife/3\nB!',
      description: 'Period 1 oscillator (smallest)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 2, rule = FuzzyLife/3\n2bB$BA!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P3 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nAB$BA!',
      description: 'Period 3 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 5, y = 4, rule = FuzzyLife/3\n3bB$bB2A$b3AB$BAB!',
      description: 'Period 4 oscillator (smallest)',
    },
    'Oscillator P6 1': {
      rle: 'x = 6, y = 4, rule = FuzzyLife/3\n4bB$5bA$BA3bB$AB!',
      description: 'Period 6 oscillator (smallest)',
    },
    'Oscillator P8 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\nbAB$BAB$BA!',
      description: 'Period 8 oscillator (smallest)',
    },
    'Oscillator P24 1': {
      rle: 'x = 5, y = 3, rule = FuzzyLife/3\nBABAB$BABAB$BABAB!',
      description: 'Period 24 oscillator (smallest)',
    },
  },
  'b1_s0,4-8': {
    'Glider c 1': {
      rle: 'x = 2, y = 4, rule = FuzzyLife/3\nbA$A$A$bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
  },
  'b3-5_s0-1,3-5': {
    'Glider c/4 1': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\nbA$3B$BAB$bB!',
      description: 'Glider, speed c/4 (period 4, displacement 1)',
    },
    'Glider c/4 2': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\nAbA$3B$ABA!',
      description: 'Glider, speed c/4 (period 4, displacement 1)',
    },
    'Oscillator P1': {
      rle: 'x = 1, y = 1, rule = FuzzyLife/3\nB!',
      description: 'Period 1 oscillator (smallest)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 2, rule = FuzzyLife/3\nbB$3B!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P3 1': {
      rle: 'x = 3, y = 1, rule = FuzzyLife/3\n3B!',
      description: 'Period 3 oscillator (smallest)',
    },
  },
  'b2-3_s0-1,5-7': {
    'Glider c/3 1': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bA$2AbA$3bA!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Glider c/3 2': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bB$2BAB$3bB!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Glider c/3 3': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bA$2AbA$2bA!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Glider c/3 4': {
      rle: 'x = 5, y = 3, rule = FuzzyLife/3\n4bA$2BAbA$4bA!',
      description: 'Glider, speed c/3 (period 9, displacement 3)',
    },
    'Oscillator P1': {
      rle: 'x = 1, y = 1, rule = FuzzyLife/3\nB!',
      description: 'Period 1 oscillator (smallest)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 2, rule = FuzzyLife/3\n2bB$BA!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P3 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nAB$BA!',
      description: 'Period 3 oscillator (smallest)',
    },
    'Oscillator P6 1': {
      rle: 'x = 7, y = 3, rule = FuzzyLife/3\n6bB$AB3bA$BA2bB!',
      description: 'Period 6 oscillator (smallest)',
    },
    'Oscillator P8 1': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\n2bB$B2AB$B2AB$bB!',
      description: 'Period 8 oscillator (smallest)',
    },
    'Oscillator P11 1': {
      rle: 'x = 5, y = 3, rule = FuzzyLife/3\nBABAB$BABAB$BABAB!',
      description: 'Period 11 oscillator (smallest)',
    },
    'Oscillator P22 1': {
      rle: 'x = 10, y = 13, rule = FuzzyLife/3\n8bB$7bAbA$8bB$$$$$9bB$3B$3A$3B$3A$3B!',
      description: 'Period 22 oscillator (smallest)',
    },
    'Oscillator P33 1': {
      rle: 'x = 7, y = 9, rule = FuzzyLife/3\n4bB$BA$AB$$4b3B$4b3A$B3b3B$4b3A$4b3B!',
      description: 'Period 33 oscillator (smallest)',
    },
  },
  'b1_s0,5': {
    'Glider c 1': {
      rle: 'x = 2, y = 4, rule = FuzzyLife/3\nbA$A$A$bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
  },
  'b1_s2,4-6': {
    'Glider c 1': {
      rle: 'x = 2, y = 4, rule = FuzzyLife/3\nbA$A$A$bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 2': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\n2bA$A$A$2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 3': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bA$A$b2A!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
  },
  'b1_s0,5-6': {
    'Glider c 1': {
      rle: 'x = 4, y = 2, rule = FuzzyLife/3\nb2A$A2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
  },
  'b2-3_s0-1,7-8': {
    'Glider c/3 1': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bA$2AbA$3bA!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Glider c/3 2': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bA$2AbA$2bA!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Glider c/3 3': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bB$2BAB$3bB!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Glider c/3 4': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\nAb2A$AbAB$Ab2A!',
      description: 'Glider, speed c/3 (period 9, displacement 3)',
    },
    'Glider c/3 5': {
      rle: 'x = 5, y = 3, rule = FuzzyLife/3\n3bA$2AbAB$3bA!',
      description: 'Glider, speed c/3 (period 9, displacement 3)',
    },
    'Oscillator P1': {
      rle: 'x = 1, y = 1, rule = FuzzyLife/3\nB!',
      description: 'Period 1 oscillator (smallest)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 2, rule = FuzzyLife/3\n2bB$BA!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P3 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nAB$BA!',
      description: 'Period 3 oscillator (smallest)',
    },
    'Oscillator P6 1': {
      rle: 'x = 6, y = 5, rule = FuzzyLife/3\n4bBA$4bAB$B$bA$2bB!',
      description: 'Period 6 oscillator (smallest)',
    },
    'Oscillator P8 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\nbAB$BAB$BA!',
      description: 'Period 8 oscillator (smallest)',
    },
    'Oscillator P24 1': {
      rle: 'x = 5, y = 3, rule = FuzzyLife/3\nBABAB$BABAB$BABAB!',
      description: 'Period 24 oscillator (smallest)',
    },
  },
  'b1_s3-5,7-8': {
    'Glider c 1': {
      rle: 'x = 2, y = 4, rule = FuzzyLife/3\nbA$A$A$bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 2': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bA$A$b2A!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 3': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\n2bA$A$A$2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 4': {
      rle: 'x = 7, y = 7, rule = FuzzyLife/3\n6bA$2bA$$b2A$A4bA$bA2bA$2b2A!',
      description: 'Glider, speed c (period 4, displacement 4)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
  },
  'b2_s0-1,3-4': {
    'Glider c/9 1': {
      rle: 'x = 6, y = 4, rule = FuzzyLife/3\n4bB$5bA$2ABAB$2A2bA!',
      description: 'Glider, speed c/9 (period 18, displacement 2)',
    },
    'Glider c/9 2': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\nb2A$3B$A2B!',
      description: 'Glider, speed c/9 (period 18, displacement 2)',
    },
    'Oscillator P1': {
      rle: 'x = 1, y = 1, rule = FuzzyLife/3\nB!',
      description: 'Period 1 oscillator (smallest)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\n2bB$bA$B!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P3 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nAB$BA!',
      description: 'Period 3 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 5, y = 4, rule = FuzzyLife/3\n3bA$BA3B$A2bA$bBA!',
      description: 'Period 4 oscillator (smallest)',
    },
    'Oscillator P6 1': {
      rle: 'x = 5, y = 5, rule = FuzzyLife/3\n3bAB$3bBA$B$bA$2bB!',
      description: 'Period 6 oscillator (smallest)',
    },
    'Oscillator P8 1': {
      rle: 'x = 5, y = 3, rule = FuzzyLife/3\nb3A$BbBbB$b3A!',
      description: 'Period 8 oscillator (smallest)',
    },
    'Oscillator P12 1': {
      rle: 'x = 12, y = 7, rule = FuzzyLife/3\n7bBbA$8b2BbB$b2A4bABbBA$3A6bB$b2BA3b2BbA$5bBb2B$6b3A!',
      description: 'Period 12 oscillator (smallest)',
    },
    'Oscillator P14 1': {
      rle: 'x = 6, y = 3, rule = FuzzyLife/3\nbAb2A$BAB2bB$bAb2A!',
      description: 'Period 14 oscillator (smallest)',
    },
    'Oscillator P24 1': {
      rle: 'x = 7, y = 7, rule = FuzzyLife/3\n5bB$4b3A$5bB$4b3A$5bB$BA$AB!',
      description: 'Period 24 oscillator (smallest)',
    },
  },
  'b1_s0,5-7': {
    'Glider c 1': {
      rle: 'x = 2, y = 4, rule = FuzzyLife/3\nbA$A$A$bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\n3bA$b2A$b2A$A!',
      description: 'Period 4 oscillator (smallest)',
    },
  },
  'b1_s1': {
    'Glider c 1': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\n2bA$A$A$2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
  },
  'b1_s1,4-5': {
    'Glider c 1': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\n2bA$A$A$2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 7, y = 7, rule = FuzzyLife/3\n2bAbA$bA3BA$AB3bBA$bB3bB$AB3bBA$bA3BA$2bAbA!',
      description: 'Period 4 oscillator (smallest)',
    },
  },
  'b2-3_s0-1,5-8': {
    'Glider c/3 1': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bA$2AbA$2bA!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Glider c/3 2': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bB$2BAB$3bB!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Glider c/3 3': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bA$2AbA$3bA!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Glider c/3 4': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\nAb2A$AbAB$Ab2A!',
      description: 'Glider, speed c/3 (period 9, displacement 3)',
    },
    'Glider c/3 5': {
      rle: 'x = 5, y = 3, rule = FuzzyLife/3\n4bA$2BAbA$4bA!',
      description: 'Glider, speed c/3 (period 9, displacement 3)',
    },
    'Oscillator P1': {
      rle: 'x = 1, y = 1, rule = FuzzyLife/3\nB!',
      description: 'Period 1 oscillator (smallest)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 2, rule = FuzzyLife/3\n2bB$BA!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P3 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nAB$BA!',
      description: 'Period 3 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\n2bB$b2A$BAB!',
      description: 'Period 4 oscillator (smallest)',
    },
    'Oscillator P6 1': {
      rle: 'x = 8, y = 4, rule = FuzzyLife/3\n6bB$7bA$BA5bB$AB!',
      description: 'Period 6 oscillator (smallest)',
    },
    'Oscillator P11 1': {
      rle: 'x = 5, y = 3, rule = FuzzyLife/3\nBABAB$BABAB$BABAB!',
      description: 'Period 11 oscillator (smallest)',
    },
    'Oscillator P22 1': {
      rle: 'x = 9, y = 8, rule = FuzzyLife/3\n7bB$6bAbA$7bB$$$BABAB$BABAB$BABAB!',
      description: 'Period 22 oscillator (smallest)',
    },
  },
  'b1_s0,5-8': {
    'Glider c 1': {
      rle: 'x = 4, y = 2, rule = FuzzyLife/3\nb2A$A2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
  },
  'b3_s1,3-6': {
    'Glider c/4 1': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\nb2A$Bb2B$4B$b2B!',
      description: 'Glider, speed c/4 (period 8, displacement 2)',
    },
    'Oscillator P1': {
      rle: 'x = 1, y = 2, rule = FuzzyLife/3\nB$B!',
      description: 'Period 1 oscillator (smallest)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 1, rule = FuzzyLife/3\nAB!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P3 1': {
      rle: 'x = 1, y = 3, rule = FuzzyLife/3\nB$B$B!',
      description: 'Period 3 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 6, y = 5, rule = FuzzyLife/3\n5bB$3b2B$3bA2B$B4bA$B3bB!',
      description: 'Period 4 oscillator (smallest)',
    },
    'Oscillator P6 1': {
      rle: 'x = 6, y = 5, rule = FuzzyLife/3\n4bB$3bB$$5bB$3B2bA!',
      description: 'Period 6 oscillator (smallest)',
    },
    'Oscillator P17 1': {
      rle: 'x = 5, y = 6, rule = FuzzyLife/3\n3b2B$3b2B$2BbB$5B$2bBAB$2b3B!',
      description: 'Period 17 oscillator (smallest)',
    },
    'Oscillator P18 1': {
      rle: 'x = 14, y = 14, rule = FuzzyLife/3\n9b2B$9b3B$6b5BbB$6bB4b2B$6b6B$b2BbBbBbB2b2B$b11B$2BbBbBbBbBbB$bBbBbBb3Bb3B$b6B2b3BAB$2bBbBb4Bb3B$b2BbBbB2bB$b7BA$3b2Bb2BA!',
      description: 'Period 18 oscillator (smallest)',
    },
    'Oscillator P34 1': {
      rle: 'x = 7, y = 5, rule = FuzzyLife/3\n3b2B$3b2B$3Bb3B$Bb3BAB$3Bb3B!',
      description: 'Period 34 oscillator (smallest)',
    },
  },
  'b1_s2,4-7': {
    'Glider c 1': {
      rle: 'x = 4, y = 2, rule = FuzzyLife/3\nb2A$A2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 2': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bA$A$b2A!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 3': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\n2bA$A$A$2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
  },
  'b1_s0,6': {
    'Glider c 1': {
      rle: 'x = 4, y = 2, rule = FuzzyLife/3\nb2A$A2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
  },
  'b2-3_s0-1,8': {
    'Glider c/3 1': {
      rle: 'x = 5, y = 3, rule = FuzzyLife/3\n2A2bB$BABAB$2A2bB!',
      description: 'Glider, speed c/3 (period 9, displacement 3)',
    },
    'Glider c/3 2': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\nAb2A$AbAB$Ab2A!',
      description: 'Glider, speed c/3 (period 9, displacement 3)',
    },
    'Glider c/3 3': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bA$2AbA$2bA!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Glider c/3 4': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bB$2BAB$3bB!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Glider c/4 1': {
      rle: 'x = 7, y = 6, rule = FuzzyLife/3\n3bA$bAbAbA$2AbAb2A$2AbAb2A$bAbAbA$2b3A!',
      description: 'Glider, speed c/4 (period 4, displacement 1)',
    },
    'Oscillator P1': {
      rle: 'x = 1, y = 1, rule = FuzzyLife/3\nB!',
      description: 'Period 1 oscillator (smallest)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 2, rule = FuzzyLife/3\n2bB$BA!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P3 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nAB$BA!',
      description: 'Period 3 oscillator (smallest)',
    },
    'Oscillator P6 1': {
      rle: 'x = 7, y = 4, rule = FuzzyLife/3\n5bAB$bB3bBA$AbA$bB!',
      description: 'Period 6 oscillator (smallest)',
    },
    'Oscillator P8 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\nbAB$BAB$BA!',
      description: 'Period 8 oscillator (smallest)',
    },
  },
  'b1_s0,6-7': {
    'Glider c 1': {
      rle: 'x = 2, y = 4, rule = FuzzyLife/3\nbA$A$A$bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
  },
  'b1_s3-5,8': {
    'Glider c 1': {
      rle: 'x = 4, y = 2, rule = FuzzyLife/3\nb2A$A2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 2': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bA$A$b2A!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 3': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\n2bA$A$A$2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 4': {
      rle: 'x = 7, y = 7, rule = FuzzyLife/3\n6bA$2bA$$b2A$A4bA$bA2bA$2b2A!',
      description: 'Glider, speed c (period 4, displacement 4)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\n3bA$b2A$b2A$A!',
      description: 'Period 4 oscillator (smallest)',
    },
  },
  'b2-3_s0-1,6': {
    'Glider c/3 1': {
      rle: 'x = 5, y = 3, rule = FuzzyLife/3\n2A2bB$BABAB$2A2bB!',
      description: 'Glider, speed c/3 (period 9, displacement 3)',
    },
    'Glider c/3 2': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bA$2AbA$3bA!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Glider c/3 3': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\nAb2A$AbAB$Ab2A!',
      description: 'Glider, speed c/3 (period 9, displacement 3)',
    },
    'Glider c/3 4': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bA$2AbA$2bA!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Oscillator P1': {
      rle: 'x = 1, y = 1, rule = FuzzyLife/3\nB!',
      description: 'Period 1 oscillator (smallest)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 2, rule = FuzzyLife/3\n2bB$BA!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P3 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nAB$BA!',
      description: 'Period 3 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\n2bB$b2A$BAB!',
      description: 'Period 4 oscillator (smallest)',
    },
    'Oscillator P6 1': {
      rle: 'x = 8, y = 2, rule = FuzzyLife/3\nbAB3bBA$B5bAB!',
      description: 'Period 6 oscillator (smallest)',
    },
    'Oscillator P8 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\nbAB$BAB$BA!',
      description: 'Period 8 oscillator (smallest)',
    },
  },
  'b1_s0,6-8': {
    'Glider c 1': {
      rle: 'x = 4, y = 2, rule = FuzzyLife/3\nb2A$A2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
  },
  'b3-5_s1,3-5': {
    'Glider c/4 1': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\nbA$3B$BAB$bB!',
      description: 'Glider, speed c/4 (period 4, displacement 1)',
    },
    'Oscillator P1': {
      rle: 'x = 1, y = 2, rule = FuzzyLife/3\nB$B!',
      description: 'Period 1 oscillator (smallest)',
    },
    'Oscillator P2 1': {
      rle: 'x = 1, y = 2, rule = FuzzyLife/3\nA$B!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P3 1': {
      rle: 'x = 1, y = 3, rule = FuzzyLife/3\nB$B$B!',
      description: 'Period 3 oscillator (smallest)',
    },
    'Oscillator P6 1': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bB$B2bB$A2bB!',
      description: 'Period 6 oscillator (smallest)',
    },
  },
  'b1_s0,7': {
    'Glider c 1': {
      rle: 'x = 4, y = 2, rule = FuzzyLife/3\nb2A$A2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 5, y = 3, rule = FuzzyLife/3\n4bA$b3A$A!',
      description: 'Period 4 oscillator (smallest)',
    },
  },
  'b1_s2,4-8': {
    'Glider c 1': {
      rle: 'x = 4, y = 2, rule = FuzzyLife/3\nb2A$A2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 2': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\n2bA$A$A$2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 3': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bA$A$b2A!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
  },
  'b1_s1,3-7': {
    'Glider c 1': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\n2bA$A$A$2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
  },
  'b1_s2,6-8': {
    'Glider c 1': {
      rle: 'x = 2, y = 4, rule = FuzzyLife/3\nbA$A$A$bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 2': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bA$A$b2A!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 3': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\n2bA$A$A$2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
  },
  'b1_s0,7-8': {
    'Glider c 1': {
      rle: 'x = 2, y = 4, rule = FuzzyLife/3\nbA$A$A$bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 5, y = 3, rule = FuzzyLife/3\n4bA$b3A$A!',
      description: 'Period 4 oscillator (smallest)',
    },
  },
  'b3-5_s2-3,5-6': {
    'Glider c/7 1': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\nbB$BAB$3B$bB!',
      description: 'Glider, speed c/7 (period 14, displacement 2)',
    },
    'Glider c/7 2': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\nbB$BAB$BbB!',
      description: 'Glider, speed c/7 (period 14, displacement 2)',
    },
    'Glider c/7 3': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\nbA$BAB$bB$3A!',
      description: 'Glider, speed c/7 (period 14, displacement 2)',
    },
    'Oscillator P1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\n2B$2B!',
      description: 'Period 1 oscillator (smallest)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\nbB$BAB$bB!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P3 1': {
      rle: 'x = 5, y = 2, rule = FuzzyLife/3\n2BA2B$2BA2B!',
      description: 'Period 3 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 4, y = 2, rule = FuzzyLife/3\nBA2B$2BAB!',
      description: 'Period 4 oscillator (smallest)',
    },
    'Oscillator P6 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\nb2B$2BA$BAB!',
      description: 'Period 6 oscillator (smallest)',
    },
    'Oscillator P12 1': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\nbB$BbB$3B$ABA!',
      description: 'Period 12 oscillator (smallest)',
    },
  },
  'b3-5_s2-3,5-7': {
    'Glider c/7 1': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\nbB$BAB$3B$bB!',
      description: 'Glider, speed c/7 (period 14, displacement 2)',
    },
    'Oscillator P1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\n2B$2B!',
      description: 'Period 1 oscillator (smallest)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\nbB$BAB$bB!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P3 1': {
      rle: 'x = 5, y = 2, rule = FuzzyLife/3\n2BA2B$2BA2B!',
      description: 'Period 3 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 4, y = 2, rule = FuzzyLife/3\nBA2B$2BAB!',
      description: 'Period 4 oscillator (smallest)',
    },
    'Oscillator P6 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\nb2B$2BA$BAB!',
      description: 'Period 6 oscillator (smallest)',
    },
    'Oscillator P7 1': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\nb2A$4B$B2bB$b2B!',
      description: 'Period 7 oscillator (smallest)',
    },
    'Oscillator P8 1': {
      rle: 'x = 4, y = 7, rule = FuzzyLife/3\n2AbB$3B$A2BA$A3B$A2BA$b3B$BAbB!',
      description: 'Period 8 oscillator (smallest)',
    },
    'Oscillator P12 1': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\nbB$BbB$3B$ABA!',
      description: 'Period 12 oscillator (smallest)',
    },
    'Oscillator P16 1': {
      rle: 'x = 7, y = 7, rule = FuzzyLife/3\nBbABAbB$b2BA3B$A5BA$BABb3B$A5BA$b4BAB$2BABA2B!',
      description: 'Period 16 oscillator (smallest)',
    },
    'Oscillator P18 1': {
      rle: 'x = 7, y = 7, rule = FuzzyLife/3\n2bBA2B$b2A2BbB$BA4BA$A5B$6B$Bb5B$b2B4A!',
      description: 'Period 18 oscillator (smallest)',
    },
  },
  'b3-5_s2-3,5-8': {
    'Glider c/7 1': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\nbB$BAB$3B$bB!',
      description: 'Glider, speed c/7 (period 14, displacement 2)',
    },
    'Glider c/7 2': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\nbB$BAB$BbB!',
      description: 'Glider, speed c/7 (period 14, displacement 2)',
    },
    'Oscillator P1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\n2B$2B!',
      description: 'Period 1 oscillator (smallest)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\nbB$BAB$bB!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P3 1': {
      rle: 'x = 5, y = 2, rule = FuzzyLife/3\n2BA2B$2BA2B!',
      description: 'Period 3 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 4, y = 2, rule = FuzzyLife/3\nBbAB$2BbB!',
      description: 'Period 4 oscillator (smallest)',
    },
    'Oscillator P6 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\nb2B$2BA$BAB!',
      description: 'Period 6 oscillator (smallest)',
    },
    'Oscillator P8 1': {
      rle: 'x = 5, y = 6, rule = FuzzyLife/3\n2bAbB$5B$b3BA$4B$b4B$2bB!',
      description: 'Period 8 oscillator (smallest)',
    },
    'Oscillator P10 1': {
      rle: 'x = 5, y = 5, rule = FuzzyLife/3\n2bAB$3BbB$5B$A3BA$BbAB!',
      description: 'Period 10 oscillator (smallest)',
    },
    'Oscillator P12 1': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\nbB$BbB$3B$ABA!',
      description: 'Period 12 oscillator (smallest)',
    },
    'Oscillator P20 1': {
      rle: 'x = 6, y = 8, rule = FuzzyLife/3\n2bAbAB$5BA$b4B$A4B$5BA$A5B$5BA$BbA2B!',
      description: 'Period 20 oscillator (smallest)',
    },
    'Oscillator P24 1': {
      rle: 'x = 7, y = 9, rule = FuzzyLife/3\n3b2BA$bB2b3B$Bb4BA$A6B$6BA$Bb4B$bA4BA$b6B$b2ABAbB!',
      description: 'Period 24 oscillator (smallest)',
    },
    'Oscillator P28 1': {
      rle: 'x = 10, y = 8, rule = FuzzyLife/3\nbAB2AB2ABA$9BA$9B$A8BA$b8B$b8BA$A9B$BbABABAB2A!',
      description: 'Period 28 oscillator (smallest)',
    },
    'Oscillator P36 1': {
      rle: 'x = 8, y = 8, rule = FuzzyLife/3\n4bBAbB$3bA3B$3b4BA$2b6B$7BA$A7B$BA5BA$2BABAB2A!',
      description: 'Period 36 oscillator (smallest)',
    },
    'Oscillator P40 1': {
      rle: 'x = 7, y = 14, rule = FuzzyLife/3\n3bBAbB$2A2b3B$6BA$A6B$A5BA$b6B$A5BA$b6B$A5BA$A5BA$6BA$b5B$2bAb3B$3b2B!',
      description: 'Period 40 oscillator (smallest)',
    },
    'Oscillator P44 1': {
      rle: 'x = 5, y = 15, rule = FuzzyLife/3\nbABA$5B$A3BA$A4B$4BA$A4B$A3BA$b4B$b3BA$A4B$b3BA$b3BA$b3BA$A2BAB$ABA2B!',
      description: 'Period 44 oscillator (smallest)',
    },
    'Oscillator P56 1': {
      rle: 'x = 5, y = 6, rule = FuzzyLife/3\nbAbB$5B$A3BA$5B$A3BA$BAB2A!',
      description: 'Period 56 oscillator (smallest)',
    },
    'Oscillator P60 1': {
      rle: 'x = 14, y = 12, rule = FuzzyLife/3\n9bBAB$9b4B$7bA4B$2bAB3A5BbB$b13B$A12B$7Bb5B$2A11B$bBb10BA$2b12B$2bA9B2A$2bBABABABABAB!',
      description: 'Period 60 oscillator (smallest)',
    },
  },
  'b3_s3-6': {
    'Glider c/3 1': {
      rle: 'x = 6, y = 5, rule = FuzzyLife/3\nb3BbA$5B$2B$5B$b3BbA!',
      description: 'Glider, speed c/3 (period 15, displacement 5)',
    },
    'Glider c/3 2': {
      rle: 'x = 6, y = 7, rule = FuzzyLife/3\n3b2A$b3BbB$A4B$2B3bA$A4B$b3BbB$3b2A!',
      description: 'Glider, speed c/3 (period 15, displacement 5)',
    },
    'Oscillator P1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\n2B$2B!',
      description: 'Period 1 oscillator (smallest)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 2, rule = FuzzyLife/3\nbB$3B!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Glider c/4 1': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\nb2A$Bb2B$4B$b2B!',
      description: 'Glider, speed c/4 (period 8, displacement 2)',
    },
    'Oscillator P12 1': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\nb3B$2BAB$B2AB$3BA!',
      description: 'Period 12 oscillator (smallest)',
    },
    'Oscillator P17 1': {
      rle: 'x = 15, y = 11, rule = FuzzyLife/3\n7bB$5b5B$3BbBbBbBbBb3B$BA11BAB$3BbB2bB2bBb3B$2bBb7BbB$2b2B3bB3b2B$3b9B$3bBbBbBbBbB$4b7B$6bBbB!',
      description: 'Period 17 oscillator (smallest)',
    },
    'Oscillator P18 1': {
      rle: 'x = 21, y = 16, rule = FuzzyLife/3\n12bA$7b3Bb2BA$7bBb3BbBA$7bBbBb2BA$b3BbBb2Bb2BbA$bBA4BbBbBbB3b3B$3BbBbBbBb5BbBbB$A2B2bBbBbBbBbBb4B$2b4BbBbBbBbBbB2b2BA$2bBbBb5BbBbBbBb3B$2b3B3bBbBbBb4BAB$7bAb2Bb2BbBb3B$7bA2BbBbB$6bABb3BbB$7bA2Bb3B$8bA!',
      description: 'Period 18 oscillator (smallest)',
    },
    'Oscillator P34 1': {
      rle: 'x = 12, y = 11, rule = FuzzyLife/3\n8b3B$8bBbB$8b3B$2b2B5bB$2b2B4b2B$3Bb2BbBb2B$BA4Bb3B$3BbBb2Bb3B$5b3BbBbB$7b5B$7b2B!',
      description: 'Period 34 oscillator (smallest)',
    },
  },
  'b3-5_s3-5': {
    'Glider c/4 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\nAbA$3B$ABA!',
      description: 'Glider, speed c/4 (period 4, displacement 1)',
    },
    'Glider c/4 2': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\nbA$3B$BAB$bB!',
      description: 'Glider, speed c/4 (period 4, displacement 1)',
    },
    'Oscillator P1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\n2B$2B!',
      description: 'Period 1 oscillator (smallest)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 2, rule = FuzzyLife/3\nbB$3B!',
      description: 'Period 2 oscillator (smallest)',
    },
  },
  'b3-5_s3-5,7': {
    'Glider c/4 1': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\nbA$3B$BAB$bB!',
      description: 'Glider, speed c/4 (period 4, displacement 1)',
    },
    'Oscillator P1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\n2B$2B!',
      description: 'Period 1 oscillator (smallest)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 2, rule = FuzzyLife/3\nbB$3B!',
      description: 'Period 2 oscillator (smallest)',
    },
  },
  'b1_s0,8': {
    'Glider c 1': {
      rle: 'x = 2, y = 4, rule = FuzzyLife/3\nbA$A$A$bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
  },
  'b3-5_s3-5,7-8': {
    'Glider c/4 1': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\nbA$3B$BAB$bB!',
      description: 'Glider, speed c/4 (period 4, displacement 1)',
    },
    'Oscillator P1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\n2B$2B!',
      description: 'Period 1 oscillator (smallest)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 2, rule = FuzzyLife/3\nbB$3B!',
      description: 'Period 2 oscillator (smallest)',
    },
  },
  'b3-4_s0,3-5': {
    'Glider c/4 1': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\nbA$3B$BAB$bB!',
      description: 'Glider, speed c/4 (period 4, displacement 1)',
    },
    'Glider c/4 2': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\nAbA$3B$ABA!',
      description: 'Glider, speed c/4 (period 4, displacement 1)',
    },
    'Oscillator P1': {
      rle: 'x = 1, y = 1, rule = FuzzyLife/3\nB!',
      description: 'Period 1 oscillator (smallest)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 2, rule = FuzzyLife/3\nbB$3B!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P10 1': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\nb2B$B2bB$4B$b2B!',
      description: 'Period 10 oscillator (smallest)',
    },
  },
  'b3-5_s3-5,8': {
    'Glider c/4 1': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\nbA$3B$BAB$bB!',
      description: 'Glider, speed c/4 (period 4, displacement 1)',
    },
    'Glider c/4 2': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\nAbA$3B$ABA!',
      description: 'Glider, speed c/4 (period 4, displacement 1)',
    },
    'Oscillator P1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\n2B$2B!',
      description: 'Period 1 oscillator (smallest)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 2, rule = FuzzyLife/3\nbB$3B!',
      description: 'Period 2 oscillator (smallest)',
    },
  },
  'b3-5_s3-6': {
    'Glider c/4 1': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\nb2B$B2bB$4B$b2B!',
      description: 'Glider, speed c/4 (period 4, displacement 1)',
    },
    'Oscillator P1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\n2B$2B!',
      description: 'Period 1 oscillator (smallest)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 2, rule = FuzzyLife/3\nbB$3B!',
      description: 'Period 2 oscillator (smallest)',
    },
  },
  'b1_s3-6': {
    'Glider c 1': {
      rle: 'x = 4, y = 2, rule = FuzzyLife/3\nb2A$A2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 2': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bA$A$b2A!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 3': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\n2bA$A$A$2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 4': {
      rle: 'x = 2, y = 4, rule = FuzzyLife/3\nbA$A$A$bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P6 1': {
      rle: 'x = 5, y = 6, rule = FuzzyLife/3\n4bA$2bBA$Ab2B$b3B$b2BbA$A2bA!',
      description: 'Period 6 oscillator (smallest)',
    },
  },
  'b2-3_s0-1,6-7': {
    'Glider c/3 1': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bA$2AbA$2bA!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Glider c/3 2': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bA$2AbA$3bA!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Glider c/3 3': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bB$2BAB$3bB!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Oscillator P1': {
      rle: 'x = 1, y = 1, rule = FuzzyLife/3\nB!',
      description: 'Period 1 oscillator (smallest)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 2, rule = FuzzyLife/3\n2bB$BA!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P3 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nAB$BA!',
      description: 'Period 3 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\nBbAB$2bA$2AbA$BbAB!',
      description: 'Period 4 oscillator (smallest)',
    },
    'Oscillator P6 1': {
      rle: 'x = 5, y = 5, rule = FuzzyLife/3\n3bAB$3bBA$B$bA$2bB!',
      description: 'Period 6 oscillator (smallest)',
    },
    'Oscillator P8 1': {
      rle: 'x = 8, y = 6, rule = FuzzyLife/3\n6bB$7bA$6bA$2B4bAB$3A$b2B2bB!',
      description: 'Period 8 oscillator (smallest)',
    },
    'Oscillator P24 1': {
      rle: 'x = 5, y = 3, rule = FuzzyLife/3\nBABAB$BABAB$BABAB!',
      description: 'Period 24 oscillator (smallest)',
    },
  },
  'b3-4_s0-1,3-5': {
    'Glider c/4 1': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\nbA$3B$BAB$bB!',
      description: 'Glider, speed c/4 (period 4, displacement 1)',
    },
    'Oscillator P1': {
      rle: 'x = 1, y = 1, rule = FuzzyLife/3\nB!',
      description: 'Period 1 oscillator (smallest)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 3, rule = FuzzyLife/3\nbB$2B$2B!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P3 1': {
      rle: 'x = 1, y = 3, rule = FuzzyLife/3\nB$B$B!',
      description: 'Period 3 oscillator (smallest)',
    },
    'Oscillator P10 1': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\nb2B$B2bB$4B$b2B!',
      description: 'Period 10 oscillator (smallest)',
    },
  },
  'b3-6_s1-3,5-6': {
    'Glider c/7 1': {
      rle: 'x = 3, y = 6, rule = FuzzyLife/3\nAbA$AbA$3B$3A$BbB$BAB!',
      description: 'Glider, speed c/7 (period 7, displacement 1)',
    },
    'Oscillator P1': {
      rle: 'x = 1, y = 2, rule = FuzzyLife/3\nB$B!',
      description: 'Period 1 oscillator (smallest)',
    },
    'Oscillator P2 1': {
      rle: 'x = 1, y = 2, rule = FuzzyLife/3\nA$B!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P3 1': {
      rle: 'x = 5, y = 2, rule = FuzzyLife/3\n2BA2B$2BA2B!',
      description: 'Period 3 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 2, y = 3, rule = FuzzyLife/3\nbB$BA$2B!',
      description: 'Period 4 oscillator (smallest)',
    },
    'Oscillator P6 1': {
      rle: 'x = 6, y = 3, rule = FuzzyLife/3\n4b2B$2BAbB$2BA2B!',
      description: 'Period 6 oscillator (smallest)',
    },
    'Oscillator P8 1': {
      rle: 'x = 5, y = 4, rule = FuzzyLife/3\n2bB$bBAB$BbBAB$b2BbB!',
      description: 'Period 8 oscillator (smallest)',
    },
  },
  'b1_s1,7': {
    'Glider c 1': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\n2bA$A$A$2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
  },
  'b1_s2,5': {
    'Glider c 1': {
      rle: 'x = 4, y = 2, rule = FuzzyLife/3\nb2A$A2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 2': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\n2bA$A$A$2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 3': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bA$A$b2A!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
  },
  'b3-6_s2-3': {
    'Glider c/26 1': {
      rle: 'x = 5, y = 6, rule = FuzzyLife/3\n2bA$b3B$2AB2A$BABAB$b3B$2bB!',
      description: 'Glider, speed c/26 (period 26, displacement 1)',
    },
    'Oscillator P1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\n2B$2B!',
      description: 'Period 1 oscillator (smallest)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\nbB$BAB$bB!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P3 1': {
      rle: 'x = 5, y = 2, rule = FuzzyLife/3\n2BA2B$2BA2B!',
      description: 'Period 3 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\nbB$BAB$b2B!',
      description: 'Period 4 oscillator (smallest)',
    },
    'Oscillator P6 1': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\n2b2B$b2AB$2BA$2B!',
      description: 'Period 6 oscillator (smallest)',
    },
    'Oscillator P8 1': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\n2b2B$2bAB$BAB$2B!',
      description: 'Period 8 oscillator (smallest)',
    },
    'Oscillator P10 1': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\n2b2B$bBAB$BAB$2B!',
      description: 'Period 10 oscillator (smallest)',
    },
    'Oscillator P12 1': {
      rle: 'x = 4, y = 5, rule = FuzzyLife/3\n2bBA$bBAB$2B2A$B2AB$b2B!',
      description: 'Period 12 oscillator (smallest)',
    },
    'Oscillator P24 1': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\nb2B$BbAB$4B!',
      description: 'Period 24 oscillator (smallest)',
    },
  },
  'b3-6_s2-3,5-6': {
    'Glider c/7 1': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\nbB$BAB$3B$bB!',
      description: 'Glider, speed c/7 (period 14, displacement 2)',
    },
    'Glider c/7 2': {
      rle: 'x = 5, y = 3, rule = FuzzyLife/3\n2bAB$ABABA$2bAB!',
      description: 'Glider, speed c/7 (period 14, displacement 2)',
    },
    'Glider c/7 3': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\nbB$BAB$BbB!',
      description: 'Glider, speed c/7 (period 14, displacement 2)',
    },
    'Glider c/7 4': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\nb3A$4B$b3A!',
      description: 'Glider, speed c/7 (period 14, displacement 2)',
    },
    'Glider c/7 5': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n2bB$2BAB$2bB!',
      description: 'Glider, speed c/7 (period 14, displacement 2)',
    },
    'Oscillator P1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\n2B$2B!',
      description: 'Period 1 oscillator (smallest)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\nbB$BAB$bB!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P3 1': {
      rle: 'x = 5, y = 2, rule = FuzzyLife/3\n2BA2B$2BA2B!',
      description: 'Period 3 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 4, y = 2, rule = FuzzyLife/3\nBA2B$2BAB!',
      description: 'Period 4 oscillator (smallest)',
    },
    'Oscillator P6 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\nb2B$2BA$BAB!',
      description: 'Period 6 oscillator (smallest)',
    },
  },
  'b3-6_s2-3,5-7': {
    'Glider c/7 1': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\nbB$BAB$3B$bB!',
      description: 'Glider, speed c/7 (period 14, displacement 2)',
    },
    'Glider c/7 2': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\nbB$BAB$BbB!',
      description: 'Glider, speed c/7 (period 14, displacement 2)',
    },
    'Glider c/7 3': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n2bB$2BAB$2bB!',
      description: 'Glider, speed c/7 (period 14, displacement 2)',
    },
    'Glider c/7 4': {
      rle: 'x = 5, y = 3, rule = FuzzyLife/3\n2bAB$ABABA$2bAB!',
      description: 'Glider, speed c/7 (period 14, displacement 2)',
    },
    'Glider c/7 5': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\nbA$BbB$BAB$bB!',
      description: 'Glider, speed c/7 (period 14, displacement 2)',
    },
    'Oscillator P1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\n2B$2B!',
      description: 'Period 1 oscillator (smallest)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\nbB$BAB$bB!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P3 1': {
      rle: 'x = 5, y = 2, rule = FuzzyLife/3\n2BA2B$2BA2B!',
      description: 'Period 3 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 4, y = 2, rule = FuzzyLife/3\nBA2B$2BAB!',
      description: 'Period 4 oscillator (smallest)',
    },
    'Oscillator P6 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\nb2B$2BA$BAB!',
      description: 'Period 6 oscillator (smallest)',
    },
    'Oscillator P8 1': {
      rle: 'x = 7, y = 7, rule = FuzzyLife/3\n3bBABA$2bBA2BA$b2A3B$BABb2BA$A6B$BA4BA$2BAbAbB!',
      description: 'Period 8 oscillator (smallest)',
    },
    'Oscillator P12 1': {
      rle: 'x = 7, y = 7, rule = FuzzyLife/3\nbBbAb2A$7B$A5BA$3Bb2B$A5B$b5BA$BAbABAB!',
      description: 'Period 12 oscillator (smallest)',
    },
    'Oscillator P18 1': {
      rle: 'x = 9, y = 9, rule = FuzzyLife/3\nBbAbABAbB$8BA$A7B$3BbBb2B$A3BA3BA$3BbBb3B$A7BA$BA6B$2BABA2bAB!',
      description: 'Period 18 oscillator (smallest)',
    },
    'Oscillator P26 1': {
      rle: 'x = 5, y = 5, rule = FuzzyLife/3\n2bBA$b3BA$5B$A3B$bAB!',
      description: 'Period 26 oscillator (smallest)',
    },
    'Oscillator P28 1': {
      rle: 'x = 9, y = 9, rule = FuzzyLife/3\n3bBbAB2A$2bA5BA$2b7B$5Bb2BA$A7BA$b2BbBb2BA$b7BA$7BAB$B2bAb2A2B!',
      description: 'Period 28 oscillator (smallest)',
    },
  },
  'b1_s2,7': {
    'Glider c 1': {
      rle: 'x = 4, y = 2, rule = FuzzyLife/3\nb2A$A2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 2': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\n2bA$A$A$2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 3': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bA$A$b2A!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 5, y = 3, rule = FuzzyLife/3\n4bA$b3A$A!',
      description: 'Period 4 oscillator (smallest)',
    },
  },
  'b3-6_s2-3,5-8': {
    'Glider c/7 1': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\nbB$BAB$3B$bB!',
      description: 'Glider, speed c/7 (period 14, displacement 2)',
    },
    'Glider c/7 2': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\nbA$BAB$bB$3A!',
      description: 'Glider, speed c/7 (period 14, displacement 2)',
    },
    'Glider c/7 3': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n2bB$2BAB$2bB!',
      description: 'Glider, speed c/7 (period 14, displacement 2)',
    },
    'Glider c/7 4': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\nbA$BbB$BAB$bB!',
      description: 'Glider, speed c/7 (period 14, displacement 2)',
    },
    'Oscillator P1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\n2B$2B!',
      description: 'Period 1 oscillator (smallest)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\nbB$BAB$bB!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P3 1': {
      rle: 'x = 5, y = 2, rule = FuzzyLife/3\n2BA2B$2BA2B!',
      description: 'Period 3 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 4, y = 2, rule = FuzzyLife/3\nBbAB$2BbB!',
      description: 'Period 4 oscillator (smallest)',
    },
    'Oscillator P6 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\nb2B$2BA$BAB!',
      description: 'Period 6 oscillator (smallest)',
    },
    'Oscillator P8 1': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\n2bB$bAbB$BAB$b3B!',
      description: 'Period 8 oscillator (smallest)',
    },
    'Oscillator P10 1': {
      rle: 'x = 4, y = 7, rule = FuzzyLife/3\nBbAB$A2B$b2BA$A3B$3BA$A3B$BAbB!',
      description: 'Period 10 oscillator (smallest)',
    },
    'Oscillator P12 1': {
      rle: 'x = 4, y = 6, rule = FuzzyLife/3\nbA2B$3BA$A2B$3B$A2BA$BAbB!',
      description: 'Period 12 oscillator (smallest)',
    },
    'Oscillator P16 1': {
      rle: 'x = 8, y = 7, rule = FuzzyLife/3\n2bBAbAB$bA4B2A$8B$A6BA$b6BA$A7B$BABABAbB!',
      description: 'Period 16 oscillator (smallest)',
    },
    'Oscillator P20 1': {
      rle: 'x = 7, y = 8, rule = FuzzyLife/3\n4bBbB$4b3B$3b3BA$2b4BA$7B$A4BbB$4BA$2A2B!',
      description: 'Period 20 oscillator (smallest)',
    },
    'Oscillator P22 1': {
      rle: 'x = 5, y = 4, rule = FuzzyLife/3\n2bA2B$b3BA$BA3B$b2B2A!',
      description: 'Period 22 oscillator (smallest)',
    },
    'Oscillator P24 1': {
      rle: 'x = 7, y = 9, rule = FuzzyLife/3\n2ABAbAB$A5B$6BA$A6B$6BA$A5B$A5BA$b5B$BbABA2B!',
      description: 'Period 24 oscillator (smallest)',
    },
    'Oscillator P26 1': {
      rle: 'x = 4, y = 6, rule = FuzzyLife/3\nbA2B$3BA$A2B$3B$4B$b2B!',
      description: 'Period 26 oscillator (smallest)',
    },
    'Oscillator P28 1': {
      rle: 'x = 9, y = 8, rule = FuzzyLife/3\n4bA$3b3B$2bA3BA$bA5BA$9B$b7BA$A6BAB$AB2AB2A2B!',
      description: 'Period 28 oscillator (smallest)',
    },
    'Oscillator P30 1': {
      rle: 'x = 10, y = 9, rule = FuzzyLife/3\nbAB2A2bAbB$BA8B$A8BA$10B$A4Bb3BA$A8B$9B$A8BA$BABABABAbB!',
      description: 'Period 30 oscillator (smallest)',
    },
    'Oscillator P42 1': {
      rle: 'x = 7, y = 9, rule = FuzzyLife/3\n3bBbB$2bA4B$2b4BA$7B$6BA$A5B$6B$A5BA$BbABAbB!',
      description: 'Period 42 oscillator (smallest)',
    },
    'Oscillator P56 1': {
      rle: 'x = 5, y = 6, rule = FuzzyLife/3\nbBbAB$4B$A3BA$5B$A3BA$2ABAB!',
      description: 'Period 56 oscillator (smallest)',
    },
  },
  'b3-6_s2-3,7-8': {
    'Glider c/26 1': {
      rle: 'x = 5, y = 6, rule = FuzzyLife/3\n2bA$b3B$2AB2A$BABAB$b3B$2bB!',
      description: 'Glider, speed c/26 (period 26, displacement 1)',
    },
    'Oscillator P1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\n2B$2B!',
      description: 'Period 1 oscillator (smallest)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\nbB$BAB$bB!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P3 1': {
      rle: 'x = 5, y = 2, rule = FuzzyLife/3\n2BA2B$2BA2B!',
      description: 'Period 3 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\nbB$BAB$b2B!',
      description: 'Period 4 oscillator (smallest)',
    },
    'Oscillator P6 1': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\n2b2B$b2AB$2BA$2B!',
      description: 'Period 6 oscillator (smallest)',
    },
    'Oscillator P12 1': {
      rle: 'x = 4, y = 5, rule = FuzzyLife/3\n2bBA$bBAB$2B2A$B2AB$b2B!',
      description: 'Period 12 oscillator (smallest)',
    },
    'Oscillator P24 1': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\nb2B$BbAB$4B!',
      description: 'Period 24 oscillator (smallest)',
    },
  },
  'b1_s1,7-8': {
    'Glider c 1': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\n2bA$A$A$2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
  },
  'b1_s2-5': {
    'Glider c 1': {
      rle: 'x = 2, y = 4, rule = FuzzyLife/3\nbA$A$A$bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 2': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bA$A$b2A!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 3': {
      rle: 'x = 4, y = 2, rule = FuzzyLife/3\nb2A$A2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P6 1': {
      rle: 'x = 5, y = 5, rule = FuzzyLife/3\n4bA$A2bB$b3B$b2BbA$3bA!',
      description: 'Period 6 oscillator (smallest)',
    },
    'Oscillator P12 1': {
      rle: 'x = 6, y = 5, rule = FuzzyLife/3\n5bA$b2BbB$b2BbB$Ab3B$bA!',
      description: 'Period 12 oscillator (smallest)',
    },
  },
  'b1_s3,5-7': {
    'Glider c 1': {
      rle: 'x = 4, y = 2, rule = FuzzyLife/3\nb2A$A2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 2': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bA$A$b2A!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 3': {
      rle: 'x = 10, y = 10, rule = FuzzyLife/3\n9bA$7bA$7bA$8bA$$$bA$A$A$2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 4': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\n2bA$A$A$2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\n3bA$b2A$b2A$A!',
      description: 'Period 4 oscillator (smallest)',
    },
  },
  'b1_s2-3,6-8': {
    'Glider c 1': {
      rle: 'x = 4, y = 2, rule = FuzzyLife/3\nb2A$A2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 2': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bA$A$b2A!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P5 1': {
      rle: 'x = 5, y = 5, rule = FuzzyLife/3\n3bA$b2BbA$bBbB$Ab2B$bA!',
      description: 'Period 5 oscillator (smallest)',
    },
    'Oscillator P6 1': {
      rle: 'x = 6, y = 6, rule = FuzzyLife/3\n5bA$b4B$bB2bB$bB2bB$Ab3B$bA3bA!',
      description: 'Period 6 oscillator (smallest)',
    },
  },
  'b1_s3-6,8': {
    'Glider c 1': {
      rle: 'x = 4, y = 2, rule = FuzzyLife/3\nb2A$A2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 2': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bA$A$b2A!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 3': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\n2bA$A$A$2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P6 1': {
      rle: 'x = 5, y = 5, rule = FuzzyLife/3\n4bA$b2B$b3B$Ab2B$bA2bA!',
      description: 'Period 6 oscillator (smallest)',
    },
  },
  'b1_s2,5-6': {
    'Glider c 1': {
      rle: 'x = 2, y = 4, rule = FuzzyLife/3\nbA$A$A$bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 2': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bA$A$b2A!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 3': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\n2bA$A$A$2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
  },
  'b1_s2,5-8': {
    'Glider c 1': {
      rle: 'x = 4, y = 2, rule = FuzzyLife/3\nb2A$A2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 2': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bA$A$b2A!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 3': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\n2bA$A$A$2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
  },
  'b1_s2,7-8': {
    'Glider c 1': {
      rle: 'x = 4, y = 2, rule = FuzzyLife/3\nb2A$A2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 2': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bA$A$b2A!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 3': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\n2bA$A$A$2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
  },
  'b1_s2-5,7': {
    'Glider c 1': {
      rle: 'x = 4, y = 2, rule = FuzzyLife/3\nb2A$A2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 2': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bA$A$b2A!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P6 1': {
      rle: 'x = 5, y = 5, rule = FuzzyLife/3\nbA2bA$Ab2B$bBbB$b2BbA$A2bA!',
      description: 'Period 6 oscillator (smallest)',
    },
    'Oscillator P12 1': {
      rle: 'x = 6, y = 5, rule = FuzzyLife/3\nbA3bA$Ab3B$bB2bB$b2BbB$A4bA!',
      description: 'Period 12 oscillator (smallest)',
    },
  },
  'b1_s2-6,8': {
    'Glider c 1': {
      rle: 'x = 4, y = 2, rule = FuzzyLife/3\nb2A$A2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 2': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bA$A$b2A!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P6 1': {
      rle: 'x = 5, y = 5, rule = FuzzyLife/3\nbA2bA$Ab2B$bBbB$b3B$A3bA!',
      description: 'Period 6 oscillator (smallest)',
    },
  },
  'b1_s2-3,7': {
    'Glider c 1': {
      rle: 'x = 2, y = 4, rule = FuzzyLife/3\nbA$A$A$bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 2': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bA$A$b2A!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 3': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\n2bA$A$A$2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P5 1': {
      rle: 'x = 5, y = 5, rule = FuzzyLife/3\n3bA$b2BbA$bBbB$Ab2B$bA!',
      description: 'Period 5 oscillator (smallest)',
    },
  },
  'b1_s3,5-8': {
    'Glider c 1': {
      rle: 'x = 2, y = 4, rule = FuzzyLife/3\nbA$A$A$bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 2': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bA$A$b2A!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 3': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\n2bA$A$A$2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 4': {
      rle: 'x = 7, y = 7, rule = FuzzyLife/3\n6bA$2bA$$b2A$A4bA$bA2bA$2b2A!',
      description: 'Glider, speed c (period 4, displacement 4)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
  },
  'b1_s3,7-8': {
    'Glider c 1': {
      rle: 'x = 4, y = 2, rule = FuzzyLife/3\nb2A$A2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 2': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bA$A$b2A!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 3': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\n2bA$A$A$2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
  },
  'b1_s2-5,7-8': {
    'Glider c 1': {
      rle: 'x = 4, y = 2, rule = FuzzyLife/3\nb2A$A2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 2': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bA$A$b2A!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P6 1': {
      rle: 'x = 5, y = 5, rule = FuzzyLife/3\n4bA$b3B$bBbB$b2BbA$A2bA!',
      description: 'Period 6 oscillator (smallest)',
    },
  },
  'b1_s3-7': {
    'Glider c 1': {
      rle: 'x = 2, y = 4, rule = FuzzyLife/3\nbA$A$A$bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 2': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\n2bA$A$A$2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 3': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bA$A$b2A!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 4': {
      rle: 'x = 7, y = 7, rule = FuzzyLife/3\n6bA$2bA$$b2A$A4bA$bA2bA$2b2A!',
      description: 'Glider, speed c (period 4, displacement 4)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P6 1': {
      rle: 'x = 6, y = 5, rule = FuzzyLife/3\n5bA$A2b2B$bA3B$b2B2bA$3bA!',
      description: 'Period 6 oscillator (smallest)',
    },
    'Oscillator P10 1': {
      rle: 'x = 7, y = 6, rule = FuzzyLife/3\n6bA$3b3B$AbBb2B$b2BbBbA$b3BbA$A3bA!',
      description: 'Period 10 oscillator (smallest)',
    },
  },
  'b1_s2-7': {
    'Glider c 1': {
      rle: 'x = 4, y = 2, rule = FuzzyLife/3\nb2A$A2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 2': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\n2bA$A$A$2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 3': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bA$A$b2A!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P6 1': {
      rle: 'x = 7, y = 6, rule = FuzzyLife/3\n5bA$Ab3BbA$2bBb2B$bB2b2B$b2B$A2bA!',
      description: 'Period 6 oscillator (smallest)',
    },
  },
  'b1_s2,5-7': {
    'Glider c 1': {
      rle: 'x = 2, y = 4, rule = FuzzyLife/3\nbA$A$A$bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 2': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bA$A$b2A!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 3': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\n2bA$A$A$2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
  },
  'b1_s2,6': {
    'Glider c 1': {
      rle: 'x = 4, y = 2, rule = FuzzyLife/3\nb2A$A2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 2': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bA$A$b2A!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 3': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\n2bA$A$A$2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
  },
  'b1_s2,8': {
    'Glider c 1': {
      rle: 'x = 2, y = 4, rule = FuzzyLife/3\nbA$A$A$bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 2': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bA$A$b2A!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 3': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\n2bA$A$A$2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
  },
  'b1_s2-3,7-8': {
    'Glider c 1': {
      rle: 'x = 2, y = 4, rule = FuzzyLife/3\nbA$A$A$bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 2': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bA$A$b2A!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
  },
  'b1_s3': {
    'Glider c 1': {
      rle: 'x = 4, y = 2, rule = FuzzyLife/3\nb2A$A2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 2': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bA$A$b2A!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 3': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\n2bA$A$A$2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 4': {
      rle: 'x = 2, y = 4, rule = FuzzyLife/3\nbA$A$A$bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 5': {
      rle: 'x = 7, y = 7, rule = FuzzyLife/3\n6bA$2bA$$b2A$A4bA$bA2bA$2b2A!',
      description: 'Glider, speed c (period 4, displacement 4)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 5, y = 3, rule = FuzzyLife/3\n2bA$AbAbA$b3A!',
      description: 'Period 4 oscillator (smallest)',
    },
  },
  'b1_s2-5,8': {
    'Glider c 1': {
      rle: 'x = 4, y = 2, rule = FuzzyLife/3\nb2A$A2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 2': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bA$A$b2A!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P6 1': {
      rle: 'x = 5, y = 5, rule = FuzzyLife/3\n4bA$b2BbA$bB2bA$b2BbA$A3bA!',
      description: 'Period 6 oscillator (smallest)',
    },
  },
  'b1_s3,6': {
    'Glider c 1': {
      rle: 'x = 4, y = 2, rule = FuzzyLife/3\nb2A$A2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 2': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bA$A$b2A!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 3': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\n2bA$A$A$2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
  },
  'b1_s2-8': {
    'Glider c 1': {
      rle: 'x = 2, y = 4, rule = FuzzyLife/3\nbA$A$A$bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 2': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bA$A$b2A!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 3': {
      rle: 'x = 4, y = 2, rule = FuzzyLife/3\nb2A$A2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P6 1': {
      rle: 'x = 5, y = 5, rule = FuzzyLife/3\n4bA$b2BbA$bB2bA$b2BbA$A3bA!',
      description: 'Period 6 oscillator (smallest)',
    },
  },
  'b1_s2-3,8': {
    'Glider c 1': {
      rle: 'x = 4, y = 2, rule = FuzzyLife/3\nb2A$A2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 2': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bA$A$b2A!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 3': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\n2bA$A$A$2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 5, y = 3, rule = FuzzyLife/3\n4bA$b3A$A!',
      description: 'Period 4 oscillator (smallest)',
    },
  },
  'b1_s3,8': {
    'Glider c 1': {
      rle: 'x = 2, y = 4, rule = FuzzyLife/3\nbA$A$A$bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 2': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bA$A$b2A!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 3': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\n2bA$A$A$2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
  },
  'b1_s2,6-7': {
    'Glider c 1': {
      rle: 'x = 2, y = 4, rule = FuzzyLife/3\nbA$A$A$bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 2': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\n2bA$A$A$2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 3': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bA$A$b2A!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
  },
  'b1_s3-8': {
    'Glider c 1': {
      rle: 'x = 2, y = 4, rule = FuzzyLife/3\nbA$A$A$bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 2': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bA$A$b2A!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 3': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\n2bA$A$A$2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 4': {
      rle: 'x = 7, y = 7, rule = FuzzyLife/3\n6bA$2bA$$b2A$A4bA$bA2bA$2b2A!',
      description: 'Glider, speed c (period 4, displacement 4)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 5, y = 3, rule = FuzzyLife/3\n2bA$AbAbA$b3A!',
      description: 'Period 4 oscillator (smallest)',
    },
    'Oscillator P6 1': {
      rle: 'x = 5, y = 5, rule = FuzzyLife/3\n4bA$b3B$b3B$b2BbA$A2bA!',
      description: 'Period 6 oscillator (smallest)',
    },
  },
  'b1_s3,5': {
    'Glider c 1': {
      rle: 'x = 2, y = 4, rule = FuzzyLife/3\nbA$A$A$bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 2': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bA$A$b2A!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 3': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\n2bA$A$A$2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
  },
  'b1_s2-3': {
    'Glider c 1': {
      rle: 'x = 2, y = 4, rule = FuzzyLife/3\nbA$A$A$bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 2': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bA$A$b2A!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 3': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\n2bA$A$A$2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 4': {
      rle: 'x = 4, y = 2, rule = FuzzyLife/3\nb2A$A2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 5, y = 5, rule = FuzzyLife/3\n4bA$AbBA$bBbB$b2BbA$A2bA!',
      description: 'Period 4 oscillator (smallest)',
    },
    'Oscillator P5 1': {
      rle: 'x = 5, y = 5, rule = FuzzyLife/3\n3bA$b2BbA$bBbB$Ab2B$bA!',
      description: 'Period 5 oscillator (smallest)',
    },
    'Oscillator P6 1': {
      rle: 'x = 5, y = 6, rule = FuzzyLife/3\n4bA$2b2B$A2bB$bAbB$b2BbA$3bA!',
      description: 'Period 6 oscillator (smallest)',
    },
  },
  'b1_s2-6': {
    'Glider c 1': {
      rle: 'x = 4, y = 2, rule = FuzzyLife/3\nb2A$A2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 2': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bA$A$b2A!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 3': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\n2bA$A$A$2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P6 1': {
      rle: 'x = 6, y = 5, rule = FuzzyLife/3\n5bA$b4B$bBbB$Ab2B$bA2bA!',
      description: 'Period 6 oscillator (smallest)',
    },
    'Oscillator P10 1': {
      rle: 'x = 7, y = 7, rule = FuzzyLife/3\n4bA$2b2BbA$A2b2B$b4BbA$bBb3B$b2Bb2B$A5bA!',
      description: 'Period 10 oscillator (smallest)',
    },
    'Oscillator P12 1': {
      rle: 'x = 6, y = 5, rule = FuzzyLife/3\n5bA$b2BbB$b2BbB$A2b2B$2bA2bA!',
      description: 'Period 12 oscillator (smallest)',
    },
  },
  'b1_s1,5-7': {
    'Glider c 1': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\n2bA$A$A$2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
  },
  'b1_s3-4,6': {
    'Glider c 1': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bA$A$b2A!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 2': {
      rle: 'x = 4, y = 2, rule = FuzzyLife/3\nb2A$A2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 3': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\n2bA$A$A$2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
  },
  'b1_s3,6-7': {
    'Glider c 1': {
      rle: 'x = 2, y = 4, rule = FuzzyLife/3\nbA$A$A$bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 2': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bA$A$b2A!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 3': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\n2bA$A$A$2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
  },
  'b1_s2-4': {
    'Glider c 1': {
      rle: 'x = 4, y = 2, rule = FuzzyLife/3\nb2A$A2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 2': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bA$A$b2A!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P6 1': {
      rle: 'x = 5, y = 5, rule = FuzzyLife/3\nbA2bA$Ab2B$bBbB$b3B$A3bA!',
      description: 'Period 6 oscillator (smallest)',
    },
    'Oscillator P12 1': {
      rle: 'x = 6, y = 5, rule = FuzzyLife/3\n5bA$b2BbB$b2BbB$A2b2B$2bA!',
      description: 'Period 12 oscillator (smallest)',
    },
  },
  'b1_s3,5-6': {
    'Glider c 1': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bA$A$b2A!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 2': {
      rle: 'x = 4, y = 2, rule = FuzzyLife/3\nb2A$A2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 3': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\n2bA$A$A$2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 5, y = 3, rule = FuzzyLife/3\n2bA$AbAbA$b3A!',
      description: 'Period 4 oscillator (smallest)',
    },
  },
  'b1_s2-3,5': {
    'Glider c 1': {
      rle: 'x = 4, y = 2, rule = FuzzyLife/3\nb2A$A2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 2': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bA$A$b2A!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
  },
  'b1_s3-4': {
    'Glider c 1': {
      rle: 'x = 2, y = 4, rule = FuzzyLife/3\nbA$A$A$bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 2': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bA$A$b2A!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 3': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\n2bA$A$A$2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 4': {
      rle: 'x = 7, y = 7, rule = FuzzyLife/3\n6bA$2bA$$b2A$A4bA$bA2bA$2b2A!',
      description: 'Glider, speed c (period 4, displacement 4)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 5, y = 3, rule = FuzzyLife/3\n2bA$AbAbA$b3A!',
      description: 'Period 4 oscillator (smallest)',
    },
  },
  'b1_s2-4,6': {
    'Glider c 1': {
      rle: 'x = 4, y = 2, rule = FuzzyLife/3\nb2A$A2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 2': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\n2bA$A$A$2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
  },
  'b1_s1,6': {
    'Glider c 1': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\n2bA$A$A$2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
  },
  'b1_s4': {
    'Glider c 1': {
      rle: 'x = 4, y = 2, rule = FuzzyLife/3\nb2A$A2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 2': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bA$A$b2A!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 3': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\n2bA$A$A$2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 4': {
      rle: 'x = 2, y = 4, rule = FuzzyLife/3\nbA$A$A$bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
  },
  'b1_s3-4,6-7': {
    'Glider c 1': {
      rle: 'x = 2, y = 4, rule = FuzzyLife/3\nbA$A$A$bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 2': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bA$A$b2A!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 3': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\n2bA$A$A$2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
  },
  'b1_s2-3,5-8': {
    'Glider c 1': {
      rle: 'x = 4, y = 2, rule = FuzzyLife/3\nb2A$A2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 2': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bA$A$b2A!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
  },
  'b1_s2-3,5-6': {
    'Glider c 1': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bA$A$b2A!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 2': {
      rle: 'x = 2, y = 4, rule = FuzzyLife/3\nbA$A$A$bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
  },
  'b1_s3,6-8': {
    'Glider c 1': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bA$A$b2A!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 2': {
      rle: 'x = 4, y = 2, rule = FuzzyLife/3\nb2A$A2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 3': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\n2bA$A$A$2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
  },
  'b1_s2-3,6': {
    'Glider c 1': {
      rle: 'x = 2, y = 4, rule = FuzzyLife/3\nbA$A$A$bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 2': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bA$A$b2A!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P5 1': {
      rle: 'x = 5, y = 5, rule = FuzzyLife/3\n3bA$b2BbA$bBbB$Ab2B$bA!',
      description: 'Period 5 oscillator (smallest)',
    },
  },
  'b1_s1,6-7': {
    'Glider c 1': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\n2bA$A$A$2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
  },
  'b1_s3,7': {
    'Glider c 1': {
      rle: 'x = 4, y = 2, rule = FuzzyLife/3\nb2A$A2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 2': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bA$A$b2A!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 3': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\n2bA$A$A$2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 4': {
      rle: 'x = 7, y = 7, rule = FuzzyLife/3\n6bA$2bA$$b2A$A4bA$bA2bA$2b2A!',
      description: 'Glider, speed c (period 4, displacement 4)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
  },
  'b2_s0-1,4-5': {
    'Glider c/3 1': {
      rle: 'x = 6, y = 2, rule = FuzzyLife/3\n3bAbA$3B2A!',
      description: 'Glider, speed c/3 (period 6, displacement 2)',
    },
    'Oscillator P1': {
      rle: 'x = 1, y = 1, rule = FuzzyLife/3\nB!',
      description: 'Period 1 oscillator (smallest)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\n2bB$bA$B!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P3 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nAB$BA!',
      description: 'Period 3 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n2bB$BAbA$bBAB!',
      description: 'Period 4 oscillator (smallest)',
    },
    'Oscillator P6 1': {
      rle: 'x = 6, y = 4, rule = FuzzyLife/3\n4bBA$bB2bAB$BA$2bB!',
      description: 'Period 6 oscillator (smallest)',
    },
  },
  'b1_s2-4,6-7': {
    'Glider c 1': {
      rle: 'x = 4, y = 2, rule = FuzzyLife/3\nb2A$A2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 2': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bA$A$b2A!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
  },
  'b1_s2-4,7': {
    'Glider c 1': {
      rle: 'x = 4, y = 2, rule = FuzzyLife/3\nb2A$A2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 2': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bA$A$b2A!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 3': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\n2bA$A$A$2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
  },
  'b1_s4-6': {
    'Glider c 1': {
      rle: 'x = 4, y = 2, rule = FuzzyLife/3\nb2A$A2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 2': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bA$A$b2A!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 3': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\n2bA$A$A$2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 4': {
      rle: 'x = 8, y = 6, rule = FuzzyLife/3\n6bA$bA5bA$bAbA3bA$A4bA$2bAbA$2bA!',
      description: 'Glider, speed c (period 4, displacement 4)',
    },
    'Glider c 5': {
      rle: 'x = 7, y = 7, rule = FuzzyLife/3\n6bA$2bA$$b2A$A4bA$bA2bA$2b2A!',
      description: 'Glider, speed c (period 4, displacement 4)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
  },
  'b1_s1,6-8': {
    'Glider c 1': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\n2bA$A$A$2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
  },
  'b1_s2-3,5-7': {
    'Glider c 1': {
      rle: 'x = 4, y = 2, rule = FuzzyLife/3\nb2A$A2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 2': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bA$A$b2A!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
  },
  'b1_s2-4,6-8': {
    'Glider c 1': {
      rle: 'x = 4, y = 2, rule = FuzzyLife/3\nb2A$A2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 2': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bA$A$b2A!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 3': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\n2bA$A$A$2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
  },
  'b1_s4,6': {
    'Glider c 1': {
      rle: 'x = 2, y = 4, rule = FuzzyLife/3\nbA$A$A$bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 2': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\n2bA$A$A$2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 3': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bA$A$b2A!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
  },
  'b1_s2-3,6-7': {
    'Glider c 1': {
      rle: 'x = 2, y = 4, rule = FuzzyLife/3\nbA$A$A$bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 2': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bA$A$b2A!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 3': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\n2bA$A$A$2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
  },
  'b1_s3-4,6-8': {
    'Glider c 1': {
      rle: 'x = 2, y = 4, rule = FuzzyLife/3\nbA$A$A$bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 2': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bA$A$b2A!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 3': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\n2bA$A$A$2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 4': {
      rle: 'x = 6, y = 7, rule = FuzzyLife/3\n4bA$2bAbA$bAb2A$A2bAbA$A$bA$2bAbA!',
      description: 'Glider, speed c (period 4, displacement 4)',
    },
    'Glider c 5': {
      rle: 'x = 7, y = 7, rule = FuzzyLife/3\n6bA$2bA$$b2A$A4bA$bA2bA$2b2A!',
      description: 'Glider, speed c (period 4, displacement 4)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
  },
  'b1_s5-8': {
    'Glider c 1': {
      rle: 'x = 4, y = 2, rule = FuzzyLife/3\nb2A$A2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 2': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bA$A$b2A!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 3': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\n2bA$A$A$2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 4': {
      rle: 'x = 2, y = 4, rule = FuzzyLife/3\nbA$A$A$bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 5': {
      rle: 'x = 7, y = 7, rule = FuzzyLife/3\n6bA$2bA$$b2A$A4bA$bA2bA$2b2A!',
      description: 'Glider, speed c (period 4, displacement 4)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\n3bA$b2A$b2A$A!',
      description: 'Period 4 oscillator (smallest)',
    },
  },
  'b1_s5,7': {
    'Glider c 1': {
      rle: 'x = 4, y = 2, rule = FuzzyLife/3\nb2A$A2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 2': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bA$A$b2A!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 3': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\n2bA$A$A$2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 4': {
      rle: 'x = 7, y = 7, rule = FuzzyLife/3\n6bA$2bA$$b2A$A4bA$bA2bA$2b2A!',
      description: 'Glider, speed c (period 4, displacement 4)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
  },
  'b1_s2-4,7-8': {
    'Glider c 1': {
      rle: 'x = 2, y = 4, rule = FuzzyLife/3\nbA$A$A$bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 2': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bA$A$b2A!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 3': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\n2bA$A$A$2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P6 1': {
      rle: 'x = 5, y = 5, rule = FuzzyLife/3\n4bA$b2BbA$bB2bA$b2BbA$A3bA!',
      description: 'Period 6 oscillator (smallest)',
    },
  },
  'b1_s2-4,8': {
    'Glider c 1': {
      rle: 'x = 4, y = 2, rule = FuzzyLife/3\nb2A$A2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 2': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bA$A$b2A!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P6 1': {
      rle: 'x = 6, y = 6, rule = FuzzyLife/3\n5bA$2b2B$bBb2B$bB2bB$Ab3B$bA3bA!',
      description: 'Period 6 oscillator (smallest)',
    },
  },
  'b1_s5-6': {
    'Glider c 1': {
      rle: 'x = 2, y = 4, rule = FuzzyLife/3\nbA$A$A$bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 2': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bA$A$b2A!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 3': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\n2bA$A$A$2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 4': {
      rle: 'x = 4, y = 2, rule = FuzzyLife/3\nb2A$A2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 5, y = 3, rule = FuzzyLife/3\n2bA$AbAbA$b3A!',
      description: 'Period 4 oscillator (smallest)',
    },
  },
  'b1_s5-6,8': {
    'Glider c 1': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bA$A$b2A!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 2': {
      rle: 'x = 2, y = 4, rule = FuzzyLife/3\nbA$A$A$bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 3': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\n2bA$A$A$2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 4': {
      rle: 'x = 6, y = 7, rule = FuzzyLife/3\n4bA$2bAbA$bAb2A$A2bAbA$A$bA$2bAbA!',
      description: 'Glider, speed c (period 4, displacement 4)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
  },
  'b1_s5-7': {
    'Glider c 1': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\n2bA$A$A$2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 2': {
      rle: 'x = 4, y = 2, rule = FuzzyLife/3\nb2A$A2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 3': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bA$A$b2A!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 4': {
      rle: 'x = 9, y = 6, rule = FuzzyLife/3\n6b2A$$5bA2bA$b2A$$A2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 9, y = 5, rule = FuzzyLife/3\n7bA$6bA$6b3A$bA4bA$A6bA!',
      description: 'Period 4 oscillator (smallest)',
    },
  },
  'b1_s7': {
    'Glider c 1': {
      rle: 'x = 4, y = 2, rule = FuzzyLife/3\nb2A$A2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 2': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bA$A$b2A!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 3': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\n2bA$A$A$2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 4': {
      rle: 'x = 7, y = 7, rule = FuzzyLife/3\n6bA$2bA$$b2A$A4bA$bA2bA$2b2A!',
      description: 'Glider, speed c (period 4, displacement 4)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 6, y = 5, rule = FuzzyLife/3\nbA2bA$A4bA$6A$A4bA$bA2bA!',
      description: 'Period 4 oscillator (smallest)',
    },
  },
  'b1_s4-6,8': {
    'Glider c 1': {
      rle: 'x = 4, y = 2, rule = FuzzyLife/3\nb2A$A2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 2': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bA$A$b2A!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 3': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\n2bA$A$A$2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
  },
  'b1_s4,6-7': {
    'Glider c 1': {
      rle: 'x = 4, y = 2, rule = FuzzyLife/3\nb2A$A2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 2': {
      rle: 'x = 6, y = 6, rule = FuzzyLife/3\n3bA$2bAbA$AbA2bA$5bA$4bA$bAbA!',
      description: 'Glider, speed c (period 4, displacement 4)',
    },
    'Glider c 3': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bA$A$b2A!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 4': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\n2bA$A$A$2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
  },
  'b1_s4-7': {
    'Glider c 1': {
      rle: 'x = 4, y = 2, rule = FuzzyLife/3\nb2A$A2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 2': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bA$A$b2A!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 3': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\n2bA$A$A$2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
  },
  'b1_s5,7-8': {
    'Glider c 1': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bA$A$b2A!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 2': {
      rle: 'x = 2, y = 4, rule = FuzzyLife/3\nbA$A$A$bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 3': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\n2bA$A$A$2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 5, y = 3, rule = FuzzyLife/3\n4bA$b3A$A!',
      description: 'Period 4 oscillator (smallest)',
    },
  },
  'b1_s4-8': {
    'Glider c 1': {
      rle: 'x = 2, y = 4, rule = FuzzyLife/3\nbA$A$A$bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 2': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bA$A$b2A!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 3': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\n2bA$A$A$2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 4': {
      rle: 'x = 4, y = 2, rule = FuzzyLife/3\nb2A$A2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 5': {
      rle: 'x = 7, y = 7, rule = FuzzyLife/3\n6bA$2bA$$b2A$A4bA$bA2bA$2b2A!',
      description: 'Glider, speed c (period 4, displacement 4)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
  },
  'b1_s6': {
    'Glider c 1': {
      rle: 'x = 4, y = 2, rule = FuzzyLife/3\nb2A$A2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 2': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bA$A$b2A!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 3': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\n2bA$A$A$2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 4': {
      rle: 'x = 2, y = 4, rule = FuzzyLife/3\nbA$A$A$bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 5': {
      rle: 'x = 7, y = 5, rule = FuzzyLife/3\n6bA$bA3bA$A4bA$A5bA$bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 6': {
      rle: 'x = 7, y = 7, rule = FuzzyLife/3\n6bA$2bA$$b2A$A4bA$bA2bA$2b2A!',
      description: 'Glider, speed c (period 4, displacement 4)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\n3bA$b2A$b2A$A!',
      description: 'Period 4 oscillator (smallest)',
    },
  },
  'b1_s6,8': {
    'Glider c 1': {
      rle: 'x = 4, y = 2, rule = FuzzyLife/3\nb2A$A2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 2': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bA$A$b2A!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 3': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\n2bA$A$A$2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
  },
  'b1_s7-8': {
    'Glider c 1': {
      rle: 'x = 4, y = 2, rule = FuzzyLife/3\nb2A$A2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 2': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bA$A$b2A!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 3': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\n2bA$A$A$2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 5, y = 3, rule = FuzzyLife/3\n2bA$AbAbA$b3A!',
      description: 'Period 4 oscillator (smallest)',
    },
  },
  'b1_s6-7': {
    'Glider c 1': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bA$A$b2A!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 2': {
      rle: 'x = 2, y = 4, rule = FuzzyLife/3\nbA$A$A$bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 3': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\n2bA$A$A$2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 4': {
      rle: 'x = 4, y = 2, rule = FuzzyLife/3\nb2A$A2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 5': {
      rle: 'x = 7, y = 7, rule = FuzzyLife/3\n6bA$5bA$5bA$bA4bA$A$A$bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\n3bA$b2A$b2A$A!',
      description: 'Period 4 oscillator (smallest)',
    },
  },
  'b1_s8': {
    'Glider c 1': {
      rle: 'x = 2, y = 4, rule = FuzzyLife/3\nbA$A$A$bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 2': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bA$A$b2A!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 3': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\n2bA$A$A$2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 5, y = 3, rule = FuzzyLife/3\n2bA$AbAbA$b3A!',
      description: 'Period 4 oscillator (smallest)',
    },
  },
  'b1_s5,8': {
    'Glider c 1': {
      rle: 'x = 4, y = 2, rule = FuzzyLife/3\nb2A$A2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 2': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bA$A$b2A!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 3': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\n2bA$A$A$2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 5, y = 3, rule = FuzzyLife/3\n4bA$b3A$A!',
      description: 'Period 4 oscillator (smallest)',
    },
  },
  'b1_s5': {
    'Glider c 1': {
      rle: 'x = 2, y = 4, rule = FuzzyLife/3\nbA$A$A$bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 2': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bA$A$b2A!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 3': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\n2bA$A$A$2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 4': {
      rle: 'x = 4, y = 2, rule = FuzzyLife/3\nb2A$A2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 5': {
      rle: 'x = 7, y = 7, rule = FuzzyLife/3\n6bA$2bA$$b2A$A4bA$bA2bA$2b2A!',
      description: 'Glider, speed c (period 4, displacement 4)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\n3bA$b2A$b2A$A!',
      description: 'Period 4 oscillator (smallest)',
    },
  },
  'b1_s4,6-8': {
    'Glider c 1': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bA$A$b2A!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 2': {
      rle: 'x = 2, y = 4, rule = FuzzyLife/3\nbA$A$A$bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 3': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\n2bA$A$A$2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 4': {
      rle: 'x = 7, y = 7, rule = FuzzyLife/3\n6bA$2bA$$b2A$A4bA$bA2bA$2b2A!',
      description: 'Glider, speed c (period 4, displacement 4)',
    },
    'Glider c 5': {
      rle: 'x = 7, y = 5, rule = FuzzyLife/3\n5bA$6bA$AbA3bA$4bA$bAbA!',
      description: 'Glider, speed c (period 4, displacement 4)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
  },
  'b1_s6-8': {
    'Glider c 1': {
      rle: 'x = 4, y = 2, rule = FuzzyLife/3\nb2A$A2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 2': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bA$A$b2A!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 3': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\n2bA$A$A$2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 4': {
      rle: 'x = 7, y = 7, rule = FuzzyLife/3\n6bA$2bA$$b2A$A4bA$bA2bA$2b2A!',
      description: 'Glider, speed c (period 4, displacement 4)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 5, y = 3, rule = FuzzyLife/3\n2bA$AbAbA$b3A!',
      description: 'Period 4 oscillator (smallest)',
    },
  },
  'b1_s4,7': {
    'Glider c 1': {
      rle: 'x = 2, y = 4, rule = FuzzyLife/3\nbA$A$A$bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 2': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bA$A$b2A!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 3': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\n2bA$A$A$2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
  },
  'b2_s0-1,4-6': {
    'Glider c/3 1': {
      rle: 'x = 6, y = 2, rule = FuzzyLife/3\n3bAbA$3B2A!',
      description: 'Glider, speed c/3 (period 6, displacement 2)',
    },
    'Oscillator P1': {
      rle: 'x = 1, y = 1, rule = FuzzyLife/3\nB!',
      description: 'Period 1 oscillator (smallest)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\n2bB$bA$B!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P3 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nAB$BA!',
      description: 'Period 3 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n2bB$BAbA$bBAB!',
      description: 'Period 4 oscillator (smallest)',
    },
    'Oscillator P6 1': {
      rle: 'x = 7, y = 5, rule = FuzzyLife/3\n5bBA$BbB2bAB$A$bBbA$2bAbB!',
      description: 'Period 6 oscillator (smallest)',
    },
  },
  'b1_s4,7-8': {
    'Glider c 1': {
      rle: 'x = 4, y = 2, rule = FuzzyLife/3\nb2A$A2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 2': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bA$A$b2A!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 3': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\n2bA$A$A$2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\n3bA$b2A$b2A$A!',
      description: 'Period 4 oscillator (smallest)',
    },
  },
  'b1_s4,8': {
    'Glider c 1': {
      rle: 'x = 4, y = 2, rule = FuzzyLife/3\nb2A$A2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 2': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bA$A$b2A!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 3': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\n2bA$A$A$2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 4': {
      rle: 'x = 7, y = 7, rule = FuzzyLife/3\n6bA$2bA$$b2A$A4bA$bA2bA$2b2A!',
      description: 'Glider, speed c (period 4, displacement 4)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 5, y = 3, rule = FuzzyLife/3\n4bA$b3A$A!',
      description: 'Period 4 oscillator (smallest)',
    },
  },
  'b1_s4-5': {
    'Glider c 1': {
      rle: 'x = 2, y = 4, rule = FuzzyLife/3\nbA$A$A$bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 2': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bA$A$b2A!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 3': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\n2bA$A$A$2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 4': {
      rle: 'x = 7, y = 7, rule = FuzzyLife/3\n6bA$2bA$$b2A$A4bA$bA2bA$2b2A!',
      description: 'Glider, speed c (period 4, displacement 4)',
    },
    'Glider c 5': {
      rle: 'x = 4, y = 2, rule = FuzzyLife/3\nb2A$A2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\n3bA$b2A$b2A$A!',
      description: 'Period 4 oscillator (smallest)',
    },
  },
  'b2_s0-1,4-7': {
    'Glider c/3 1': {
      rle: 'x = 6, y = 2, rule = FuzzyLife/3\n3bAbA$3B2A!',
      description: 'Glider, speed c/3 (period 6, displacement 2)',
    },
    'Oscillator P1': {
      rle: 'x = 1, y = 1, rule = FuzzyLife/3\nB!',
      description: 'Period 1 oscillator (smallest)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\n2bB$bA$B!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P3 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nAB$BA!',
      description: 'Period 3 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n2bB$BAbA$bBAB!',
      description: 'Period 4 oscillator (smallest)',
    },
    'Oscillator P14 1': {
      rle: 'x = 4, y = 5, rule = FuzzyLife/3\n2bB$bA$BA2B$B$bAB!',
      description: 'Period 14 oscillator (smallest)',
    },
  },
  'b1_s4-5,7': {
    'Glider c 1': {
      rle: 'x = 2, y = 4, rule = FuzzyLife/3\nbA$A$A$bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 2': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bA$A$b2A!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 3': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\n2bA$A$A$2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 4': {
      rle: 'x = 7, y = 7, rule = FuzzyLife/3\n6bA$2bA$$b2A$A4bA$bA2bA$2b2A!',
      description: 'Glider, speed c (period 4, displacement 4)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
  },
  'b1_s4-5,7-8': {
    'Glider c 1': {
      rle: 'x = 2, y = 4, rule = FuzzyLife/3\nbA$A$A$bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 2': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bA$A$b2A!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 3': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\n2bA$A$A$2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 5, y = 3, rule = FuzzyLife/3\n4bA$b3A$A!',
      description: 'Period 4 oscillator (smallest)',
    },
  },
  'b1_s4-5,8': {
    'Glider c 1': {
      rle: 'x = 4, y = 2, rule = FuzzyLife/3\nb2A$A2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 2': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bA$A$b2A!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 3': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\n2bA$A$A$2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 5, y = 3, rule = FuzzyLife/3\n4bA$b3A$A!',
      description: 'Period 4 oscillator (smallest)',
    },
  },
  'b2_s0-1,5': {
    'Glider c/3 1': {
      rle: 'x = 8, y = 3, rule = FuzzyLife/3\n5bA$4bBb2A$3BbBb2A!',
      description: 'Glider, speed c/3 (period 6, displacement 2)',
    },
    'Glider c/3 2': {
      rle: 'x = 5, y = 3, rule = FuzzyLife/3\nb2AbA$BbBAB$AbAbA!',
      description: 'Glider, speed c/3 (period 6, displacement 2)',
    },
    'Glider c/3 3': {
      rle: 'x = 6, y = 2, rule = FuzzyLife/3\n3bAbA$3B2A!',
      description: 'Glider, speed c/3 (period 6, displacement 2)',
    },
    'Glider c/3 4': {
      rle: 'x = 6, y = 3, rule = FuzzyLife/3\nbAb3A$AbBA2B$A2b3A!',
      description: 'Glider, speed c/3 (period 6, displacement 2)',
    },
    'Oscillator P1': {
      rle: 'x = 1, y = 1, rule = FuzzyLife/3\nB!',
      description: 'Period 1 oscillator (smallest)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\n2bB$bA$B!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P3 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nAB$BA!',
      description: 'Period 3 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 5, y = 4, rule = FuzzyLife/3\n3bB$B3bA$bABAB$bB!',
      description: 'Period 4 oscillator (smallest)',
    },
  },
  'b2_s0-1,5-6': {
    'Glider c/3 1': {
      rle: 'x = 8, y = 3, rule = FuzzyLife/3\n5bA$4bBb2A$3BbBb2A!',
      description: 'Glider, speed c/3 (period 6, displacement 2)',
    },
    'Glider c/3 2': {
      rle: 'x = 6, y = 2, rule = FuzzyLife/3\n3bAbA$3B2A!',
      description: 'Glider, speed c/3 (period 6, displacement 2)',
    },
    'Glider c/3 3': {
      rle: 'x = 5, y = 3, rule = FuzzyLife/3\nb2AbA$BbBAB$AbAbA!',
      description: 'Glider, speed c/3 (period 6, displacement 2)',
    },
    'Glider c/3 4': {
      rle: 'x = 6, y = 3, rule = FuzzyLife/3\nbAb3A$AbBA2B$A2b3A!',
      description: 'Glider, speed c/3 (period 6, displacement 2)',
    },
    'Glider c/3 5': {
      rle: 'x = 6, y = 2, rule = FuzzyLife/3\n4bAB$3AbB!',
      description: 'Glider, speed c/3 (period 6, displacement 2)',
    },
    'Oscillator P1': {
      rle: 'x = 1, y = 1, rule = FuzzyLife/3\nB!',
      description: 'Period 1 oscillator (smallest)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\n2bB$bA$B!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P3 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nAB$BA!',
      description: 'Period 3 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n2bB$BAbA$bBAB!',
      description: 'Period 4 oscillator (smallest)',
    },
  },
  'b2_s0-1,5-7': {
    'Glider c/3 1': {
      rle: 'x = 8, y = 3, rule = FuzzyLife/3\n5bA$4bBb2A$3BbBb2A!',
      description: 'Glider, speed c/3 (period 6, displacement 2)',
    },
    'Glider c/3 2': {
      rle: 'x = 5, y = 3, rule = FuzzyLife/3\nb2AbA$BbBAB$AbAbA!',
      description: 'Glider, speed c/3 (period 6, displacement 2)',
    },
    'Glider c/3 3': {
      rle: 'x = 6, y = 3, rule = FuzzyLife/3\nbAb3A$AbBA2B$A2b3A!',
      description: 'Glider, speed c/3 (period 6, displacement 2)',
    },
    'Glider c/3 4': {
      rle: 'x = 6, y = 2, rule = FuzzyLife/3\n3bAbA$3B2A!',
      description: 'Glider, speed c/3 (period 6, displacement 2)',
    },
    'Oscillator P1': {
      rle: 'x = 1, y = 1, rule = FuzzyLife/3\nB!',
      description: 'Period 1 oscillator (smallest)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\n2bB$bA$B!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P3 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nAB$BA!',
      description: 'Period 3 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n2bB$BAbA$bBAB!',
      description: 'Period 4 oscillator (smallest)',
    },
  },
  'b2_s0-1,5-8': {
    'Glider c/3 1': {
      rle: 'x = 8, y = 3, rule = FuzzyLife/3\n5bA$4bBb2A$3BbBb2A!',
      description: 'Glider, speed c/3 (period 6, displacement 2)',
    },
    'Glider c/3 2': {
      rle: 'x = 5, y = 3, rule = FuzzyLife/3\nb2AbA$BbBAB$AbAbA!',
      description: 'Glider, speed c/3 (period 6, displacement 2)',
    },
    'Glider c/3 3': {
      rle: 'x = 6, y = 2, rule = FuzzyLife/3\n3bAbA$3B2A!',
      description: 'Glider, speed c/3 (period 6, displacement 2)',
    },
    'Glider c/3 4': {
      rle: 'x = 5, y = 3, rule = FuzzyLife/3\n3b2A$bBb2B$Ab3A!',
      description: 'Glider, speed c/3 (period 6, displacement 2)',
    },
    'Glider c/3 5': {
      rle: 'x = 6, y = 3, rule = FuzzyLife/3\nbAb3A$AbBA2B$A2b3A!',
      description: 'Glider, speed c/3 (period 6, displacement 2)',
    },
    'Oscillator P1': {
      rle: 'x = 1, y = 1, rule = FuzzyLife/3\nB!',
      description: 'Period 1 oscillator (smallest)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\n2bB$bA$B!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P3 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nAB$BA!',
      description: 'Period 3 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n2bB$BAbA$bBAB!',
      description: 'Period 4 oscillator (smallest)',
    },
  },
  'b2_s0-1,6': {
    'Glider c/3 1': {
      rle: 'x = 7, y = 3, rule = FuzzyLife/3\n5b2B$2AbBbA$4bB!',
      description: 'Glider, speed c/3 (period 6, displacement 2)',
    },
    'Glider c/3 2': {
      rle: 'x = 6, y = 2, rule = FuzzyLife/3\n3bAbA$3B2A!',
      description: 'Glider, speed c/3 (period 6, displacement 2)',
    },
    'Glider c/3 3': {
      rle: 'x = 5, y = 3, rule = FuzzyLife/3\nb2AbA$BbBAB$AbAbA!',
      description: 'Glider, speed c/3 (period 6, displacement 2)',
    },
    'Glider c/3 4': {
      rle: 'x = 6, y = 3, rule = FuzzyLife/3\nbAb3A$AbBA2B$A2b3A!',
      description: 'Glider, speed c/3 (period 6, displacement 2)',
    },
    'Glider c/3 5': {
      rle: 'x = 5, y = 3, rule = FuzzyLife/3\n3b2A$bBb2B$Ab3A!',
      description: 'Glider, speed c/3 (period 6, displacement 2)',
    },
    'Oscillator P1': {
      rle: 'x = 1, y = 1, rule = FuzzyLife/3\nB!',
      description: 'Period 1 oscillator (smallest)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\n2bB$bA$B!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P3 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nAB$BA!',
      description: 'Period 3 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n2bB$BAbA$bBAB!',
      description: 'Period 4 oscillator (smallest)',
    },
  },
  'b2_s0-1,6-7': {
    'Glider c/3 1': {
      rle: 'x = 7, y = 3, rule = FuzzyLife/3\n5b2B$2AbBbA$4bB!',
      description: 'Glider, speed c/3 (period 6, displacement 2)',
    },
    'Glider c/3 2': {
      rle: 'x = 5, y = 3, rule = FuzzyLife/3\nb2AbA$BbBAB$AbAbA!',
      description: 'Glider, speed c/3 (period 6, displacement 2)',
    },
    'Glider c/3 3': {
      rle: 'x = 6, y = 2, rule = FuzzyLife/3\n3bAbA$3B2A!',
      description: 'Glider, speed c/3 (period 6, displacement 2)',
    },
    'Glider c/3 4': {
      rle: 'x = 6, y = 3, rule = FuzzyLife/3\nbAb3A$AbBA2B$A2b3A!',
      description: 'Glider, speed c/3 (period 6, displacement 2)',
    },
    'Oscillator P1': {
      rle: 'x = 1, y = 1, rule = FuzzyLife/3\nB!',
      description: 'Period 1 oscillator (smallest)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\n2bB$bA$B!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P3 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nAB$BA!',
      description: 'Period 3 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n2bB$BAbA$bBAB!',
      description: 'Period 4 oscillator (smallest)',
    },
    'Oscillator P7 1': {
      rle: 'x = 5, y = 5, rule = FuzzyLife/3\nbBAB$2BA2B$5A$2BA2B$bBAB!',
      description: 'Period 7 oscillator (smallest)',
    },
  },
  'b2_s0-1,6-8': {
    'Glider c/3 1': {
      rle: 'x = 8, y = 3, rule = FuzzyLife/3\n5bA$4bBb2A$3BbBb2A!',
      description: 'Glider, speed c/3 (period 6, displacement 2)',
    },
    'Glider c/3 2': {
      rle: 'x = 6, y = 3, rule = FuzzyLife/3\nbAb3A$AbBA2B$A2b3A!',
      description: 'Glider, speed c/3 (period 6, displacement 2)',
    },
    'Glider c/3 3': {
      rle: 'x = 6, y = 2, rule = FuzzyLife/3\n3bAbA$3B2A!',
      description: 'Glider, speed c/3 (period 6, displacement 2)',
    },
    'Glider c/3 4': {
      rle: 'x = 5, y = 3, rule = FuzzyLife/3\nb2AbA$BbBAB$AbAbA!',
      description: 'Glider, speed c/3 (period 6, displacement 2)',
    },
    'Oscillator P1': {
      rle: 'x = 1, y = 1, rule = FuzzyLife/3\nB!',
      description: 'Period 1 oscillator (smallest)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\n2bB$bA$B!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P3 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nAB$BA!',
      description: 'Period 3 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n2bB$BAbA$bBAB!',
      description: 'Period 4 oscillator (smallest)',
    },
    'Oscillator P5 1': {
      rle: 'x = 6, y = 6, rule = FuzzyLife/3\n5bB$BA$bABA$2bAB$3b2A$4bB!',
      description: 'Period 5 oscillator (smallest)',
    },
  },
  'b2_s0-1,7': {
    'Glider c/3 1': {
      rle: 'x = 7, y = 3, rule = FuzzyLife/3\n5b2B$2AbBbA$4bB!',
      description: 'Glider, speed c/3 (period 6, displacement 2)',
    },
    'Glider c/3 2': {
      rle: 'x = 5, y = 3, rule = FuzzyLife/3\nb2AbA$BbBAB$AbAbA!',
      description: 'Glider, speed c/3 (period 6, displacement 2)',
    },
    'Glider c/3 3': {
      rle: 'x = 6, y = 2, rule = FuzzyLife/3\n3bAbA$3B2A!',
      description: 'Glider, speed c/3 (period 6, displacement 2)',
    },
    'Glider c/3 4': {
      rle: 'x = 5, y = 3, rule = FuzzyLife/3\n3b2A$bBb2B$Ab3A!',
      description: 'Glider, speed c/3 (period 6, displacement 2)',
    },
    'Glider c/3 5': {
      rle: 'x = 6, y = 3, rule = FuzzyLife/3\nbAb3A$AbBA2B$A2b3A!',
      description: 'Glider, speed c/3 (period 6, displacement 2)',
    },
    'Oscillator P1': {
      rle: 'x = 1, y = 1, rule = FuzzyLife/3\nB!',
      description: 'Period 1 oscillator (smallest)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\n2bB$bA$B!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P3 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nAB$BA!',
      description: 'Period 3 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n2bB$BAbA$bBAB!',
      description: 'Period 4 oscillator (smallest)',
    },
  },
  'b2_s0-1,7-8': {
    'Glider c/3 1': {
      rle: 'x = 8, y = 3, rule = FuzzyLife/3\n5bA$4bBb2A$3BbBb2A!',
      description: 'Glider, speed c/3 (period 6, displacement 2)',
    },
    'Glider c/3 2': {
      rle: 'x = 6, y = 2, rule = FuzzyLife/3\n3bAbA$3B2A!',
      description: 'Glider, speed c/3 (period 6, displacement 2)',
    },
    'Glider c/3 3': {
      rle: 'x = 5, y = 3, rule = FuzzyLife/3\nb2AbA$BbBAB$AbAbA!',
      description: 'Glider, speed c/3 (period 6, displacement 2)',
    },
    'Glider c/3 4': {
      rle: 'x = 6, y = 2, rule = FuzzyLife/3\n4bAB$3AbB!',
      description: 'Glider, speed c/3 (period 6, displacement 2)',
    },
    'Glider c/3 5': {
      rle: 'x = 6, y = 3, rule = FuzzyLife/3\nbAb3A$AbBA2B$A2b3A!',
      description: 'Glider, speed c/3 (period 6, displacement 2)',
    },
    'Oscillator P1': {
      rle: 'x = 1, y = 1, rule = FuzzyLife/3\nB!',
      description: 'Period 1 oscillator (smallest)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\n2bB$bA$B!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P3 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nAB$BA!',
      description: 'Period 3 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\n3bB$bBA$BA$2bB!',
      description: 'Period 4 oscillator (smallest)',
    },
  },
  'b2_s0-1,8': {
    'Glider c/3 1': {
      rle: 'x = 8, y = 3, rule = FuzzyLife/3\n5bA$4bBb2A$3BbBb2A!',
      description: 'Glider, speed c/3 (period 6, displacement 2)',
    },
    'Glider c/3 2': {
      rle: 'x = 6, y = 3, rule = FuzzyLife/3\nbAb3A$AbBA2B$A2b3A!',
      description: 'Glider, speed c/3 (period 6, displacement 2)',
    },
    'Glider c/3 3': {
      rle: 'x = 6, y = 2, rule = FuzzyLife/3\n3bAbA$3B2A!',
      description: 'Glider, speed c/3 (period 6, displacement 2)',
    },
    'Glider c/3 4': {
      rle: 'x = 5, y = 3, rule = FuzzyLife/3\nb2AbA$BbBAB$AbAbA!',
      description: 'Glider, speed c/3 (period 6, displacement 2)',
    },
    'Oscillator P1': {
      rle: 'x = 1, y = 1, rule = FuzzyLife/3\nB!',
      description: 'Period 1 oscillator (smallest)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\n2bB$bA$B!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P3 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nAB$BA!',
      description: 'Period 3 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n2bB$BAbA$bBAB!',
      description: 'Period 4 oscillator (smallest)',
    },
  },
  'b2.5-3_s2.5-3.5': {
    'Glider c/4 1': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\n2bA$A2B$bAB$2BA!',
      description: 'Glider, speed c/4 (period 8, displacement 2)',
    },
    'Glider c/4 2': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n2bA$BbBA$b2B!',
      description: 'Glider, speed c/4 (period 4, displacement 1)',
    },
    'Glider c/4 3': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\n2bA$2b2B$Ab2B$3A!',
      description: 'Glider, speed c/4 (period 8, displacement 2)',
    },
    'Oscillator P1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\n2B$2B!',
      description: 'Period 1 oscillator (smallest)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\n2A$2B!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P10 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\n2bA$A2B$b2B!',
      description: 'Period 10 oscillator (smallest)',
    },
  },
  'b2.5-3_s3-4.5': {
    'Glider c/3 1': {
      rle: 'x = 5, y = 4, rule = FuzzyLife/3\n2bA$bBbB$A3BA$2bA!',
      description: 'Glider, speed c/3 (period 6, displacement 2)',
    },
    'Glider c/2 1': {
      rle: 'x = 25, y = 16, rule = FuzzyLife/3\n22bAB$21bAbB$21bAbBA$21bB$19bAb2B$2B17bBAB$2BbA13bAb2B$bBAB13bBAB$2b2BbA9bAb2B$3bBAB3bAbA3bBAB$4b2BbAbBbBbAb2B$5bBABbABAbBAB$6b2B5b2B$7b3BA3B$8b2BA2B$9b3A!',
      description: 'Glider, speed c/2 (period 16, displacement 8)',
    },
    'Oscillator P1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\n2B$2B!',
      description: 'Period 1 oscillator (smallest)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 2, rule = FuzzyLife/3\nbB$3B!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P3 1': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\n2bA$3B$3B$2bA!',
      description: 'Period 3 oscillator (smallest)',
    },
  },
  'b2-4.5_s0-1': {
    'Glider c/3 1': {
      rle: 'x = 4, y = 5, rule = FuzzyLife/3\n2bB$BAbA$BA$BAbA$2bB!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Glider c/3 2': {
      rle: 'x = 5, y = 5, rule = FuzzyLife/3\n2bAB$2AbAB$2AbA$2AbAB$2bAB!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Glider c/3 3': {
      rle: 'x = 5, y = 4, rule = FuzzyLife/3\n2bA$5A$A3bA$b3A!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Glider c/3 4': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\n2bA$A$b2A!',
      description: 'Glider, speed c/3 (period 6, displacement 2)',
    },
    'Glider c/3 5': {
      rle: 'x = 3, y = 7, rule = FuzzyLife/3\n2bA$A$AbA$A$AbA$A$2bA!',
      description: 'Glider, speed c/3 (period 6, displacement 2)',
    },
    'Oscillator P1': {
      rle: 'x = 1, y = 1, rule = FuzzyLife/3\nB!',
      description: 'Period 1 oscillator (smallest)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 2, rule = FuzzyLife/3\n2bB$BA!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P3 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nAB$BA!',
      description: 'Period 3 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 7, y = 2, rule = FuzzyLife/3\n3bAbAB$BABAB!',
      description: 'Period 4 oscillator (smallest)',
    },
    'Glider c/6 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\n2bB$BA$BAB!',
      description: 'Glider, speed c/6 (period 6, displacement 1)',
    },
    'Oscillator P8 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\nbAB$BAB$BA!',
      description: 'Period 8 oscillator (smallest)',
    },
    'Oscillator P12 1': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\n3bB$bB$bAB$B!',
      description: 'Period 12 oscillator (smallest)',
    },
  },
  'b2-4.5_s0.5-1': {
    'Glider c/6 1': {
      rle: 'x = 5, y = 4, rule = FuzzyLife/3\n2bA$bBb2A$2Ab2A$bBA!',
      description: 'Glider, speed c/6 (period 6, displacement 1)',
    },
    'Glider c/6 2': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\nb2A$A$3A!',
      description: 'Glider, speed c/6 (period 6, displacement 1)',
    },
    'Glider c/6 3': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\n2bB$BA$BAB!',
      description: 'Glider, speed c/6 (period 6, displacement 1)',
    },
    'Glider c/3 4': {
      rle: 'x = 4, y = 5, rule = FuzzyLife/3\n2bB$BAbA$BA$BAbA$2bB!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 2, rule = FuzzyLife/3\n2bB$B!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P3 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nAB$BA!',
      description: 'Period 3 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 6, y = 5, rule = FuzzyLife/3\n3bAB$2bB2bA$B3AbB$2bAbA$2bB!',
      description: 'Period 4 oscillator (smallest)',
    },
    'Oscillator P8 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\nbAB$BAB$BA!',
      description: 'Period 8 oscillator (smallest)',
    },
  },
  'b2.5-8_s1.5-2': {
    'Glider 3c/37 1': {
      rle: 'x = 6, y = 6, rule = FuzzyLife/3\n3b2B$4bAB$2BAb2A$2BAb2A$4bAB$3b2B!',
      description: 'Glider, speed 3c/37 (period 37, displacement 3)',
    },
    'Glider 3c/37 2': {
      rle: 'x = 5, y = 6, rule = FuzzyLife/3\n2bBA$bB2AB$BAb2A$BAb2A$bB2AB$2bBA!',
      description: 'Glider, speed 3c/37 (period 37, displacement 3)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\n2B$2B!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n2bAB$ABbB$bAB!',
      description: 'Period 4 oscillator (smallest)',
    },
  },
  'b2.5-8_s2-2.5': {
    'Glider c/6 1': {
      rle: 'x = 5, y = 4, rule = FuzzyLife/3\n2bB$ABABA$2BA2B$2bB!',
      description: 'Glider, speed c/6 (period 6, displacement 1)',
    },
    'Glider c/6 2': {
      rle: 'x = 3, y = 5, rule = FuzzyLife/3\nbA$AbA$AbA$3B$bA!',
      description: 'Glider, speed c/6 (period 6, displacement 1)',
    },
    'Glider c/6 3': {
      rle: 'x = 5, y = 4, rule = FuzzyLife/3\n2bA$ABbBA$bBbB$2bB!',
      description: 'Glider, speed c/6 (period 6, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nAB$2B!',
      description: 'Period 2 oscillator (smallest)',
    },
  },
  'b2.5-8_s2.5-3': {
    'Glider c/6 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\nbAB$3B$3A!',
      description: 'Glider, speed c/6 (period 6, displacement 1)',
    },
    'Oscillator P1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\n2B$2B!',
      description: 'Period 1 oscillator (smallest)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\n2A$2B!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 4, y = 5, rule = FuzzyLife/3\n2bA$A2B$BbAB$ABbA$2bB!',
      description: 'Period 4 oscillator (smallest)',
    },
  },
  'b2.5-3.5_s1-2': {
    'Glider c/12 1': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\n2bB$2bAB$BAB$bB!',
      description: 'Glider, speed c/12 (period 12, displacement 1)',
    },
    'Oscillator P1': {
      rle: 'x = 1, y = 2, rule = FuzzyLife/3\nB$B!',
      description: 'Period 1 oscillator (smallest)',
    },
    'Oscillator P2 1': {
      rle: 'x = 1, y = 2, rule = FuzzyLife/3\nA$B!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P3 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nAB$2B!',
      description: 'Period 3 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\nb2B$B$BbB!',
      description: 'Period 4 oscillator (smallest)',
    },
    'Oscillator P6 1': {
      rle: 'x = 2, y = 6, rule = FuzzyLife/3\nbA$B$$$BA$2B!',
      description: 'Period 6 oscillator (smallest)',
    },
    'Oscillator P12 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\n3A$BbB$3B!',
      description: 'Period 12 oscillator (smallest)',
    },
  },
  'b2-5_s0-0.5': {
    'Glider c/3 1': {
      rle: 'x = 15, y = 8, rule = FuzzyLife/3\n13bB$13b2A$4bAbAbAbAb2A$2bAbAbAbAbAbAbA$AbAbAbAbAbAbAbA$AbAbAbABABABA$AbAbAbA5b3A$b4A2bB!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Oscillator P1': {
      rle: 'x = 1, y = 1, rule = FuzzyLife/3\nB!',
      description: 'Period 1 oscillator (smallest)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 2, rule = FuzzyLife/3\n2bB$BA!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P3 1': {
      rle: 'x = 5, y = 5, rule = FuzzyLife/3\n4bB$3bA$2bB$bA$B!',
      description: 'Period 3 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 3, y = 2, rule = FuzzyLife/3\nbA$BAB!',
      description: 'Period 4 oscillator (smallest)',
    },
    'Oscillator P12 1': {
      rle: 'x = 6, y = 4, rule = FuzzyLife/3\n5bB$BAB$bA$BAB!',
      description: 'Period 12 oscillator (smallest)',
    },
    'Oscillator P10 1': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\n2b2A$bA$BAbA$BAB!',
      description: 'Period 10 oscillator (smallest)',
    },
  },
  'b2.5-3.5_s2.5-3.5': {
    'Glider c/4 1': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\n2bA$A2B$bAB$2BA!',
      description: 'Glider, speed c/4 (period 8, displacement 2)',
    },
    'Glider c/4 2': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n2bB$BABA$3B!',
      description: 'Glider, speed c/4 (period 4, displacement 1)',
    },
    'Glider c/4 3': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\nbA$A2B$AbB$bB!',
      description: 'Glider, speed c/4 (period 4, displacement 1)',
    },
    'Glider c/4 4': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\nbA$3B$bAB$2A!',
      description: 'Glider, speed c/4 (period 4, displacement 1)',
    },
    'Glider c/4 5': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\nbA$AbB$A2B$ABA!',
      description: 'Glider, speed c/4 (period 4, displacement 1)',
    },
    'Oscillator P1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\n2B$2B!',
      description: 'Period 1 oscillator (smallest)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\n2A$2B!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P10 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\n2bA$A2B$b2B!',
      description: 'Period 10 oscillator (smallest)',
    },
  },
  'b2.5-3.5_s3-5': {
    'Glider c/3 1': {
      rle: 'x = 3, y = 5, rule = FuzzyLife/3\n2bA$A2B$2B$A2B$2bA!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Oscillator P1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\n2B$2B!',
      description: 'Period 1 oscillator (smallest)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 2, rule = FuzzyLife/3\nbB$3B!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P12 1': {
      rle: 'x = 6, y = 6, rule = FuzzyLife/3\n3bA$b3B$bB2bBA$A2BbB$bA3B$2bA!',
      description: 'Period 12 oscillator (smallest)',
    },
  },
  'b3-5_s2.5-4': {
    'Glider c/4 1': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\nb2A$A2BA$B2bB$b2B!',
      description: 'Glider, speed c/4 (period 4, displacement 1)',
    },
    'Oscillator P1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\n2B$2B!',
      description: 'Period 1 oscillator (smallest)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\n2A$2B!',
      description: 'Period 2 oscillator (smallest)',
    },
  },
  'b3-5_s2.5-4.5': {
    'Glider c/6 1': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\nbA$3B$BbB$bB!',
      description: 'Glider, speed c/6 (period 6, displacement 1)',
    },
    'Glider c/6 2': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\nbA$BAB$3B!',
      description: 'Glider, speed c/6 (period 6, displacement 1)',
    },
    'Oscillator P1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\n2B$2B!',
      description: 'Period 1 oscillator (smallest)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\n2A$2B!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Glider c/4 1': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\nA2BA$B2bB$4B!',
      description: 'Glider, speed c/4 (period 4, displacement 1)',
    },
  },
  'b2.5-3.5_s3.5-6.5': {
    'Glider 2c/31 1': {
      rle: 'x = 7, y = 5, rule = FuzzyLife/3\n3bA$3b3B$A5B$b2Bb2BA$2b3BA!',
      description: 'Glider, speed 2c/31 (period 62, displacement 4)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\nb2A$3B$b2B!',
      description: 'Period 2 oscillator (smallest)',
    },
  },
  'b3-5_s3-5.5': {
    'Glider c/4 1': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\nb2B$B2bB$4B$b2B!',
      description: 'Glider, speed c/4 (period 4, displacement 1)',
    },
    'Glider c/4 2': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\nb2A$4B$B2AB$b2B!',
      description: 'Glider, speed c/4 (period 4, displacement 1)',
    },
    'Oscillator P1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\n2B$2B!',
      description: 'Period 1 oscillator (smallest)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 2, rule = FuzzyLife/3\nbB$3B!',
      description: 'Period 2 oscillator (smallest)',
    },
  },
  'b2-5_s0.5-1': {
    'Glider c/6 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\nb2A$A$3A!',
      description: 'Glider, speed c/6 (period 6, displacement 1)',
    },
    'Glider c/6 2': {
      rle: 'x = 5, y = 4, rule = FuzzyLife/3\n2bA$bBb2A$2Ab2A$bBA!',
      description: 'Glider, speed c/6 (period 6, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 2, rule = FuzzyLife/3\n2bB$B!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P3 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nAB$BA!',
      description: 'Period 3 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 6, y = 4, rule = FuzzyLife/3\n3bBA$b2A2bB$B2b2A$bAB!',
      description: 'Period 4 oscillator (smallest)',
    },
    'Oscillator P6 1': {
      rle: 'x = 2, y = 4, rule = FuzzyLife/3\nbB$B$B$bB!',
      description: 'Period 6 oscillator (smallest)',
    },
    'Oscillator P8 1': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\n2bB$B2AB$B2AB$bB!',
      description: 'Period 8 oscillator (smallest)',
    },
  },
  'b3-5.5_s2.5-4.5': {
    'Glider c/6 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\nABA$BbB$3B!',
      description: 'Glider, speed c/6 (period 6, displacement 1)',
    },
    'Glider c/6 2': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\nbA$BAB$3B!',
      description: 'Glider, speed c/6 (period 6, displacement 1)',
    },
    'Glider c/6 3': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\nABA$BAB$BAB!',
      description: 'Glider, speed c/6 (period 6, displacement 1)',
    },
    'Oscillator P1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\n2B$2B!',
      description: 'Period 1 oscillator (smallest)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\n2A$2B!',
      description: 'Period 2 oscillator (smallest)',
    },
  },
  'b3-5.5_s3-5.5': {
    'Glider c/4 1': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\nb2B$B2bB$4B$b2B!',
      description: 'Glider, speed c/4 (period 4, displacement 1)',
    },
    'Glider c/4 2': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\nb2A$4B$B2AB$b2B!',
      description: 'Glider, speed c/4 (period 4, displacement 1)',
    },
    'Oscillator P1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\n2B$2B!',
      description: 'Period 1 oscillator (smallest)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 2, rule = FuzzyLife/3\nbB$3B!',
      description: 'Period 2 oscillator (smallest)',
    },
  },
  'b3-5.5_s3-6': {
    'Glider c/4 1': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\nb2A$4B$B2AB$b2B!',
      description: 'Glider, speed c/4 (period 4, displacement 1)',
    },
    'Oscillator P1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\n2B$2B!',
      description: 'Period 1 oscillator (smallest)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 2, rule = FuzzyLife/3\nbB$3B!',
      description: 'Period 2 oscillator (smallest)',
    },
  },
  'b2-7_s0.5-1': {
    'Glider c/3 1': {
      rle: 'x = 4, y = 5, rule = FuzzyLife/3\n2bB$BAbA$BA$BAbA$2bB!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Glider c/6 2': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\n2bB$BA$BAB!',
      description: 'Glider, speed c/6 (period 6, displacement 1)',
    },
    'Glider c/6 3': {
      rle: 'x = 5, y = 4, rule = FuzzyLife/3\n2bA$bBb2A$2Ab2A$bBA!',
      description: 'Glider, speed c/6 (period 6, displacement 1)',
    },
    'Glider c/6 4': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\nb2A$A$3A!',
      description: 'Glider, speed c/6 (period 6, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 2, rule = FuzzyLife/3\n2bB$B!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P3 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nAB$BA!',
      description: 'Period 3 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 4, y = 5, rule = FuzzyLife/3\n2bAB$BA$2b2A$2AbB$BbA!',
      description: 'Period 4 oscillator (smallest)',
    },
    'Oscillator P8 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\nbAB$BAB$BA!',
      description: 'Period 8 oscillator (smallest)',
    },
  },
  'b2.5-4_s2-2.5': {
    'Glider c/6 1': {
      rle: 'x = 5, y = 4, rule = FuzzyLife/3\n2bA$ABbBA$bBbB$2bB!',
      description: 'Glider, speed c/6 (period 6, displacement 1)',
    },
    'Oscillator P1': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\nbB$BbB$BbB$bB!',
      description: 'Period 1 oscillator (smallest)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nAB$2B!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P3 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\nbB$BbB$b2B!',
      description: 'Period 3 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\nbBA$BbB$2B!',
      description: 'Period 4 oscillator (smallest)',
    },
    'Oscillator P5 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\nb2B$BbB$2B!',
      description: 'Period 5 oscillator (smallest)',
    },
    'Oscillator P6 1': {
      rle: 'x = 3, y = 5, rule = FuzzyLife/3\nbA$3B$3A$3B$bA!',
      description: 'Period 6 oscillator (smallest)',
    },
    'Oscillator P10 1': {
      rle: 'x = 7, y = 3, rule = FuzzyLife/3\n4b2B$2B2bBbB$AB3b2B!',
      description: 'Period 10 oscillator (smallest)',
    },
    'Oscillator P11 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\nbB$BbB$BAB!',
      description: 'Period 11 oscillator (smallest)',
    },
    'Oscillator P22 1': {
      rle: 'x = 7, y = 3, rule = FuzzyLife/3\n4b2B$BA2bAbB$2B2b2B!',
      description: 'Period 22 oscillator (smallest)',
    },
    'Oscillator P33 1': {
      rle: 'x = 7, y = 8, rule = FuzzyLife/3\n5bB$4bBbB$5b2B$$$2B$AbB$2B!',
      description: 'Period 33 oscillator (smallest)',
    },
  },
  'b2.5-4_s2.5-3': {
    'Glider c/6 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\nbAB$3B$3A!',
      description: 'Glider, speed c/6 (period 6, displacement 1)',
    },
    'Oscillator P1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\n2B$2B!',
      description: 'Period 1 oscillator (smallest)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nAB$BA!',
      description: 'Period 2 oscillator (smallest)',
    },
  },
  'b2.5-4_s2.5-3.5': {
    'Glider c/4 1': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n2bB$2BbA$A2B!',
      description: 'Glider, speed c/4 (period 4, displacement 1)',
    },
    'Glider c/4 2': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\nAbB$2AB$ABA!',
      description: 'Glider, speed c/4 (period 4, displacement 1)',
    },
    'Oscillator P1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\n2B$2B!',
      description: 'Period 1 oscillator (smallest)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\n2A$2B!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P8 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\n2bA$A2B$b2B!',
      description: 'Period 8 oscillator (smallest)',
    },
  },
  'b2-5.5_s0-1': {
    'Glider c/6 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\n2bB$BA$BAB!',
      description: 'Glider, speed c/6 (period 6, displacement 1)',
    },
    'Glider c/3 2': {
      rle: 'x = 5, y = 4, rule = FuzzyLife/3\n2bA$5A$A3bA$b3A!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Glider c/3 3': {
      rle: 'x = 4, y = 5, rule = FuzzyLife/3\n2bB$BAbA$BA$BAbA$2bB!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Glider c/6 4': {
      rle: 'x = 5, y = 4, rule = FuzzyLife/3\n2bA$bBb2A$2Ab2A$bBA!',
      description: 'Glider, speed c/6 (period 6, displacement 1)',
    },
    'Glider c/3 5': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\n2bA$A$b2A!',
      description: 'Glider, speed c/3 (period 6, displacement 2)',
    },
    'Oscillator P1': {
      rle: 'x = 1, y = 1, rule = FuzzyLife/3\nB!',
      description: 'Period 1 oscillator (smallest)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 2, rule = FuzzyLife/3\n2bB$BA!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P3 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nAB$BA!',
      description: 'Period 3 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 6, y = 5, rule = FuzzyLife/3\n3bB$Bb2A$2A2bAB$Bb2A$bAbB!',
      description: 'Period 4 oscillator (smallest)',
    },
    'Glider c/8 1': {
      rle: 'x = 6, y = 6, rule = FuzzyLife/3\n4bB$3bAB$2bBbB$bAbA$3Bb2B$4bB!',
      description: 'Glider, speed c/8 (period 8, displacement 1)',
    },
    'Oscillator P12 1': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\n3bB$bB$bAB$B!',
      description: 'Period 12 oscillator (smallest)',
    },
  },
  'b2-5.5_s0.5-1': {
    'Glider c/6 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\nb2A$A$3A!',
      description: 'Glider, speed c/6 (period 6, displacement 1)',
    },
    'Glider c/6 2': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\n2bB$BA$BAB!',
      description: 'Glider, speed c/6 (period 6, displacement 1)',
    },
    'Glider c/6 3': {
      rle: 'x = 5, y = 4, rule = FuzzyLife/3\n2bA$bBb2A$2Ab2A$bBA!',
      description: 'Glider, speed c/6 (period 6, displacement 1)',
    },
    'Glider c/3 4': {
      rle: 'x = 5, y = 4, rule = FuzzyLife/3\n2bA$5A$A3bA$b3A!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Glider c/3 5': {
      rle: 'x = 5, y = 5, rule = FuzzyLife/3\n2bAB$2AbAB$2AbA$2AbAB$2bAB!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Glider c/3 6': {
      rle: 'x = 4, y = 5, rule = FuzzyLife/3\n2bB$BAbA$BA$BAbA$2bB!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 2, rule = FuzzyLife/3\n2bB$B!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P3 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nAB$BA!',
      description: 'Period 3 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 6, y = 4, rule = FuzzyLife/3\n3bBA$b2A2bB$B2b2A$bAB!',
      description: 'Period 4 oscillator (smallest)',
    },
    'Oscillator P10 1': {
      rle: 'x = 9, y = 8, rule = FuzzyLife/3\n5bAB$3b2BAbA$Bb2AbAbA$AbAB2A2bA$bBAbAb2AB$4bAbA$3bA2bA$4bBA!',
      description: 'Period 10 oscillator (smallest)',
    },
  },
  'b2-5.5_s2': {
    'Glider c/9 1': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\n2bA$bA2B$BA$bAB!',
      description: 'Glider, speed c/9 (period 9, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 2, rule = FuzzyLife/3\nb2A$AB!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P6 1': {
      rle: 'x = 6, y = 6, rule = FuzzyLife/3\n2b2A$bA2BA$AB2ABA$AB2ABA$bA2BA$2b2A!',
      description: 'Period 6 oscillator (smallest)',
    },
  },
  'b2_s1-1.5': {
    'Glider c/8 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\nbA$3A$AbA!',
      description: 'Glider, speed c/8 (period 8, displacement 1)',
    },
    'Glider c/8 2': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\nbA$3B$bB!',
      description: 'Glider, speed c/8 (period 8, displacement 1)',
    },
    'Glider c/8 3': {
      rle: 'x = 3, y = 2, rule = FuzzyLife/3\nbA$3A!',
      description: 'Glider, speed c/8 (period 8, displacement 1)',
    },
    'Glider c/8 4': {
      rle: 'x = 3, y = 2, rule = FuzzyLife/3\nbB$3B!',
      description: 'Glider, speed c/8 (period 8, displacement 1)',
    },
    'Glider c/8 5': {
      rle: 'x = 5, y = 4, rule = FuzzyLife/3\n2bA$ABbBA$2Ab2A$b3A!',
      description: 'Glider, speed c/8 (period 8, displacement 1)',
    },
    'Glider c/8 6': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\nbB$BbB$BbB!',
      description: 'Glider, speed c/8 (period 8, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 1, rule = FuzzyLife/3\nAB!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P6 1': {
      rle: 'x = 7, y = 4, rule = FuzzyLife/3\n5bBA$$ABA$ABA!',
      description: 'Period 6 oscillator (smallest)',
    },
    'Oscillator P40 1': {
      rle: 'x = 7, y = 4, rule = FuzzyLife/3\n6bB$bABABbB$BbBABA$B!',
      description: 'Period 40 oscillator (smallest)',
    },
  },
  'b3_s1.5-2.5': {
    'Glider c/8 1': {
      rle: 'x = 3, y = 6, rule = FuzzyLife/3\n2bA$b2B$2B$2B$b2B$2bA!',
      description: 'Glider, speed c/8 (period 8, displacement 1)',
    },
    'Oscillator P1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\nbB$BbB$bB!',
      description: 'Period 1 oscillator (smallest)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nAB$2B!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P3 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\nb2B$BbB$2B!',
      description: 'Period 3 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\nbBA$BbB$2B!',
      description: 'Period 4 oscillator (smallest)',
    },
    'Oscillator P6 1': {
      rle: 'x = 5, y = 4, rule = FuzzyLife/3\n3b2B$2bBbB$BbAB$2B!',
      description: 'Period 6 oscillator (smallest)',
    },
    'Oscillator P7 1': {
      rle: 'x = 6, y = 6, rule = FuzzyLife/3\n4bB$2bABbB$b2BAbB$B2bAB$bBAB$2bB!',
      description: 'Period 7 oscillator (smallest)',
    },
    'Oscillator P8 1': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\n2bB$3bB$BbB$2B!',
      description: 'Period 8 oscillator (smallest)',
    },
    'Oscillator P10 1': {
      rle: 'x = 6, y = 6, rule = FuzzyLife/3\n4bBA$2b2BAB$bB2bB$B3bB$bBbB$2bB!',
      description: 'Period 10 oscillator (smallest)',
    },
    'Oscillator P11 1': {
      rle: 'x = 7, y = 5, rule = FuzzyLife/3\n2b3A$b5B$B5bB$Bb3BbB$bB3AB!',
      description: 'Period 11 oscillator (smallest)',
    },
    'Oscillator P12 1': {
      rle: 'x = 8, y = 6, rule = FuzzyLife/3\n5bB$b2BbBbB$bABbBbAB$bB2bBbBA$2B2bBbB$BA3bB!',
      description: 'Period 12 oscillator (smallest)',
    },
    'Oscillator P14 1': {
      rle: 'x = 7, y = 3, rule = FuzzyLife/3\nbB3bB$BbBbBbB$bB2b2B!',
      description: 'Period 14 oscillator (smallest)',
    },
  },
  'b2-7.5_s0-0.5': {
    'Glider c/3 1': {
      rle: 'x = 13, y = 7, rule = FuzzyLife/3\n10bB$6bAbAb2A$4bAbAbAbA$2bAbAbAbAbA$AbAbAbAbAbAbA$AbAbAbAbAbA$8bAb3A!',
      description: 'Glider, speed c/3 (period 6, displacement 2)',
    },
    'Oscillator P1': {
      rle: 'x = 1, y = 1, rule = FuzzyLife/3\nB!',
      description: 'Period 1 oscillator (smallest)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 2, rule = FuzzyLife/3\n2bB$BA!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P3 1': {
      rle: 'x = 5, y = 5, rule = FuzzyLife/3\n4bB$3bA$2bB$bA$B!',
      description: 'Period 3 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 3, y = 2, rule = FuzzyLife/3\nbA$BAB!',
      description: 'Period 4 oscillator (smallest)',
    },
    'Oscillator P12 1': {
      rle: 'x = 6, y = 4, rule = FuzzyLife/3\n5bB$BAB$bA$BAB!',
      description: 'Period 12 oscillator (smallest)',
    },
    'Oscillator P10 1': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\n2b2A$bA$BAbA$BAB!',
      description: 'Period 10 oscillator (smallest)',
    },
    'Oscillator P16 1': {
      rle: 'x = 5, y = 5, rule = FuzzyLife/3\n3bB$3b2A$BbB$B2b2A$3bB!',
      description: 'Period 16 oscillator (smallest)',
    },
    'Oscillator P20 1': {
      rle: 'x = 10, y = 5, rule = FuzzyLife/3\n7bB$AbA3b3AB$A2bB3bB$b3A$2b2B!',
      description: 'Period 20 oscillator (smallest)',
    },
  },
  'b2-7.5_s0-1': {
    'Glider c/3 1': {
      rle: 'x = 4, y = 5, rule = FuzzyLife/3\n2bB$BAbA$BA$BAbA$2bB!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Glider c/6 2': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\nb2A$A$3A!',
      description: 'Glider, speed c/6 (period 6, displacement 1)',
    },
    'Glider c/6 3': {
      rle: 'x = 5, y = 4, rule = FuzzyLife/3\n2bA$bBb2A$2Ab2A$bBA!',
      description: 'Glider, speed c/6 (period 6, displacement 1)',
    },
    'Oscillator P1': {
      rle: 'x = 1, y = 1, rule = FuzzyLife/3\nB!',
      description: 'Period 1 oscillator (smallest)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 2, rule = FuzzyLife/3\n2bB$BA!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P3 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nAB$BA!',
      description: 'Period 3 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 5, y = 3, rule = FuzzyLife/3\n2bAB$2bAbA$BAbB!',
      description: 'Period 4 oscillator (smallest)',
    },
    'Glider c/6 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\n2bB$BA$BAB!',
      description: 'Glider, speed c/6 (period 6, displacement 1)',
    },
    'Oscillator P8 1': {
      rle: 'x = 9, y = 9, rule = FuzzyLife/3\n6bAB$4b2BbA$3b4AbA$BA2B3b2A$2b4A$2bB2bAb2A$3bAbA2bB$4bBAbA$6bB!',
      description: 'Period 8 oscillator (smallest)',
    },
    'Oscillator P12 1': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\n3bB$bB$bAB$B!',
      description: 'Period 12 oscillator (smallest)',
    },
  },
  'b2-8_s0.5-1': {
    'Glider c/6 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\nb2A$A$3A!',
      description: 'Glider, speed c/6 (period 6, displacement 1)',
    },
    'Glider c/6 2': {
      rle: 'x = 5, y = 4, rule = FuzzyLife/3\n2bA$bBb2A$2Ab2A$bBA!',
      description: 'Glider, speed c/6 (period 6, displacement 1)',
    },
    'Glider c/6 3': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\n2bB$BA$BAB!',
      description: 'Glider, speed c/6 (period 6, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 2, rule = FuzzyLife/3\n2bB$B!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P3 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nAB$BA!',
      description: 'Period 3 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 6, y = 4, rule = FuzzyLife/3\n3bBA$b2A2bB$B2b2A$bAB!',
      description: 'Period 4 oscillator (smallest)',
    },
  },
  'b2-7.5_s0.5-1': {
    'Glider c/6 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\n2bB$BA$BAB!',
      description: 'Glider, speed c/6 (period 6, displacement 1)',
    },
    'Glider c/6 2': {
      rle: 'x = 5, y = 4, rule = FuzzyLife/3\n2bA$bBb2A$2Ab2A$bBA!',
      description: 'Glider, speed c/6 (period 6, displacement 1)',
    },
    'Glider c/3 3': {
      rle: 'x = 4, y = 5, rule = FuzzyLife/3\n2bB$BAbA$BA$BAbA$2bB!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Glider c/3 4': {
      rle: 'x = 5, y = 4, rule = FuzzyLife/3\n2bA$5A$A3bA$b3A!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 2, rule = FuzzyLife/3\n2bB$B!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P3 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nAB$BA!',
      description: 'Period 3 oscillator (smallest)',
    },
    'Oscillator P16 1': {
      rle: 'x = 8, y = 8, rule = FuzzyLife/3\n3b2B$3b4A$2bB3bA$BAb2AbAB$BAb2AbAB$bA3bB$b4A$3b2B!',
      description: 'Period 16 oscillator (smallest)',
    },
  },
  'b3_s2.5-4.5': {
    'Glider c/4 1': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\nb2B$B2bB$4B$b2B!',
      description: 'Glider, speed c/4 (period 8, displacement 2)',
    },
    'Glider c/4 2': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\nA2bA$B2bB$4B!',
      description: 'Glider, speed c/4 (period 8, displacement 2)',
    },
    'Glider c/6 1': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\n2b2B$2b2B$3B$2B!',
      description: 'Glider, speed c/6 (period 6, displacement 1)',
    },
    'Oscillator P1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\n2B$2B!',
      description: 'Period 1 oscillator (smallest)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\n2A$2B!',
      description: 'Period 2 oscillator (smallest)',
    },
  },
  'b3_s3-5.5': {
    'Glider c/3 1': {
      rle: 'x = 11, y = 9, rule = FuzzyLife/3\n6bA$5bA3B$2B3bB2bAB$2B2b7B$3b3B3bAB$2B2b7B$2B3bB2bAB$5bA3B$6bA!',
      description: 'Glider, speed c/3 (period 24, displacement 8)',
    },
    'Oscillator P1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\n2B$2B!',
      description: 'Period 1 oscillator (smallest)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 2, rule = FuzzyLife/3\nbB$3B!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P12 1': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\nb3B$BbAB$BA2B$3B!',
      description: 'Period 12 oscillator (smallest)',
    },
  },
  'b2.5-4.5_s2-2.5': {
    'Glider c/6 1': {
      rle: 'x = 5, y = 4, rule = FuzzyLife/3\n2bB$ABbBA$2BA2B$2bB!',
      description: 'Glider, speed c/6 (period 6, displacement 1)',
    },
    'Glider c/6 2': {
      rle: 'x = 4, y = 5, rule = FuzzyLife/3\n2bB$4A$B2bB$4A$2bB!',
      description: 'Glider, speed c/6 (period 6, displacement 1)',
    },
    'Oscillator P1': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\nbB$BbB$BbB$bB!',
      description: 'Period 1 oscillator (smallest)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nAB$2B!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P3 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\nbB$BbB$b2B!',
      description: 'Period 3 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\nbBA$BbB$2B!',
      description: 'Period 4 oscillator (smallest)',
    },
    'Oscillator P5 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\nb2B$BbB$2B!',
      description: 'Period 5 oscillator (smallest)',
    },
    'Oscillator P10 1': {
      rle: 'x = 7, y = 5, rule = FuzzyLife/3\n5b2B$5bBA$2B$BbB$b2B!',
      description: 'Period 10 oscillator (smallest)',
    },
  },
  'b2-6_s0-0.5': {
    'Glider c/3 1': {
      rle: 'x = 12, y = 5, rule = FuzzyLife/3\n9bAB$3b6Ab2A$3AbAbAb3A$AbAbAbAbAb2A$AbABABAB2bB!',
      description: 'Glider, speed c/3 (period 6, displacement 2)',
    },
    'Oscillator P1': {
      rle: 'x = 1, y = 1, rule = FuzzyLife/3\nB!',
      description: 'Period 1 oscillator (smallest)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 2, rule = FuzzyLife/3\n2bB$BA!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P3 1': {
      rle: 'x = 6, y = 5, rule = FuzzyLife/3\n5bB$B3bA$3bB$2bA$bB!',
      description: 'Period 3 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 3, y = 2, rule = FuzzyLife/3\nbA$BAB!',
      description: 'Period 4 oscillator (smallest)',
    },
    'Oscillator P12 1': {
      rle: 'x = 3, y = 8, rule = FuzzyLife/3\n2bB$$B$$$BAB$bA$BAB!',
      description: 'Period 12 oscillator (smallest)',
    },
    'Oscillator P10 1': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\n2b2A$bA$BAbA$BAB!',
      description: 'Period 10 oscillator (smallest)',
    },
  },
  'b2.5-4.5_s2.5-3': {
    'Glider c/6 1': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\nbA$BAB$bA$A2B!',
      description: 'Glider, speed c/6 (period 6, displacement 1)',
    },
    'Oscillator P1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\n2B$2B!',
      description: 'Period 1 oscillator (smallest)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\n2A$2B!',
      description: 'Period 2 oscillator (smallest)',
    },
  },
  'b1.5-6.5_s0': {
    'Glider c/3 1': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\n3bB$b2A$bAB$B!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Glider c/3 2': {
      rle: 'x = 3, y = 2, rule = FuzzyLife/3\nb2A$BbB!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Glider c/3 3': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n2bA$4A$A2bA!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Glider c/3 4': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\n2bA$A$AbA!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Oscillator P1': {
      rle: 'x = 1, y = 1, rule = FuzzyLife/3\nB!',
      description: 'Period 1 oscillator (smallest)',
    },
    'Oscillator P6 1': {
      rle: 'x = 8, y = 8, rule = FuzzyLife/3\n7bA$BAbAbA$2AbAb2A$3bA$7A$3bA$2AbAb2A$BAbAbAB!',
      description: 'Period 6 oscillator (smallest)',
    },
  },
  'b2-6_s0.5-1': {
    'Glider c/6 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\nb2A$A$3A!',
      description: 'Glider, speed c/6 (period 6, displacement 1)',
    },
    'Glider c/3 2': {
      rle: 'x = 4, y = 5, rule = FuzzyLife/3\n2bB$BAbA$BA$BAbA$2bB!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Glider c/6 3': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\n2bB$BA$BAB!',
      description: 'Glider, speed c/6 (period 6, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 2, rule = FuzzyLife/3\n2bB$B!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P3 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nAB$BA!',
      description: 'Period 3 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 5, y = 5, rule = FuzzyLife/3\n2bAB$2bAbA$BAbAB$2bA$2bB!',
      description: 'Period 4 oscillator (smallest)',
    },
    'Oscillator P6 1': {
      rle: 'x = 6, y = 4, rule = FuzzyLife/3\n4bAB$B3bBA$$bB!',
      description: 'Period 6 oscillator (smallest)',
    },
    'Oscillator P12 1': {
      rle: 'x = 8, y = 7, rule = FuzzyLife/3\n5bB$5bA$bBAbBAbA$A2b2AbAB$bBA2bA$3bAbA$4bB!',
      description: 'Period 12 oscillator (smallest)',
    },
  },
  'b2-6_s1.5': {
    'Glider c/7 1': {
      rle: 'x = 5, y = 5, rule = FuzzyLife/3\n2bA$2bAB$3AbA$bB2bA$2b2A!',
      description: 'Glider, speed c/7 (period 7, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbB$BA!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\n2bAB$3bA$AbA$BA!',
      description: 'Period 4 oscillator (smallest)',
    },
    'Oscillator P24 1': {
      rle: 'x = 3, y = 5, rule = FuzzyLife/3\nBbB$BbB$3A$BbB$BbB!',
      description: 'Period 24 oscillator (smallest)',
    },
  },
  'b2_s1.5-2.5': {
    'Glider c/2 1': {
      rle: 'x = 9, y = 4, rule = FuzzyLife/3\n8bB$ABA4B2A$2A6bB$b2A!',
      description: 'Glider, speed c/2 (period 4, displacement 2)',
    },
    'Glider c/2 2': {
      rle: 'x = 11, y = 4, rule = FuzzyLife/3\n9bB$ABA7BA$2A7bB$b2A!',
      description: 'Glider, speed c/2 (period 4, displacement 2)',
    },
    'Glider c/2 3': {
      rle: 'x = 7, y = 4, rule = FuzzyLife/3\n6bB$ABA2B2A$2A4bB$b2A!',
      description: 'Glider, speed c/2 (period 4, displacement 2)',
    },
    'Glider c/2 4': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\n2bA$AbB$BbBA$b2B!',
      description: 'Glider, speed c/2 (period 2, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\nbB$3B$bB!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 6, y = 6, rule = FuzzyLife/3\n2b2A$bA2BA$AB2bBA$AB2bBA$bA2BA$2b2A!',
      description: 'Period 4 oscillator (smallest)',
    },
    'Oscillator P10 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\nb2A$A2B$AB!',
      description: 'Period 10 oscillator (smallest)',
    },
  },
  'b2.5_s2.5-3.5': {
    'Glider c/4 1': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\n2bA$b2BA$BAbA$2B!',
      description: 'Glider, speed c/4 (period 4, displacement 1)',
    },
    'Glider c/4 2': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n2bA$2ABA$b2B!',
      description: 'Glider, speed c/4 (period 4, displacement 1)',
    },
    'Glider c/4 3': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\n2bA$2B$A2B!',
      description: 'Glider, speed c/4 (period 4, displacement 1)',
    },
    'Glider c/2 4': {
      rle: 'x = 3, y = 6, rule = FuzzyLife/3\n2bA$A2B$BA$BA$A2B$2bA!',
      description: 'Glider, speed c/2 (period 2, displacement 1)',
    },
    'Oscillator P1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\n2B$2B!',
      description: 'Period 1 oscillator (smallest)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\n2A$2B!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P6 1': {
      rle: 'x = 7, y = 3, rule = FuzzyLife/3\n2bAbA$A2Bb2BA$b2Bb2B!',
      description: 'Period 6 oscillator (smallest)',
    },
    'Oscillator P10 1': {
      rle: 'x = 7, y = 4, rule = FuzzyLife/3\n4b2B$bA2b2BA$b2BbA$A2B!',
      description: 'Period 10 oscillator (smallest)',
    },
  },
  'b2.5_s2.5-4': {
    'Glider c/4 1': {
      rle: 'x = 2, y = 4, rule = FuzzyLife/3\n2A$2B$2A$2B!',
      description: 'Glider, speed c/4 (period 4, displacement 1)',
    },
    'Glider c/4 2': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\n2bA$2BbA$2BbA$2bA!',
      description: 'Glider, speed c/4 (period 4, displacement 1)',
    },
    'Glider c/4 3': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\n2bA$A2B$A2B$2bA!',
      description: 'Glider, speed c/4 (period 4, displacement 1)',
    },
    'Glider c/4 4': {
      rle: 'x = 2, y = 4, rule = FuzzyLife/3\nbA$2B$2B$bA!',
      description: 'Glider, speed c/4 (period 4, displacement 1)',
    },
    'Oscillator P1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\n2B$2B!',
      description: 'Period 1 oscillator (smallest)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\n2A$2B!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P6 1': {
      rle: 'x = 7, y = 7, rule = FuzzyLife/3\n5bA$3bA2B$bBbBb2B$A3BbB$4bB$bA2B$2bB!',
      description: 'Period 6 oscillator (smallest)',
    },
  },
  'b2_s2-2.5': {
    'Glider c/3 1': {
      rle: 'x = 6, y = 5, rule = FuzzyLife/3\n3bBA$2Ab2B$B3b2A$2Ab2B$3bBA!',
      description: 'Glider, speed c/3 (period 6, displacement 2)',
    },
    'Glider c/3 2': {
      rle: 'x = 5, y = 5, rule = FuzzyLife/3\n3bA$bBABA$2A2bB$bBABA$3bA!',
      description: 'Glider, speed c/3 (period 6, displacement 2)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 2, rule = FuzzyLife/3\nb2A$AB!',
      description: 'Period 2 oscillator (smallest)',
    },
  },
  'b2.5_s2.5-5': {
    'Glider c/2 1': {
      rle: 'x = 6, y = 5, rule = FuzzyLife/3\n2b2A$b4B$2B2A2B$BA2bAB$6B!',
      description: 'Glider, speed c/2 (period 8, displacement 4)',
    },
    'Oscillator P1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\n2B$2B!',
      description: 'Period 1 oscillator (smallest)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\n2A$2B!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 3, y = 5, rule = FuzzyLife/3\n2bA$A2B$b2B$2B$2B!',
      description: 'Period 4 oscillator (smallest)',
    },
    'Oscillator P6 1': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\n2bA$b2B$3BA$bB!',
      description: 'Period 6 oscillator (smallest)',
    },
    'Oscillator P8 1': {
      rle: 'x = 7, y = 6, rule = FuzzyLife/3\n6bA$5b2B$2bA2b2B$A2BbBbB$b5B$bA2b2B!',
      description: 'Period 8 oscillator (smallest)',
    },
    'Oscillator P12 1': {
      rle: 'x = 8, y = 4, rule = FuzzyLife/3\n3b2BbB$A3Bb2BA$b2Bb2B$bAbAbA!',
      description: 'Period 12 oscillator (smallest)',
    },
    'Oscillator P14 1': {
      rle: 'x = 6, y = 4, rule = FuzzyLife/3\n2bAbA$A2Bb2B$b2Bb2B$bAbAbA!',
      description: 'Period 14 oscillator (smallest)',
    },
  },
  'b2.5_s3-5': {
    'Glider c/4 1': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\n2bA$b2BA$2BbB$A2BA!',
      description: 'Glider, speed c/4 (period 12, displacement 3)',
    },
    'Glider c/4 2': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\n2bA$b2B$BABA$3B!',
      description: 'Glider, speed c/4 (period 12, displacement 3)',
    },
    'Glider c/4 3': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n2bBA$A3B$b2BA!',
      description: 'Glider, speed c/4 (period 12, displacement 3)',
    },
    'Oscillator P1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\n2B$2B!',
      description: 'Period 1 oscillator (smallest)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 3, rule = FuzzyLife/3\nbA$2B$BA!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\nb2A$3B$bB!',
      description: 'Period 4 oscillator (smallest)',
    },
    'Oscillator P6 1': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\n2bA$A2B$A2B$2bA!',
      description: 'Period 6 oscillator (smallest)',
    },
  },
  'b2_s2-3.5': {
    'Glider c/3 1': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\n2bAB$2bB$A2BA$BbA!',
      description: 'Glider, speed c/3 (period 6, displacement 2)',
    },
    'Glider c/3 2': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\n3bA$A2B$A2B$b2A!',
      description: 'Glider, speed c/3 (period 6, displacement 2)',
    },
    'Glider c/3 3': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\nA2B$B2A$BAB!',
      description: 'Glider, speed c/3 (period 6, displacement 2)',
    },
    'Glider c/3 4': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\n2bBA$2bA$BA2B$AbBA!',
      description: 'Glider, speed c/3 (period 6, displacement 2)',
    },
    'Oscillator P1': {
      rle: 'x = 5, y = 4, rule = FuzzyLife/3\n3bB$bBb2B$2BbB$bB!',
      description: 'Period 1 oscillator (smallest)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 2, rule = FuzzyLife/3\nb2A$AB!',
      description: 'Period 2 oscillator (smallest)',
    },
  },
  'b2_s2.5-4': {
    'Glider 2c/5 1': {
      rle: 'x = 5, y = 3, rule = FuzzyLife/3\n3b2B$bBb2B$2AbB!',
      description: 'Glider, speed 2c/5 (period 10, displacement 4)',
    },
    'Glider 2c/5 2': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\n3bA$BAB$BAB$A2B!',
      description: 'Glider, speed 2c/5 (period 10, displacement 4)',
    },
    'Glider 2c/5 3': {
      rle: 'x = 5, y = 5, rule = FuzzyLife/3\n3bA$b2BA$bB$A3BA$bA!',
      description: 'Glider, speed 2c/5 (period 10, displacement 4)',
    },
    'Glider 2c/5 4': {
      rle: 'x = 5, y = 5, rule = FuzzyLife/3\n3bA$2bB2A$A2bA$bA3B$3bBA!',
      description: 'Glider, speed 2c/5 (period 10, displacement 4)',
    },
    'Oscillator P1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\nbB$3B$bB!',
      description: 'Period 1 oscillator (smallest)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 2, rule = FuzzyLife/3\nbA$3B!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 3, y = 5, rule = FuzzyLife/3\n2bB$A2B$bB$2B$b2A!',
      description: 'Period 4 oscillator (smallest)',
    },
    'Oscillator P6 1': {
      rle: 'x = 5, y = 4, rule = FuzzyLife/3\n3bB$A2b2B$A3B$bBbA!',
      description: 'Period 6 oscillator (smallest)',
    },
  },
  'b2.5-5_s2-2.5': {
    'Glider c/6 1': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\n2bA$3AB$BbA$bAB!',
      description: 'Glider, speed c/6 (period 6, displacement 1)',
    },
    'Glider c/6 2': {
      rle: 'x = 5, y = 4, rule = FuzzyLife/3\n2bA$ABbBA$bBbB$2bB!',
      description: 'Glider, speed c/6 (period 6, displacement 1)',
    },
    'Glider c/6 3': {
      rle: 'x = 3, y = 5, rule = FuzzyLife/3\nbA$AbA$AbA$3B$bA!',
      description: 'Glider, speed c/6 (period 6, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nAB$2B!',
      description: 'Period 2 oscillator (smallest)',
    },
  },
  'b2.5-5_s2.5-3': {
    'Glider c/6 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\nbAB$3B$3A!',
      description: 'Glider, speed c/6 (period 6, displacement 1)',
    },
    'Oscillator P1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\n2B$2B!',
      description: 'Period 1 oscillator (smallest)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\n2A$2B!',
      description: 'Period 2 oscillator (smallest)',
    },
  },
  'b2.5-5_s3-4.5': {
    'Glider c/4 1': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\n2bA$4B$Bb2B$bBbA!',
      description: 'Glider, speed c/4 (period 8, displacement 2)',
    },
    'Glider c/4 2': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\n2bA$4B$AbAB$bA2B!',
      description: 'Glider, speed c/4 (period 4, displacement 1)',
    },
    'Oscillator P1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\n2B$2B!',
      description: 'Period 1 oscillator (smallest)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 2, rule = FuzzyLife/3\nbB$3B!',
      description: 'Period 2 oscillator (smallest)',
    },
  },
  'b2-6.5_s0-1': {
    'Glider c/3 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\n2bA$A$b2A!',
      description: 'Glider, speed c/3 (period 6, displacement 2)',
    },
    'Glider c/6 2': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\nb2A$A$3A!',
      description: 'Glider, speed c/6 (period 6, displacement 1)',
    },
    'Glider c/3 3': {
      rle: 'x = 4, y = 5, rule = FuzzyLife/3\n2bB$BAbA$BA$BAbA$2bB!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Oscillator P1': {
      rle: 'x = 1, y = 1, rule = FuzzyLife/3\nB!',
      description: 'Period 1 oscillator (smallest)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 2, rule = FuzzyLife/3\n2bB$BA!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P3 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nAB$BA!',
      description: 'Period 3 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 5, y = 4, rule = FuzzyLife/3\n4bB$b2A$BbB$bA!',
      description: 'Period 4 oscillator (smallest)',
    },
    'Glider c/6 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\n2bB$BA$BAB!',
      description: 'Glider, speed c/6 (period 6, displacement 1)',
    },
    'Oscillator P12 1': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\n3bB$bB$bAB$B!',
      description: 'Period 12 oscillator (smallest)',
    },
  },
  'b2_s3-4.5': {
    'Glider c/3 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\nbB$3B$b2B!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Glider c/3 2': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\n2bB$ABAB$A2B$b2A!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Oscillator P1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\nbB$3B$bB!',
      description: 'Period 1 oscillator (smallest)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\nbA$3B$bA!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\n2bA$b2BA$A2B$bA!',
      description: 'Period 4 oscillator (smallest)',
    },
    'Oscillator P5 1': {
      rle: 'x = 5, y = 5, rule = FuzzyLife/3\n3bA$b3BA$bBbB$A3B$bA!',
      description: 'Period 5 oscillator (smallest)',
    },
  },
  'b2-6.5_s0.5-1': {
    'Glider c/6 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\nb2A$A$3A!',
      description: 'Glider, speed c/6 (period 6, displacement 1)',
    },
    'Glider c/6 2': {
      rle: 'x = 5, y = 4, rule = FuzzyLife/3\n2bA$bBb2A$2Ab2A$bBA!',
      description: 'Glider, speed c/6 (period 6, displacement 1)',
    },
    'Glider c/6 3': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\n2bB$BA$BAB!',
      description: 'Glider, speed c/6 (period 6, displacement 1)',
    },
    'Glider c/3 4': {
      rle: 'x = 4, y = 5, rule = FuzzyLife/3\n2bB$BAbA$BA$BAbA$2bB!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 2, rule = FuzzyLife/3\n2bB$B!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P3 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nAB$BA!',
      description: 'Period 3 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 6, y = 3, rule = FuzzyLife/3\n5bB$2bBAbA$BABAB!',
      description: 'Period 4 oscillator (smallest)',
    },
    'Oscillator P8 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\nbAB$BAB$BA!',
      description: 'Period 8 oscillator (smallest)',
    },
    'Oscillator P12 1': {
      rle: 'x = 8, y = 7, rule = FuzzyLife/3\n4bAB$2b2BbA$2b3Ab2A$2b2BA2bB$B3Ab2A$2bBbA$3bAB!',
      description: 'Period 12 oscillator (smallest)',
    },
    'Oscillator P16 1': {
      rle: 'x = 8, y = 8, rule = FuzzyLife/3\n3b2B$3b4A$2bB3bA$BAb2AbAB$BAb2AbAB$bA3bB$b4A$3b2B!',
      description: 'Period 16 oscillator (smallest)',
    },
  },
  'b2.5-5.5_s2-2.5': {
    'Glider c/6 1': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\n2bA$3AB$BbA$bAB!',
      description: 'Glider, speed c/6 (period 6, displacement 1)',
    },
    'Glider c/18 1': {
      rle: 'x = 6, y = 6, rule = FuzzyLife/3\n3bAB$2b2BAB$4bBA$2BAbB$b2B$2bB!',
      description: 'Glider, speed c/18 (period 18, displacement 1)',
    },
    'Glider c/6 2': {
      rle: 'x = 5, y = 4, rule = FuzzyLife/3\n2bB$ABABA$2BA2B$2bB!',
      description: 'Glider, speed c/6 (period 6, displacement 1)',
    },
    'Glider c/6 3': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\nbA$BAB$BAB$AbA!',
      description: 'Glider, speed c/6 (period 6, displacement 1)',
    },
    'Glider c/18 2': {
      rle: 'x = 5, y = 5, rule = FuzzyLife/3\n2bA$b2AB$2ABAB$bB2AB$2b2B!',
      description: 'Glider, speed c/18 (period 18, displacement 1)',
    },
    'Glider c/18 3': {
      rle: 'x = 5, y = 5, rule = FuzzyLife/3\n2bA$bBAB$2A2bB$bBbB$2bB!',
      description: 'Glider, speed c/18 (period 18, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nAB$2B!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\n2bBA$2b2B$2B$AB!',
      description: 'Period 4 oscillator (smallest)',
    },
  },
  'b2.5-5.5_s2.5-3': {
    'Glider c/6 1': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\nbA$BAB$bA$A2B!',
      description: 'Glider, speed c/6 (period 6, displacement 1)',
    },
    'Oscillator P1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\n2B$2B!',
      description: 'Period 1 oscillator (smallest)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nAB$BA!',
      description: 'Period 2 oscillator (smallest)',
    },
  },
  'b2.5-5.5_s3-4.5': {
    'Glider c/4 1': {
      rle: 'x = 5, y = 5, rule = FuzzyLife/3\n2bA$bABA$AB2bB$b3BA$bABA!',
      description: 'Glider, speed c/4 (period 4, displacement 1)',
    },
    'Oscillator P1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\n2B$2B!',
      description: 'Period 1 oscillator (smallest)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 2, rule = FuzzyLife/3\nbB$3B!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 4, y = 5, rule = FuzzyLife/3\n2bA$3B$BAbB$A2B$2bB!',
      description: 'Period 4 oscillator (smallest)',
    },
    'Oscillator P6 1': {
      rle: 'x = 5, y = 4, rule = FuzzyLife/3\n2bB$A3BA$bBAB$A3BA!',
      description: 'Period 6 oscillator (smallest)',
    },
  },
  'b1_s1.5': {
    'Glider c 1': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\n2bA$A$A$2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 2': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\n3bA$A2bB$3bA$b2A!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 3': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\n3bA$3bB$A2bA$b2A!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 4': {
      rle: 'x = 4, y = 2, rule = FuzzyLife/3\nb2A$A2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 5': {
      rle: 'x = 5, y = 5, rule = FuzzyLife/3\n4bA$4bB$4bA$A2bA$b2A!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 6': {
      rle: 'x = 3, y = 5, rule = FuzzyLife/3\n2bA$AbA$BbA$AbB$b2A!',
      description: 'Glider, speed c (period 2, displacement 2)',
    },
    'Glider c 7': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bA$A$b2A!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 8': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\nb2A$A2bA$B2bB$A2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 9': {
      rle: 'x = 7, y = 5, rule = FuzzyLife/3\n4bA$2bA3bA$A2bAbA$A$bABA!',
      description: 'Glider, speed c (period 4, displacement 4)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
  },
  'b2-3.5_s0-1': {
    'Glider c/3 1': {
      rle: 'x = 8, y = 5, rule = FuzzyLife/3\n4bA$5b3A$3AbA2bA$$4b3A!',
      description: 'Glider, speed c/3 (period 6, displacement 2)',
    },
    'Oscillator P1': {
      rle: 'x = 1, y = 1, rule = FuzzyLife/3\nB!',
      description: 'Period 1 oscillator (smallest)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 2, rule = FuzzyLife/3\n2bB$BA!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P3 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nAB$BA!',
      description: 'Period 3 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 5, y = 4, rule = FuzzyLife/3\n4bB$b2A$BbB$bA!',
      description: 'Period 4 oscillator (smallest)',
    },
    'Oscillator P6 1': {
      rle: 'x = 5, y = 5, rule = FuzzyLife/3\n3bAB$3bBA$B$bA$2bB!',
      description: 'Period 6 oscillator (smallest)',
    },
    'Oscillator P12 1': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\n3bB$bB$bAB$B!',
      description: 'Period 12 oscillator (smallest)',
    },
  },
  'b2-4_s0-0.5': {
    'Glider c/3 1': {
      rle: 'x = 6, y = 5, rule = FuzzyLife/3\n5bB$3bBA$2B3bB$3bBA$5bB!',
      description: 'Glider, speed c/3 (period 15, displacement 5)',
    },
    'Oscillator P1': {
      rle: 'x = 1, y = 1, rule = FuzzyLife/3\nB!',
      description: 'Period 1 oscillator (smallest)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 2, rule = FuzzyLife/3\n2bB$BA!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 3, y = 2, rule = FuzzyLife/3\nbA$BAB!',
      description: 'Period 4 oscillator (smallest)',
    },
    'Oscillator P12 1': {
      rle: 'x = 3, y = 9, rule = FuzzyLife/3\n2bB$$B$$$$BbB$3A$BbB!',
      description: 'Period 12 oscillator (smallest)',
    },
    'Oscillator P10 1': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\n2b2A$bA$BAbA$BAB!',
      description: 'Period 10 oscillator (smallest)',
    },
    'Oscillator P20 1': {
      rle: 'x = 9, y = 5, rule = FuzzyLife/3\n7bA$2A4bBAB$2bA4bA$AbAB3bB$bBAB!',
      description: 'Period 20 oscillator (smallest)',
    },
  },
  'b2-3.5_s0.5-1': {
    'Glider c/3 1': {
      rle: 'x = 5, y = 4, rule = FuzzyLife/3\n2bA$5A$A3bA$b3A!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Glider c/3 2': {
      rle: 'x = 4, y = 5, rule = FuzzyLife/3\n2bB$BAbA$BA$BAbA$2bB!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 2, rule = FuzzyLife/3\n2bB$B!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P3 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nAB$BA!',
      description: 'Period 3 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 5, y = 3, rule = FuzzyLife/3\n2bAB$2bAbA$BAbB!',
      description: 'Period 4 oscillator (smallest)',
    },
    'Oscillator P6 1': {
      rle: 'x = 4, y = 2, rule = FuzzyLife/3\nb2B$B2bB!',
      description: 'Period 6 oscillator (smallest)',
    },
    'Oscillator P8 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\nbAB$BAB$BA!',
      description: 'Period 8 oscillator (smallest)',
    },
    'Oscillator P26 1': {
      rle: 'x = 3, y = 9, rule = FuzzyLife/3\nBAB$BAB$bA$3B$3A$3B$bA$BAB$BAB!',
      description: 'Period 26 oscillator (smallest)',
    },
  },
  'b1_s1.5-2': {
    'Glider c 1': {
      rle: 'x = 2, y = 4, rule = FuzzyLife/3\nbA$A$A$bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 2': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\n3bA$A2bB$3bA$b2A!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 3': {
      rle: 'x = 6, y = 4, rule = FuzzyLife/3\n3bA$5bA$5bA$ABABA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 4': {
      rle: 'x = 5, y = 5, rule = FuzzyLife/3\n4bA$4bB$4bA$A2bA$b2A!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 5': {
      rle: 'x = 8, y = 4, rule = FuzzyLife/3\n4bABA$7bA$7bA$ABABABA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 6': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\nb2A$A2bA$B2bB$A2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 7': {
      rle: 'x = 10, y = 4, rule = FuzzyLife/3\n7bA$9bA$9bA$ABABABABA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 8': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bA$A$b2A!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 9': {
      rle: 'x = 14, y = 4, rule = FuzzyLife/3\n12bA$13bA$13bA$ABABABABABABA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 10': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\n3bA$3bB$A2bA$b2A!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 11': {
      rle: 'x = 7, y = 5, rule = FuzzyLife/3\n5bA$6bA$6bA$5bA$ABABA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 12': {
      rle: 'x = 9, y = 5, rule = FuzzyLife/3\n7bA$8bA$8bA$7bA$ABABABA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 13': {
      rle: 'x = 8, y = 4, rule = FuzzyLife/3\n5bA$7bA$7bA$ABABABA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 14': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\n2bA$A$A$2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 15': {
      rle: 'x = 4, y = 6, rule = FuzzyLife/3\n3bA$3bB$A2bA$B2bB$A2bA$b2A!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 16': {
      rle: 'x = 8, y = 4, rule = FuzzyLife/3\n6bA$7bA$7bA$ABABABA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 17': {
      rle: 'x = 7, y = 5, rule = FuzzyLife/3\n4bA$6bA$6bA$5bA$ABABA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 18': {
      rle: 'x = 5, y = 7, rule = FuzzyLife/3\n4bA$4bB$4bA$A3bB$B3bA$A2bA$b2A!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 19': {
      rle: 'x = 6, y = 4, rule = FuzzyLife/3\n4bA$5bA$5bA$ABABA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 20': {
      rle: 'x = 4, y = 6, rule = FuzzyLife/3\nb2A$A2bA$B2bB$A2bA$B2bB$A2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
  },
  'b2-4_s0.5-1': {
    'Glider c/3 1': {
      rle: 'x = 4, y = 5, rule = FuzzyLife/3\n2bB$BAbA$BA$BAbA$2bB!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Glider c/6 2': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\nb2A$A$3A!',
      description: 'Glider, speed c/6 (period 6, displacement 1)',
    },
    'Glider c/3 3': {
      rle: 'x = 5, y = 4, rule = FuzzyLife/3\n2bA$5A$A3bA$b3A!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Glider c/6 4': {
      rle: 'x = 5, y = 4, rule = FuzzyLife/3\n2bA$bBb2A$2Ab2A$bBA!',
      description: 'Glider, speed c/6 (period 6, displacement 1)',
    },
    'Glider c/6 5': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\n2bB$BA$BAB!',
      description: 'Glider, speed c/6 (period 6, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 2, rule = FuzzyLife/3\n2bB$B!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P3 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nAB$BA!',
      description: 'Period 3 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 4, y = 5, rule = FuzzyLife/3\n2bAB$BA$2b2A$2AbB$BbA!',
      description: 'Period 4 oscillator (smallest)',
    },
    'Oscillator P6 1': {
      rle: 'x = 7, y = 6, rule = FuzzyLife/3\n5bB$$6bB$$BA$AB!',
      description: 'Period 6 oscillator (smallest)',
    },
    'Oscillator P8 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\nbAB$BAB$BA!',
      description: 'Period 8 oscillator (smallest)',
    },
  },
  'b3-3.5_s2.5-4.5': {
    'Glider c/6 1': {
      rle: 'x = 5, y = 5, rule = FuzzyLife/3\n3bA$bA2BA$b2BbA$ABbA$b2A!',
      description: 'Glider, speed c/6 (period 6, displacement 1)',
    },
    'Glider c/6 2': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\n2bAB$b3B$ABA$2B!',
      description: 'Glider, speed c/6 (period 6, displacement 1)',
    },
    'Oscillator P1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\n2B$2B!',
      description: 'Period 1 oscillator (smallest)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\n2A$2B!',
      description: 'Period 2 oscillator (smallest)',
    },
  },
  'b3-3.5_s2.5-5.5': {
    'Glider c/3 1': {
      rle: 'x = 5, y = 4, rule = FuzzyLife/3\n2bA$A3BA$B3AB$BbBbB!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Oscillator P1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\n2B$2B!',
      description: 'Period 1 oscillator (smallest)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\n2A$2B!',
      description: 'Period 2 oscillator (smallest)',
    },
  },
  'b3-3.5_s3-6': {
    'Glider c/3 1': {
      rle: 'x = 5, y = 5, rule = FuzzyLife/3\n2bA$A3BA$2BA2B$2Bb2B$AbAbA!',
      description: 'Glider, speed c/3 (period 9, displacement 3)',
    },
    'Oscillator P1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\n2B$2B!',
      description: 'Period 1 oscillator (smallest)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 2, rule = FuzzyLife/3\nbB$3B!',
      description: 'Period 2 oscillator (smallest)',
    },
  },
  'b2.5-6_s2-2.5': {
    'Glider c/6 1': {
      rle: 'x = 5, y = 4, rule = FuzzyLife/3\n2bB$ABABA$2BA2B$2bB!',
      description: 'Glider, speed c/6 (period 6, displacement 1)',
    },
    'Glider c/6 2': {
      rle: 'x = 3, y = 5, rule = FuzzyLife/3\nbA$AbA$AbA$3B$bA!',
      description: 'Glider, speed c/6 (period 6, displacement 1)',
    },
    'Glider c/6 3': {
      rle: 'x = 5, y = 4, rule = FuzzyLife/3\n2bA$ABbBA$bBbB$2bB!',
      description: 'Glider, speed c/6 (period 6, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nAB$2B!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\n2bBA$2b2B$2B$AB!',
      description: 'Period 4 oscillator (smallest)',
    },
    'Oscillator P8 1': {
      rle: 'x = 6, y = 5, rule = FuzzyLife/3\n3bBA$BbBABA$ABAB2A$b2AB2A$2b3A!',
      description: 'Period 8 oscillator (smallest)',
    },
  },
  'b2-3.5_s1.5': {
    'Glider c/2 1': {
      rle: 'x = 4, y = 5, rule = FuzzyLife/3\n2bA$3A$B2AB$$b2B!',
      description: 'Glider, speed c/2 (period 16, displacement 8)',
    },
    'Glider c/2 2': {
      rle: 'x = 5, y = 4, rule = FuzzyLife/3\n2bA$bBb2A$ABb2A$2bA!',
      description: 'Glider, speed c/2 (period 16, displacement 8)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbB$BA!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\n2bAB$3bA$AbA$BA!',
      description: 'Period 4 oscillator (smallest)',
    },
  },
  'b2.5-6_s2.5-3': {
    'Glider c/6 1': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\nbA$BAB$bA$A2B!',
      description: 'Glider, speed c/6 (period 6, displacement 1)',
    },
    'Oscillator P1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\n2B$2B!',
      description: 'Period 1 oscillator (smallest)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\n2A$2B!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 4, y = 5, rule = FuzzyLife/3\n2bA$A2B$BbAB$ABbA$2bB!',
      description: 'Period 4 oscillator (smallest)',
    },
  },
  'b2-3.5_s2': {
    'Glider c/5 1': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\n2bA$AbBA$AbBA$bB!',
      description: 'Glider, speed c/5 (period 5, displacement 1)',
    },
    'Glider c/5 2': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bA$3A$Ab2A!',
      description: 'Glider, speed c/5 (period 5, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 2, rule = FuzzyLife/3\nb2A$AB!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n2bB$B2bB$bB!',
      description: 'Period 4 oscillator (smallest)',
    },
    'Oscillator P6 1': {
      rle: 'x = 6, y = 6, rule = FuzzyLife/3\n2b2A$bA2BA$AB2bBA$AB2bBA$bA2BA$2b2A!',
      description: 'Period 6 oscillator (smallest)',
    },
  },
  'b2-4_s2.5-3': {
    'Glider c/3 1': {
      rle: 'x = 5, y = 5, rule = FuzzyLife/3\n3bA$3bB$Ab3A$ABAB$2bA!',
      description: 'Glider, speed c/3 (period 6, displacement 2)',
    },
    'Glider c/8 1': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\n2bBA$2AbA$2ABA$b2A!',
      description: 'Glider, speed c/8 (period 8, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nAB$BA!',
      description: 'Period 2 oscillator (smallest)',
    },
  },
  'b1_s1.5-2.5': {
    'Glider c 1': {
      rle: 'x = 4, y = 2, rule = FuzzyLife/3\nb2A$A2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 2': {
      rle: 'x = 8, y = 4, rule = FuzzyLife/3\n5bA$7bA$7bA$ABABABA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 3': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\n3bA$A2bB$3bA$b2A!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 4': {
      rle: 'x = 6, y = 4, rule = FuzzyLife/3\n4bA$5bA$5bA$ABABA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 5': {
      rle: 'x = 6, y = 4, rule = FuzzyLife/3\n3bA$5bA$5bA$ABABA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 6': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\nb2A$A2bA$B2bB$A2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 7': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\n3bA$3bB$A2bA$b2A!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 8': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\n2bA$A$A$2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
  },
  'b2-2.5_s1-1.5': {
    'Glider c/6 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\nbB$BbB$BAB!',
      description: 'Glider, speed c/6 (period 6, displacement 1)',
    },
    'Glider c/6 2': {
      rle: 'x = 5, y = 4, rule = FuzzyLife/3\n2bA$ABbBA$2Ab2A$b3A!',
      description: 'Glider, speed c/6 (period 6, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 1, rule = FuzzyLife/3\nAB!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 7, y = 7, rule = FuzzyLife/3\n3bA$bABABA$bBAbAB$2AbAb2A$bBAbAB$bABABA$3bA!',
      description: 'Period 4 oscillator (smallest)',
    },
    'Oscillator P12 1': {
      rle: 'x = 10, y = 10, rule = FuzzyLife/3\n8b2A$8b2B$8b2A$3bA$bABABA$bBAbAB$2AbAb2A$bBAbAB$bABABA$3bA!',
      description: 'Period 12 oscillator (smallest)',
    },
  },
  'b1.5-4_s0': {
    'Glider c/3 1': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\n3bB$b2A$bAB$B!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Glider c/3 2': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\n2bA$A$AbA!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Glider c/3 3': {
      rle: 'x = 3, y = 2, rule = FuzzyLife/3\nb2A$BbB!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Oscillator P1': {
      rle: 'x = 1, y = 1, rule = FuzzyLife/3\nB!',
      description: 'Period 1 oscillator (smallest)',
    },
    'Oscillator P2 1': {
      rle: 'x = 7, y = 6, rule = FuzzyLife/3\n4b2A$2bA$2bAb3A$AbAbA$AbAbA$2bAbA!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P6 1': {
      rle: 'x = 7, y = 6, rule = FuzzyLife/3\n5b2A$bBAbAbA$b2Ab2A$A2bA$2AbAbA$b2A3bB!',
      description: 'Period 6 oscillator (smallest)',
    },
  },
  'b2.5-7_s1.5-2': {
    'Glider 3c/37 1': {
      rle: 'x = 6, y = 6, rule = FuzzyLife/3\n3b2B$4bAB$2BAb2A$2BAb2A$4bAB$3b2B!',
      description: 'Glider, speed 3c/37 (period 37, displacement 3)',
    },
    'Glider 3c/37 2': {
      rle: 'x = 6, y = 6, rule = FuzzyLife/3\n3bB2A$b3AbA$2AbA$2AbA$b3AbA$3bB2A!',
      description: 'Glider, speed 3c/37 (period 37, displacement 3)',
    },
    'Glider 3c/37 3': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\nb2B$B2bB$B2bB!',
      description: 'Glider, speed 3c/37 (period 37, displacement 3)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\n2B$2B!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n2bAB$ABbB$bAB!',
      description: 'Period 4 oscillator (smallest)',
    },
  },
  'b2-2.5_s1.5': {
    'Glider c/4 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\n2bA$3B$bA!',
      description: 'Glider, speed c/4 (period 4, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbB$BA!',
      description: 'Period 2 oscillator (smallest)',
    },
  },
  'b1.5-5_s0': {
    'Glider c/3 1': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\n3bB$b2A$bAB$B!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Glider c/3 2': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\n2bA$A$AbA!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Glider c/3 3': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n2bA$4A$A2bA!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Glider c/3 4': {
      rle: 'x = 3, y = 2, rule = FuzzyLife/3\nb2A$BbB!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Oscillator P1': {
      rle: 'x = 1, y = 1, rule = FuzzyLife/3\nB!',
      description: 'Period 1 oscillator (smallest)',
    },
    'Oscillator P6 1': {
      rle: 'x = 7, y = 6, rule = FuzzyLife/3\n6bB$3bAbA$3bA$6A$$4A!',
      description: 'Period 6 oscillator (smallest)',
    },
  },
  'b2.5-7_s2-2.5': {
    'Glider c/6 1': {
      rle: 'x = 5, y = 4, rule = FuzzyLife/3\n2bB$ABABA$2BA2B$2bB!',
      description: 'Glider, speed c/6 (period 6, displacement 1)',
    },
    'Glider c/6 2': {
      rle: 'x = 3, y = 5, rule = FuzzyLife/3\nbA$AbA$AbA$3B$bA!',
      description: 'Glider, speed c/6 (period 6, displacement 1)',
    },
    'Glider c/6 3': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\nbA$BAB$BAB$AbA!',
      description: 'Glider, speed c/6 (period 6, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nAB$2B!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P16 1': {
      rle: 'x = 5, y = 4, rule = FuzzyLife/3\n2bB$2BA2B$BbAbB$b3B!',
      description: 'Period 16 oscillator (smallest)',
    },
  },
  'b1_s1.5-3': {
    'Glider c 1': {
      rle: 'x = 2, y = 4, rule = FuzzyLife/3\nbA$A$A$bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 2': {
      rle: 'x = 6, y = 4, rule = FuzzyLife/3\n3bA$5bA$5bA$ABABA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 3': {
      rle: 'x = 8, y = 4, rule = FuzzyLife/3\n5bA$7bA$7bA$ABABABA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 4': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\n3bA$A2bB$3bA$b2A!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P6 1': {
      rle: 'x = 13, y = 13, rule = FuzzyLife/3\n9bA$10b2B$2b2BbBb3BbB$2bB3bB3bBbA$6bB3bB$2bB3bB3bB$3b3Bb3B$2bB3bB3bB$2bB3bB$AbB3bB3bB$bBb3BbBb2B$b2B$3bA!',
      description: 'Period 6 oscillator (smallest)',
    },
    'Oscillator P10 1': {
      rle: 'x = 6, y = 3, rule = FuzzyLife/3\n5bA$b4B$A4bA!',
      description: 'Period 10 oscillator (smallest)',
    },
  },
  'b2.5-7_s2.5-3': {
    'Glider c/6 1': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\nbA$BAB$bA$A2B!',
      description: 'Glider, speed c/6 (period 6, displacement 1)',
    },
    'Glider c/6 2': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\nbAB$3B$3A!',
      description: 'Glider, speed c/6 (period 6, displacement 1)',
    },
    'Oscillator P1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\n2B$2B!',
      description: 'Period 1 oscillator (smallest)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\n2A$2B!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 4, y = 5, rule = FuzzyLife/3\n2bA$A2B$BbAB$ABbA$2bB!',
      description: 'Period 4 oscillator (smallest)',
    },
  },
  'b2-2.5_s2.5-4.5': {
    'Glider c/2 1': {
      rle: 'x = 6, y = 4, rule = FuzzyLife/3\n2b2A$2Ab2BA$2Ab2BA$2b2A!',
      description: 'Glider, speed c/2 (period 4, displacement 2)',
    },
    'Glider c/2 2': {
      rle: 'x = 5, y = 4, rule = FuzzyLife/3\nbAb2A$ABAB$ABAB$bAb2A!',
      description: 'Glider, speed c/2 (period 4, displacement 2)',
    },
    'Oscillator P1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\nbB$3B$bB!',
      description: 'Period 1 oscillator (smallest)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 2, rule = FuzzyLife/3\nb2A$2B!',
      description: 'Period 2 oscillator (smallest)',
    },
  },
  'b1_s1.5-3.5': {
    'Glider c 1': {
      rle: 'x = 4, y = 2, rule = FuzzyLife/3\nb2A$A2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 2': {
      rle: 'x = 8, y = 4, rule = FuzzyLife/3\n6bA$7bA$7bA$ABABABA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 3': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\n3bA$A2bB$3bA$b2A!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 4': {
      rle: 'x = 8, y = 4, rule = FuzzyLife/3\n5bA$7bA$7bA$ABABABA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 5': {
      rle: 'x = 6, y = 4, rule = FuzzyLife/3\n3bA$5bA$5bA$ABABA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 13, y = 13, rule = FuzzyLife/3\n6bA$7b2B2bA$7bBb2B$8bBbB$7bBbBbB$7b2Bb2B$A5bB5bA$b2Bb2B$bBbBbB$2bBbB$2b2BbB$bA2b2B$6bA!',
      description: 'Period 4 oscillator (smallest)',
    },
    'Oscillator P6 1': {
      rle: 'x = 9, y = 9, rule = FuzzyLife/3\n6bA$3b2B$bAB2b2BbA$3b2BbB$2bB2bBbB$AbB2bBbB$bBb2BbB$b2B3bA$3bA!',
      description: 'Period 6 oscillator (smallest)',
    },
    'Oscillator P10 1': {
      rle: 'x = 11, y = 7, rule = FuzzyLife/3\n7bAbA$8bB$4bA3bBbA$2b2B4bB$AB2b4BbB$2b2B4b2B$4bA2bA!',
      description: 'Period 10 oscillator (smallest)',
    },
  },
  'b2.5-6.5_s2-2.5': {
    'Glider c/6 1': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\nbAbA$ABAB$A2B!',
      description: 'Glider, speed c/6 (period 6, displacement 1)',
    },
    'Glider c/6 2': {
      rle: 'x = 3, y = 5, rule = FuzzyLife/3\nbA$AbA$AbA$3B$bA!',
      description: 'Glider, speed c/6 (period 6, displacement 1)',
    },
    'Glider c/6 3': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\nbA$BAB$BAB$AbA!',
      description: 'Glider, speed c/6 (period 6, displacement 1)',
    },
    'Glider c/6 4': {
      rle: 'x = 5, y = 4, rule = FuzzyLife/3\n2bB$ABABA$2BA2B$2bB!',
      description: 'Glider, speed c/6 (period 6, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nAB$2B!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\n2bBA$2b2B$2B$AB!',
      description: 'Period 4 oscillator (smallest)',
    },
  },
  'b2-2.5_s3-4.5': {
    'Glider c/3 1': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\n2bB$ABAB$A2B$b2A!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Glider c/3 2': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\nbB$3B$b2B!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Glider c/3 3': {
      rle: 'x = 5, y = 5, rule = FuzzyLife/3\n2b2A$b3B$ABAbB$A2B$2b2A!',
      description: 'Glider, speed c/3 (period 6, displacement 2)',
    },
    'Oscillator P1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\nbB$3B$bB!',
      description: 'Period 1 oscillator (smallest)',
    },
    'Oscillator P2 1': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n2bA$2B2A$BbB!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\nb2A$3B$bB!',
      description: 'Period 4 oscillator (smallest)',
    },
    'Oscillator P5 1': {
      rle: 'x = 6, y = 5, rule = FuzzyLife/3\n3bB$bA3B$AB2b2B$A3BbA$2bB!',
      description: 'Period 5 oscillator (smallest)',
    },
    'Oscillator P6 1': {
      rle: 'x = 5, y = 3, rule = FuzzyLife/3\n2bB$ABABA$2bB!',
      description: 'Period 6 oscillator (smallest)',
    },
  },
  'b2-2.5_s3-5': {
    'Glider c/3 1': {
      rle: 'x = 5, y = 5, rule = FuzzyLife/3\n2b2A$b3B$ABAbB$A2B$2b2A!',
      description: 'Glider, speed c/3 (period 6, displacement 2)',
    },
    'Oscillator P1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\nbB$3B$bB!',
      description: 'Period 1 oscillator (smallest)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\nb2A$3B$2A!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\nb2A$3B$bB!',
      description: 'Period 4 oscillator (smallest)',
    },
    'Oscillator P10 1': {
      rle: 'x = 6, y = 5, rule = FuzzyLife/3\n3bB$Ab3B$2B2b2B$b2BbB$2b3B!',
      description: 'Period 10 oscillator (smallest)',
    },
    'Oscillator P12 1': {
      rle: 'x = 6, y = 4, rule = FuzzyLife/3\n2bA2bA$Ab4B$bBb2B$b2BbA!',
      description: 'Period 12 oscillator (smallest)',
    },
    'Oscillator P22 1': {
      rle: 'x = 9, y = 6, rule = FuzzyLife/3\n5bA$3bAb3B$b3BbBbB$bBbBb2BbA$2A4B$bA3bA!',
      description: 'Period 22 oscillator (smallest)',
    },
  },
  'b2.5-6.5_s2.5-3': {
    'Glider c/6 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\nbAB$3B$3A!',
      description: 'Glider, speed c/6 (period 6, displacement 1)',
    },
    'Oscillator P1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\n2B$2B!',
      description: 'Period 1 oscillator (smallest)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\n2A$2B!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 4, y = 5, rule = FuzzyLife/3\n2bA$A2B$BbAB$ABbA$2bB!',
      description: 'Period 4 oscillator (smallest)',
    },
  },
  'b1.5-2.5_s1': {
    'Glider c/5 1': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\nb2A$4A$A2bA!',
      description: 'Glider, speed c/5 (period 10, displacement 2)',
    },
    'Glider c/5 2': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\n2A$2B!',
      description: 'Glider, speed c/5 (period 10, displacement 2)',
    },
    'Oscillator P4 1': {
      rle: 'x = 5, y = 5, rule = FuzzyLife/3\n4bA$bBA$b3A$2bAB$A!',
      description: 'Period 4 oscillator (smallest)',
    },
  },
  'b1_s1.5-4': {
    'Glider c 1': {
      rle: 'x = 6, y = 4, rule = FuzzyLife/3\n3bA$5bA$5bA$ABABA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 2': {
      rle: 'x = 4, y = 2, rule = FuzzyLife/3\nb2A$A2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P6 1': {
      rle: 'x = 7, y = 7, rule = FuzzyLife/3\n6bA$b2Bb2B$bBbBbB$2bBbBbA$bBb2B$b2B2bA$A2bA!',
      description: 'Period 6 oscillator (smallest)',
    },
    'Oscillator P12 1': {
      rle: 'x = 12, y = 11, rule = FuzzyLife/3\n11bA$9b2B$3bAbBb2BbB$A3bBbBb2BbA$b4BbB2bB$B4bBb2BbA$b2B2bB2bB$A4bBbBbA$3bBb3B$3b2B$5bA!',
      description: 'Period 12 oscillator (smallest)',
    },
  },
  'b1.5-2.5_s2': {
    'Glider 2c/3 1': {
      rle: 'x = 5, y = 4, rule = FuzzyLife/3\n3bA$2A2bA$A2bBA$b2AbA!',
      description: 'Glider, speed 2c/3 (period 3, displacement 2)',
    },
    'Glider 2c/3 2': {
      rle: 'x = 11, y = 4, rule = FuzzyLife/3\n8b2A$2b2A2bA2b2A$2A2b2A2b2AB$2b2A2b2A2bA!',
      description: 'Glider, speed 2c/3 (period 3, displacement 2)',
    },
    'Glider 2c/3 3': {
      rle: 'x = 5, y = 3, rule = FuzzyLife/3\n2bA$2A2BA$b2AB!',
      description: 'Glider, speed 2c/3 (period 3, displacement 2)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\n2bA$ABA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P6 1': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bA$A2B$ABbA!',
      description: 'Period 6 oscillator (smallest)',
    },
  },
  'b3-4.5_s3-5': {
    'Glider c/4 1': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\nbA$3B$BAB$bB!',
      description: 'Glider, speed c/4 (period 4, displacement 1)',
    },
    'Glider c/4 2': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\nAbA$3B$ABA!',
      description: 'Glider, speed c/4 (period 4, displacement 1)',
    },
    'Oscillator P1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\n2B$2B!',
      description: 'Period 1 oscillator (smallest)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 2, rule = FuzzyLife/3\nbB$3B!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P10 1': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\nb2B$B2bB$4B$b2B!',
      description: 'Period 10 oscillator (smallest)',
    },
  },
  'b2.5-7.5_s2.5-3': {
    'Glider c/6 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\nbAB$3B$3A!',
      description: 'Glider, speed c/6 (period 6, displacement 1)',
    },
    'Oscillator P1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\n2B$2B!',
      description: 'Period 1 oscillator (smallest)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nAB$BA!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\n2bA$2bBA$ABAB$bAB!',
      description: 'Period 4 oscillator (smallest)',
    },
  },
  'b1.5-2.5_s2.5-3': {
    'Glider 2c/3 1': {
      rle: 'x = 6, y = 4, rule = FuzzyLife/3\n2b2AbA$2A2bBA$2A2bBA$2b2AbA!',
      description: 'Glider, speed 2c/3 (period 3, displacement 2)',
    },
    'Glider c/16 1': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\n2bA$AbB$bA$3A!',
      description: 'Glider, speed c/16 (period 16, displacement 1)',
    },
    'Glider 2c/3 2': {
      rle: 'x = 4, y = 5, rule = FuzzyLife/3\nb2A$A2bA$A2bA$b2B$4A!',
      description: 'Glider, speed 2c/3 (period 3, displacement 2)',
    },
    'Glider 2c/3 3': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\nA2bA$b2A$b2A$A2BA!',
      description: 'Glider, speed 2c/3 (period 3, displacement 2)',
    },
    'Glider 2c/3 4': {
      rle: 'x = 6, y = 4, rule = FuzzyLife/3\n2bA2bA$A2b2AB$A2b2AB$2bA2bA!',
      description: 'Glider, speed 2c/3 (period 3, displacement 2)',
    },
    'Glider c/16 2': {
      rle: 'x = 4, y = 5, rule = FuzzyLife/3\n2bA$$ABbA$2AB$AbA!',
      description: 'Glider, speed c/16 (period 16, displacement 1)',
    },
    'Glider 2c/3 5': {
      rle: 'x = 5, y = 4, rule = FuzzyLife/3\n2bA$Ab2BA$Ab2BA$2bA!',
      description: 'Glider, speed 2c/3 (period 3, displacement 2)',
    },
    'Glider 2c/3 6': {
      rle: 'x = 6, y = 4, rule = FuzzyLife/3\n2bA2bA$A2BbA$A2BbA$2bA2bA!',
      description: 'Glider, speed 2c/3 (period 3, displacement 2)',
    },
    'Glider c/9 1': {
      rle: 'x = 5, y = 5, rule = FuzzyLife/3\n2bA$ABbBA$bB3A$A2bBA$2bAbA!',
      description: 'Glider, speed c/9 (period 18, displacement 2)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\n2bA$AB$bA!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bA$A2B$3bA!',
      description: 'Period 4 oscillator (smallest)',
    },
  },
  'b1.5-2.5_s2.5-3.5': {
    'Glider 2c/3 1': {
      rle: 'x = 4, y = 5, rule = FuzzyLife/3\n2bA$A$bBAB$b2A$A2BA!',
      description: 'Glider, speed 2c/3 (period 6, displacement 4)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\n2bA$AB$bA!',
      description: 'Period 2 oscillator (smallest)',
    },
  },
  'b1_s1.5-4.5': {
    'Glider c 1': {
      rle: 'x = 4, y = 2, rule = FuzzyLife/3\nb2A$A2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 2': {
      rle: 'x = 6, y = 4, rule = FuzzyLife/3\n3bA$5bA$5bA$ABABA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 3': {
      rle: 'x = 16, y = 4, rule = FuzzyLife/3\n13bA$15bA$15bA$ABABABABABABABA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 4': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\n3bA$A2bB$3bA$b2A!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 5': {
      rle: 'x = 8, y = 4, rule = FuzzyLife/3\n5bA$7bA$7bA$ABABABA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 9, y = 9, rule = FuzzyLife/3\n8bA$6b2B$AbBb2BbB$bBbBb2B$b4BbB$2bBb2B$2b3BbB$bA2b2B$6bA!',
      description: 'Period 4 oscillator (smallest)',
    },
    'Oscillator P6 1': {
      rle: 'x = 7, y = 7, rule = FuzzyLife/3\n6bA$b2Bb2B$bBbBbB$2bBbBbA$bBb2B$b2B2bA$A2bA!',
      description: 'Period 6 oscillator (smallest)',
    },
  },
  'b1_s1.5-5': {
    'Glider c 1': {
      rle: 'x = 4, y = 2, rule = FuzzyLife/3\nb2A$A2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 2': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\n3bA$A2bB$3bA$b2A!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 3': {
      rle: 'x = 8, y = 4, rule = FuzzyLife/3\n5bA$7bA$7bA$ABABABA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 4': {
      rle: 'x = 10, y = 4, rule = FuzzyLife/3\n7bA$9bA$9bA$ABABABABA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 5': {
      rle: 'x = 6, y = 4, rule = FuzzyLife/3\n3bA$5bA$5bA$ABABA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P6 1': {
      rle: 'x = 7, y = 7, rule = FuzzyLife/3\n6bA$b2Bb2B$bBbBbB$2b3BbA$bBb2B$b2B2bA$A2bA!',
      description: 'Period 6 oscillator (smallest)',
    },
  },
  'b2.5-7.5_s1.5-2': {
    'Glider 3c/37 1': {
      rle: 'x = 6, y = 6, rule = FuzzyLife/3\n3b2B$4bAB$2BAb2A$2BAb2A$4bAB$3b2B!',
      description: 'Glider, speed 3c/37 (period 37, displacement 3)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\n2B$2B!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n2bBA$B2bA$b2B!',
      description: 'Period 4 oscillator (smallest)',
    },
  },
  'b1_s1.5-5.5': {
    'Glider c 1': {
      rle: 'x = 6, y = 4, rule = FuzzyLife/3\n3bA$5bA$5bA$ABABA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 2': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\n3bA$A2bB$3bA$b2A!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 3': {
      rle: 'x = 4, y = 2, rule = FuzzyLife/3\nb2A$A2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 4': {
      rle: 'x = 10, y = 4, rule = FuzzyLife/3\n7bA$9bA$9bA$ABABABABA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 5': {
      rle: 'x = 12, y = 4, rule = FuzzyLife/3\n9bA$11bA$11bA$ABABABABABA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P6 1': {
      rle: 'x = 7, y = 6, rule = FuzzyLife/3\n3bA$b2B3bA$bBb3B$AbBb2B$2b2B2bA$bA2bA!',
      description: 'Period 6 oscillator (smallest)',
    },
    'Oscillator P10 1': {
      rle: 'x = 9, y = 7, rule = FuzzyLife/3\n6bA$4b2B$4bB$$A3b3BbA$b3B3bB$A4b3B!',
      description: 'Period 10 oscillator (smallest)',
    },
    'Oscillator P30 1': {
      rle: 'x = 6, y = 7, rule = FuzzyLife/3\n3bAbA$4bB$A3bB$b2BbB$Bb3B$b2B2bA$A2bA!',
      description: 'Period 30 oscillator (smallest)',
    },
  },
  'b1.5-7_s0': {
    'Glider c/3 1': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\n3bB$b2A$bAB$B!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Glider c/3 2': {
      rle: 'x = 3, y = 2, rule = FuzzyLife/3\nb2A$BbB!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Glider c/3 3': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n2bA$4A$A2bA!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Oscillator P1': {
      rle: 'x = 1, y = 1, rule = FuzzyLife/3\nB!',
      description: 'Period 1 oscillator (smallest)',
    },
    'Oscillator P6 1': {
      rle: 'x = 7, y = 7, rule = FuzzyLife/3\n6bB$bAbAbA$3bA$b5A$3bA$bAbAbA$B5bB!',
      description: 'Period 6 oscillator (smallest)',
    },
  },
  'b2.5-7.5_s2-2.5': {
    'Glider c/6 1': {
      rle: 'x = 5, y = 4, rule = FuzzyLife/3\n2bB$ABABA$2BA2B$2bB!',
      description: 'Glider, speed c/6 (period 6, displacement 1)',
    },
    'Glider c/6 2': {
      rle: 'x = 5, y = 4, rule = FuzzyLife/3\n2bA$ABbBA$bBbB$2bB!',
      description: 'Glider, speed c/6 (period 6, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nAB$2B!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 9, y = 9, rule = FuzzyLife/3\n7bA$7bBA$6bB2A$5b4A$6b2B$$b2B$A2bA$b2B!',
      description: 'Period 4 oscillator (smallest)',
    },
  },
  'b1_s1.5-6': {
    'Glider c 1': {
      rle: 'x = 2, y = 4, rule = FuzzyLife/3\nbA$A$A$bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 2': {
      rle: 'x = 6, y = 4, rule = FuzzyLife/3\n3bA$5bA$5bA$ABABA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 3': {
      rle: 'x = 12, y = 4, rule = FuzzyLife/3\n9bA$11bA$11bA$ABABABABABA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P6 1': {
      rle: 'x = 5, y = 6, rule = FuzzyLife/3\n2bA$A2b2B$b2BbB$bBbB$b3B$A3bA!',
      description: 'Period 6 oscillator (smallest)',
    },
    'Oscillator P10 1': {
      rle: 'x = 7, y = 3, rule = FuzzyLife/3\n6bA$b5B$A5bA!',
      description: 'Period 10 oscillator (smallest)',
    },
    'Oscillator P18 1': {
      rle: 'x = 9, y = 9, rule = FuzzyLife/3\n8bA$A5b2B$b2Bb2BbB$bBbBb2B$Ab4BbBA$2b2Bb2B$bA2b2BbB$3bA2b2B$5bA2bA!',
      description: 'Period 18 oscillator (smallest)',
    },
  },
  'b1.5-4_s2.5-3.5': {
    'Glider 2c/3 1': {
      rle: 'x = 6, y = 5, rule = FuzzyLife/3\n2b2A$2b2B$2A2B2A$6A$Ab2AbA!',
      description: 'Glider, speed 2c/3 (period 3, displacement 2)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\n2bA$AB$bA!',
      description: 'Period 2 oscillator (smallest)',
    },
  },
  'b1_s1.5-6.5': {
    'Glider c 1': {
      rle: 'x = 2, y = 4, rule = FuzzyLife/3\nbA$A$A$bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 2': {
      rle: 'x = 6, y = 4, rule = FuzzyLife/3\n3bA$5bA$5bA$ABABA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P6 1': {
      rle: 'x = 7, y = 7, rule = FuzzyLife/3\n6bA$b2Bb2B$bBbBbB$2b3BbA$bBb2B$b2B2bA$A2bA!',
      description: 'Period 6 oscillator (smallest)',
    },
    'Oscillator P10 1': {
      rle: 'x = 8, y = 7, rule = FuzzyLife/3\n5bA$A2b2B$b2BbB$bBbB3bA$2bBb3B$2b2B3bA$bA3bA!',
      description: 'Period 10 oscillator (smallest)',
    },
  },
  'b1.5-8_s0': {
    'Glider c/3 1': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\n3bB$b2A$bAB$B!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Glider c/3 2': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\n2bA$A$AbA!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Glider c/3 3': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n2bA$4A$A2bA!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Glider c/3 4': {
      rle: 'x = 3, y = 2, rule = FuzzyLife/3\nb2A$BbB!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Oscillator P1': {
      rle: 'x = 1, y = 1, rule = FuzzyLife/3\nB!',
      description: 'Period 1 oscillator (smallest)',
    },
    'Oscillator P2 1': {
      rle: 'x = 9, y = 16, rule = FuzzyLife/3\n5bAbA$3bAbAbA$3bAbAbA$4AbAb2A$3bAbA$4AbAb2A$5bA$9A$$9A$$9A$$2b6A$$4b2A!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P6 1': {
      rle: 'x = 8, y = 6, rule = FuzzyLife/3\n7bB$2bAbAbA$AbAbA$AbAb3A$2bA$2bAb2A!',
      description: 'Period 6 oscillator (smallest)',
    },
  },
  'b1.5-5_s2.5-3.5': {
    'Glider 2c/3 1': {
      rle: 'x = 6, y = 5, rule = FuzzyLife/3\n2b2A$2b2B$2A2B2A$6A$Ab2AbA!',
      description: 'Glider, speed 2c/3 (period 3, displacement 2)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\n2bA$AB$bA!',
      description: 'Period 2 oscillator (smallest)',
    },
  },
  'b1_s1.5-7': {
    'Glider c 1': {
      rle: 'x = 6, y = 4, rule = FuzzyLife/3\n3bA$5bA$5bA$ABABA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 2': {
      rle: 'x = 4, y = 2, rule = FuzzyLife/3\nb2A$A2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 3': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\n3bA$A2bB$3bA$b2A!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 4': {
      rle: 'x = 10, y = 4, rule = FuzzyLife/3\n7bA$9bA$9bA$ABABABABA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 5': {
      rle: 'x = 8, y = 4, rule = FuzzyLife/3\n5bA$7bA$7bA$ABABABA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P6 1': {
      rle: 'x = 7, y = 7, rule = FuzzyLife/3\n6bA$b2Bb2B$bBbBbB$2b3BbA$bBb2B$b2B2bA$A2bA!',
      description: 'Period 6 oscillator (smallest)',
    },
  },
  'b1_s1.5-7.5': {
    'Glider c 1': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\n3bA$A2bB$3bA$b2A!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 2': {
      rle: 'x = 4, y = 2, rule = FuzzyLife/3\nb2A$A2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 3': {
      rle: 'x = 6, y = 4, rule = FuzzyLife/3\n3bA$5bA$5bA$ABABA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P6 1': {
      rle: 'x = 7, y = 7, rule = FuzzyLife/3\n6bA$b2Bb2B$bBbBbB$2b3BbA$bBb2B$b2B2bA$A2bA!',
      description: 'Period 6 oscillator (smallest)',
    },
  },
  'b2-3_s0.5-1': {
    'Glider c/3 1': {
      rle: 'x = 5, y = 3, rule = FuzzyLife/3\n2A2bB$BABAB$2A2bB!',
      description: 'Glider, speed c/3 (period 9, displacement 3)',
    },
    'Glider c/3 2': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bB$2BAB$2bB!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Glider c/3 3': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bA$2AbA$3bA!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Glider c/4 1': {
      rle: 'x = 7, y = 6, rule = FuzzyLife/3\n3bA$bAbAbA$2AbAb2A$2AbAb2A$bAbAbA$2b3A!',
      description: 'Glider, speed c/4 (period 4, displacement 1)',
    },
    'Glider c/4 2': {
      rle: 'x = 5, y = 5, rule = FuzzyLife/3\n2bA$2bA$AbAbA$BbAbB$2bA!',
      description: 'Glider, speed c/4 (period 4, displacement 1)',
    },
    'Glider c/15 1': {
      rle: 'x = 5, y = 5, rule = FuzzyLife/3\n4bA$4bA$2bAbA$$3A!',
      description: 'Glider, speed c/15 (period 15, displacement 1)',
    },
    'Glider c/3 4': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bA$2AbA$2bA!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Glider c/4 3': {
      rle: 'x = 5, y = 5, rule = FuzzyLife/3\n3bB$4A$b4B$4A$3bB!',
      description: 'Glider, speed c/4 (period 4, displacement 1)',
    },
    'Glider c/3 5': {
      rle: 'x = 5, y = 3, rule = FuzzyLife/3\n3bA$2AbAB$3bA!',
      description: 'Glider, speed c/3 (period 9, displacement 3)',
    },
    'Glider c/3 6': {
      rle: 'x = 5, y = 3, rule = FuzzyLife/3\nb2AbA$2AbAB$2Ab2A!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 2, rule = FuzzyLife/3\n2bB$B!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P3 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nAB$BA!',
      description: 'Period 3 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\n2bB$b2A$BAB!',
      description: 'Period 4 oscillator (smallest)',
    },
    'Oscillator P6 1': {
      rle: 'x = 7, y = 6, rule = FuzzyLife/3\n6bB$4bB$$$BA$AB!',
      description: 'Period 6 oscillator (smallest)',
    },
    'Oscillator P8 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\nbAB$BAB$BA!',
      description: 'Period 8 oscillator (smallest)',
    },
  },
  'b1_s1.5-8': {
    'Glider c 1': {
      rle: 'x = 2, y = 4, rule = FuzzyLife/3\nbA$A$A$bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 2': {
      rle: 'x = 8, y = 4, rule = FuzzyLife/3\n5bA$7bA$7bA$ABABABA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 3': {
      rle: 'x = 6, y = 4, rule = FuzzyLife/3\n3bA$5bA$5bA$ABABA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 4': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\n3bA$A2bB$3bA$b2A!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 5': {
      rle: 'x = 10, y = 4, rule = FuzzyLife/3\n7bA$9bA$9bA$ABABABABA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P6 1': {
      rle: 'x = 7, y = 6, rule = FuzzyLife/3\n3bA$b2B3bA$bBb3B$AbBb2B$2b2B2bA$bA2bA!',
      description: 'Period 6 oscillator (smallest)',
    },
    'Oscillator P10 1': {
      rle: 'x = 8, y = 7, rule = FuzzyLife/3\n7bA$2b2Bb2B$ABb2BbB$2b2BbB$5bBbA$5bB$4bAbA!',
      description: 'Period 10 oscillator (smallest)',
    },
  },
  'b2-3_s1-1.5': {
    'Glider c/13 1': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\n2bA$bBbB$A$2B!',
      description: 'Glider, speed c/13 (period 13, displacement 1)',
    },
    'Glider c/13 2': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\n2bA$B2A$b2A$BA!',
      description: 'Glider, speed c/13 (period 13, displacement 1)',
    },
    'Glider c/13 3': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\n3bA$2b2A$ABbB$AB!',
      description: 'Glider, speed c/13 (period 13, displacement 1)',
    },
    'Glider c/13 4': {
      rle: 'x = 4, y = 2, rule = FuzzyLife/3\nbAbB$2AB!',
      description: 'Glider, speed c/13 (period 13, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 1, y = 2, rule = FuzzyLife/3\nA$B!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 7, y = 7, rule = FuzzyLife/3\n3bA$bABABA$bBAbAB$2AbAb2A$bBAbAB$bABABA$3bA!',
      description: 'Period 4 oscillator (smallest)',
    },
    'Oscillator P6 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\nbAB$BbB$BA!',
      description: 'Period 6 oscillator (smallest)',
    },
    'Oscillator P12 1': {
      rle: 'x = 6, y = 5, rule = FuzzyLife/3\n4bB$4b2B$B4bB$2B$bB!',
      description: 'Period 12 oscillator (smallest)',
    },
  },
  'b2-3_s1.5': {
    'Glider c/2 1': {
      rle: 'x = 6, y = 4, rule = FuzzyLife/3\n4b2B$BbBA$BbBA$4b2B!',
      description: 'Glider, speed c/2 (period 4, displacement 2)',
    },
    'Glider c/2 2': {
      rle: 'x = 6, y = 6, rule = FuzzyLife/3\n4bA$5bA$BbAB$BbAB$5bA$4bA!',
      description: 'Glider, speed c/2 (period 4, displacement 2)',
    },
    'Glider c/2 3': {
      rle: 'x = 7, y = 6, rule = FuzzyLife/3\n5b2A$2bAbABA$2AbAb2A$2AbAb2A$2bAbABA$5b2A!',
      description: 'Glider, speed c/2 (period 4, displacement 2)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbB$BA!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P12 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\n2bB$AB$3A!',
      description: 'Period 12 oscillator (smallest)',
    },
  },
  'b1.5-3_s0': {
    'Glider c/3 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\n2bA$A$AbA!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Glider c/3 2': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n2bA$4A$A2bA!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Glider c/3 3': {
      rle: 'x = 3, y = 2, rule = FuzzyLife/3\nb2A$BbB!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Oscillator P1': {
      rle: 'x = 1, y = 1, rule = FuzzyLife/3\nB!',
      description: 'Period 1 oscillator (smallest)',
    },
    'Oscillator P2 1': {
      rle: 'x = 6, y = 8, rule = FuzzyLife/3\n3bA$bA2b2A$2b2A$6A$$6A$$2b2A!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P6 1': {
      rle: 'x = 5, y = 5, rule = FuzzyLife/3\n3bA$b2A$A2b2A$2AbAB$b2A!',
      description: 'Period 6 oscillator (smallest)',
    },
  },
  'b2-3_s2.5-3': {
    'Glider c/3 1': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\n3bA$bA2B$b2B$ABbA!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n2bA$A2B$b2BA!',
      description: 'Period 2 oscillator (smallest)',
    },
  },
  'b1.5-7.5_s0': {
    'Glider c/3 1': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\n3bB$b2A$bAB$B!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Glider c/3 2': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\n2bA$A$AbA!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Glider c/3 3': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n2bA$4A$A2bA!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Glider c/3 4': {
      rle: 'x = 3, y = 2, rule = FuzzyLife/3\nb2A$BbB!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Oscillator P1': {
      rle: 'x = 1, y = 1, rule = FuzzyLife/3\nB!',
      description: 'Period 1 oscillator (smallest)',
    },
    'Oscillator P6 1': {
      rle: 'x = 7, y = 6, rule = FuzzyLife/3\n6bB$3bAbA$3bA$6A$$b4A!',
      description: 'Period 6 oscillator (smallest)',
    },
  },
  'b1.5-2_s0': {
    'Glider c/4 1': {
      rle: 'x = 6, y = 3, rule = FuzzyLife/3\n5bB$2bAbA$A4bB!',
      description: 'Glider, speed c/4 (period 4, displacement 1)',
    },
    'Oscillator P1': {
      rle: 'x = 1, y = 1, rule = FuzzyLife/3\nB!',
      description: 'Period 1 oscillator (smallest)',
    },
    'Oscillator P2 1': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\n2bA$AbA$bAbA$bA!',
      description: 'Period 2 oscillator (smallest)',
    },
  },
  'b1_s2-2.5': {
    'Glider c 1': {
      rle: 'x = 2, y = 4, rule = FuzzyLife/3\nbA$A$A$bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 2': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\n2bA$A$A$2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 3': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bA$A$b2A!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
  },
  'b1.5-3_s2.5': {
    'Glider c/9 1': {
      rle: 'x = 6, y = 4, rule = FuzzyLife/3\n3bA$3ABbA$b2ABbA$2AbA!',
      description: 'Glider, speed c/9 (period 9, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\n2bA$AB$bA!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 4, y = 5, rule = FuzzyLife/3\n2bA$ABbA$$AbBA$bA!',
      description: 'Period 4 oscillator (smallest)',
    },
  },
  'b1.5-2.5_s0': {
    'Glider c/3 1': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\n3bB$b2A$bAB$B!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Glider c/3 2': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\n2b2A$3bA$Ab2A$3A!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Oscillator P1': {
      rle: 'x = 1, y = 1, rule = FuzzyLife/3\nB!',
      description: 'Period 1 oscillator (smallest)',
    },
    'Oscillator P8 1': {
      rle: 'x = 8, y = 6, rule = FuzzyLife/3\n7bB$6bA$6bA$4b2A$6b2A$B4bA!',
      description: 'Period 8 oscillator (smallest)',
    },
  },
  'b1.5-5.5_s0': {
    'Glider c/3 1': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\n3bB$b2A$bAB$B!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Glider c/3 2': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\n2bA$A$AbA!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Glider c/3 3': {
      rle: 'x = 3, y = 2, rule = FuzzyLife/3\nb2A$BbB!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Glider c/3 4': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n2bA$4A$A2bA!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Oscillator P1': {
      rle: 'x = 1, y = 1, rule = FuzzyLife/3\nB!',
      description: 'Period 1 oscillator (smallest)',
    },
    'Oscillator P6 1': {
      rle: 'x = 6, y = 7, rule = FuzzyLife/3\n5bB$2bAbA$AbA$Ab3A$AbA$AbAbA$5bB!',
      description: 'Period 6 oscillator (smallest)',
    },
  },
  'b1.5_s1': {
    'Glider c/3 1': {
      rle: 'x = 14, y = 6, rule = FuzzyLife/3\n12b2A$12bAB$12b2A$$$BA!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Glider c/2 1': {
      rle: 'x = 2, y = 3, rule = FuzzyLife/3\nbA$A$AB!',
      description: 'Glider, speed c/2 (period 4, displacement 2)',
    },
    'Glider c/3 2': {
      rle: 'x = 3, y = 2, rule = FuzzyLife/3\n3A$ABA!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Glider c/3 3': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bA$AbA$3bA!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Glider c/2 2': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\n2bA$bB$2A!',
      description: 'Glider, speed c/2 (period 4, displacement 2)',
    },
    'Glider c/3 4': {
      rle: 'x = 9, y = 8, rule = FuzzyLife/3\n8bA$8bB$$$$$A$B!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Glider c/3 5': {
      rle: 'x = 18, y = 13, rule = FuzzyLife/3\n16bBA$$$$$$$$$9b2A$3bA5bAB$AbA6b2A$3bA!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Glider c/3 6': {
      rle: 'x = 8, y = 5, rule = FuzzyLife/3\n7bA$AbA4bB$bA$$bA!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Glider c/3 7': {
      rle: 'x = 7, y = 4, rule = FuzzyLife/3\n5b2A$5bAB$5b2A$BA!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Glider c/3 8': {
      rle: 'x = 16, y = 5, rule = FuzzyLife/3\n15bA$12bAbA$3bA11bA$AbA$3bA!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Glider c/3 9': {
      rle: 'x = 18, y = 5, rule = FuzzyLife/3\n16bBA$9b2A$3bA5bAB$AbA6b2A$3bA!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Glider c/3 10': {
      rle: 'x = 19, y = 7, rule = FuzzyLife/3\n18bA$15bAbA$18bA$$3bA$AbA$3bA!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Glider c/3 11': {
      rle: 'x = 7, y = 5, rule = FuzzyLife/3\n6bB$6bA$$3A$ABA!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Glider c/3 12': {
      rle: 'x = 13, y = 9, rule = FuzzyLife/3\n11b2A$11bBA$11b2A$$$$$$AB!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Oscillator P1': {
      rle: 'x = 1, y = 2, rule = FuzzyLife/3\nB$B!',
      description: 'Period 1 oscillator (smallest)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\nbB$BbB$BbB$bB!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P60 1': {
      rle: 'x = 4, y = 6, rule = FuzzyLife/3\n3bA$Bb2B$Bb2A$2b2A$bAB$bA!',
      description: 'Period 60 oscillator (smallest)',
    },
  },
  'b1.5-2.5_s0.5': {
    'Glider c/7 1': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\nbAbA$BA$BA$bAbA!',
      description: 'Glider, speed c/7 (period 7, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\n2bB$$B!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\n2bA$A$BA!',
      description: 'Period 4 oscillator (smallest)',
    },
    'Oscillator P6 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\n2A$2B!',
      description: 'Period 6 oscillator (smallest)',
    },
  },
  'b1.5_s1-1.5': {
    'Glider c/3 1': {
      rle: 'x = 2, y = 1, rule = FuzzyLife/3\nAB!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Glider c/3 2': {
      rle: 'x = 3, y = 2, rule = FuzzyLife/3\n3A$ABA!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Oscillator P1': {
      rle: 'x = 2, y = 1, rule = FuzzyLife/3\n2B!',
      description: 'Period 1 oscillator (smallest)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\n2B$2B!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 3, y = 5, rule = FuzzyLife/3\nbA$A2B$AB$AB$b2B!',
      description: 'Period 4 oscillator (smallest)',
    },
  },
  'b1.5-3.5_s0': {
    'Glider c/3 1': {
      rle: 'x = 3, y = 2, rule = FuzzyLife/3\nb2A$BbB!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Glider c/3 2': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\n2bA$A$AbA!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Glider c/3 3': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n2bA$4A$A2bA!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Glider c/3 4': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\n3bB$b2A$bAB$B!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Oscillator P1': {
      rle: 'x = 1, y = 1, rule = FuzzyLife/3\nB!',
      description: 'Period 1 oscillator (smallest)',
    },
    'Oscillator P6 1': {
      rle: 'x = 6, y = 7, rule = FuzzyLife/3\n5bB$2bAbA$AbA$Ab3A$AbA$AbAbA$5bB!',
      description: 'Period 6 oscillator (smallest)',
    },
  },
  'b1_s2-3.5': {
    'Glider c 1': {
      rle: 'x = 2, y = 4, rule = FuzzyLife/3\nbA$A$A$bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 2': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bA$A$b2A!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P6 1': {
      rle: 'x = 6, y = 6, rule = FuzzyLife/3\n5bA$b3B$bB2bB$bB2bB$Ab3B$bA3bA!',
      description: 'Period 6 oscillator (smallest)',
    },
  },
  'b1.5-4.5_s2.5-3.5': {
    'Glider 2c/3 1': {
      rle: 'x = 6, y = 5, rule = FuzzyLife/3\n2b2A$2b2B$2A2B2A$6A$Ab2AbA!',
      description: 'Glider, speed 2c/3 (period 3, displacement 2)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\n2bA$AB$bA!',
      description: 'Period 2 oscillator (smallest)',
    },
  },
  'b1.5-4.5_s0': {
    'Glider c/3 1': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n2bA$4A$A2bA!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Glider c/3 2': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\n3bB$b2A$bAB$B!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Glider c/3 3': {
      rle: 'x = 3, y = 2, rule = FuzzyLife/3\nb2A$BbB!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Glider c/3 4': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\n2bA$A$AbA!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Oscillator P1': {
      rle: 'x = 1, y = 1, rule = FuzzyLife/3\nB!',
      description: 'Period 1 oscillator (smallest)',
    },
    'Oscillator P6 1': {
      rle: 'x = 6, y = 7, rule = FuzzyLife/3\n5bB$AbAbA$AbA$Ab3A$AbA2bA$2bAb2A$3b2A!',
      description: 'Period 6 oscillator (smallest)',
    },
  },
  'b1.5-2_s2': {
    'Glider c/2 1': {
      rle: 'x = 9, y = 9, rule = FuzzyLife/3\n5bA$5bA$2b2AbA$3bBAb3A$A2bAbA$bBAbABA$bAbA2bA$2bAB$4bA!',
      description: 'Glider, speed c/2 (period 8, displacement 4)',
    },
    'Glider c/8 1': {
      rle: 'x = 5, y = 4, rule = FuzzyLife/3\n3b2A$bAb2B$2A2bB$A2bA!',
      description: 'Glider, speed c/8 (period 8, displacement 1)',
    },
    'Glider c/2 2': {
      rle: 'x = 8, y = 8, rule = FuzzyLife/3\n4bAbA$3bB2b2A$3bBbA$bA5bA$2AbAb2B$AB$2bB2A$2b2A!',
      description: 'Glider, speed c/2 (period 8, displacement 4)',
    },
    'Oscillator P2 1': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\n2bA$AbBA$bB$AbA!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P16 1': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n2bA$AB$2bBA!',
      description: 'Period 16 oscillator (smallest)',
    },
  },
  'b1.5-2_s2-2.5': {
    'Glider 2c/3 1': {
      rle: 'x = 5, y = 5, rule = FuzzyLife/3\n3bA$bBbB$A2bA$2b2BA$2bA!',
      description: 'Glider, speed 2c/3 (period 6, displacement 4)',
    },
    'Glider 2c/3 2': {
      rle: 'x = 6, y = 5, rule = FuzzyLife/3\n4bA$AbBAB$4bBA$AbB$3bA!',
      description: 'Glider, speed 2c/3 (period 6, displacement 4)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\n2bA$AB$bA!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 7, y = 4, rule = FuzzyLife/3\n6bA$$A4bAB$B!',
      description: 'Period 4 oscillator (smallest)',
    },
  },
  'b1.5-6_s0': {
    'Glider c/3 1': {
      rle: 'x = 3, y = 2, rule = FuzzyLife/3\nb2A$BbB!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Glider c/3 2': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\n3bB$b2A$bAB$B!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Glider c/3 3': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\n2bA$A$AbA!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Glider c/3 4': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n2bA$4A$A2bA!',
      description: 'Glider, speed c/3 (period 3, displacement 1)',
    },
    'Oscillator P1': {
      rle: 'x = 1, y = 1, rule = FuzzyLife/3\nB!',
      description: 'Period 1 oscillator (smallest)',
    },
    'Oscillator P6 1': {
      rle: 'x = 7, y = 7, rule = FuzzyLife/3\nB5bB$bAbAbA$3bA$b5A$3bA$bAbAbA$B5bB!',
      description: 'Period 6 oscillator (smallest)',
    },
  },
  'b1.5-2_s2.5-4': {
    'Glider c/2 1': {
      rle: 'x = 6, y = 7, rule = FuzzyLife/3\n5bA$2bA2bA$A4bA$bB$bBAB$A2BbA$b2A!',
      description: 'Glider, speed c/2 (period 4, displacement 2)',
    },
    'Glider c/2 2': {
      rle: 'x = 5, y = 5, rule = FuzzyLife/3\n3bBA$2A3B$A2bAB$b2AbA$b2A!',
      description: 'Glider, speed c/2 (period 4, displacement 2)',
    },
    'Glider c/2 3': {
      rle: 'x = 5, y = 5, rule = FuzzyLife/3\n3bBA$2A3B$A2bAB$b2AbA$2bA!',
      description: 'Glider, speed c/2 (period 4, displacement 2)',
    },
    'Glider c/2 4': {
      rle: 'x = 7, y = 6, rule = FuzzyLife/3\n4b2A$2bAb2BA$3b3BA$A$bAbB2A$bA2bA!',
      description: 'Glider, speed c/2 (period 8, displacement 4)',
    },
    'Glider c/2 5': {
      rle: 'x = 6, y = 5, rule = FuzzyLife/3\n4bBA$2bBA2B$2bAbB$3AbA$3b2A!',
      description: 'Glider, speed c/2 (period 8, displacement 4)',
    },
    'Glider c/2 6': {
      rle: 'x = 5, y = 5, rule = FuzzyLife/3\n3bBA$2A3B$3bB$bABA$A2bA!',
      description: 'Glider, speed c/2 (period 8, displacement 4)',
    },
    'Glider c/2 7': {
      rle: 'x = 11, y = 6, rule = FuzzyLife/3\n6bA$bAb2A2bB2bA$bABAbAbB2A$bB$3BAb3B2A$AB2b2B3bA!',
      description: 'Glider, speed c/2 (period 16, displacement 8)',
    },
    'Glider c/2 8': {
      rle: 'x = 7, y = 6, rule = FuzzyLife/3\n4bA$A2bA2bA$A4bB$bAbBbB$3b3BA$2bA2bA!',
      description: 'Glider, speed c/2 (period 8, displacement 4)',
    },
    'Glider c/2 9': {
      rle: 'x = 6, y = 6, rule = FuzzyLife/3\n4b2A$bA$2bBbB$A2Bb2A$A2BbA$b2A!',
      description: 'Glider, speed c/2 (period 8, displacement 4)',
    },
    'Glider c/2 10': {
      rle: 'x = 6, y = 6, rule = FuzzyLife/3\n4bA$bA2B$2bA2bA$ABAB$A2BbA$b2A!',
      description: 'Glider, speed c/2 (period 8, displacement 4)',
    },
    'Glider c/2 11': {
      rle: 'x = 8, y = 7, rule = FuzzyLife/3\n7bA$bA2bA2B$bA4bB$bAbBb2BA$2Ab2ABA$bAb2BA$3b2A!',
      description: 'Glider, speed c/2 (period 4, displacement 2)',
    },
    'Glider c/2 12': {
      rle: 'x = 8, y = 6, rule = FuzzyLife/3\n7bA$bA2b3A$bAbA$bBbB$3B2A$AB!',
      description: 'Glider, speed c/2 (period 8, displacement 4)',
    },
    'Glider c/2 13': {
      rle: 'x = 6, y = 6, rule = FuzzyLife/3\n3bA$2bA2bA$bB2bB$A3bB$2b3BA$bA2bA!',
      description: 'Glider, speed c/2 (period 8, displacement 4)',
    },
    'Oscillator P1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\nbB$3B$bB!',
      description: 'Period 1 oscillator (smallest)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\n2bA$AB$bA!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bA$AbB$2bA!',
      description: 'Period 4 oscillator (smallest)',
    },
    'Oscillator P6 1': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bA$A2B$2bB!',
      description: 'Period 6 oscillator (smallest)',
    },
    'Oscillator P8 1': {
      rle: 'x = 4, y = 5, rule = FuzzyLife/3\n2bA$AbB$A3B$bB$AbA!',
      description: 'Period 8 oscillator (smallest)',
    },
    'Oscillator P24 1': {
      rle: 'x = 11, y = 4, rule = FuzzyLife/3\n3bA4bB$A2B3bA2BbA$2bB5b2B$b2A4bA2bA!',
      description: 'Period 24 oscillator (smallest)',
    },
  },
  'b1.5-2_s2.5-4.5': {
    'Glider c/2 1': {
      rle: 'x = 6, y = 6, rule = FuzzyLife/3\n3bA$bA3bA$2bBbB$A2B3A$A2BbA$b2A!',
      description: 'Glider, speed c/2 (period 8, displacement 4)',
    },
    'Glider c/2 2': {
      rle: 'x = 7, y = 6, rule = FuzzyLife/3\n4bA$A2bA2bA$2AbBbB$bAbBbB$3b3BA$2bA2bA!',
      description: 'Glider, speed c/2 (period 8, displacement 4)',
    },
    'Glider c/2 3': {
      rle: 'x = 7, y = 5, rule = FuzzyLife/3\n5bBA$3b4B$A2bBbB$3bAbA$b2A2bA!',
      description: 'Glider, speed c/2 (period 8, displacement 4)',
    },
    'Glider c/2 4': {
      rle: 'x = 7, y = 7, rule = FuzzyLife/3\n4b2A$2bAb2BA$3b3BA$A3bB$bA3bA$AbA$bAbA!',
      description: 'Glider, speed c/2 (period 4, displacement 2)',
    },
    'Glider c/2 5': {
      rle: 'x = 5, y = 6, rule = FuzzyLife/3\n3bA$2AB$4bA$A4B$2b2AB$bA2BA!',
      description: 'Glider, speed c/2 (period 8, displacement 4)',
    },
    'Glider c/2 6': {
      rle: 'x = 9, y = 7, rule = FuzzyLife/3\n5bA$bA4bA$2bBA$A4bA2bA$4BAb2B$B2A2b2BbA$A2B2A2BA!',
      description: 'Glider, speed c/2 (period 4, displacement 2)',
    },
    'Glider c/2 7': {
      rle: 'x = 6, y = 9, rule = FuzzyLife/3\n2bA2BA$A2bBAB$bBbBAB$bAbBbA$3bAbA$2bAb2B$2Ab3B$3bBbA$3AbA!',
      description: 'Glider, speed c/2 (period 4, displacement 2)',
    },
    'Glider c/2 8': {
      rle: 'x = 7, y = 6, rule = FuzzyLife/3\n4bBA$b2A3BA$5bAB$AbAb3B$b2AbBbA$3bAbA!',
      description: 'Glider, speed c/2 (period 8, displacement 4)',
    },
    'Glider c/2 9': {
      rle: 'x = 7, y = 5, rule = FuzzyLife/3\n5bBA$3b4B$A2bBbB$3bAbA$2bA2bA!',
      description: 'Glider, speed c/2 (period 8, displacement 4)',
    },
    'Glider c/2 10': {
      rle: 'x = 10, y = 11, rule = FuzzyLife/3\n8bA$7bAbA$6bA2bA$4bAbBb2A$3b2A2B2bA$bA2bBbB$2bBA2BA$AbAbAbA$B3AB$B2A2bA$A2BA!',
      description: 'Glider, speed c/2 (period 8, displacement 4)',
    },
    'Glider c/2 11': {
      rle: 'x = 7, y = 6, rule = FuzzyLife/3\n3b2A$AbAbBbA$b2AbBAB$4b2AB$2A4BA$A3bBA!',
      description: 'Glider, speed c/2 (period 8, displacement 4)',
    },
    'Glider c/2 12': {
      rle: 'x = 8, y = 8, rule = FuzzyLife/3\n7bA$5bAbA$2bAbA2bA$b2ABbA$2bA2bA$A3B$A2BbA$b2A!',
      description: 'Glider, speed c/2 (period 12, displacement 6)',
    },
    'Glider c/2 13': {
      rle: 'x = 10, y = 7, rule = FuzzyLife/3\n5b2A$6b2A$9bA$A2BbBA3B$2b2A4bB$b4Bb3BA$bA2b2A2bA!',
      description: 'Glider, speed c/2 (period 4, displacement 2)',
    },
    'Glider c/2 14': {
      rle: 'x = 10, y = 10, rule = FuzzyLife/3\n6bA2BA$4bA2b2AB$5bB3AB$5bAbAbA$bAb3BAB$A2bBbB2bA$bA2b2B$bB$2bBAbA$4bA!',
      description: 'Glider, speed c/2 (period 4, displacement 2)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 2, rule = FuzzyLife/3\nbA$3B!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P3 1': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\n2bA$2b2B$A2B$bB!',
      description: 'Period 3 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bA$AbB$2bA!',
      description: 'Period 4 oscillator (smallest)',
    },
    'Oscillator P6 1': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bA$A2B$2bB!',
      description: 'Period 6 oscillator (smallest)',
    },
    'Oscillator P8 1': {
      rle: 'x = 4, y = 5, rule = FuzzyLife/3\n2bA$AbB$A3B$bB$AbA!',
      description: 'Period 8 oscillator (smallest)',
    },
    'Oscillator P12 1': {
      rle: 'x = 7, y = 9, rule = FuzzyLife/3\n4bA$2bAbBbA$2bBb2B$A4B$bB3bBA$A4B$2bBb2B$2bAbBbA$4bA!',
      description: 'Period 12 oscillator (smallest)',
    },
    'Oscillator P20 1': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\n2bB$b2BA$2BbA$bB!',
      description: 'Period 20 oscillator (smallest)',
    },
    'Oscillator P24 1': {
      rle: 'x = 7, y = 5, rule = FuzzyLife/3\n5bA$2bB2bB$Ab4B$b2B3bA$AbA!',
      description: 'Period 24 oscillator (smallest)',
    },
  },
  'b1.5-3.5_s2.5-3.5': {
    'Glider 2c/3 1': {
      rle: 'x = 6, y = 5, rule = FuzzyLife/3\n2b2A$2b2B$2A2B2A$6A$Ab2AbA!',
      description: 'Glider, speed 2c/3 (period 3, displacement 2)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\n2bA$AB$bA!',
      description: 'Period 2 oscillator (smallest)',
    },
  },
  'b1_s2-6.5': {
    'Glider c 1': {
      rle: 'x = 2, y = 4, rule = FuzzyLife/3\nbA$A$A$bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 2': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bA$A$b2A!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P30 1': {
      rle: 'x = 6, y = 7, rule = FuzzyLife/3\n3bAbA$4bB$A3bB$b4B$bB2bB$Ab3B$bA3bA!',
      description: 'Period 30 oscillator (smallest)',
    },
  },
  'b1_s2-4.5': {
    'Glider c 1': {
      rle: 'x = 2, y = 4, rule = FuzzyLife/3\nbA$A$A$bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 2': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bA$A$b2A!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 3': {
      rle: 'x = 9, y = 4, rule = FuzzyLife/3\nbA6bA$A6bA$A6bA$bA6bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P20 1': {
      rle: 'x = 7, y = 7, rule = FuzzyLife/3\n5bA$bBA$bB3bBA$b4B$A2bBbB$2bAb2B$3bA!',
      description: 'Period 20 oscillator (smallest)',
    },
  },
  'b2_s0.5-1': {
    'Glider c/3 1': {
      rle: 'x = 6, y = 2, rule = FuzzyLife/3\n3bAbA$3B2A!',
      description: 'Glider, speed c/3 (period 6, displacement 2)',
    },
    'Glider c/3 2': {
      rle: 'x = 5, y = 3, rule = FuzzyLife/3\n3b2A$bBb2B$Ab3A!',
      description: 'Glider, speed c/3 (period 6, displacement 2)',
    },
    'Oscillator P2 1': {
      rle: 'x = 3, y = 2, rule = FuzzyLife/3\n2bB$B!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P3 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nAB$BA!',
      description: 'Period 3 oscillator (smallest)',
    },
    'Oscillator P5 1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\n2bB$B$bB!',
      description: 'Period 5 oscillator (smallest)',
    },
    'Oscillator P6 1': {
      rle: 'x = 6, y = 4, rule = FuzzyLife/3\n5bB$$BA2bB$AB!',
      description: 'Period 6 oscillator (smallest)',
    },
    'Oscillator P15 1': {
      rle: 'x = 7, y = 5, rule = FuzzyLife/3\n5bB$4bB$6bB$BA$AB!',
      description: 'Period 15 oscillator (smallest)',
    },
  },
  'b1_s6-6.5': {
    'Glider c 1': {
      rle: 'x = 2, y = 4, rule = FuzzyLife/3\nbA$A$A$bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 2': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bA$A$b2A!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 3': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\n2bA$A$A$2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 4': {
      rle: 'x = 7, y = 7, rule = FuzzyLife/3\n6bA$2bA$$b2A$A4bA$bA2bA$2b2A!',
      description: 'Glider, speed c (period 4, displacement 4)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 5, y = 3, rule = FuzzyLife/3\n4bA$b3A$A!',
      description: 'Period 4 oscillator (smallest)',
    },
  },
  'b1.5_s2-2.5': {
    'Glider c/2 1': {
      rle: 'x = 6, y = 6, rule = FuzzyLife/3\n5bA$A3bB$4bB$2BAbBA$2b2B$2b2A!',
      description: 'Glider, speed c/2 (period 4, displacement 2)',
    },
    'Glider 2c/3 1': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\n3bA$BABA$BA$3A!',
      description: 'Glider, speed 2c/3 (period 6, displacement 4)',
    },
    'Glider c/2 2': {
      rle: 'x = 5, y = 5, rule = FuzzyLife/3\n2b2A$2b2B$ABbAB$ABA$2bB!',
      description: 'Glider, speed c/2 (period 4, displacement 2)',
    },
    'Oscillator P1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbB$2B!',
      description: 'Period 1 oscillator (smallest)',
    },
    'Oscillator P2 1': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bA$ABA$3bA!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P6 1': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bA$A2B$3bA!',
      description: 'Period 6 oscillator (smallest)',
    },
    'Oscillator P8 1': {
      rle: 'x = 3, y = 2, rule = FuzzyLife/3\n2bA$AB!',
      description: 'Period 8 oscillator (smallest)',
    },
  },
  'b1.5_s2-3': {
    'Glider c/2 1': {
      rle: 'x = 6, y = 5, rule = FuzzyLife/3\n3bB$3bABA$2BAbBA$2b2B$2b2A!',
      description: 'Glider, speed c/2 (period 4, displacement 2)',
    },
    'Glider 2c/3 1': {
      rle: 'x = 5, y = 5, rule = FuzzyLife/3\n3bA$A2B$4bA$Ab2BA$3bBA!',
      description: 'Glider, speed 2c/3 (period 6, displacement 4)',
    },
    'Glider c/2 2': {
      rle: 'x = 6, y = 6, rule = FuzzyLife/3\n5bA$4bB$4bB$4bBA$b3B$A2bA!',
      description: 'Glider, speed c/2 (period 4, displacement 2)',
    },
    'Glider 2c/3 2': {
      rle: 'x = 6, y = 6, rule = FuzzyLife/3\n5bA$3b2A$$ABABA$b2BbA$b2A!',
      description: 'Glider, speed 2c/3 (period 6, displacement 4)',
    },
    'Glider c/2 3': {
      rle: 'x = 6, y = 6, rule = FuzzyLife/3\n4bA$4bA$4bB$4b2B$2A2BbA$3bBA!',
      description: 'Glider, speed c/2 (period 4, displacement 2)',
    },
    'Glider c/2 4': {
      rle: 'x = 5, y = 5, rule = FuzzyLife/3\nb2AbA$A2bAB$A2bAB$b2AbA$A2BA!',
      description: 'Glider, speed c/2 (period 4, displacement 2)',
    },
    'Glider c/2 5': {
      rle: 'x = 5, y = 5, rule = FuzzyLife/3\n2b2A$2b2B$ABbAB$ABA$2bB!',
      description: 'Glider, speed c/2 (period 4, displacement 2)',
    },
    'Glider 2c/3 3': {
      rle: 'x = 6, y = 5, rule = FuzzyLife/3\n5bA$2bB$BA$BAB$AbBA!',
      description: 'Glider, speed 2c/3 (period 6, displacement 4)',
    },
    'Oscillator P1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbB$2B!',
      description: 'Period 1 oscillator (smallest)',
    },
    'Oscillator P2 1': {
      rle: 'x = 4, y = 2, rule = FuzzyLife/3\n3bB$A3B!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 5, y = 3, rule = FuzzyLife/3\nA3bA$b3B$AbBbA!',
      description: 'Period 4 oscillator (smallest)',
    },
    'Oscillator P6 1': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bA$A2B$3bA!',
      description: 'Period 6 oscillator (smallest)',
    },
    'Oscillator P8 1': {
      rle: 'x = 3, y = 2, rule = FuzzyLife/3\n2bA$AB!',
      description: 'Period 8 oscillator (smallest)',
    },
    'Oscillator P12 1': {
      rle: 'x = 4, y = 7, rule = FuzzyLife/3\n3bA$b2B$bB$B$b2BA$bB$AbA!',
      description: 'Period 12 oscillator (smallest)',
    },
    'Oscillator P14 1': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\n2bA$AbB$b2B$A!',
      description: 'Period 14 oscillator (smallest)',
    },
    'Oscillator P28 1': {
      rle: 'x = 8, y = 8, rule = FuzzyLife/3\n4bAbA$bB3bB$2B3b2BA$$2B$B6bA$b3Bb2B$3bBbBbA!',
      description: 'Period 28 oscillator (smallest)',
    },
    'Oscillator P36 1': {
      rle: 'x = 7, y = 4, rule = FuzzyLife/3\n2bA3bA$AbB3bB$b2B2b2B$A2b2A!',
      description: 'Period 36 oscillator (smallest)',
    },
    'Oscillator P42 1': {
      rle: 'x = 10, y = 14, rule = FuzzyLife/3\n9bA$7bAbB$8b2B$7bA$3b2BA$3bB$2bB2bA$2B2bB$bBb2B$bB6b2B$bB6bB$2B$7b2B$8bB!',
      description: 'Period 42 oscillator (smallest)',
    },
  },
  'b1_s4.5-6.5': {
    'Glider c 1': {
      rle: 'x = 4, y = 2, rule = FuzzyLife/3\nb2A$A2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 2': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\n2bA$A$A$2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 3': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bA$A$b2A!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 4': {
      rle: 'x = 7, y = 7, rule = FuzzyLife/3\n6bA$2bA$$b2A$A4bA$bA2bA$2b2A!',
      description: 'Glider, speed c (period 4, displacement 4)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
  },
  'b1_s4.5-8': {
    'Glider c 1': {
      rle: 'x = 4, y = 2, rule = FuzzyLife/3\nb2A$A2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 2': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bA$A$b2A!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 3': {
      rle: 'x = 7, y = 7, rule = FuzzyLife/3\n6bA$2bA$$b2A$A4bA$bA2bA$2b2A!',
      description: 'Glider, speed c (period 4, displacement 4)',
    },
    'Glider c 4': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\n2bA$A$A$2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 5, y = 3, rule = FuzzyLife/3\n2bA$AbAbA$b3A!',
      description: 'Period 4 oscillator (smallest)',
    },
  },
  'b1.5_s2-3.5': {
    'Glider c/2 1': {
      rle: 'x = 7, y = 7, rule = FuzzyLife/3\n3b2A$3bA2bA$3bBbB$2AB2bB$A4bBA$2b3B$bA2bA!',
      description: 'Glider, speed c/2 (period 8, displacement 4)',
    },
    'Glider c/2 2': {
      rle: 'x = 7, y = 7, rule = FuzzyLife/3\n4bA$3bBbA$3bBbB$b2B2bB$A4bBA$bA3B$4bA!',
      description: 'Glider, speed c/2 (period 8, displacement 4)',
    },
    'Glider c/2 3': {
      rle: 'x = 6, y = 6, rule = FuzzyLife/3\n2b2A$3bB$A2b2AB$ABAbAB$2b2AbA$2b2BA!',
      description: 'Glider, speed c/2 (period 8, displacement 4)',
    },
    'Glider c/2 4': {
      rle: 'x = 6, y = 5, rule = FuzzyLife/3\n3bBbA$A2b2AB$ABAbAB$2b2AbA$2b2BA!',
      description: 'Glider, speed c/2 (period 8, displacement 4)',
    },
    'Oscillator P1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbB$2B!',
      description: 'Period 1 oscillator (smallest)',
    },
    'Oscillator P2 1': {
      rle: 'x = 4, y = 2, rule = FuzzyLife/3\n3bB$A3B!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P3 1': {
      rle: 'x = 5, y = 3, rule = FuzzyLife/3\n2bB$Bb3B$2BbB!',
      description: 'Period 3 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n2b2A$AbB$b3B!',
      description: 'Period 4 oscillator (smallest)',
    },
    'Oscillator P6 1': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bA$A2B$3bA!',
      description: 'Period 6 oscillator (smallest)',
    },
    'Oscillator P8 1': {
      rle: 'x = 3, y = 2, rule = FuzzyLife/3\n2bA$AB!',
      description: 'Period 8 oscillator (smallest)',
    },
    'Oscillator P10 1': {
      rle: 'x = 3, y = 5, rule = FuzzyLife/3\n2bA$2bB$AbB$b2B$AbB!',
      description: 'Period 10 oscillator (smallest)',
    },
    'Oscillator P11 1': {
      rle: 'x = 10, y = 7, rule = FuzzyLife/3\n9bA$7b2B$7bBbA$bB$2B3bBbA$4b3B$7bA!',
      description: 'Period 11 oscillator (smallest)',
    },
    'Oscillator P12 1': {
      rle: 'x = 5, y = 4, rule = FuzzyLife/3\n4bA$b3B$AbBbA$2bA!',
      description: 'Period 12 oscillator (smallest)',
    },
    'Oscillator P14 1': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\n2bA$AbB$b2B$A!',
      description: 'Period 14 oscillator (smallest)',
    },
    'Oscillator P16 1': {
      rle: 'x = 8, y = 7, rule = FuzzyLife/3\n5bA$5bBbA$4b3B$A$b3B$AbBbA$2bA!',
      description: 'Period 16 oscillator (smallest)',
    },
    'Oscillator P20 1': {
      rle: 'x = 11, y = 6, rule = FuzzyLife/3\n8bA$8bB$AbB5b2B$b2B5bBbA$AbB5bB$8bA!',
      description: 'Period 20 oscillator (smallest)',
    },
    'Oscillator P24 1': {
      rle: 'x = 7, y = 7, rule = FuzzyLife/3\n4bBbA$3bBbB$4bBbA$A2B$2bBb2BA$4bB$3bAbA!',
      description: 'Period 24 oscillator (smallest)',
    },
    'Oscillator P28 1': {
      rle: 'x = 9, y = 8, rule = FuzzyLife/3\n7bA$6bB$6b2BA$$6b2B$A2B3bB$2bB$bAbA!',
      description: 'Period 28 oscillator (smallest)',
    },
    'Oscillator P30 1': {
      rle: 'x = 13, y = 9, rule = FuzzyLife/3\n11bA$8b3B$6b2B2b2BA$7bB$$$4BbA$bB$AbA!',
      description: 'Period 30 oscillator (smallest)',
    },
    'Oscillator P42 1': {
      rle: 'x = 11, y = 6, rule = FuzzyLife/3\n10bA$8b2B$8bBbA$A2B$2bB5b2B$bAbA5bB!',
      description: 'Period 42 oscillator (smallest)',
    },
  },
  'b1_s4.5-5': {
    'Glider c 1': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bA$A$b2A!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 2': {
      rle: 'x = 4, y = 2, rule = FuzzyLife/3\nb2A$A2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 3': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\n2bA$A$A$2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 4': {
      rle: 'x = 7, y = 7, rule = FuzzyLife/3\n6bA$2bA$$b2A$A4bA$bA2bA$2b2A!',
      description: 'Glider, speed c (period 4, displacement 4)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 5, y = 3, rule = FuzzyLife/3\n2bA$AbAbA$b3A!',
      description: 'Period 4 oscillator (smallest)',
    },
  },
  'b1_s2-7.5': {
    'Glider c 1': {
      rle: 'x = 2, y = 4, rule = FuzzyLife/3\nbA$A$A$bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 2': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bA$A$b2A!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P6 1': {
      rle: 'x = 5, y = 5, rule = FuzzyLife/3\nbA2bA$Ab2B$b3B$b2BbA$A2bA!',
      description: 'Period 6 oscillator (smallest)',
    },
    'Oscillator P30 1': {
      rle: 'x = 9, y = 7, rule = FuzzyLife/3\n2bA5bA$3b4B$A2bB2b2B$b3BbBbB$A2bBbBb2A$3b3B$2bA3bA!',
      description: 'Period 30 oscillator (smallest)',
    },
  },
  'b1_s2-5.5': {
    'Glider c 1': {
      rle: 'x = 4, y = 2, rule = FuzzyLife/3\nb2A$A2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 2': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bA$A$b2A!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P6 1': {
      rle: 'x = 5, y = 5, rule = FuzzyLife/3\n4bA$b3B$bBbB$b2BbA$A2bA!',
      description: 'Period 6 oscillator (smallest)',
    },
  },
  'b1_s4.5-7': {
    'Glider c 1': {
      rle: 'x = 4, y = 2, rule = FuzzyLife/3\nb2A$A2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 2': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bA$A$b2A!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 3': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\n2bA$A$A$2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\n3bA$b2A$b2A$A!',
      description: 'Period 4 oscillator (smallest)',
    },
  },
  'b1.5_s2-4': {
    'Glider 2c/3 1': {
      rle: 'x = 7, y = 5, rule = FuzzyLife/3\n4b2A$4b2B$2A4BA$$b3A!',
      description: 'Glider, speed 2c/3 (period 6, displacement 4)',
    },
    'Oscillator P1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbB$2B!',
      description: 'Period 1 oscillator (smallest)',
    },
    'Oscillator P2 1': {
      rle: 'x = 4, y = 2, rule = FuzzyLife/3\n3bB$A3B!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\n3bA$2bB$2B$BbA!',
      description: 'Period 4 oscillator (smallest)',
    },
    'Oscillator P6 1': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n2bA$2B$b2BA!',
      description: 'Period 6 oscillator (smallest)',
    },
    'Oscillator P8 1': {
      rle: 'x = 3, y = 2, rule = FuzzyLife/3\n2bA$AB!',
      description: 'Period 8 oscillator (smallest)',
    },
    'Oscillator P10 1': {
      rle: 'x = 6, y = 4, rule = FuzzyLife/3\n3bA$A2B$2b2BbA$bAb2B!',
      description: 'Period 10 oscillator (smallest)',
    },
    'Oscillator P12 1': {
      rle: 'x = 5, y = 4, rule = FuzzyLife/3\n4bA$b3B$AbBbA$2bA!',
      description: 'Period 12 oscillator (smallest)',
    },
    'Oscillator P14 1': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\n2bA$AbB$b2B$A!',
      description: 'Period 14 oscillator (smallest)',
    },
    'Oscillator P24 1': {
      rle: 'x = 8, y = 8, rule = FuzzyLife/3\n5bA$3bAbBbA$4b3B$4bB2bA$AbBb2B$b2BbB$AbBbA$2bA!',
      description: 'Period 24 oscillator (smallest)',
    },
    'Oscillator P28 1': {
      rle: 'x = 7, y = 5, rule = FuzzyLife/3\n5bA$A2b2B$b2Bb2BA$AbBbB$5bA!',
      description: 'Period 28 oscillator (smallest)',
    },
    'Oscillator P30 1': {
      rle: 'x = 11, y = 10, rule = FuzzyLife/3\n7bA$7bBbA$5b4B$4bB5bA$5b2Bb2B$6bBbBbA$2B2b2BbB$bBbBbB2bA$2b2B2bA$4bA!',
      description: 'Period 30 oscillator (smallest)',
    },
    'Oscillator P36 1': {
      rle: 'x = 7, y = 7, rule = FuzzyLife/3\n6bA$5bB$3bA2B$$AbA$bB$b2BA!',
      description: 'Period 36 oscillator (smallest)',
    },
    'Oscillator P42 1': {
      rle: 'x = 5, y = 6, rule = FuzzyLife/3\n4bA$bAbB$2bB$A2BbA$2b2B$bA2bA!',
      description: 'Period 42 oscillator (smallest)',
    },
  },
  'b1_s4.5': {
    'Glider c 1': {
      rle: 'x = 2, y = 4, rule = FuzzyLife/3\nbA$A$A$bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 2': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bA$A$b2A!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 3': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\n2bA$A$A$2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
  },
  'b1_s5-6.5': {
    'Glider c 1': {
      rle: 'x = 2, y = 4, rule = FuzzyLife/3\nbA$A$A$bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 2': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bA$A$b2A!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 3': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\n2bA$A$A$2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 5, y = 3, rule = FuzzyLife/3\n2bA$AbAbA$b3A!',
      description: 'Period 4 oscillator (smallest)',
    },
  },
  'b1_s5.5-6': {
    'Glider c 1': {
      rle: 'x = 2, y = 4, rule = FuzzyLife/3\nbA$A$A$bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 2': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bA$A$b2A!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 3': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\n2bA$A$A$2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 5, y = 3, rule = FuzzyLife/3\n2bA$AbAbA$b3A!',
      description: 'Period 4 oscillator (smallest)',
    },
  },
  'b1_s4.5-5.5': {
    'Glider c 1': {
      rle: 'x = 2, y = 4, rule = FuzzyLife/3\nbA$A$A$bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 2': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bA$A$b2A!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 3': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\n2bA$A$A$2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\n3bA$b2A$b2A$A!',
      description: 'Period 4 oscillator (smallest)',
    },
  },
  'b1_s3-6.5': {
    'Glider c 1': {
      rle: 'x = 4, y = 2, rule = FuzzyLife/3\nb2A$A2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 2': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bA$A$b2A!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 3': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\n2bA$A$A$2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 4': {
      rle: 'x = 7, y = 7, rule = FuzzyLife/3\n6bA$2bA$$b2A$A4bA$bA2bA$2b2A!',
      description: 'Glider, speed c (period 4, displacement 4)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P6 1': {
      rle: 'x = 5, y = 5, rule = FuzzyLife/3\nbA2bA$Ab2B$b3B$b2BbA$A2bA!',
      description: 'Period 6 oscillator (smallest)',
    },
  },
  'b1_s4.5-7.5': {
    'Glider c 1': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\n2bA$A$A$2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 2': {
      rle: 'x = 2, y = 4, rule = FuzzyLife/3\nbA$A$A$bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 3': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bA$A$b2A!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
  },
  'b1_s2.5': {
    'Glider c 1': {
      rle: 'x = 4, y = 2, rule = FuzzyLife/3\nb2A$A2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 2': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bA$A$b2A!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 3': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\n2bA$A$A$2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
  },
  'b1_s7.5': {
    'Glider c 1': {
      rle: 'x = 4, y = 2, rule = FuzzyLife/3\nb2A$A2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 2': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bA$A$b2A!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 3': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\n2bA$A$A$2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 4': {
      rle: 'x = 7, y = 7, rule = FuzzyLife/3\n6bA$2bA$$b2A$A4bA$bA2bA$2b2A!',
      description: 'Glider, speed c (period 4, displacement 4)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\n3bA$b2A$b2A$A!',
      description: 'Period 4 oscillator (smallest)',
    },
  },
  'b1_s6-7.5': {
    'Glider c 1': {
      rle: 'x = 4, y = 2, rule = FuzzyLife/3\nb2A$A2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 2': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bA$A$b2A!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 3': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\n2bA$A$A$2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 4': {
      rle: 'x = 7, y = 7, rule = FuzzyLife/3\n6bA$2bA$$b2A$A4bA$bA2bA$2b2A!',
      description: 'Glider, speed c (period 4, displacement 4)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
  },
  'b1_s3.5-6.5': {
    'Glider c 1': {
      rle: 'x = 2, y = 4, rule = FuzzyLife/3\nbA$A$A$bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 2': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bA$A$b2A!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 3': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\n2bA$A$A$2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 4': {
      rle: 'x = 7, y = 7, rule = FuzzyLife/3\n6bA$2bA$$b2A$A4bA$bA2bA$2b2A!',
      description: 'Glider, speed c (period 4, displacement 4)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
  },
  'b1_s5.5-6.5': {
    'Glider c 1': {
      rle: 'x = 4, y = 2, rule = FuzzyLife/3\nb2A$A2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 2': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bA$A$b2A!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 3': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\n2bA$A$A$2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 4': {
      rle: 'x = 7, y = 5, rule = FuzzyLife/3\n5bA$6bA$AbA3bA$4bA$bAbA!',
      description: 'Glider, speed c (period 4, displacement 4)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\n3bA$b2A$b2A$A!',
      description: 'Period 4 oscillator (smallest)',
    },
  },
  'b1_s5-5.5': {
    'Glider c 1': {
      rle: 'x = 4, y = 2, rule = FuzzyLife/3\nb2A$A2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 2': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bA$A$b2A!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 3': {
      rle: 'x = 7, y = 7, rule = FuzzyLife/3\n6bA$2bA$$b2A$A4bA$bA2bA$2b2A!',
      description: 'Glider, speed c (period 4, displacement 4)',
    },
    'Glider c 4': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\n2bA$A$A$2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 5, y = 3, rule = FuzzyLife/3\n2bA$AbAbA$b3A!',
      description: 'Period 4 oscillator (smallest)',
    },
  },
  'b1_s4.5-6': {
    'Glider c 1': {
      rle: 'x = 2, y = 4, rule = FuzzyLife/3\nbA$A$A$bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 2': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bA$A$b2A!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 3': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\n2bA$A$A$2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
  },
  'b1_s3.5': {
    'Glider c 1': {
      rle: 'x = 2, y = 4, rule = FuzzyLife/3\nbA$A$A$bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 2': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bA$A$b2A!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 3': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\n2bA$A$A$2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 5, y = 3, rule = FuzzyLife/3\n2bA$AbAbA$b3A!',
      description: 'Period 4 oscillator (smallest)',
    },
  },
  'b1_s5-7.5': {
    'Glider c 1': {
      rle: 'x = 4, y = 2, rule = FuzzyLife/3\nb2A$A2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 2': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bA$A$b2A!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 3': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\n2bA$A$A$2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\n3bA$b2A$b2A$A!',
      description: 'Period 4 oscillator (smallest)',
    },
  },
  'b1_s7.5-8': {
    'Glider c 1': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bA$A$b2A!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 2': {
      rle: 'x = 2, y = 4, rule = FuzzyLife/3\nbA$A$A$bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 3': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\n2bA$A$A$2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 4': {
      rle: 'x = 7, y = 7, rule = FuzzyLife/3\n6bA$2bA$$b2A$A4bA$bA2bA$2b2A!',
      description: 'Glider, speed c (period 4, displacement 4)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 9, y = 5, rule = FuzzyLife/3\n7bA$6bA$6b3A$bA4bA$A6bA!',
      description: 'Period 4 oscillator (smallest)',
    },
  },
  'b1_s2.5-3': {
    'Glider c 1': {
      rle: 'x = 4, y = 2, rule = FuzzyLife/3\nb2A$A2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 2': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bA$A$b2A!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 3': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\n2bA$A$A$2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 4': {
      rle: 'x = 6, y = 6, rule = FuzzyLife/3\n3bA$2bAbA$AbA2bA$5bA$4bA$bAbA!',
      description: 'Glider, speed c (period 4, displacement 4)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
  },
  'b1_s5.5': {
    'Glider c 1': {
      rle: 'x = 2, y = 4, rule = FuzzyLife/3\nbA$A$A$bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 2': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bA$A$b2A!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 3': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\n2bA$A$A$2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\n3bA$b2A$b2A$A!',
      description: 'Period 4 oscillator (smallest)',
    },
  },
  'b1_s3.5-7': {
    'Glider c 1': {
      rle: 'x = 2, y = 4, rule = FuzzyLife/3\nbA$A$A$bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 2': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bA$A$b2A!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 3': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\n2bA$A$A$2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 5, y = 3, rule = FuzzyLife/3\n2bA$AbAbA$b3A!',
      description: 'Period 4 oscillator (smallest)',
    },
  },
  'b1_s5.5-7': {
    'Glider c 1': {
      rle: 'x = 4, y = 2, rule = FuzzyLife/3\nb2A$A2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 2': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bA$A$b2A!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 3': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\n2bA$A$A$2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
  },
  'b1_s6.5-7': {
    'Glider c 1': {
      rle: 'x = 2, y = 4, rule = FuzzyLife/3\nbA$A$A$bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 2': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bA$A$b2A!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 3': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\n2bA$A$A$2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 4': {
      rle: 'x = 10, y = 10, rule = FuzzyLife/3\n9bA$7bA$7bA$8bA$$$bA$A$A$2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 5, y = 3, rule = FuzzyLife/3\n2bA$AbAbA$b3A!',
      description: 'Period 4 oscillator (smallest)',
    },
  },
  'b1_s5.5-7.5': {
    'Glider c 1': {
      rle: 'x = 2, y = 4, rule = FuzzyLife/3\nbA$A$A$bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 2': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bA$A$b2A!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 3': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\n2bA$A$A$2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\n3bA$b2A$b2A$A!',
      description: 'Period 4 oscillator (smallest)',
    },
  },
  'b1_s3.5-4': {
    'Glider c 1': {
      rle: 'x = 2, y = 4, rule = FuzzyLife/3\nbA$A$A$bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 2': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bA$A$b2A!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 3': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\n2bA$A$A$2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 4': {
      rle: 'x = 7, y = 7, rule = FuzzyLife/3\n6bA$2bA$$b2A$A4bA$bA2bA$2b2A!',
      description: 'Glider, speed c (period 4, displacement 4)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 5, y = 3, rule = FuzzyLife/3\n4bA$b3A$A!',
      description: 'Period 4 oscillator (smallest)',
    },
  },
  'b1_s3-7.5': {
    'Glider c 1': {
      rle: 'x = 2, y = 4, rule = FuzzyLife/3\nbA$A$A$bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 2': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bA$A$b2A!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 3': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\n2bA$A$A$2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
  },
  'b1_s3.5-5': {
    'Glider c 1': {
      rle: 'x = 4, y = 2, rule = FuzzyLife/3\nb2A$A2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 2': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bA$A$b2A!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 3': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\n2bA$A$A$2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 5, y = 3, rule = FuzzyLife/3\n4bA$b3A$A!',
      description: 'Period 4 oscillator (smallest)',
    },
  },
  'b1_s3.5-5.5': {
    'Glider c 1': {
      rle: 'x = 2, y = 4, rule = FuzzyLife/3\nbA$A$A$bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 2': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bA$A$b2A!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 3': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\n2bA$A$A$2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 5, y = 3, rule = FuzzyLife/3\n4bA$b3A$A!',
      description: 'Period 4 oscillator (smallest)',
    },
  },
  'b1_s6.5': {
    'Glider c 1': {
      rle: 'x = 4, y = 2, rule = FuzzyLife/3\nb2A$A2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 2': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bA$A$b2A!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 3': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\n2bA$A$A$2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
  },
  'b1_s5.5-8': {
    'Glider c 1': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bA$A$b2A!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 2': {
      rle: 'x = 4, y = 2, rule = FuzzyLife/3\nb2A$A2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 3': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\n2bA$A$A$2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 5, y = 3, rule = FuzzyLife/3\n4bA$b3A$A!',
      description: 'Period 4 oscillator (smallest)',
    },
  },
  'b1_s3.5-7.5': {
    'Glider c 1': {
      rle: 'x = 4, y = 2, rule = FuzzyLife/3\nb2A$A2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 2': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bA$A$b2A!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 3': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\n2bA$A$A$2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
  },
  'b1_s2.5-3.5': {
    'Glider c 1': {
      rle: 'x = 4, y = 2, rule = FuzzyLife/3\nb2A$A2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 2': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bA$A$b2A!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 3': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\n2bA$A$A$2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
  },
  'b1_s6.5-7.5': {
    'Glider c 1': {
      rle: 'x = 4, y = 2, rule = FuzzyLife/3\nb2A$A2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 2': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bA$A$b2A!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 3': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\n2bA$A$A$2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
  },
  'b1_s3.5-4.5': {
    'Glider c 1': {
      rle: 'x = 2, y = 4, rule = FuzzyLife/3\nbA$A$A$bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 2': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bA$A$b2A!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 3': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\n2bA$A$A$2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
  },
  'b1_s3.5-6': {
    'Glider c 1': {
      rle: 'x = 2, y = 4, rule = FuzzyLife/3\nbA$A$A$bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 2': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bA$A$b2A!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 3': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\n2bA$A$A$2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
  },
  'b1_s7-7.5': {
    'Glider c 1': {
      rle: 'x = 2, y = 4, rule = FuzzyLife/3\nbA$A$A$bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 2': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bA$A$b2A!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 3': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\n2bA$A$A$2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
  },
  'b1_s6.5-8': {
    'Glider c 1': {
      rle: 'x = 2, y = 4, rule = FuzzyLife/3\nbA$A$A$bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 2': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bA$A$b2A!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 3': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\n2bA$A$A$2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 5, y = 3, rule = FuzzyLife/3\n2bA$AbAbA$b3A!',
      description: 'Period 4 oscillator (smallest)',
    },
  },
  'b1_s3.5-8': {
    'Glider c 1': {
      rle: 'x = 4, y = 2, rule = FuzzyLife/3\nb2A$A2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 2': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bA$A$b2A!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 3': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\n2bA$A$A$2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 4': {
      rle: 'x = 8, y = 6, rule = FuzzyLife/3\n7bA$6bA$bA4bA$A6bA$A$bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
  },
  'b1_s4-4.5': {
    'Glider c 1': {
      rle: 'x = 2, y = 4, rule = FuzzyLife/3\nbA$A$A$bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 2': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bA$A$b2A!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 3': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\n2bA$A$A$2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 4': {
      rle: 'x = 7, y = 7, rule = FuzzyLife/3\n6bA$2bA$$b2A$A4bA$bA2bA$2b2A!',
      description: 'Glider, speed c (period 4, displacement 4)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 5, y = 3, rule = FuzzyLife/3\n4bA$b3A$A!',
      description: 'Period 4 oscillator (smallest)',
    },
  },
  'b1_s2.5-4': {
    'Glider c 1': {
      rle: 'x = 4, y = 2, rule = FuzzyLife/3\nb2A$A2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 2': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bA$A$b2A!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
  },
  'b1_s4-6.5': {
    'Glider c 1': {
      rle: 'x = 4, y = 2, rule = FuzzyLife/3\nb2A$A2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 2': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bA$A$b2A!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 3': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\n2bA$A$A$2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
  },
  'b1_s4-5.5': {
    'Glider c 1': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bA$A$b2A!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 2': {
      rle: 'x = 2, y = 4, rule = FuzzyLife/3\nbA$A$A$bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 3': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\n2bA$A$A$2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
  },
  'b1_s4-7.5': {
    'Glider c 1': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bA$A$b2A!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 2': {
      rle: 'x = 2, y = 4, rule = FuzzyLife/3\nbA$A$A$bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 3': {
      rle: 'x = 9, y = 9, rule = FuzzyLife/3\n8bA$6bA$6bA$8bA$$2bA$A$A$bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 4': {
      rle: 'x = 7, y = 7, rule = FuzzyLife/3\n6bA$2bA$$b2A$A4bA$bA2bA$2b2A!',
      description: 'Glider, speed c (period 4, displacement 4)',
    },
    'Glider c 5': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\n2bA$A$A$2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
  },
  'b1_s2.5-4.5': {
    'Glider c 1': {
      rle: 'x = 4, y = 2, rule = FuzzyLife/3\nb2A$A2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 2': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bA$A$b2A!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 3': {
      rle: 'x = 7, y = 7, rule = FuzzyLife/3\n6bA$2bA$$b2A$A4bA$bA2bA$2b2A!',
      description: 'Glider, speed c (period 4, displacement 4)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
  },
  'b1_s2.5-5': {
    'Glider c 1': {
      rle: 'x = 4, y = 2, rule = FuzzyLife/3\nb2A$A2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 2': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bA$A$b2A!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P6 1': {
      rle: 'x = 5, y = 5, rule = FuzzyLife/3\n4bA$b2B$bBbB$Ab2B$bA!',
      description: 'Period 6 oscillator (smallest)',
    },
  },
  'b1_s2.5-5.5': {
    'Glider c 1': {
      rle: 'x = 4, y = 2, rule = FuzzyLife/3\nb2A$A2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 2': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bA$A$b2A!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 5, y = 3, rule = FuzzyLife/3\n4bA$b3A$A!',
      description: 'Period 4 oscillator (smallest)',
    },
  },
  'b1_s2.5-6': {
    'Glider c 1': {
      rle: 'x = 4, y = 2, rule = FuzzyLife/3\nb2A$A2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 2': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bA$A$b2A!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 3': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\n2bA$A$A$2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P6 1': {
      rle: 'x = 5, y = 5, rule = FuzzyLife/3\nbA2bA$Ab2B$b3B$b2BbA$A2bA!',
      description: 'Period 6 oscillator (smallest)',
    },
  },
  'b1_s2.5-6.5': {
    'Glider c 1': {
      rle: 'x = 4, y = 2, rule = FuzzyLife/3\nb2A$A2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 2': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bA$A$b2A!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 3': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\n2bA$A$A$2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 4': {
      rle: 'x = 12, y = 3, rule = FuzzyLife/3\n3bA4bA$A10bA$b2A6b2A!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P4 1': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\n3bA$b2A$b2A$A!',
      description: 'Period 4 oscillator (smallest)',
    },
    'Oscillator P6 1': {
      rle: 'x = 5, y = 5, rule = FuzzyLife/3\n4bA$b2B$b3B$Ab2B$bA2bA!',
      description: 'Period 6 oscillator (smallest)',
    },
  },
  'b1_s2.5-7': {
    'Glider c 1': {
      rle: 'x = 2, y = 4, rule = FuzzyLife/3\nbA$A$A$bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 2': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bA$A$b2A!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P6 1': {
      rle: 'x = 5, y = 5, rule = FuzzyLife/3\nbA2bA$Ab2B$b3B$b2B$A3bA!',
      description: 'Period 6 oscillator (smallest)',
    },
    'Oscillator P10 1': {
      rle: 'x = 7, y = 6, rule = FuzzyLife/3\n6bA$2bA2bB$2bBb2B$b4BbA$b2B2bA$A2bA!',
      description: 'Period 10 oscillator (smallest)',
    },
  },
  'b1_s2.5-7.5': {
    'Glider c 1': {
      rle: 'x = 2, y = 4, rule = FuzzyLife/3\nbA$A$A$bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 2': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bA$A$b2A!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 3': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\n2bA$A$A$2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
  },
  'b1_s2.5-8': {
    'Glider c 1': {
      rle: 'x = 4, y = 2, rule = FuzzyLife/3\nb2A$A2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 2': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bA$A$b2A!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
    'Oscillator P24 1': {
      rle: 'x = 6, y = 9, rule = FuzzyLife/3\n5bA$3b2B$3b2B$5bA$A3bA$b2B$b3B$Ab2B$bA2bA!',
      description: 'Period 24 oscillator (smallest)',
    },
  },
  'b1_s3-3.5': {
    'Glider c 1': {
      rle: 'x = 2, y = 4, rule = FuzzyLife/3\nbA$A$A$bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 2': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bA$A$b2A!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 3': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\n2bA$A$A$2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 4': {
      rle: 'x = 15, y = 6, rule = FuzzyLife/3\n14bA$12bA$bA10bA$A13bA$A$2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
  },
  'b1_s3-4.5': {
    'Glider c 1': {
      rle: 'x = 4, y = 2, rule = FuzzyLife/3\nb2A$A2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 2': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bA$A$b2A!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 3': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\n2bA$A$A$2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 4': {
      rle: 'x = 7, y = 7, rule = FuzzyLife/3\n6bA$2bA$$b2A$A4bA$bA2bA$2b2A!',
      description: 'Glider, speed c (period 4, displacement 4)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
  },
  'b1_s3-5.5': {
    'Glider c 1': {
      rle: 'x = 2, y = 4, rule = FuzzyLife/3\nbA$A$A$bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 2': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3bA$A$b2A!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 3': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\n2bA$A$A$2bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 4': {
      rle: 'x = 7, y = 5, rule = FuzzyLife/3\n6bA$bA3bA$A4bA$A5bA$bA!',
      description: 'Glider, speed c (period 1, displacement 1)',
    },
    'Glider c 5': {
      rle: 'x = 7, y = 7, rule = FuzzyLife/3\n6bA$2bA$$b2A$A4bA$bA2bA$2b2A!',
      description: 'Glider, speed c (period 4, displacement 4)',
    },
    'Oscillator P2 1': {
      rle: 'x = 2, y = 2, rule = FuzzyLife/3\nbA$A!',
      description: 'Period 2 oscillator (smallest)',
    },
  },
  'b2-2_s3-5,2-2': {
    'Glider c/5 1': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n2bA$A2BA$2bBA!',
      description: 'Glider, speed c/5 (period 10, displacement 2)',
    },
    'Glider c/5 2': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\nbAB$2B$bBA!',
      description: 'Glider, speed c/5 (period 10, displacement 2)',
    },
    'Oscillator P12 151': {
      rle: 'x = 6, y = 4, rule = FuzzyLife/3\n3bB2A$bB2bB$5B$2bB2bA!',
      description: 'Period 12 oscillator',
    },
    'Oscillator P13 1': {
      rle: 'x = 7, y = 6, rule = FuzzyLife/3\n3bAB$2bAb2B$2B2b3B$bBbB$bBb3B$2B2bA!',
      description: 'Period 13 oscillator',
    },
    'Oscillator P14 10': {
      rle: 'x = 6, y = 5, rule = FuzzyLife/3\n3b2A$2bBbB$b2Bb2B$BAb2B$3bB!',
      description: 'Period 14 oscillator',
    },
    'Oscillator P15 8': {
      rle: 'x = 6, y = 6, rule = FuzzyLife/3\n3bAB$2b2B$b2BbB$2Bb3B$Ab2BbA$bAbBA!',
      description: 'Period 15 oscillator',
    },
    'Oscillator P16 8': {
      rle: 'x = 9, y = 6, rule = FuzzyLife/3\n5bB$5bABbA$4bAb3B$B4bBbB$6BbB$bB2bA!',
      description: 'Period 16 oscillator',
    },
    'Oscillator P18 48': {
      rle: 'x = 8, y = 5, rule = FuzzyLife/3\n4bB$4bA2B$AB2bBbBA$A5BbA$2bB2bBA!',
      description: 'Period 18 oscillator',
    },
    'Oscillator P1': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\nbB$3B$bB!',
      description: 'Period 1 oscillator',
    },
    'Oscillator P20 5030': {
      rle: 'x = 6, y = 4, rule = FuzzyLife/3\n3bB$Ab3B$3BbAB$bBbA!',
      description: 'Period 20 oscillator',
    },
    'Oscillator P21 1': {
      rle: 'x = 8, y = 8, rule = FuzzyLife/3\n4bB$3b3B$bA2Bb2B$AB2bB2bA$b3Bb2BA$2BbBbB$b7B$2bB3bB!',
      description: 'Period 21 oscillator',
    },
    'Oscillator P22 32': {
      rle: 'x = 8, y = 5, rule = FuzzyLife/3\n5bB$A2bBbBA$3Bb2BbA$b2B2bBA$AB3bB!',
      description: 'Period 22 oscillator',
    },
    'Oscillator P24 152': {
      rle: 'x = 8, y = 7, rule = FuzzyLife/3\n5bA$2bAb3B$bA3B$bBbBb2B$A2B2bBbA$B2b3BA$3bAbB!',
      description: 'Period 24 oscillator',
    },
    'Oscillator P25 1': {
      rle: 'x = 8, y = 5, rule = FuzzyLife/3\n5bBA$bB2b2BbA$5BbBA$bB2b3B$4bB!',
      description: 'Period 25 oscillator',
    },
    'Oscillator P26 1': {
      rle: 'x = 7, y = 6, rule = FuzzyLife/3\n2bA2bB$bAb4B$2B2bB$b3BbBA$2Bb3BA$bB2bB!',
      description: 'Period 26 oscillator',
    },
    'Oscillator P28 11': {
      rle: 'x = 7, y = 6, rule = FuzzyLife/3\n5bA$bB2bB$4BbB$bB2b3B$3b2BbA$3bA!',
      description: 'Period 28 oscillator',
    },
    'Oscillator P2 22': {
      rle: 'x = 3, y = 1, rule = FuzzyLife/3\n3B!',
      description: 'Period 2 oscillator',
    },
    'Oscillator P30 54': {
      rle: 'x = 5, y = 6, rule = FuzzyLife/3\n3bA$Bb2BA$A2B$bBbB$bA3B$2bAbA!',
      description: 'Period 30 oscillator',
    },
    'Oscillator P32 1': {
      rle: 'x = 8, y = 8, rule = FuzzyLife/3\n6bB$5b3B$6bB$bAbBbBA$Ab3BA$2BbB$b2BbA$2bBA!',
      description: 'Period 32 oscillator',
    },
    'Oscillator P34 4': {
      rle: 'x = 7, y = 7, rule = FuzzyLife/3\n4bA$A4B$bBbB$A2Bb2BA$bA2b2BA$3b2B$3b2A!',
      description: 'Period 34 oscillator',
    },
    'Oscillator P35 3': {
      rle: 'x = 6, y = 6, rule = FuzzyLife/3\n3b2A$2bBbB$b2Bb2B$ABb2B$Bb2BbA$3bBA!',
      description: 'Period 35 oscillator',
    },
    'Oscillator P36 60': {
      rle: 'x = 7, y = 5, rule = FuzzyLife/3\n3bBb2A$b3Bb2B$ABbBbB$Ab4B$bAB3bA!',
      description: 'Period 36 oscillator',
    },
    'Oscillator P38 1': {
      rle: 'x = 11, y = 10, rule = FuzzyLife/3\n6bB2bB$5b4BA$8bB$4b3BbB$bB3b2Bb2B$A4B2b2BbA$bBbB2bBbBA$bB2b3B2bB$A4Bb2B$B3bBb2A!',
      description: 'Period 38 oscillator',
    },
    'Oscillator P3 14': {
      rle: 'x = 6, y = 3, rule = FuzzyLife/3\n2b2B$AB2bBA$2b2B!',
      description: 'Period 3 oscillator',
    },
    'Oscillator P40 1048': {
      rle: 'x = 8, y = 5, rule = FuzzyLife/3\n5bBA$bB2b2BbA$5BbB$bB2b2BAB$2b2AB!',
      description: 'Period 40 oscillator',
    },
    'Oscillator P42 11': {
      rle: 'x = 10, y = 5, rule = FuzzyLife/3\n7b2A$AB4bBbB$A6Bb2B$2bA2bBb2B$7bB!',
      description: 'Period 42 oscillator',
    },
    'Oscillator P44 12': {
      rle: 'x = 13, y = 6, rule = FuzzyLife/3\n7bB$7bABAB$bB2bB2bBbB$A7Bb3B$BbBb2BbAbBb2B$4bBbAbA2bB!',
      description: 'Period 44 oscillator',
    },
    'Oscillator P45 1': {
      rle: 'x = 5, y = 6, rule = FuzzyLife/3\n3bA$2bBbA$b4B$2BbB$Ab2B$b2A!',
      description: 'Period 45 oscillator',
    },
    'Oscillator P48 6': {
      rle: 'x = 7, y = 7, rule = FuzzyLife/3\n5bB$2bA2bB$bA4B$bBbBb2B$3BbBbA$Ab3B$bAB!',
      description: 'Period 48 oscillator',
    },
    'Oscillator P4 10': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\n2bB$2AB$bB!',
      description: 'Period 4 oscillator',
    },
    'Oscillator P50 3': {
      rle: 'x = 11, y = 9, rule = FuzzyLife/3\n6bB2bA$6bA3BA$4bB2bBbB$2bBb2B2b3B$b3B2bBbB$ABb4Bb2B$b3B3b2BbA$3b4BbBA$2bAB2bB!',
      description: 'Period 50 oscillator',
    },
    'Oscillator P52 1': {
      rle: 'x = 8, y = 8, rule = FuzzyLife/3\n6b2A$3bB2b2B$Ab5B$2BbBbB$bBbBAB$bBbBA2B$4B$bB!',
      description: 'Period 52 oscillator',
    },
    'Oscillator P54 14': {
      rle: 'x = 8, y = 7, rule = FuzzyLife/3\n4bAbB$3bA4B$bAbB2bB$Ab4BbA$2BbBbBA$b2B2bB$2bBA!',
      description: 'Period 54 oscillator',
    },
    'Oscillator P55 1': {
      rle: 'x = 7, y = 5, rule = FuzzyLife/3\n4b2A$B2bBbB$A2Bb3B$b2B2bB$2bB2A!',
      description: 'Period 55 oscillator',
    },
    'Oscillator P56 23': {
      rle: 'x = 10, y = 6, rule = FuzzyLife/3\n5bB$4b2BbBA$bBb2BbBbB$bB2b4B$b4B2b3B$BA2bAB2bB!',
      description: 'Period 56 oscillator',
    },
    'Oscillator P5 18': {
      rle: 'x = 5, y = 4, rule = FuzzyLife/3\n3bA$2bBbA$b4B$ABbB!',
      description: 'Period 5 oscillator',
    },
    'Oscillator P60 1512': {
      rle: 'x = 7, y = 5, rule = FuzzyLife/3\n5bA$bB2bBbA$7B$AbB2bB$4bB2A!',
      description: 'Period 60 oscillator',
    },
    'Oscillator P6 15': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\nbAB$2B$b2B$AB!',
      description: 'Period 6 oscillator',
    },
    'Oscillator P7 8': {
      rle: 'x = 6, y = 6, rule = FuzzyLife/3\n3b2A$2bBbB$b2Bb2B$2Bb2B$b3B$2bB!',
      description: 'Period 7 oscillator',
    },
    'Oscillator P8 129': {
      rle: 'x = 5, y = 5, rule = FuzzyLife/3\n3bA$bA3B$Ab2B$2Bb2A$bB!',
      description: 'Period 8 oscillator',
    },
    'Oscillator P9 3': {
      rle: 'x = 6, y = 6, rule = FuzzyLife/3\n4bB$3b3B$b3B$ABb2B$Ab2B$bAB!',
      description: 'Period 9 oscillator',
    },
  },
  'b4-6_s1-3,4-6': {
    'Oscillator P1': {
      rle: 'x = 1, y = 2, rule = FuzzyLife/3\nB$B!',
      description: 'Period 1 oscillator',
    },
    'Oscillator P10': {
      rle: 'x = 5, y = 3, rule = FuzzyLife/3\nbBA2B$5B$bA2B!',
      description: 'Period 10 oscillator',
    },
    'Oscillator P100': {
      rle: 'x = 6, y = 7, rule = FuzzyLife/3\n2b4B$b2Bb2B$6B$BbBb2B$b4BA$3Bb2B$B2A2B!',
      description: 'Period 100 oscillator',
    },
    'Oscillator P102': {
      rle: 'x = 7, y = 7, rule = FuzzyLife/3\n2b4B$b3Bb2B$ABbBb2B$A6B$2Bb2BbA$b2BA3B$5bB!',
      description: 'Period 102 oscillator',
    },
    'Oscillator P104': {
      rle: 'x = 7, y = 7, rule = FuzzyLife/3\nb2BAB$b2Bb2B$b6B$b2BbBbB$BbBb3B$5BbB$2bA2BAB!',
      description: 'Period 104 oscillator',
    },
    'Oscillator P105': {
      rle: 'x = 8, y = 8, rule = FuzzyLife/3\n4b4B$2Bb2Bb2B$BbBb4B$5B2bB$b2Bb4B$3b4B$4bBA$5bB!',
      description: 'Period 105 oscillator',
    },
    'Oscillator P106': {
      rle: 'x = 7, y = 8, rule = FuzzyLife/3\n2BbB$2Bb2B$4Bb2B$2Bb4B$4B3A$2Bb4B$b6B$4b2B!',
      description: 'Period 106 oscillator',
    },
    'Oscillator P108': {
      rle: 'x = 7, y = 6, rule = FuzzyLife/3\n2b5B$b2BA2BA$Bb4BA$4BbB$Bb4B$2B!',
      description: 'Period 108 oscillator',
    },
    'Oscillator P11': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\nbBA$4B$Bb2B$4B!',
      description: 'Period 11 oscillator',
    },
    'Oscillator P110': {
      rle: 'x = 6, y = 5, rule = FuzzyLife/3\n2bA3B$b5B$6B$2BA3B$b4B!',
      description: 'Period 110 oscillator',
    },
    'Oscillator P112': {
      rle: 'x = 8, y = 7, rule = FuzzyLife/3\nb4B$2Bb3B$4Bb2B$B2b5B$7BA$2BbBbBA$2BA3B!',
      description: 'Period 112 oscillator',
    },
    'Oscillator P114': {
      rle: 'x = 5, y = 7, rule = FuzzyLife/3\nb4B$bABbB$b4B$b2BbB$Bb3B$3BbB$b2BAB!',
      description: 'Period 114 oscillator',
    },
    'Oscillator P115': {
      rle: 'x = 8, y = 9, rule = FuzzyLife/3\nB2A$6B$3Bb3B$2bBbBb2B$5Bb2B$2Bb5B$2BbB2b2B$7B$bABA!',
      description: 'Period 115 oscillator',
    },
    'Oscillator P116': {
      rle: 'x = 7, y = 8, rule = FuzzyLife/3\nb5B$3Bb3B$BbBbBbA$A6B$4Bb2B$2Bb3B$B2A2B$4B!',
      description: 'Period 116 oscillator',
    },
    'Oscillator P117': {
      rle: 'x = 9, y = 9, rule = FuzzyLife/3\n4bA2BAB$2b5BbB$b2BbBb3B$Bb2BA2BbB$3BbBb3B$Bb5BbB$BbBbBb3B$3BA4B$b6B!',
      description: 'Period 117 oscillator',
    },
    'Oscillator P118': {
      rle: 'x = 8, y = 7, rule = FuzzyLife/3\n2bAB$$$6BAB$6BbB$2B2A4B$b5BA!',
      description: 'Period 118 oscillator',
    },
    'Oscillator P12': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\nBA$3B$3B!',
      description: 'Period 12 oscillator',
    },
    'Oscillator P120': {
      rle: 'x = 7, y = 7, rule = FuzzyLife/3\n2b5B$bBbBAbB$7B$AbBbBbB$7B$2BbBb2B$2BA3B!',
      description: 'Period 120 oscillator',
    },
    'Oscillator P122': {
      rle: 'x = 8, y = 8, rule = FuzzyLife/3\n6B$AbB2b2B$8B$BbBbB2bB$b7B$bBbBbBbB$bBb4BA$b7B!',
      description: 'Period 122 oscillator',
    },
    'Oscillator P124': {
      rle: 'x = 7, y = 7, rule = FuzzyLife/3\n3b4B$2b3BbB$b2Bb3B$b4BbB$bBb3BA$b3BA2B$B3b2B!',
      description: 'Period 124 oscillator',
    },
    'Oscillator P126': {
      rle: 'x = 6, y = 5, rule = FuzzyLife/3\n2b4B$bA2BbB$2Bb3B$3Bb2B$b4B!',
      description: 'Period 126 oscillator',
    },
    'Oscillator P128': {
      rle: 'x = 9, y = 8, rule = FuzzyLife/3\nb6BAB$3BbBbBbB$Bb5BAB$3BbBb3B$Bb5BbB$3BbBbBbB$BbBA5B$BA3BA3B!',
      description: 'Period 128 oscillator',
    },
    'Oscillator P13': {
      rle: 'x = 7, y = 3, rule = FuzzyLife/3\n2bA3B$7B$b3BA!',
      description: 'Period 13 oscillator',
    },
    'Oscillator P130': {
      rle: 'x = 7, y = 8, rule = FuzzyLife/3\n7B$BbBbBbA$A6B$2BbB2bB$A6B$BbBbB$7B$b6B!',
      description: 'Period 130 oscillator',
    },
    'Oscillator P132': {
      rle: 'x = 6, y = 7, rule = FuzzyLife/3\n2b3B$bA3B$b2BA$B$4b2B$3bA2B$3b3B!',
      description: 'Period 132 oscillator',
    },
    'Oscillator P133': {
      rle: 'x = 8, y = 8, rule = FuzzyLife/3\n4b4B$bBABABAB$2Bb3BbB$4Bb3B$B2b3BbB$4Bb3B$b5BbB$3b3BAB!',
      description: 'Period 133 oscillator',
    },
    'Oscillator P134': {
      rle: 'x = 10, y = 10, rule = FuzzyLife/3\nB2b2Bb3B$b2BbBA3B$b5BA2B$2BbBb4B$6BbBbB$B2bBb5B$BA4BbBbB$B2bBb5B$4BbBb2B$b7B!',
      description: 'Period 134 oscillator',
    },
    'Oscillator P135': {
      rle: 'x = 7, y = 7, rule = FuzzyLife/3\nb2Bb2B$3B2A2B$Bb5B$3BbBbB$Ab5B$3Bb2B$3BAB!',
      description: 'Period 135 oscillator',
    },
    'Oscillator P136': {
      rle: 'x = 8, y = 8, rule = FuzzyLife/3\n3bBb3B$2bB2b3B$3B3bAB$BAB3bB$b2B2b2B$4b3B$5b2B$7bB!',
      description: 'Period 136 oscillator',
    },
    'Oscillator P138': {
      rle: 'x = 6, y = 8, rule = FuzzyLife/3\n4B$2Bb2B$Ab4B$3Bb2B$b2BA2B$2b2BbB$3b3B$4bAB!',
      description: 'Period 138 oscillator',
    },
    'Oscillator P14': {
      rle: 'x = 3, y = 5, rule = FuzzyLife/3\nb2B$b2B$3B$BAB$b2B!',
      description: 'Period 14 oscillator',
    },
    'Oscillator P140': {
      rle: 'x = 6, y = 9, rule = FuzzyLife/3\nBA4B$2BbBbB$4BbB$2Bb3B$4BbB$Ab4B$3Bb2B$b4B$2bAB!',
      description: 'Period 140 oscillator',
    },
    'Oscillator P141': {
      rle: 'x = 8, y = 9, rule = FuzzyLife/3\n2b5B$b2Bb4B$BbBbB2bB$8B$ABbBbBbB$4Bb2B$7B$2BbBb2B$4b2B!',
      description: 'Period 141 oscillator',
    },
    'Oscillator P142': {
      rle: 'x = 7, y = 8, rule = FuzzyLife/3\n2bB$b3B$2BbBA$5BA$2Bb3B$4Bb2B$2Bb3B$2BbAB!',
      description: 'Period 142 oscillator',
    },
    'Oscillator P143': {
      rle: 'x = 7, y = 9, rule = FuzzyLife/3\n2b4B$b2Bb3B$2ABbBbB$7B$2BbB2bB$7B$BbBbB$7B$b6B!',
      description: 'Period 143 oscillator',
    },
    'Oscillator P144': {
      rle: 'x = 8, y = 9, rule = FuzzyLife/3\nb3B2A2B$2Bb5B$4BbBbA$2Bb5B$A3BbBbB$bA6B$2b2BbBbB$3b5B$6b2B!',
      description: 'Period 144 oscillator',
    },
    'Oscillator P145': {
      rle: 'x = 9, y = 9, rule = FuzzyLife/3\n3bA3B$b7B$2BbBbBb2B$6Bb2B$BbB2b3B$7B$AbBb2B$3BA$3B!',
      description: 'Period 145 oscillator',
    },
    'Oscillator P146': {
      rle: 'x = 10, y = 7, rule = FuzzyLife/3\n2bBA4B$b4BA3B$3BbBbBb2B$Bb5Bb2B$3BbBb3B$Ab2Bb3B$3B3bB!',
      description: 'Period 146 oscillator',
    },
    'Oscillator P148': {
      rle: 'x = 8, y = 7, rule = FuzzyLife/3\n7B$BABABb2B$BbBb4B$2BA2B2bB$BbBb4B$5Bb2B$b2ABb2B!',
      description: 'Period 148 oscillator',
    },
    'Oscillator P15': {
      rle: 'x = 4, y = 6, rule = FuzzyLife/3\n2b2B$b3B$2BA$4B$b2BA$2bB!',
      description: 'Period 15 oscillator',
    },
    'Oscillator P150': {
      rle: 'x = 8, y = 7, rule = FuzzyLife/3\nA$b4B$b2Bb2B$Bb5B$3BbBbBA$b4BA2B$2bA5B!',
      description: 'Period 150 oscillator',
    },
    'Oscillator P152': {
      rle: 'x = 8, y = 8, rule = FuzzyLife/3\n6b2B$2bBABA2B$2Bb5B$4Bb3B$2Bb3BbB$A3Bb3B$bBb4B$b2B!',
      description: 'Period 152 oscillator',
    },
    'Oscillator P153': {
      rle: 'x = 8, y = 10, rule = FuzzyLife/3\n4b2B$b3Bb2B$bBb5B$4BbBbB$BAb5B$4B2b2B$B2b5B$5BbA$BbBbBbB$2Bb4B!',
      description: 'Period 153 oscillator',
    },
    'Oscillator P154': {
      rle: 'x = 8, y = 6, rule = FuzzyLife/3\n7bB$7B$B2ABAbB$7B$b3Bb2B$2b4B!',
      description: 'Period 154 oscillator',
    },
    'Oscillator P156': {
      rle: 'x = 7, y = 7, rule = FuzzyLife/3\nb3BA$5BAB$BbBbBbB$7B$BbBbBbB$A2BA3B$6B!',
      description: 'Period 156 oscillator',
    },
    'Oscillator P157': {
      rle: 'x = 9, y = 10, rule = FuzzyLife/3\n7B$3Bb4B$2bBbB2b2B$9B$BAbBbBb2B$6Bb2B$2BbBb3B$7B$3Bb2B$2BA2B!',
      description: 'Period 157 oscillator',
    },
    'Oscillator P16': {
      rle: 'x = 6, y = 3, rule = FuzzyLife/3\nb5B$3B2bB$bBA3B!',
      description: 'Period 16 oscillator',
    },
    'Oscillator P160': {
      rle: 'x = 9, y = 9, rule = FuzzyLife/3\n2b4B$b2Bb3B$8B$BbBbBb2AB$7BAB$BbBbBbBbB$9B$B2bB2A2B$7B!',
      description: 'Period 160 oscillator',
    },
    'Oscillator P162': {
      rle: 'x = 10, y = 10, rule = FuzzyLife/3\nb2B2A4B$2Bb7B$4BbBbBbB$B2b7B$5Bb4B$BbBb3Bb2B$BbBbBb4B$7Bb2B$bBbBABA2B$2b3B!',
      description: 'Period 162 oscillator',
    },
    'Oscillator P164': {
      rle: 'x = 9, y = 9, rule = FuzzyLife/3\n4b3B$4bBA2B$3b3BbB$2b6B$b3B2bBbB$bBb6B$4BbBb2B$BAbBb2B$6B!',
      description: 'Period 164 oscillator',
    },
    'Oscillator P165': {
      rle: 'x = 9, y = 9, rule = FuzzyLife/3\n8B$2BbBbBb2B$4Bb4B$B2b3B2bB$4Bb4B$2Bb3B2bB$4Bb4B$ABb3Bb2B$b2BABA2B!',
      description: 'Period 165 oscillator',
    },
    'Oscillator P166': {
      rle: 'x = 10, y = 10, rule = FuzzyLife/3\n2b7B$b2BbBbBbA$A8B$ABbBbBbBAB$3BA4BAB$4BbBbBbB$BA8B$5BbB2bB$3b2Bb4B$4b5B!',
      description: 'Period 166 oscillator',
    },
    'Oscillator P168': {
      rle: 'x = 8, y = 8, rule = FuzzyLife/3\n7bB$Bb5B$bBABAbB$b6B$b2BbBbB$b2Bb3B$2b3BbB$3bBA2B!',
      description: 'Period 168 oscillator',
    },
    'Oscillator P17': {
      rle: 'x = 6, y = 4, rule = FuzzyLife/3\nb2BbB$3Bb2B$4BAB$2BA3B!',
      description: 'Period 17 oscillator',
    },
    'Oscillator P170': {
      rle: 'x = 8, y = 8, rule = FuzzyLife/3\n4bA3B$2b4BAB$b3BbBAB$8B$B2bBb2B$5B$Bb2B$BAB!',
      description: 'Period 170 oscillator',
    },
    'Oscillator P171': {
      rle: 'x = 8, y = 8, rule = FuzzyLife/3\n2B$2BABAB$5Bb2B$3Bb4B$Bb3BbBA$3Bb4B$b2BbBb2B$2b4BAB!',
      description: 'Period 171 oscillator',
    },
    'Oscillator P172': {
      rle: 'x = 7, y = 7, rule = FuzzyLife/3\nbBA$3BA2B$2BbBb2B$6BA$2BbBbBA$b5B$2bA2B!',
      description: 'Period 172 oscillator',
    },
    'Oscillator P174': {
      rle: 'x = 8, y = 8, rule = FuzzyLife/3\n7B$4BA3B$ABbBbBbB$8B$b2BbBbBA$2b5B$3b3B$4bB!',
      description: 'Period 174 oscillator',
    },
    'Oscillator P175': {
      rle: 'x = 8, y = 8, rule = FuzzyLife/3\n6b2B$b5BAB$2BbBb3B$A6B$2BbBbB$5B$2Bb2B$4B!',
      description: 'Period 175 oscillator',
    },
    'Oscillator P176': {
      rle: 'x = 7, y = 9, rule = FuzzyLife/3\n2b4B$b2B2bB$b6B$bBbBbAB$b5BA$bBbB2bB$7B$BAbBb2B$6B!',
      description: 'Period 176 oscillator',
    },
    'Oscillator P18': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\nbAB$4B$b3B$2bB!',
      description: 'Period 18 oscillator',
    },
    'Oscillator P180': {
      rle: 'x = 8, y = 8, rule = FuzzyLife/3\nb2BA4B$2Bb4BA$4BbBbB$B2b5B$5B2bB$BbBb4B$3BABb2B$4BA2B!',
      description: 'Period 180 oscillator',
    },
    'Oscillator P182': {
      rle: 'x = 8, y = 8, rule = FuzzyLife/3\nb7B$4BA2BA$B2bBbBbB$8B$BbB2bBbB$A7B$3BbBb2B$b6B!',
      description: 'Period 182 oscillator',
    },
    'Oscillator P184': {
      rle: 'x = 8, y = 9, rule = FuzzyLife/3\n6BAB$BbABbBbB$3BA4B$BAbBbBAB$6BAB$ABbBb3B$b5BbA$2b2Bb3B$3b4B!',
      description: 'Period 184 oscillator',
    },
    'Oscillator P186': {
      rle: 'x = 7, y = 7, rule = FuzzyLife/3\n2b2BAB$b3Bb2B$2BbBA2B$6B$Bb2B$3B$2B!',
      description: 'Period 186 oscillator',
    },
    'Oscillator P187': {
      rle: 'x = 8, y = 9, rule = FuzzyLife/3\n7bB$b4BA2B$2BbBb3B$6BbB$BbB2b3B$6BbB$AbB2b3B$3BA2BA$3B!',
      description: 'Period 187 oscillator',
    },
    'Oscillator P19': {
      rle: 'x = 7, y = 3, rule = FuzzyLife/3\n2bA3B$b6B$4BA!',
      description: 'Period 19 oscillator',
    },
    'Oscillator P190': {
      rle: 'x = 4, y = 6, rule = FuzzyLife/3\n2B$2B$BA2B$BA2B$3B$2B!',
      description: 'Period 190 oscillator',
    },
    'Oscillator P192': {
      rle: 'x = 9, y = 9, rule = FuzzyLife/3\n7b2B$6BAbB$BbBbBb3B$A6BbB$2BAbBb3B$A6BAB$bBbBbB2AB$b3Bb4B$2b3BA2B!',
      description: 'Period 192 oscillator',
    },
    'Oscillator P195': {
      rle: 'x = 10, y = 8, rule = FuzzyLife/3\n2b5Bb2B$b2BbBbBb2B$5Bb4B$BbBb3Bb2B$5Bb4B$BABb3Bb2B$BA3BbBb2B$2B3b5B!',
      description: 'Period 195 oscillator',
    },
    'Oscillator P196': {
      rle: 'x = 9, y = 9, rule = FuzzyLife/3\nbBA6B$b2BbBbBA$b8B$4BbBb2B$ABA6B$4BbB2bB$9B$bABbBbBbB$2b5BAB!',
      description: 'Period 196 oscillator',
    },
    'Oscillator P198': {
      rle: 'x = 8, y = 8, rule = FuzzyLife/3\n3B3bBA$BAB$3B$bB$bB2b3B$B3b3BA$4bBb2B$4b3B!',
      description: 'Period 198 oscillator',
    },
    'Oscillator P2': {
      rle: 'x = 1, y = 2, rule = FuzzyLife/3\nB$A!',
      description: 'Period 2 oscillator',
    },
    'Oscillator P20': {
      rle: 'x = 6, y = 3, rule = FuzzyLife/3\nbA2B$4BAB$bA2B!',
      description: 'Period 20 oscillator',
    },
    'Oscillator P21': {
      rle: 'x = 5, y = 4, rule = FuzzyLife/3\nBb3B$bBA2B$b3B$b2B!',
      description: 'Period 21 oscillator',
    },
    'Oscillator P22': {
      rle: 'x = 3, y = 7, rule = FuzzyLife/3\n2bB$b2B$A2B$2BA$2BA$3B$bB!',
      description: 'Period 22 oscillator',
    },
    'Oscillator P23': {
      rle: 'x = 4, y = 6, rule = FuzzyLife/3\nb3B$2BAB$b3B$$2bB$b3B!',
      description: 'Period 23 oscillator',
    },
    'Oscillator P24': {
      rle: 'x = 5, y = 5, rule = FuzzyLife/3\nb4B$2B2AB$b4B$2bAB$3bB!',
      description: 'Period 24 oscillator',
    },
    'Oscillator P25': {
      rle: 'x = 6, y = 5, rule = FuzzyLife/3\n3bA2B$2BA3B$3Bb2B$b3BA$2b2B!',
      description: 'Period 25 oscillator',
    },
    'Oscillator P26': {
      rle: 'x = 5, y = 5, rule = FuzzyLife/3\n2bA2B$3BAB$BbBbB$5B$bB2A!',
      description: 'Period 26 oscillator',
    },
    'Oscillator P27': {
      rle: 'x = 4, y = 6, rule = FuzzyLife/3\n2bAB$b3B$2BbB$4B$2BbA$4B!',
      description: 'Period 27 oscillator',
    },
    'Oscillator P28': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\n2BAB$2BAB$2BAB$Bb2B!',
      description: 'Period 28 oscillator',
    },
    'Oscillator P29': {
      rle: 'x = 5, y = 6, rule = FuzzyLife/3\n3B$5B$BABAB$A2BA$Bb3B$4B!',
      description: 'Period 29 oscillator',
    },
    'Oscillator P3': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n3B$BAB$2BbA!',
      description: 'Period 3 oscillator',
    },
    'Oscillator P30': {
      rle: 'x = 4, y = 6, rule = FuzzyLife/3\nb3B$bBAB$b2B$b2B$bAB$B2bB!',
      description: 'Period 30 oscillator',
    },
    'Oscillator P31': {
      rle: 'x = 6, y = 4, rule = FuzzyLife/3\nB$2Bb2B$2b4B$3b3B!',
      description: 'Period 31 oscillator',
    },
    'Oscillator P32': {
      rle: 'x = 5, y = 4, rule = FuzzyLife/3\nB2A2B$5B$b3B$2bB!',
      description: 'Period 32 oscillator',
    },
    'Oscillator P33': {
      rle: 'x = 6, y = 6, rule = FuzzyLife/3\n5B$4BA$AbBbB$5B$B2bBbB$6B!',
      description: 'Period 33 oscillator',
    },
    'Oscillator P34': {
      rle: 'x = 6, y = 4, rule = FuzzyLife/3\n6B$6B$2BABbB$6B!',
      description: 'Period 34 oscillator',
    },
    'Oscillator P35': {
      rle: 'x = 7, y = 5, rule = FuzzyLife/3\n3b4B$2bBA2B$bA3B$4B$3B!',
      description: 'Period 35 oscillator',
    },
    'Oscillator P36': {
      rle: 'x = 3, y = 6, rule = FuzzyLife/3\nB$3B$2BA$2BA$3B$bB!',
      description: 'Period 36 oscillator',
    },
    'Oscillator P37': {
      rle: 'x = 5, y = 6, rule = FuzzyLife/3\n5B$b3B$bA2B$bBbB$b3B$2b2B!',
      description: 'Period 37 oscillator',
    },
    'Oscillator P38': {
      rle: 'x = 5, y = 7, rule = FuzzyLife/3\n2b3B$b3BA$bBb2B$b4B$bAb2B$b3B$B!',
      description: 'Period 38 oscillator',
    },
    'Oscillator P39': {
      rle: 'x = 6, y = 4, rule = FuzzyLife/3\n3B$BA3B$2Bb3B$b4B!',
      description: 'Period 39 oscillator',
    },
    'Oscillator P4': {
      rle: 'x = 3, y = 3, rule = FuzzyLife/3\nb2B$3B$3B!',
      description: 'Period 4 oscillator',
    },
    'Oscillator P40': {
      rle: 'x = 8, y = 5, rule = FuzzyLife/3\n3B3bAB$BAB$2B3b2B$2B3bBAB$4b4B!',
      description: 'Period 40 oscillator',
    },
    'Oscillator P41': {
      rle: 'x = 5, y = 6, rule = FuzzyLife/3\nb3B$2BbA$4BA$bBb2B$2b3B$3b2B!',
      description: 'Period 41 oscillator',
    },
    'Oscillator P42': {
      rle: 'x = 4, y = 4, rule = FuzzyLife/3\n2B$BAB$BA2B$4B!',
      description: 'Period 42 oscillator',
    },
    'Oscillator P43': {
      rle: 'x = 6, y = 7, rule = FuzzyLife/3\nbBA$3BA$2Bb2B$5B$2BbBbB$b5B$2bA2B!',
      description: 'Period 43 oscillator',
    },
    'Oscillator P44': {
      rle: 'x = 6, y = 5, rule = FuzzyLife/3\nBA$6B$5B$B2ABAB$6B!',
      description: 'Period 44 oscillator',
    },
    'Oscillator P45': {
      rle: 'x = 6, y = 4, rule = FuzzyLife/3\nb2Bb2B$2B2A2B$6B$6B!',
      description: 'Period 45 oscillator',
    },
    'Oscillator P46': {
      rle: 'x = 5, y = 6, rule = FuzzyLife/3\nBbBbB$bB2bA$$b3B$bBA2B$b3B!',
      description: 'Period 46 oscillator',
    },
    'Oscillator P47': {
      rle: 'x = 5, y = 8, rule = FuzzyLife/3\n2b3B$b2BbB$BbBbB$2BA2B$BbBA$5B$2Bb2B$b4B!',
      description: 'Period 47 oscillator',
    },
    'Oscillator P48': {
      rle: 'x = 6, y = 4, rule = FuzzyLife/3\nb4B$2Bb3B$4BbB$2BAb2B!',
      description: 'Period 48 oscillator',
    },
    'Oscillator P49': {
      rle: 'x = 6, y = 5, rule = FuzzyLife/3\n2BA$4B$b2BbB$bABA2B$b5B!',
      description: 'Period 49 oscillator',
    },
    'Oscillator P5': {
      rle: 'x = 3, y = 4, rule = FuzzyLife/3\n2B$2B$BAB$3B!',
      description: 'Period 5 oscillator',
    },
    'Oscillator P50': {
      rle: 'x = 6, y = 5, rule = FuzzyLife/3\n6B$bBA3B$b2BbB$2b3B$3bB!',
      description: 'Period 50 oscillator',
    },
    'Oscillator P51': {
      rle: 'x = 7, y = 7, rule = FuzzyLife/3\n4b2B$b3Bb2B$7B$BbBbBA$5BAB$BbBb3B$6B!',
      description: 'Period 51 oscillator',
    },
    'Oscillator P52': {
      rle: 'x = 5, y = 7, rule = FuzzyLife/3\n4B$2BbB$BA3B$bBbBA$bA2BA$BbBbB$5B!',
      description: 'Period 52 oscillator',
    },
    'Oscillator P53': {
      rle: 'x = 9, y = 6, rule = FuzzyLife/3\n3bA3B$b7B$2BbBbBb2B$9B$BbBbBbBbB$9B!',
      description: 'Period 53 oscillator',
    },
    'Oscillator P54': {
      rle: 'x = 6, y = 7, rule = FuzzyLife/3\nbAB$4B$Bb3B$3Bb2B$6B$2BABA$2B!',
      description: 'Period 54 oscillator',
    },
    'Oscillator P55': {
      rle: 'x = 7, y = 7, rule = FuzzyLife/3\n5b2B$b4BAB$bB2b3B$bA4B$2Bb2B$3BA$3B!',
      description: 'Period 55 oscillator',
    },
    'Oscillator P56': {
      rle: 'x = 5, y = 7, rule = FuzzyLife/3\nb4B$3BA$BbBAB$A4B$2B2bB$b4B$2b2B!',
      description: 'Period 56 oscillator',
    },
    'Oscillator P57': {
      rle: 'x = 7, y = 6, rule = FuzzyLife/3\n5b2B$4b3B$3b2BAB$2b3BbB$b2Bb3B$BABA2B!',
      description: 'Period 57 oscillator',
    },
    'Oscillator P58': {
      rle: 'x = 7, y = 4, rule = FuzzyLife/3\nBA2BA2B$Bb3BbB$3Bb3B$b5B!',
      description: 'Period 58 oscillator',
    },
    'Oscillator P59': {
      rle: 'x = 8, y = 8, rule = FuzzyLife/3\n4b3B$4b4B$4b2BAB$4b2BAB$4b4B$bB2b4B$B3bAbBA$B3b3B!',
      description: 'Period 59 oscillator',
    },
    'Oscillator P6': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\n2bAB$b3B$3B!',
      description: 'Period 6 oscillator',
    },
    'Oscillator P60': {
      rle: 'x = 4, y = 9, rule = FuzzyLife/3\nBA2B$BA2B$BA2B$4B$B2bB$4B$2BbB$b3B$2b2B!',
      description: 'Period 60 oscillator',
    },
    'Oscillator P61': {
      rle: 'x = 6, y = 9, rule = FuzzyLife/3\nb5B$2BbBbB$4BbB$2Bb3B$4BbB$2BbBbB$6B$2Bb2B$BA2B!',
      description: 'Period 61 oscillator',
    },
    'Oscillator P62': {
      rle: 'x = 4, y = 6, rule = FuzzyLife/3\nbBAB$2BbB$4B$Bb2B$3B$2B!',
      description: 'Period 62 oscillator',
    },
    'Oscillator P63': {
      rle: 'x = 4, y = 8, rule = FuzzyLife/3\nbB$3B$BbB$2BAB$Bb2B$4B$B2bB$4B!',
      description: 'Period 63 oscillator',
    },
    'Oscillator P64': {
      rle: 'x = 7, y = 7, rule = FuzzyLife/3\n2BA$5B$BbBb2B$7B$A2bBb2B$6B$5B!',
      description: 'Period 64 oscillator',
    },
    'Oscillator P65': {
      rle: 'x = 8, y = 7, rule = FuzzyLife/3\n6B$ABbBb2B$A7B$2BbBbBbB$7BA$2B2bBb2B$b5BAB!',
      description: 'Period 65 oscillator',
    },
    'Oscillator P66': {
      rle: 'x = 8, y = 5, rule = FuzzyLife/3\n3b5B$2b2BbBbA$b4BA2B$2BbABAbB$8B!',
      description: 'Period 66 oscillator',
    },
    'Oscillator P67': {
      rle: 'x = 7, y = 8, rule = FuzzyLife/3\nb3BAB$2B2A3B$2BA2BbB$3Bb3B$5BbB$b2Bb3B$4BAbB$5b2B!',
      description: 'Period 67 oscillator',
    },
    'Oscillator P68': {
      rle: 'x = 6, y = 6, rule = FuzzyLife/3\nbB$3B$ABb3B$A3BAB$BbBb2B$6B!',
      description: 'Period 68 oscillator',
    },
    'Oscillator P69': {
      rle: 'x = 9, y = 8, rule = FuzzyLife/3\n3b5B$b2BbBb3B$7BbB$B2bB2b3B$7BbB$BbBbBA2B$5B2AB$4BA3B!',
      description: 'Period 69 oscillator',
    },
    'Oscillator P7': {
      rle: 'x = 3, y = 5, rule = FuzzyLife/3\n2bB$3B$BAB$3B$B!',
      description: 'Period 7 oscillator',
    },
    'Oscillator P70': {
      rle: 'x = 6, y = 6, rule = FuzzyLife/3\nb3B$4BA$BbBb2B$A5B$2BbBbB$BA4B!',
      description: 'Period 70 oscillator',
    },
    'Oscillator P71': {
      rle: 'x = 6, y = 7, rule = FuzzyLife/3\nb5B$6B$BbBb2B$3Bb2B$bBA3B$2b2BAB$3b3B!',
      description: 'Period 71 oscillator',
    },
    'Oscillator P72': {
      rle: 'x = 7, y = 7, rule = FuzzyLife/3\n4b2B$3b4B$b4BAB$7B$3BA3B$bBA3B$3b2B!',
      description: 'Period 72 oscillator',
    },
    'Oscillator P73': {
      rle: 'x = 6, y = 10, rule = FuzzyLife/3\n2b4B$b3BbB$2BbBbB$6B$BAbBbB$6B$ABbBbB$6B$b2Bb2B$2b2B!',
      description: 'Period 73 oscillator',
    },
    'Oscillator P74': {
      rle: 'x = 8, y = 8, rule = FuzzyLife/3\n6B$A3Bb2B$B2A5B$4BbBbB$B2bBbBbB$8B$b2BbA2B$2b4B!',
      description: 'Period 74 oscillator',
    },
    'Oscillator P75': {
      rle: 'x = 10, y = 9, rule = FuzzyLife/3\n2B$Bb5B$3BA3BA$b2BbBbBb2B$2b8B$3b2BbBbAB$4b6B$5b2BbAB$6b4B!',
      description: 'Period 75 oscillator',
    },
    'Oscillator P76': {
      rle: 'x = 7, y = 7, rule = FuzzyLife/3\nb3BAB$3Bb3B$Bb3BbB$b2Bb3B$b6B$2bABA2B$5b2B!',
      description: 'Period 76 oscillator',
    },
    'Oscillator P77': {
      rle: 'x = 7, y = 8, rule = FuzzyLife/3\n2Bb4B$BA5B$BABbBbA$7B$B2bB2bB$7B$b2Bb2B$2b3B!',
      description: 'Period 77 oscillator',
    },
    'Oscillator P78': {
      rle: 'x = 6, y = 6, rule = FuzzyLife/3\nb3B$2BAB$Bb2B$3B$3B$bB2bAB!',
      description: 'Period 78 oscillator',
    },
    'Oscillator P79': {
      rle: 'x = 10, y = 9, rule = FuzzyLife/3\nb5BA2B$2BbBA4B$2BbBbBbBbB$10B$BAbBbBbBbB$10B$b2BbBbB2bB$2b3Bb4B$3b6B!',
      description: 'Period 79 oscillator',
    },
    'Oscillator P8': {
      rle: 'x = 4, y = 3, rule = FuzzyLife/3\nb2B$3B$2BAB!',
      description: 'Period 8 oscillator',
    },
    'Oscillator P80': {
      rle: 'x = 8, y = 6, rule = FuzzyLife/3\n3b2BA2B$2b2Bb2BA$b5BbB$2BbBb3B$4BA2B$3Bb2B!',
      description: 'Period 80 oscillator',
    },
    'Oscillator P81': {
      rle: 'x = 7, y = 8, rule = FuzzyLife/3\n7B$BbBbBbB$BbBb3B$6BA$B2bBb2B$6B$2Bb2B$b3B!',
      description: 'Period 81 oscillator',
    },
    'Oscillator P82': {
      rle: 'x = 7, y = 7, rule = FuzzyLife/3\n4B$2Bb2B$6B$B2bBbB$5BA$2Bb2BAB$4B!',
      description: 'Period 82 oscillator',
    },
    'Oscillator P83': {
      rle: 'x = 9, y = 9, rule = FuzzyLife/3\nBABA4B$Bb7B$4BbB2bB$BAb6B$5BbBbB$b2Bb5B$2b3BbBbB$3b2Bb3B$4b4B!',
      description: 'Period 83 oscillator',
    },
    'Oscillator P84': {
      rle: 'x = 7, y = 5, rule = FuzzyLife/3\n7B$BbABAbB$7B$2BbBAB$b4B!',
      description: 'Period 84 oscillator',
    },
    'Oscillator P85': {
      rle: 'x = 8, y = 8, rule = FuzzyLife/3\n3b5B$2b3BA2B$2bAbBb2B$2b3Bb2B$bAb5B$4B2b2B$B2b4B$6B!',
      description: 'Period 85 oscillator',
    },
    'Oscillator P86': {
      rle: 'x = 7, y = 7, rule = FuzzyLife/3\n4bAB$b2BA3B$2BbBb2B$7B$2BbBb2B$6B$4BA!',
      description: 'Period 86 oscillator',
    },
    'Oscillator P87': {
      rle: 'x = 8, y = 8, rule = FuzzyLife/3\n4b2B$3b2Bb2B$2b6B$2b2BbB$bBb5B$4BbBbB$2Bb5B$b2BA4B!',
      description: 'Period 87 oscillator',
    },
    'Oscillator P88': {
      rle: 'x = 7, y = 7, rule = FuzzyLife/3\n2bBAb2B$b3Bb2B$2Bb4B$b3Bb2B$2b5B$3bBb2B$4b2B!',
      description: 'Period 88 oscillator',
    },
    'Oscillator P89': {
      rle: 'x = 9, y = 9, rule = FuzzyLife/3\n6b3B$5b2BbB$3b2Bb2B$2b5BAB$b2BbBb3B$9B$BbBbBbBbB$3Bb5B$b6B!',
      description: 'Period 89 oscillator',
    },
    'Oscillator P9': {
      rle: 'x = 5, y = 3, rule = FuzzyLife/3\n2b3B$3BAB$2b3B!',
      description: 'Period 9 oscillator',
    },
    'Oscillator P90': {
      rle: 'x = 7, y = 8, rule = FuzzyLife/3\n4bBA$3b4B$2Bb3B$4bB$$b2B$bBA4B$b4BA!',
      description: 'Period 90 oscillator',
    },
    'Oscillator P91': {
      rle: 'x = 8, y = 9, rule = FuzzyLife/3\n2B4b2B$BAB3b2B$3BA$2Bb2B$A5B$2BbBb2B$7B$2B2b2B$b4B!',
      description: 'Period 91 oscillator',
    },
    'Oscillator P92': {
      rle: 'x = 7, y = 8, rule = FuzzyLife/3\nbB$bA2b3B$4bBbB$4b2BA$bB3b2B$3B3bB$BAB$3Bb2B!',
      description: 'Period 92 oscillator',
    },
    'Oscillator P93': {
      rle: 'x = 9, y = 9, rule = FuzzyLife/3\nbB5b2B$2bB3b3B$B4b4B$B3b5B$B2b6B$5bBb2B$3b6B$3bABbBbA$4b5B!',
      description: 'Period 93 oscillator',
    },
    'Oscillator P94': {
      rle: 'x = 8, y = 6, rule = FuzzyLife/3\n4BA2B$5Bb2B$BA2b3BA$5BbBA$2BbBb2B$b4BAB!',
      description: 'Period 94 oscillator',
    },
    'Oscillator P95': {
      rle: 'x = 8, y = 6, rule = FuzzyLife/3\nb4BA2B$4Bb2BA$B2b3BbB$4Bb3B$b5BbB$3b3BAB!',
      description: 'Period 95 oscillator',
    },
    'Oscillator P96': {
      rle: 'x = 8, y = 8, rule = FuzzyLife/3\n6B$BAbBb2B$8B$bBbBbBAB$b5BAB$bBbBb3B$Bb2Bb2B$3b3B!',
      description: 'Period 96 oscillator',
    },
    'Oscillator P98': {
      rle: 'x = 8, y = 8, rule = FuzzyLife/3\nb7B$6BbB$B2bBbBbB$A7B$2B2ABbB$b5B$b4BA$6bB!',
      description: 'Period 98 oscillator',
    },
    'Oscillator P99': {
      rle: 'x = 7, y = 7, rule = FuzzyLife/3\n3BABA$BA5B$6B$ABb2B$4B$3B$2B!',
      description: 'Period 99 oscillator',
    },
  },
};

export default patterns;
